import "core/math";

/**
 * @function dumpDataSet
 * @description  Copied from node-dicom
 * @ref @see https://github.com/grmble/node-dicom
 * @param {*} dataSet
 * @param {*} output
 */
const TAG_DICT = {
  "(0000,0000)": {
    tag: "(0000,0000)",
    vr: "UL",
    vm: "1",
    name: "Command Group Length"
  },
  "(0000,0001)": {
    tag: "(0000,0001)",
    vr: "UL",
    vm: "1",
    name: "Command Length To End"
  },
  "(0000,0002)": {
    tag: "(0000,0002)",
    vr: "UI",
    vm: "1",
    name: "Affected SOPClass UID"
  },
  "(0000,0003)": {
    tag: "(0000,0003)",
    vr: "UI",
    vm: "1",
    name: "Requested SOPClass UID"
  },
  "(0000,0010)": {
    tag: "(0000,0010)",
    vr: "SH",
    vm: "1",
    name: "Command Recognition Code"
  },
  "(0000,0100)": {
    tag: "(0000,0100)",
    vr: "US",
    vm: "1",
    name: "Command Field"
  },
  "(0000,0110)": { tag: "(0000,0110)", vr: "US", vm: "1", name: "Message ID" },
  "(0000,0120)": {
    tag: "(0000,0120)",
    vr: "US",
    vm: "1",
    name: "Message IDBeing Responded To"
  },
  "(0000,0200)": { tag: "(0000,0200)", vr: "AE", vm: "1", name: "Initiator" },
  "(0000,0300)": { tag: "(0000,0300)", vr: "AE", vm: "1", name: "Receiver" },
  "(0000,0400)": {
    tag: "(0000,0400)",
    vr: "AE",
    vm: "1",
    name: "Find Location"
  },
  "(0000,0600)": {
    tag: "(0000,0600)",
    vr: "AE",
    vm: "1",
    name: "Move Destination"
  },
  "(0000,0700)": { tag: "(0000,0700)", vr: "US", vm: "1", name: "Priority" },
  "(0000,0800)": {
    tag: "(0000,0800)",
    vr: "US",
    vm: "1",
    name: "Command Data Set Type"
  },
  "(0000,0850)": {
    tag: "(0000,0850)",
    vr: "US",
    vm: "1",
    name: "Number Of Matches"
  },
  "(0000,0860)": {
    tag: "(0000,0860)",
    vr: "US",
    vm: "1",
    name: "Response Sequence Number"
  },
  "(0000,0900)": { tag: "(0000,0900)", vr: "US", vm: "1", name: "Status" },
  "(0000,0901)": {
    tag: "(0000,0901)",
    vr: "AT",
    vm: "1",
    name: "Offending Element"
  },
  "(0000,0902)": {
    tag: "(0000,0902)",
    vr: "LO",
    vm: "1",
    name: "Error Comment"
  },
  "(0000,0903)": { tag: "(0000,0903)", vr: "US", vm: "1", name: "Error ID" },
  "(0000,1000)": {
    tag: "(0000,1000)",
    vr: "UI",
    vm: "1",
    name: "Affected SOPInstance UID"
  },
  "(0000,1001)": {
    tag: "(0000,1001)",
    vr: "UI",
    vm: "1",
    name: "Requested SOPInstance UID"
  },
  "(0000,1002)": {
    tag: "(0000,1002)",
    vr: "US",
    vm: "1",
    name: "Event Type ID"
  },
  "(0000,1005)": {
    tag: "(0000,1005)",
    vr: "AT",
    vm: "1",
    name: "Attribute Identifier List"
  },
  "(0000,1008)": {
    tag: "(0000,1008)",
    vr: "US",
    vm: "1",
    name: "Action Type ID"
  },
  "(0000,1020)": {
    tag: "(0000,1020)",
    vr: "US",
    vm: "1",
    name: "Number Of Remaining Suboperations"
  },
  "(0000,1021)": {
    tag: "(0000,1021)",
    vr: "US",
    vm: "1",
    name: "Number Of Completed Suboperations"
  },
  "(0000,1022)": {
    tag: "(0000,1022)",
    vr: "US",
    vm: "1",
    name: "Number Of Failed Suboperations"
  },
  "(0000,1023)": {
    tag: "(0000,1023)",
    vr: "US",
    vm: "1",
    name: "Number Of Warning Suboperations"
  },
  "(0000,1030)": {
    tag: "(0000,1030)",
    vr: "AE",
    vm: "1",
    name: "Move Originator Application Entity Title"
  },
  "(0000,1031)": {
    tag: "(0000,1031)",
    vr: "US",
    vm: "1",
    name: "Move Originator Message ID"
  },
  "(0000,4000)": {
    tag: "(0000,4000)",
    vr: "LT",
    vm: "1",
    name: "Dialog Receiver"
  },
  "(0000,4010)": {
    tag: "(0000,4010)",
    vr: "LT",
    vm: "1",
    name: "Terminal Type"
  },
  "(0000,5010)": {
    tag: "(0000,5010)",
    vr: "SH",
    vm: "1",
    name: "Message Set ID"
  },
  "(0000,5020)": {
    tag: "(0000,5020)",
    vr: "SH",
    vm: "1",
    name: "End Message ID"
  },
  "(0000,5110)": {
    tag: "(0000,5110)",
    vr: "LT",
    vm: "1",
    name: "Display Format"
  },
  "(0000,5120)": {
    tag: "(0000,5120)",
    vr: "LT",
    vm: "1",
    name: "Page Position ID"
  },
  "(0000,5130)": {
    tag: "(0000,5130)",
    vr: "CS",
    vm: "1",
    name: "Text Format ID"
  },
  "(0000,5140)": {
    tag: "(0000,5140)",
    vr: "CS",
    vm: "1",
    name: "Normal Reverse"
  },
  "(0000,5150)": {
    tag: "(0000,5150)",
    vr: "CS",
    vm: "1",
    name: "Add Gray Scale"
  },
  "(0000,5160)": { tag: "(0000,5160)", vr: "CS", vm: "1", name: "Borders" },
  "(0000,5170)": { tag: "(0000,5170)", vr: "IS", vm: "1", name: "Copies" },
  "(0000,5180)": {
    tag: "(0000,5180)",
    vr: "CS",
    vm: "1",
    name: "Command Magnification Type"
  },
  "(0000,5190)": { tag: "(0000,5190)", vr: "CS", vm: "1", name: "Erase" },
  "(0000,51A0)": { tag: "(0000,51A0)", vr: "CS", vm: "1", name: "Print" },
  "(0000,51B0)": { tag: "(0000,51B0)", vr: "US", vm: "1", name: "Overlays" },
  "(0002,0000)": {
    tag: "(0002,0000)",
    vr: "UL",
    vm: "1",
    name: "File Meta Information Group Length"
  },
  "(0002,0001)": {
    tag: "(0002,0001)",
    vr: "OB",
    vm: "1",
    name: "File Meta Information Version"
  },
  "(0002,0002)": {
    tag: "(0002,0002)",
    vr: "UI",
    vm: "1",
    name: "Media Storage SOPClass UID"
  },
  "(0002,0003)": {
    tag: "(0002,0003)",
    vr: "UI",
    vm: "1",
    name: "Media Storage SOPInstance UID"
  },
  "(0002,0010)": {
    tag: "(0002,0010)",
    vr: "UI",
    vm: "1",
    name: "Transfer Syntax UID"
  },
  "(0002,0012)": {
    tag: "(0002,0012)",
    vr: "UI",
    vm: "1",
    name: "Implementation Class UID"
  },
  "(0002,0013)": {
    tag: "(0002,0013)",
    vr: "SH",
    vm: "1",
    name: "Implementation Version Name"
  },
  "(0002,0016)": {
    tag: "(0002,0016)",
    vr: "AE",
    vm: "1",
    name: "Source Application Entity Title"
  },
  "(0002,0100)": {
    tag: "(0002,0100)",
    vr: "UI",
    vm: "1",
    name: "Private Information Creator UID"
  },
  "(0002,0102)": {
    tag: "(0002,0102)",
    vr: "OB",
    vm: "1",
    name: "Private Information"
  },
  "(0004,1130)": { tag: "(0004,1130)", vr: "CS", vm: "1", name: "File Set ID" },
  "(0004,1141)": {
    tag: "(0004,1141)",
    vr: "CS",
    vm: "1-8",
    name: "File Set Descriptor File ID"
  },
  "(0004,1142)": {
    tag: "(0004,1142)",
    vr: "CS",
    vm: "1",
    name: "Specific Character Set Of File Set Descriptor File"
  },
  "(0004,1200)": {
    tag: "(0004,1200)",
    vr: "UL",
    vm: "1",
    name: "Offset Of The First Directory Record Of The Root Directory Entity"
  },
  "(0004,1202)": {
    tag: "(0004,1202)",
    vr: "UL",
    vm: "1",
    name: "Offset Of The Last Directory Record Of The Root Directory Entity"
  },
  "(0004,1212)": {
    tag: "(0004,1212)",
    vr: "US",
    vm: "1",
    name: "File Set Consistency Flag"
  },
  "(0004,1220)": {
    tag: "(0004,1220)",
    vr: "SQ",
    vm: "1",
    name: "Directory Record Sequence"
  },
  "(0004,1400)": {
    tag: "(0004,1400)",
    vr: "UL",
    vm: "1",
    name: "Offset Of The Next Directory Record"
  },
  "(0004,1410)": {
    tag: "(0004,1410)",
    vr: "US",
    vm: "1",
    name: "Record In Use Flag"
  },
  "(0004,1420)": {
    tag: "(0004,1420)",
    vr: "UL",
    vm: "1",
    name: "Offset Of Referenced Lower Level Directory Entity"
  },
  "(0004,1430)": {
    tag: "(0004,1430)",
    vr: "CS",
    vm: "1",
    name: "Directory Record Type"
  },
  "(0004,1432)": {
    tag: "(0004,1432)",
    vr: "UI",
    vm: "1",
    name: "Private Record UID"
  },
  "(0004,1500)": {
    tag: "(0004,1500)",
    vr: "CS",
    vm: "1-8",
    name: "Referenced File ID"
  },
  "(0004,1504)": {
    tag: "(0004,1504)",
    vr: "UL",
    vm: "1",
    name: "MRDRDirectory Record Offset"
  },
  "(0004,1510)": {
    tag: "(0004,1510)",
    vr: "UI",
    vm: "1",
    name: "Referenced SOPClass UIDIn File"
  },
  "(0004,1511)": {
    tag: "(0004,1511)",
    vr: "UI",
    vm: "1",
    name: "Referenced SOPInstance UIDIn File"
  },
  "(0004,1512)": {
    tag: "(0004,1512)",
    vr: "UI",
    vm: "1",
    name: "Referenced Transfer Syntax UIDIn File"
  },
  "(0004,151A)": {
    tag: "(0004,151A)",
    vr: "UI",
    vm: "1",
    name: "Referenced Related General SOPClass UIDIn File"
  },
  "(0004,1600)": {
    tag: "(0004,1600)",
    vr: "UL",
    vm: "1",
    name: "Number Of References"
  },
  "(0008,0001)": {
    tag: "(0008,0001)",
    vr: "UL",
    vm: "1",
    name: "Length To End"
  },
  "(0008,0005)": {
    tag: "(0008,0005)",
    vr: "CS",
    vm: "1",
    name: "Specific Character Set"
  },
  "(0008,0006)": {
    tag: "(0008,0006)",
    vr: "SQ",
    vm: "1",
    name: "Language Code Sequence"
  },
  "(0008,0008)": {
    tag: "(0008,0008)",
    vr: "CS",
    vm: "2",
    name: "Image Type"
  },
  "(0008,0010)": {
    tag: "(0008,0010)",
    vr: "SH",
    vm: "1",
    name: "Recognition Code"
  },
  "(0008,0012)": {
    tag: "(0008,0012)",
    vr: "DA",
    vm: "1",
    name: "Instance Creation Date"
  },
  "(0008,0013)": {
    tag: "(0008,0013)",
    vr: "TM",
    vm: "1",
    name: "Instance Creation Time"
  },
  "(0008,0014)": {
    tag: "(0008,0014)",
    vr: "UI",
    vm: "1",
    name: "Instance Creator UID"
  },
  "(0008,0016)": {
    tag: "(0008,0016)",
    vr: "UI",
    vm: "1",
    name: "SOPClass UID"
  },
  "(0008,0018)": {
    tag: "(0008,0018)",
    vr: "UI",
    vm: "1",
    name: "SOPInstance UID"
  },
  "(0008,001A)": {
    tag: "(0008,001A)",
    vr: "UI",
    vm: "1",
    name: "Related General SOPClass UID"
  },
  "(0008,001B)": {
    tag: "(0008,001B)",
    vr: "UI",
    vm: "1",
    name: "Original Specialized SOPClass UID"
  },
  "(0008,0020)": { tag: "(0008,0020)", vr: "DA", vm: "1", name: "Study Date" },
  "(0008,0021)": { tag: "(0008,0021)", vr: "DA", vm: "1", name: "Series Date" },
  "(0008,0022)": {
    tag: "(0008,0022)",
    vr: "DA",
    vm: "1",
    name: "Acquisition Date"
  },
  "(0008,0023)": {
    tag: "(0008,0023)",
    vr: "DA",
    vm: "1",
    name: "Content Date"
  },
  "(0008,0024)": {
    tag: "(0008,0024)",
    vr: "DA",
    vm: "1",
    name: "Overlay Date"
  },
  "(0008,0025)": { tag: "(0008,0025)", vr: "DA", vm: "1", name: "Curve Date" },
  "(0008,002A)": {
    tag: "(0008,002A)",
    vr: "DT",
    vm: "1",
    name: "Acquisition Date Time"
  },
  "(0008,0030)": { tag: "(0008,0030)", vr: "TM", vm: "1", name: "Study Time" },
  "(0008,0031)": { tag: "(0008,0031)", vr: "TM", vm: "1", name: "Series Time" },
  "(0008,0032)": {
    tag: "(0008,0032)",
    vr: "TM",
    vm: "1",
    name: "Acquisition Time"
  },
  "(0008,0033)": {
    tag: "(0008,0033)",
    vr: "TM",
    vm: "1",
    name: "Content Time"
  },
  "(0008,0034)": {
    tag: "(0008,0034)",
    vr: "TM",
    vm: "1",
    name: "Overlay Time"
  },
  "(0008,0035)": { tag: "(0008,0035)", vr: "TM", vm: "1", name: "Curve Time" },
  "(0008,0040)": {
    tag: "(0008,0040)",
    vr: "US",
    vm: "1",
    name: "Data Set Type"
  },
  "(0008,0041)": {
    tag: "(0008,0041)",
    vr: "LO",
    vm: "1",
    name: "Data Set Subtype"
  },
  "(0008,0042)": {
    tag: "(0008,0042)",
    vr: "CS",
    vm: "1",
    name: "Nuclear Medicine Series Type"
  },
  "(0008,0050)": {
    tag: "(0008,0050)",
    vr: "SH",
    vm: "1",
    name: "Accession Number"
  },
  "(0008,0051)": {
    tag: "(0008,0051)",
    vr: "SQ",
    vm: "1",
    name: "Issuer Of Accession Number Sequence"
  },
  "(0008,0052)": {
    tag: "(0008,0052)",
    vr: "CS",
    vm: "1",
    name: "Query Retrieve Level"
  },
  "(0008,0054)": {
    tag: "(0008,0054)",
    vr: "AE",
    vm: "1",
    name: "Retrieve AETitle"
  },
  "(0008,0056)": {
    tag: "(0008,0056)",
    vr: "CS",
    vm: "1",
    name: "Instance Availability"
  },
  "(0008,0058)": {
    tag: "(0008,0058)",
    vr: "UI",
    vm: "1",
    name: "Failed SOPInstance UIDList"
  },
  "(0008,0060)": { tag: "(0008,0060)", vr: "CS", vm: "1", name: "Modality" },
  "(0008,0061)": {
    tag: "(0008,0061)",
    vr: "CS",
    vm: "1",
    name: "Modalities In Study"
  },
  "(0008,0062)": {
    tag: "(0008,0062)",
    vr: "UI",
    vm: "1",
    name: "SOPClasses In Study"
  },
  "(0008,0064)": {
    tag: "(0008,0064)",
    vr: "CS",
    vm: "1",
    name: "Conversion Type"
  },
  "(0008,0068)": {
    tag: "(0008,0068)",
    vr: "CS",
    vm: "1",
    name: "Presentation Intent Type"
  },
  "(0008,0070)": {
    tag: "(0008,0070)",
    vr: "LO",
    vm: "1",
    name: "Manufacturer"
  },
  "(0008,0080)": {
    tag: "(0008,0080)",
    vr: "LO",
    vm: "1",
    name: "Institution Name"
  },
  "(0008,0081)": {
    tag: "(0008,0081)",
    vr: "ST",
    vm: "1",
    name: "Institution Address"
  },
  "(0008,0082)": {
    tag: "(0008,0082)",
    vr: "SQ",
    vm: "1",
    name: "Institution Code Sequence"
  },
  "(0008,0090)": {
    tag: "(0008,0090)",
    vr: "PN",
    vm: "1",
    name: "Referring Physician Name"
  },
  "(0008,0092)": {
    tag: "(0008,0092)",
    vr: "ST",
    vm: "1",
    name: "Referring Physician Address"
  },
  "(0008,0094)": {
    tag: "(0008,0094)",
    vr: "SH",
    vm: "1",
    name: "Referring Physician Telephone Numbers"
  },
  "(0008,0096)": {
    tag: "(0008,0096)",
    vr: "SQ",
    vm: "1",
    name: "Referring Physician Identification Sequence"
  },
  "(0008,0100)": { tag: "(0008,0100)", vr: "SH", vm: "1", name: "Code Value" },
  "(0008,0102)": {
    tag: "(0008,0102)",
    vr: "SH",
    vm: "1",
    name: "Coding Scheme Designator"
  },
  "(0008,0103)": {
    tag: "(0008,0103)",
    vr: "SH",
    vm: "1",
    name: "Coding Scheme Version"
  },
  "(0008,0104)": {
    tag: "(0008,0104)",
    vr: "LO",
    vm: "1",
    name: "Code Meaning"
  },
  "(0008,0105)": {
    tag: "(0008,0105)",
    vr: "CS",
    vm: "1",
    name: "Mapping Resource"
  },
  "(0008,0106)": {
    tag: "(0008,0106)",
    vr: "DT",
    vm: "1",
    name: "Context Group Version"
  },
  "(0008,0107)": {
    tag: "(0008,0107)",
    vr: "DT",
    vm: "1",
    name: "Context Group Local Version"
  },
  "(0008,010B)": {
    tag: "(0008,010B)",
    vr: "CS",
    vm: "1",
    name: "Context Group Extension Flag"
  },
  "(0008,010C)": {
    tag: "(0008,010C)",
    vr: "UI",
    vm: "1",
    name: "Coding Scheme UID"
  },
  "(0008,010D)": {
    tag: "(0008,010D)",
    vr: "UI",
    vm: "1",
    name: "Context Group Extension Creator UID"
  },
  "(0008,010F)": {
    tag: "(0008,010F)",
    vr: "CS",
    vm: "1",
    name: "Context Identifier"
  },
  "(0008,0110)": {
    tag: "(0008,0110)",
    vr: "SQ",
    vm: "1",
    name: "Coding Scheme Identification Sequence"
  },
  "(0008,0112)": {
    tag: "(0008,0112)",
    vr: "LO",
    vm: "1",
    name: "Coding Scheme Registry"
  },
  "(0008,0114)": {
    tag: "(0008,0114)",
    vr: "ST",
    vm: "1",
    name: "Coding Scheme External ID"
  },
  "(0008,0115)": {
    tag: "(0008,0115)",
    vr: "ST",
    vm: "1",
    name: "Coding Scheme Name"
  },
  "(0008,0116)": {
    tag: "(0008,0116)",
    vr: "ST",
    vm: "1",
    name: "Coding Scheme Responsible Organization"
  },
  "(0008,0117)": { tag: "(0008,0117)", vr: "UI", vm: "1", name: "Context UID" },
  "(0008,0201)": {
    tag: "(0008,0201)",
    vr: "SH",
    vm: "1",
    name: "Timezone Offset From UTC"
  },
  "(0008,1000)": { tag: "(0008,1000)", vr: "AE", vm: "1", name: "Network ID" },
  "(0008,1010)": {
    tag: "(0008,1010)",
    vr: "SH",
    vm: "1",
    name: "Station Name"
  },
  "(0008,1030)": {
    tag: "(0008,1030)",
    vr: "LO",
    vm: "1",
    name: "Study Description"
  },
  "(0008,1032)": {
    tag: "(0008,1032)",
    vr: "SQ",
    vm: "1",
    name: "Procedure Code Sequence"
  },
  "(0008,103E)": {
    tag: "(0008,103E)",
    vr: "LO",
    vm: "1",
    name: "Series Description"
  },
  "(0008,103F)": {
    tag: "(0008,103F)",
    vr: "SQ",
    vm: "1",
    name: "Series Description Code Sequence"
  },
  "(0008,1040)": {
    tag: "(0008,1040)",
    vr: "LO",
    vm: "1",
    name: "Institutional Department Name"
  },
  "(0008,1048)": {
    tag: "(0008,1048)",
    vr: "PN",
    vm: "1",
    name: "Physicians Of Record"
  },
  "(0008,1049)": {
    tag: "(0008,1049)",
    vr: "SQ",
    vm: "1",
    name: "Physicians Of Record Identification Sequence"
  },
  "(0008,1050)": {
    tag: "(0008,1050)",
    vr: "PN",
    vm: "1",
    name: "Performing Physician Name"
  },
  "(0008,1052)": {
    tag: "(0008,1052)",
    vr: "SQ",
    vm: "1",
    name: "Performing Physician Identification Sequence"
  },
  "(0008,1060)": {
    tag: "(0008,1060)",
    vr: "PN",
    vm: "1",
    name: "Name Of Physicians Reading Study"
  },
  "(0008,1062)": {
    tag: "(0008,1062)",
    vr: "SQ",
    vm: "1",
    name: "Physicians Reading Study Identification Sequence"
  },
  "(0008,1070)": {
    tag: "(0008,1070)",
    vr: "PN",
    vm: "1",
    name: "Operators Name"
  },
  "(0008,1072)": {
    tag: "(0008,1072)",
    vr: "SQ",
    vm: "1",
    name: "Operator Identification Sequence"
  },
  "(0008,1080)": {
    tag: "(0008,1080)",
    vr: "LO",
    vm: "1",
    name: "Admitting Diagnoses Description"
  },
  "(0008,1084)": {
    tag: "(0008,1084)",
    vr: "SQ",
    vm: "1",
    name: "Admitting Diagnoses Code Sequence"
  },
  "(0008,1090)": {
    tag: "(0008,1090)",
    vr: "LO",
    vm: "1",
    name: "Manufacturer Model Name"
  },
  "(0008,1100)": {
    tag: "(0008,1100)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Results Sequence"
  },
  "(0008,1110)": {
    tag: "(0008,1110)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Study Sequence"
  },
  "(0008,1111)": {
    tag: "(0008,1111)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Performed Procedure Step Sequence"
  },
  "(0008,1115)": {
    tag: "(0008,1115)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Series Sequence"
  },
  "(0008,1120)": {
    tag: "(0008,1120)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Patient Sequence"
  },
  "(0008,1125)": {
    tag: "(0008,1125)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Visit Sequence"
  },
  "(0008,1130)": {
    tag: "(0008,1130)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Overlay Sequence"
  },
  "(0008,1134)": {
    tag: "(0008,1134)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Stereometric Instance Sequence"
  },
  "(0008,113A)": {
    tag: "(0008,113A)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Waveform Sequence"
  },
  "(0008,1140)": {
    tag: "(0008,1140)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Image Sequence"
  },
  "(0008,1145)": {
    tag: "(0008,1145)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Curve Sequence"
  },
  "(0008,114A)": {
    tag: "(0008,114A)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Instance Sequence"
  },
  "(0008,114B)": {
    tag: "(0008,114B)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Real World Value Mapping Instance Sequence"
  },
  "(0008,1150)": {
    tag: "(0008,1150)",
    vr: "UI",
    vm: "1",
    name: "Referenced SOPClass UID"
  },
  "(0008,1155)": {
    tag: "(0008,1155)",
    vr: "UI",
    vm: "1",
    name: "Referenced SOPInstance UID"
  },
  "(0008,115A)": {
    tag: "(0008,115A)",
    vr: "UI",
    vm: "1",
    name: "SOPClasses Supported"
  },
  "(0008,1160)": {
    tag: "(0008,1160)",
    vr: "IS",
    vm: "1",
    name: "Referenced Frame Number"
  },
  "(0008,1161)": {
    tag: "(0008,1161)",
    vr: "UL",
    vm: "1",
    name: "Simple Frame List"
  },
  "(0008,1162)": {
    tag: "(0008,1162)",
    vr: "UL",
    vm: "3-3n",
    name: "Calculated Frame List"
  },
  "(0008,1163)": { tag: "(0008,1163)", vr: "FD", vm: "2", name: "Time Range" },
  "(0008,1164)": {
    tag: "(0008,1164)",
    vr: "SQ",
    vm: "1",
    name: "Frame Extraction Sequence"
  },
  "(0008,1167)": {
    tag: "(0008,1167)",
    vr: "UI",
    vm: "1",
    name: "Multi Frame Source SOPInstance UID"
  },
  "(0008,1195)": {
    tag: "(0008,1195)",
    vr: "UI",
    vm: "1",
    name: "Transaction UID"
  },
  "(0008,1197)": {
    tag: "(0008,1197)",
    vr: "US",
    vm: "1",
    name: "Failure Reason"
  },
  "(0008,1198)": {
    tag: "(0008,1198)",
    vr: "SQ",
    vm: "1",
    name: "Failed SOPSequence"
  },
  "(0008,1199)": {
    tag: "(0008,1199)",
    vr: "SQ",
    vm: "1",
    name: "Referenced SOPSequence"
  },
  "(0008,1200)": {
    tag: "(0008,1200)",
    vr: "SQ",
    vm: "1",
    name: "Studies Containing Other Referenced Instances Sequence"
  },
  "(0008,1250)": {
    tag: "(0008,1250)",
    vr: "SQ",
    vm: "1",
    name: "Related Series Sequence"
  },
  "(0008,2110)": {
    tag: "(0008,2110)",
    vr: "CS",
    vm: "1",
    name: "Lossy Image Compression Retired"
  },
  "(0008,2111)": {
    tag: "(0008,2111)",
    vr: "ST",
    vm: "1",
    name: "Derivation Description"
  },
  "(0008,2112)": {
    tag: "(0008,2112)",
    vr: "SQ",
    vm: "1",
    name: "Source Image Sequence"
  },
  "(0008,2120)": { tag: "(0008,2120)", vr: "SH", vm: "1", name: "Stage Name" },
  "(0008,2122)": {
    tag: "(0008,2122)",
    vr: "IS",
    vm: "1",
    name: "Stage Number"
  },
  "(0008,2124)": {
    tag: "(0008,2124)",
    vr: "IS",
    vm: "1",
    name: "Number Of Stages"
  },
  "(0008,2127)": { tag: "(0008,2127)", vr: "SH", vm: "1", name: "View Name" },
  "(0008,2128)": { tag: "(0008,2128)", vr: "IS", vm: "1", name: "View Number" },
  "(0008,2129)": {
    tag: "(0008,2129)",
    vr: "IS",
    vm: "1",
    name: "Number Of Event Timers"
  },
  "(0008,212A)": {
    tag: "(0008,212A)",
    vr: "IS",
    vm: "1",
    name: "Number Of Views In Stage"
  },
  "(0008,2130)": {
    tag: "(0008,2130)",
    vr: "DS",
    vm: "1",
    name: "Event Elapsed Times"
  },
  "(0008,2132)": {
    tag: "(0008,2132)",
    vr: "LO",
    vm: "1",
    name: "Event Timer Names"
  },
  "(0008,2133)": {
    tag: "(0008,2133)",
    vr: "SQ",
    vm: "1",
    name: "Event Timer Sequence"
  },
  "(0008,2134)": {
    tag: "(0008,2134)",
    vr: "FD",
    vm: "1",
    name: "Event Time Offset"
  },
  "(0008,2135)": {
    tag: "(0008,2135)",
    vr: "SQ",
    vm: "1",
    name: "Event Code Sequence"
  },
  "(0008,2142)": { tag: "(0008,2142)", vr: "IS", vm: "1", name: "Start Trim" },
  "(0008,2143)": { tag: "(0008,2143)", vr: "IS", vm: "1", name: "Stop Trim" },
  "(0008,2144)": {
    tag: "(0008,2144)",
    vr: "IS",
    vm: "1",
    name: "Recommended Display Frame Rate"
  },
  "(0008,2200)": {
    tag: "(0008,2200)",
    vr: "CS",
    vm: "1",
    name: "Transducer Position"
  },
  "(0008,2204)": {
    tag: "(0008,2204)",
    vr: "CS",
    vm: "1",
    name: "Transducer Orientation"
  },
  "(0008,2208)": {
    tag: "(0008,2208)",
    vr: "CS",
    vm: "1",
    name: "Anatomic Structure"
  },
  "(0008,2218)": {
    tag: "(0008,2218)",
    vr: "SQ",
    vm: "1",
    name: "Anatomic Region Sequence"
  },
  "(0008,2220)": {
    tag: "(0008,2220)",
    vr: "SQ",
    vm: "1",
    name: "Anatomic Region Modifier Sequence"
  },
  "(0008,2228)": {
    tag: "(0008,2228)",
    vr: "SQ",
    vm: "1",
    name: "Primary Anatomic Structure Sequence"
  },
  "(0008,2229)": {
    tag: "(0008,2229)",
    vr: "SQ",
    vm: "1",
    name: "Anatomic Structure Space Or Region Sequence"
  },
  "(0008,2230)": {
    tag: "(0008,2230)",
    vr: "SQ",
    vm: "1",
    name: "Primary Anatomic Structure Modifier Sequence"
  },
  "(0008,2240)": {
    tag: "(0008,2240)",
    vr: "SQ",
    vm: "1",
    name: "Transducer Position Sequence"
  },
  "(0008,2242)": {
    tag: "(0008,2242)",
    vr: "SQ",
    vm: "1",
    name: "Transducer Position Modifier Sequence"
  },
  "(0008,2244)": {
    tag: "(0008,2244)",
    vr: "SQ",
    vm: "1",
    name: "Transducer Orientation Sequence"
  },
  "(0008,2246)": {
    tag: "(0008,2246)",
    vr: "SQ",
    vm: "1",
    name: "Transducer Orientation Modifier Sequence"
  },
  "(0008,2251)": {
    tag: "(0008,2251)",
    vr: "SQ",
    vm: "1",
    name: "Anatomic Structure Space Or Region Code Sequence Trial"
  },
  "(0008,2253)": {
    tag: "(0008,2253)",
    vr: "SQ",
    vm: "1",
    name: "Anatomic Portal Of Entrance Code Sequence Trial"
  },
  "(0008,2255)": {
    tag: "(0008,2255)",
    vr: "SQ",
    vm: "1",
    name: "Anatomic Approach Direction Code Sequence Trial"
  },
  "(0008,2256)": {
    tag: "(0008,2256)",
    vr: "ST",
    vm: "1",
    name: "Anatomic Perspective Description Trial"
  },
  "(0008,2257)": {
    tag: "(0008,2257)",
    vr: "SQ",
    vm: "1",
    name: "Anatomic Perspective Code Sequence Trial"
  },
  "(0008,2258)": {
    tag: "(0008,2258)",
    vr: "ST",
    vm: "1",
    name: "Anatomic Location Of Examining Instrument Description Trial"
  },
  "(0008,2259)": {
    tag: "(0008,2259)",
    vr: "SQ",
    vm: "1",
    name: "Anatomic Location Of Examining Instrument Code Sequence Trial"
  },
  "(0008,225A)": {
    tag: "(0008,225A)",
    vr: "SQ",
    vm: "1",
    name: "Anatomic Structure Space Or Region Modifier Code Sequence Trial"
  },
  "(0008,225C)": {
    tag: "(0008,225C)",
    vr: "SQ",
    vm: "1",
    name: "On Axis Background Anatomic Structure Code Sequence Trial"
  },
  "(0008,3001)": {
    tag: "(0008,3001)",
    vr: "SQ",
    vm: "1",
    name: "Alternate Representation Sequence"
  },
  "(0008,3010)": {
    tag: "(0008,3010)",
    vr: "UI",
    vm: "1",
    name: "Irradiation Event UID"
  },
  "(0008,4000)": {
    tag: "(0008,4000)",
    vr: "LT",
    vm: "1",
    name: "Identifying Comments"
  },
  "(0008,9007)": { tag: "(0008,9007)", vr: "CS", vm: "4", name: "Frame Type" },
  "(0008,9092)": {
    tag: "(0008,9092)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Image Evidence Sequence"
  },
  "(0008,9121)": {
    tag: "(0008,9121)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Raw Data Sequence"
  },
  "(0008,9123)": {
    tag: "(0008,9123)",
    vr: "UI",
    vm: "1",
    name: "Creator Version UID"
  },
  "(0008,9124)": {
    tag: "(0008,9124)",
    vr: "SQ",
    vm: "1",
    name: "Derivation Image Sequence"
  },
  "(0008,9154)": {
    tag: "(0008,9154)",
    vr: "SQ",
    vm: "1",
    name: "Source Image Evidence Sequence"
  },
  "(0008,9205)": {
    tag: "(0008,9205)",
    vr: "CS",
    vm: "1",
    name: "Pixel Presentation"
  },
  "(0008,9206)": {
    tag: "(0008,9206)",
    vr: "CS",
    vm: "1",
    name: "Volumetric Properties"
  },
  "(0008,9207)": {
    tag: "(0008,9207)",
    vr: "CS",
    vm: "1",
    name: "Volume Based Calculation Technique"
  },
  "(0008,9208)": {
    tag: "(0008,9208)",
    vr: "CS",
    vm: "1",
    name: "Complex Image Component"
  },
  "(0008,9209)": {
    tag: "(0008,9209)",
    vr: "CS",
    vm: "1",
    name: "Acquisition Contrast"
  },
  "(0008,9215)": {
    tag: "(0008,9215)",
    vr: "SQ",
    vm: "1",
    name: "Derivation Code Sequence"
  },
  "(0008,9237)": {
    tag: "(0008,9237)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Presentation State Sequence"
  },
  "(0008,9410)": {
    tag: "(0008,9410)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Other Plane Sequence"
  },
  "(0008,9458)": {
    tag: "(0008,9458)",
    vr: "SQ",
    vm: "1",
    name: "Frame Display Sequence"
  },
  "(0008,9459)": {
    tag: "(0008,9459)",
    vr: "FL",
    vm: "1",
    name: "Recommended Display Frame Rate In Float"
  },
  "(0008,9460)": {
    tag: "(0008,9460)",
    vr: "CS",
    vm: "1",
    name: "Skip Frame Range Flag"
  },
  "(0010,0010)": {
    tag: "(0010,0010)",
    vr: "PN",
    vm: "1",
    name: "Patient Name"
  },
  "(0010,0020)": { tag: "(0010,0020)", vr: "LO", vm: "1", name: "Patient ID" },
  "(0010,0021)": {
    tag: "(0010,0021)",
    vr: "LO",
    vm: "1",
    name: "Issuer Of Patient ID"
  },
  "(0010,0022)": {
    tag: "(0010,0022)",
    vr: "CS",
    vm: "1",
    name: "Type Of Patient ID"
  },
  "(0010,0024)": {
    tag: "(0010,0024)",
    vr: "SQ",
    vm: "1",
    name: "Issuer Of Patient IDQualifiers Sequence"
  },
  "(0010,0030)": {
    tag: "(0010,0030)",
    vr: "DA",
    vm: "1",
    name: "Patient Birth Date"
  },
  "(0010,0032)": {
    tag: "(0010,0032)",
    vr: "TM",
    vm: "1",
    name: "Patient Birth Time"
  },
  "(0010,0040)": { tag: "(0010,0040)", vr: "CS", vm: "1", name: "Patient Sex" },
  "(0010,0050)": {
    tag: "(0010,0050)",
    vr: "SQ",
    vm: "1",
    name: "Patient Insurance Plan Code Sequence"
  },
  "(0010,0101)": {
    tag: "(0010,0101)",
    vr: "SQ",
    vm: "1",
    name: "Patient Primary Language Code Sequence"
  },
  "(0010,0102)": {
    tag: "(0010,0102)",
    vr: "SQ",
    vm: "1",
    name: "Patient Primary Language Modifier Code Sequence"
  },
  "(0010,1000)": {
    tag: "(0010,1000)",
    vr: "LO",
    vm: "1",
    name: "Other Patient IDs"
  },
  "(0010,1001)": {
    tag: "(0010,1001)",
    vr: "PN",
    vm: "1",
    name: "Other Patient Names"
  },
  "(0010,1002)": {
    tag: "(0010,1002)",
    vr: "SQ",
    vm: "1",
    name: "Other Patient IDs Sequence"
  },
  "(0010,1005)": {
    tag: "(0010,1005)",
    vr: "PN",
    vm: "1",
    name: "Patient Birth Name"
  },
  "(0010,1010)": { tag: "(0010,1010)", vr: "AS", vm: "1", name: "Patient Age" },
  "(0010,1020)": {
    tag: "(0010,1020)",
    vr: "DS",
    vm: "1",
    name: "Patient Size"
  },
  "(0010,1021)": {
    tag: "(0010,1021)",
    vr: "SQ",
    vm: "1",
    name: "Patient Size Code Sequence"
  },
  "(0010,1030)": {
    tag: "(0010,1030)",
    vr: "DS",
    vm: "1",
    name: "Patient Weight"
  },
  "(0010,1040)": {
    tag: "(0010,1040)",
    vr: "LO",
    vm: "1",
    name: "Patient Address"
  },
  "(0010,1050)": {
    tag: "(0010,1050)",
    vr: "LO",
    vm: "1",
    name: "Insurance Plan Identification"
  },
  "(0010,1060)": {
    tag: "(0010,1060)",
    vr: "PN",
    vm: "1",
    name: "Patient Mother Birth Name"
  },
  "(0010,1080)": {
    tag: "(0010,1080)",
    vr: "LO",
    vm: "1",
    name: "Military Rank"
  },
  "(0010,1081)": {
    tag: "(0010,1081)",
    vr: "LO",
    vm: "1",
    name: "Branch Of Service"
  },
  "(0010,1090)": {
    tag: "(0010,1090)",
    vr: "LO",
    vm: "1",
    name: "Medical Record Locator"
  },
  "(0010,2000)": {
    tag: "(0010,2000)",
    vr: "LO",
    vm: "1",
    name: "Medical Alerts"
  },
  "(0010,2110)": { tag: "(0010,2110)", vr: "LO", vm: "1", name: "Allergies" },
  "(0010,2150)": {
    tag: "(0010,2150)",
    vr: "LO",
    vm: "1",
    name: "Country Of Residence"
  },
  "(0010,2152)": {
    tag: "(0010,2152)",
    vr: "LO",
    vm: "1",
    name: "Region Of Residence"
  },
  "(0010,2154)": {
    tag: "(0010,2154)",
    vr: "SH",
    vm: "1",
    name: "Patient Telephone Numbers"
  },
  "(0010,2160)": {
    tag: "(0010,2160)",
    vr: "SH",
    vm: "1",
    name: "Ethnic Group"
  },
  "(0010,2180)": { tag: "(0010,2180)", vr: "SH", vm: "1", name: "Occupation" },
  "(0010,21A0)": {
    tag: "(0010,21A0)",
    vr: "CS",
    vm: "1",
    name: "Smoking Status"
  },
  "(0010,21B0)": {
    tag: "(0010,21B0)",
    vr: "LT",
    vm: "1",
    name: "Additional Patient History"
  },
  "(0010,21C0)": {
    tag: "(0010,21C0)",
    vr: "US",
    vm: "1",
    name: "Pregnancy Status"
  },
  "(0010,21D0)": {
    tag: "(0010,21D0)",
    vr: "DA",
    vm: "1",
    name: "Last Menstrual Date"
  },
  "(0010,21F0)": {
    tag: "(0010,21F0)",
    vr: "LO",
    vm: "1",
    name: "Patient Religious Preference"
  },
  "(0010,2201)": {
    tag: "(0010,2201)",
    vr: "LO",
    vm: "1",
    name: "Patient Species Description"
  },
  "(0010,2202)": {
    tag: "(0010,2202)",
    vr: "SQ",
    vm: "1",
    name: "Patient Species Code Sequence"
  },
  "(0010,2203)": {
    tag: "(0010,2203)",
    vr: "CS",
    vm: "1",
    name: "Patient Sex Neutered"
  },
  "(0010,2210)": {
    tag: "(0010,2210)",
    vr: "CS",
    vm: "1",
    name: "Anatomical Orientation Type"
  },
  "(0010,2292)": {
    tag: "(0010,2292)",
    vr: "LO",
    vm: "1",
    name: "Patient Breed Description"
  },
  "(0010,2293)": {
    tag: "(0010,2293)",
    vr: "SQ",
    vm: "1",
    name: "Patient Breed Code Sequence"
  },
  "(0010,2294)": {
    tag: "(0010,2294)",
    vr: "SQ",
    vm: "1",
    name: "Breed Registration Sequence"
  },
  "(0010,2295)": {
    tag: "(0010,2295)",
    vr: "LO",
    vm: "1",
    name: "Breed Registration Number"
  },
  "(0010,2296)": {
    tag: "(0010,2296)",
    vr: "SQ",
    vm: "1",
    name: "Breed Registry Code Sequence"
  },
  "(0010,2297)": {
    tag: "(0010,2297)",
    vr: "PN",
    vm: "1",
    name: "Responsible Person"
  },
  "(0010,2298)": {
    tag: "(0010,2298)",
    vr: "CS",
    vm: "1",
    name: "Responsible Person Role"
  },
  "(0010,2299)": {
    tag: "(0010,2299)",
    vr: "LO",
    vm: "1",
    name: "Responsible Organization"
  },
  "(0010,4000)": {
    tag: "(0010,4000)",
    vr: "LT",
    vm: "1",
    name: "Patient Comments"
  },
  "(0010,9431)": {
    tag: "(0010,9431)",
    vr: "FL",
    vm: "1",
    name: "Examined Body Thickness"
  },
  "(0012,0010)": {
    tag: "(0012,0010)",
    vr: "LO",
    vm: "1",
    name: "Clinical Trial Sponsor Name"
  },
  "(0012,0020)": {
    tag: "(0012,0020)",
    vr: "LO",
    vm: "1",
    name: "Clinical Trial Protocol ID"
  },
  "(0012,0021)": {
    tag: "(0012,0021)",
    vr: "LO",
    vm: "1",
    name: "Clinical Trial Protocol Name"
  },
  "(0012,0030)": {
    tag: "(0012,0030)",
    vr: "LO",
    vm: "1",
    name: "Clinical Trial Site ID"
  },
  "(0012,0031)": {
    tag: "(0012,0031)",
    vr: "LO",
    vm: "1",
    name: "Clinical Trial Site Name"
  },
  "(0012,0040)": {
    tag: "(0012,0040)",
    vr: "LO",
    vm: "1",
    name: "Clinical Trial Subject ID"
  },
  "(0012,0042)": {
    tag: "(0012,0042)",
    vr: "LO",
    vm: "1",
    name: "Clinical Trial Subject Reading ID"
  },
  "(0012,0050)": {
    tag: "(0012,0050)",
    vr: "LO",
    vm: "1",
    name: "Clinical Trial Time Point ID"
  },
  "(0012,0051)": {
    tag: "(0012,0051)",
    vr: "ST",
    vm: "1",
    name: "Clinical Trial Time Point Description"
  },
  "(0012,0060)": {
    tag: "(0012,0060)",
    vr: "LO",
    vm: "1",
    name: "Clinical Trial Coordinating Center Name"
  },
  "(0012,0062)": {
    tag: "(0012,0062)",
    vr: "CS",
    vm: "1",
    name: "Patient Identity Removed"
  },
  "(0012,0063)": {
    tag: "(0012,0063)",
    vr: "LO",
    vm: "1",
    name: "Deidentification Method"
  },
  "(0012,0064)": {
    tag: "(0012,0064)",
    vr: "SQ",
    vm: "1",
    name: "Deidentification Method Code Sequence"
  },
  "(0012,0071)": {
    tag: "(0012,0071)",
    vr: "LO",
    vm: "1",
    name: "Clinical Trial Series ID"
  },
  "(0012,0072)": {
    tag: "(0012,0072)",
    vr: "LO",
    vm: "1",
    name: "Clinical Trial Series Description"
  },
  "(0012,0081)": {
    tag: "(0012,0081)",
    vr: "LO",
    vm: "1",
    name: "Clinical Trial Protocol Ethics Committee Name"
  },
  "(0012,0082)": {
    tag: "(0012,0082)",
    vr: "LO",
    vm: "1",
    name: "Clinical Trial Protocol Ethics Committee Approval Number"
  },
  "(0012,0083)": {
    tag: "(0012,0083)",
    vr: "SQ",
    vm: "1",
    name: "Consent For Clinical Trial Use Sequence"
  },
  "(0012,0084)": {
    tag: "(0012,0084)",
    vr: "CS",
    vm: "1",
    name: "Distribution Type"
  },
  "(0012,0085)": {
    tag: "(0012,0085)",
    vr: "CS",
    vm: "1",
    name: "Consent For Distribution Flag"
  },
  "(0014,0023)": {
    tag: "(0014,0023)",
    vr: "ST",
    vm: "1",
    name: "CADFile Format"
  },
  "(0014,0024)": {
    tag: "(0014,0024)",
    vr: "ST",
    vm: "1",
    name: "Component Reference System"
  },
  "(0014,0025)": {
    tag: "(0014,0025)",
    vr: "ST",
    vm: "1",
    name: "Component Manufacturing Procedure"
  },
  "(0014,0028)": {
    tag: "(0014,0028)",
    vr: "ST",
    vm: "1",
    name: "Component Manufacturer"
  },
  "(0014,0030)": {
    tag: "(0014,0030)",
    vr: "DS",
    vm: "1",
    name: "Material Thickness"
  },
  "(0014,0032)": {
    tag: "(0014,0032)",
    vr: "DS",
    vm: "1",
    name: "Material Pipe Diameter"
  },
  "(0014,0034)": {
    tag: "(0014,0034)",
    vr: "DS",
    vm: "1",
    name: "Material Isolation Diameter"
  },
  "(0014,0042)": {
    tag: "(0014,0042)",
    vr: "ST",
    vm: "1",
    name: "Material Grade"
  },
  "(0014,0044)": {
    tag: "(0014,0044)",
    vr: "ST",
    vm: "1",
    name: "Material Properties File ID"
  },
  "(0014,0045)": {
    tag: "(0014,0045)",
    vr: "ST",
    vm: "1",
    name: "Material Properties File Format"
  },
  "(0014,0046)": {
    tag: "(0014,0046)",
    vr: "LT",
    vm: "1",
    name: "Material Notes"
  },
  "(0014,0050)": {
    tag: "(0014,0050)",
    vr: "CS",
    vm: "1",
    name: "Component Shape"
  },
  "(0014,0052)": {
    tag: "(0014,0052)",
    vr: "CS",
    vm: "1",
    name: "Curvature Type"
  },
  "(0014,0054)": {
    tag: "(0014,0054)",
    vr: "DS",
    vm: "1",
    name: "Outer Diameter"
  },
  "(0014,0056)": {
    tag: "(0014,0056)",
    vr: "DS",
    vm: "1",
    name: "Inner Diameter"
  },
  "(0014,1010)": {
    tag: "(0014,1010)",
    vr: "ST",
    vm: "1",
    name: "Actual Environmental Conditions"
  },
  "(0014,1020)": { tag: "(0014,1020)", vr: "DA", vm: "1", name: "Expiry Date" },
  "(0014,1040)": {
    tag: "(0014,1040)",
    vr: "ST",
    vm: "1",
    name: "Environmental Conditions"
  },
  "(0014,2002)": {
    tag: "(0014,2002)",
    vr: "SQ",
    vm: "1",
    name: "Evaluator Sequence"
  },
  "(0014,2004)": {
    tag: "(0014,2004)",
    vr: "IS",
    vm: "1",
    name: "Evaluator Number"
  },
  "(0014,2006)": {
    tag: "(0014,2006)",
    vr: "PN",
    vm: "1",
    name: "Evaluator Name"
  },
  "(0014,2008)": {
    tag: "(0014,2008)",
    vr: "IS",
    vm: "1",
    name: "Evaluation Attempt"
  },
  "(0014,2012)": {
    tag: "(0014,2012)",
    vr: "SQ",
    vm: "1",
    name: "Indication Sequence"
  },
  "(0014,2014)": {
    tag: "(0014,2014)",
    vr: "IS",
    vm: "1",
    name: "Indication Number "
  },
  "(0014,2016)": {
    tag: "(0014,2016)",
    vr: "SH",
    vm: "1",
    name: "Indication Label"
  },
  "(0014,2018)": {
    tag: "(0014,2018)",
    vr: "ST",
    vm: "1",
    name: "Indication Description"
  },
  "(0014,201A)": {
    tag: "(0014,201A)",
    vr: "CS",
    vm: "1",
    name: "Indication Type"
  },
  "(0014,201C)": {
    tag: "(0014,201C)",
    vr: "CS",
    vm: "1",
    name: "Indication Disposition"
  },
  "(0014,201E)": {
    tag: "(0014,201E)",
    vr: "SQ",
    vm: "1",
    name: "Indication ROISequence"
  },
  "(0014,2030)": {
    tag: "(0014,2030)",
    vr: "SQ",
    vm: "1",
    name: "Indication Physical Property Sequence"
  },
  "(0014,2032)": {
    tag: "(0014,2032)",
    vr: "SH",
    vm: "1",
    name: "Property Label"
  },
  "(0014,2202)": {
    tag: "(0014,2202)",
    vr: "IS",
    vm: "1",
    name: "Coordinate System Number Of Axes "
  },
  "(0014,2204)": {
    tag: "(0014,2204)",
    vr: "SQ",
    vm: "1",
    name: "Coordinate System Axes Sequence"
  },
  "(0014,2206)": {
    tag: "(0014,2206)",
    vr: "ST",
    vm: "1",
    name: "Coordinate System Axis Description"
  },
  "(0014,2208)": {
    tag: "(0014,2208)",
    vr: "CS",
    vm: "1",
    name: "Coordinate System Data Set Mapping"
  },
  "(0014,220A)": {
    tag: "(0014,220A)",
    vr: "IS",
    vm: "1",
    name: "Coordinate System Axis Number"
  },
  "(0014,220C)": {
    tag: "(0014,220C)",
    vr: "CS",
    vm: "1",
    name: "Coordinate System Axis Type"
  },
  "(0014,220E)": {
    tag: "(0014,220E)",
    vr: "CS",
    vm: "1",
    name: "Coordinate System Axis Units"
  },
  "(0014,2210)": {
    tag: "(0014,2210)",
    vr: "OB",
    vm: "1",
    name: "Coordinate System Axis Values"
  },
  "(0014,2220)": {
    tag: "(0014,2220)",
    vr: "SQ",
    vm: "1",
    name: "Coordinate System Transform Sequence"
  },
  "(0014,2222)": {
    tag: "(0014,2222)",
    vr: "ST",
    vm: "1",
    name: "Transform Description"
  },
  "(0014,2224)": {
    tag: "(0014,2224)",
    vr: "IS",
    vm: "1",
    name: "Transform Number Of Axes"
  },
  "(0014,2226)": {
    tag: "(0014,2226)",
    vr: "IS",
    vm: "1",
    name: "Transform Order Of Axes"
  },
  "(0014,2228)": {
    tag: "(0014,2228)",
    vr: "CS",
    vm: "1",
    name: "Transformed Axis Units"
  },
  "(0014,222A)": {
    tag: "(0014,222A)",
    vr: "DS",
    vm: "1",
    name: "Coordinate System Transform Rotation And Scale Matrix"
  },
  "(0014,222C)": {
    tag: "(0014,222C)",
    vr: "DS",
    vm: "1",
    name: "Coordinate System Transform Translation Matrix"
  },
  "(0014,3011)": {
    tag: "(0014,3011)",
    vr: "DS",
    vm: "1",
    name: "Internal Detector Frame Time"
  },
  "(0014,3012)": {
    tag: "(0014,3012)",
    vr: "DS",
    vm: "1",
    name: "Number Of Frames Integrated"
  },
  "(0014,3020)": {
    tag: "(0014,3020)",
    vr: "SQ",
    vm: "1",
    name: "Detector Temperature Sequence"
  },
  "(0014,3022)": { tag: "(0014,3022)", vr: "DS", vm: "1", name: "Sensor Name" },
  "(0014,3024)": {
    tag: "(0014,3024)",
    vr: "DS",
    vm: "1",
    name: "Horizontal Offset Of Sensor"
  },
  "(0014,3026)": {
    tag: "(0014,3026)",
    vr: "DS",
    vm: "1",
    name: "Vertical Offset Of Sensor"
  },
  "(0014,3028)": {
    tag: "(0014,3028)",
    vr: "DS",
    vm: "1",
    name: "Sensor Temperature"
  },
  "(0014,3040)": {
    tag: "(0014,3040)",
    vr: "SQ",
    vm: "1",
    name: "Dark Current Sequence"
  },
  "(0014,3050)": {
    tag: "(0014,3050)",
    vr: "OB|OW",
    vm: "1",
    name: "Dark Current Counts"
  },
  "(0014,3060)": {
    tag: "(0014,3060)",
    vr: "SQ",
    vm: "1",
    name: "Gain Correction Reference Sequence"
  },
  "(0014,3070)": {
    tag: "(0014,3070)",
    vr: "OB|OW",
    vm: "1",
    name: "Air Counts"
  },
  "(0014,3071)": {
    tag: "(0014,3071)",
    vr: "DS",
    vm: "1",
    name: "KVUsed In Gain Calibration"
  },
  "(0014,3072)": {
    tag: "(0014,3072)",
    vr: "DS",
    vm: "1",
    name: "MAUsed In Gain Calibration"
  },
  "(0014,3073)": {
    tag: "(0014,3073)",
    vr: "DS",
    vm: "1",
    name: "Number Of Frames Used For Integration"
  },
  "(0014,3074)": {
    tag: "(0014,3074)",
    vr: "LO",
    vm: "1",
    name: "Filter Material Used In Gain Calibration"
  },
  "(0014,3075)": {
    tag: "(0014,3075)",
    vr: "DS",
    vm: "1",
    name: "Filter Thickness Used In Gain Calibration"
  },
  "(0014,3076)": {
    tag: "(0014,3076)",
    vr: "DA",
    vm: "1",
    name: "Date Of Gain Calibration"
  },
  "(0014,3077)": {
    tag: "(0014,3077)",
    vr: "TM",
    vm: "1",
    name: "Time Of Gain Calibration"
  },
  "(0014,3080)": {
    tag: "(0014,3080)",
    vr: "OB",
    vm: "1",
    name: "Bad Pixel Image"
  },
  "(0014,3099)": {
    tag: "(0014,3099)",
    vr: "LT",
    vm: "1",
    name: "Calibration Notes"
  },
  "(0014,4002)": {
    tag: "(0014,4002)",
    vr: "SQ",
    vm: "1",
    name: "Pulser Equipment Sequence"
  },
  "(0014,4004)": { tag: "(0014,4004)", vr: "CS", vm: "1", name: "Pulser Type" },
  "(0014,4006)": {
    tag: "(0014,4006)",
    vr: "LT",
    vm: "1",
    name: "Pulser Notes"
  },
  "(0014,4008)": {
    tag: "(0014,4008)",
    vr: "SQ",
    vm: "1",
    name: "Receiver Equipment Sequence"
  },
  "(0014,400A)": {
    tag: "(0014,400A)",
    vr: "CS",
    vm: "1",
    name: "Amplifier Type"
  },
  "(0014,400C)": {
    tag: "(0014,400C)",
    vr: "LT",
    vm: "1",
    name: "Receiver Notes"
  },
  "(0014,400E)": {
    tag: "(0014,400E)",
    vr: "SQ",
    vm: "1",
    name: "Pre Amplifier Equipment Sequence"
  },
  "(0014,400F)": {
    tag: "(0014,400F)",
    vr: "LT",
    vm: "1",
    name: "Pre Amplifier Notes"
  },
  "(0014,4010)": {
    tag: "(0014,4010)",
    vr: "SQ",
    vm: "1",
    name: "Transmit Transducer Sequence"
  },
  "(0014,4011)": {
    tag: "(0014,4011)",
    vr: "SQ",
    vm: "1",
    name: "Receive Transducer Sequence"
  },
  "(0014,4012)": {
    tag: "(0014,4012)",
    vr: "US",
    vm: "1",
    name: "Number Of Elements"
  },
  "(0014,4013)": {
    tag: "(0014,4013)",
    vr: "CS",
    vm: "1",
    name: "Element Shape"
  },
  "(0014,4014)": {
    tag: "(0014,4014)",
    vr: "DS",
    vm: "1",
    name: "Element Dimension A"
  },
  "(0014,4015)": {
    tag: "(0014,4015)",
    vr: "DS",
    vm: "1",
    name: "Element Dimension B"
  },
  "(0014,4016)": {
    tag: "(0014,4016)",
    vr: "DS",
    vm: "1",
    name: "Element Pitch"
  },
  "(0014,4017)": {
    tag: "(0014,4017)",
    vr: "DS",
    vm: "1",
    name: "Measured Beam Dimension A"
  },
  "(0014,4018)": {
    tag: "(0014,4018)",
    vr: "DS",
    vm: "1",
    name: "Measured Beam Dimension B"
  },
  "(0014,4019)": {
    tag: "(0014,4019)",
    vr: "DS",
    vm: "1",
    name: "Location Of Measured Beam Diameter"
  },
  "(0014,401A)": {
    tag: "(0014,401A)",
    vr: "DS",
    vm: "1",
    name: "Nominal Frequency"
  },
  "(0014,401B)": {
    tag: "(0014,401B)",
    vr: "DS",
    vm: "1",
    name: "Measured Center Frequency"
  },
  "(0014,401C)": {
    tag: "(0014,401C)",
    vr: "DS",
    vm: "1",
    name: "Measured Bandwidth"
  },
  "(0014,4020)": {
    tag: "(0014,4020)",
    vr: "SQ",
    vm: "1",
    name: "Pulser Settings Sequence"
  },
  "(0014,4022)": { tag: "(0014,4022)", vr: "DS", vm: "1", name: "Pulse Width" },
  "(0014,4024)": {
    tag: "(0014,4024)",
    vr: "DS",
    vm: "1",
    name: "Excitation Frequency"
  },
  "(0014,4026)": {
    tag: "(0014,4026)",
    vr: "CS",
    vm: "1",
    name: "Modulation Type"
  },
  "(0014,4028)": { tag: "(0014,4028)", vr: "DS", vm: "1", name: "Damping" },
  "(0014,4030)": {
    tag: "(0014,4030)",
    vr: "SQ",
    vm: "1",
    name: "Receiver Settings Sequence"
  },
  "(0014,4031)": {
    tag: "(0014,4031)",
    vr: "DS",
    vm: "1",
    name: "Acquired Soundpath Length"
  },
  "(0014,4032)": {
    tag: "(0014,4032)",
    vr: "CS",
    vm: "1",
    name: "Acquisition Compression Type"
  },
  "(0014,4033)": {
    tag: "(0014,4033)",
    vr: "IS",
    vm: "1",
    name: "Acquisition Sample Size"
  },
  "(0014,4034)": {
    tag: "(0014,4034)",
    vr: "DS",
    vm: "1",
    name: "Rectifier Smoothing"
  },
  "(0014,4035)": { tag: "(0014,4035)", vr: "SQ", vm: "1", name: "DACSequence" },
  "(0014,4036)": { tag: "(0014,4036)", vr: "CS", vm: "1", name: "DACType" },
  "(0014,4038)": {
    tag: "(0014,4038)",
    vr: "DS",
    vm: "1",
    name: "DACGain Points"
  },
  "(0014,403A)": {
    tag: "(0014,403A)",
    vr: "DS",
    vm: "1",
    name: "DACTime Points"
  },
  "(0014,403C)": {
    tag: "(0014,403C)",
    vr: "DS",
    vm: "1",
    name: "DACAmplitude"
  },
  "(0014,4040)": {
    tag: "(0014,4040)",
    vr: "SQ",
    vm: "1",
    name: "Pre Amplifier Settings Sequence"
  },
  "(0014,4050)": {
    tag: "(0014,4050)",
    vr: "SQ",
    vm: "1",
    name: "Transmit Transducer Settings Sequence"
  },
  "(0014,4051)": {
    tag: "(0014,4051)",
    vr: "SQ",
    vm: "1",
    name: "Receive Transducer Settings Sequence"
  },
  "(0014,4052)": {
    tag: "(0014,4052)",
    vr: "DS",
    vm: "1",
    name: "Incident Angle"
  },
  "(0014,4054)": {
    tag: "(0014,4054)",
    vr: "ST",
    vm: "1",
    name: "Coupling Technique"
  },
  "(0014,4056)": {
    tag: "(0014,4056)",
    vr: "ST",
    vm: "1",
    name: "Coupling Medium"
  },
  "(0014,4057)": {
    tag: "(0014,4057)",
    vr: "DS",
    vm: "1",
    name: "Coupling Velocity"
  },
  "(0014,4058)": {
    tag: "(0014,4058)",
    vr: "DS",
    vm: "1",
    name: "Crystal Center Location X"
  },
  "(0014,4059)": {
    tag: "(0014,4059)",
    vr: "DS",
    vm: "1",
    name: "Crystal Center Location Z"
  },
  "(0014,405A)": {
    tag: "(0014,405A)",
    vr: "DS",
    vm: "1",
    name: "Sound Path Length"
  },
  "(0014,405C)": {
    tag: "(0014,405C)",
    vr: "ST",
    vm: "1",
    name: "Delay Law Identifier"
  },
  "(0014,4060)": {
    tag: "(0014,4060)",
    vr: "SQ",
    vm: "1",
    name: "Gate Settings Sequence"
  },
  "(0014,4062)": {
    tag: "(0014,4062)",
    vr: "DS",
    vm: "1",
    name: "Gate Threshold"
  },
  "(0014,4064)": {
    tag: "(0014,4064)",
    vr: "DS",
    vm: "1",
    name: "Velocity Of Sound"
  },
  "(0014,4070)": {
    tag: "(0014,4070)",
    vr: "SQ",
    vm: "1",
    name: "Calibration Settings Sequence"
  },
  "(0014,4072)": {
    tag: "(0014,4072)",
    vr: "ST",
    vm: "1",
    name: "Calibration Procedure"
  },
  "(0014,4074)": {
    tag: "(0014,4074)",
    vr: "SH",
    vm: "1",
    name: "Procedure Version"
  },
  "(0014,4076)": {
    tag: "(0014,4076)",
    vr: "DA",
    vm: "1",
    name: "Procedure Creation Date"
  },
  "(0014,4078)": {
    tag: "(0014,4078)",
    vr: "DA",
    vm: "1",
    name: "Procedure Expiration Date"
  },
  "(0014,407A)": {
    tag: "(0014,407A)",
    vr: "DA",
    vm: "1",
    name: "Procedure Last Modified Date"
  },
  "(0014,407C)": {
    tag: "(0014,407C)",
    vr: "TM",
    vm: "1",
    name: "Calibration Time"
  },
  "(0014,407E)": {
    tag: "(0014,407E)",
    vr: "DA",
    vm: "1",
    name: "Calibration Date"
  },
  "(0014,5002)": { tag: "(0014,5002)", vr: "IS", vm: "1", name: "LINACEnergy" },
  "(0014,5004)": { tag: "(0014,5004)", vr: "IS", vm: "1", name: "LINACOutput" },
  "(0018,0010)": {
    tag: "(0018,0010)",
    vr: "LO",
    vm: "1",
    name: "Contrast Bolus Agent"
  },
  "(0018,0012)": {
    tag: "(0018,0012)",
    vr: "SQ",
    vm: "1",
    name: "Contrast Bolus Agent Sequence"
  },
  "(0018,0014)": {
    tag: "(0018,0014)",
    vr: "SQ",
    vm: "1",
    name: "Contrast Bolus Administration Route Sequence"
  },
  "(0018,0015)": {
    tag: "(0018,0015)",
    vr: "CS",
    vm: "1",
    name: "Body Part Examined"
  },
  "(0018,0020)": {
    tag: "(0018,0020)",
    vr: "CS",
    vm: "1",
    name: "Scanning Sequence"
  },
  "(0018,0021)": {
    tag: "(0018,0021)",
    vr: "CS",
    vm: "1",
    name: "Sequence Variant"
  },
  "(0018,0022)": {
    tag: "(0018,0022)",
    vr: "CS",
    vm: "1",
    name: "Scan Options"
  },
  "(0018,0023)": {
    tag: "(0018,0023)",
    vr: "CS",
    vm: "1",
    name: "MRAcquisition Type"
  },
  "(0018,0024)": {
    tag: "(0018,0024)",
    vr: "SH",
    vm: "1",
    name: "Sequence Name"
  },
  "(0018,0025)": { tag: "(0018,0025)", vr: "CS", vm: "1", name: "Angio Flag" },
  "(0018,0026)": {
    tag: "(0018,0026)",
    vr: "SQ",
    vm: "1",
    name: "Intervention Drug Information Sequence"
  },
  "(0018,0027)": {
    tag: "(0018,0027)",
    vr: "TM",
    vm: "1",
    name: "Intervention Drug Stop Time"
  },
  "(0018,0028)": {
    tag: "(0018,0028)",
    vr: "DS",
    vm: "1",
    name: "Intervention Drug Dose"
  },
  "(0018,0029)": {
    tag: "(0018,0029)",
    vr: "SQ",
    vm: "1",
    name: "Intervention Drug Code Sequence"
  },
  "(0018,002A)": {
    tag: "(0018,002A)",
    vr: "SQ",
    vm: "1",
    name: "Additional Drug Sequence"
  },
  "(0018,0030)": {
    tag: "(0018,0030)",
    vr: "LO",
    vm: "1",
    name: "Radionuclide"
  },
  "(0018,0031)": {
    tag: "(0018,0031)",
    vr: "LO",
    vm: "1",
    name: "Radiopharmaceutical"
  },
  "(0018,0032)": {
    tag: "(0018,0032)",
    vr: "DS",
    vm: "1",
    name: "Energy Window Centerline"
  },
  "(0018,0033)": {
    tag: "(0018,0033)",
    vr: "DS",
    vm: "1",
    name: "Energy Window Total Width"
  },
  "(0018,0034)": {
    tag: "(0018,0034)",
    vr: "LO",
    vm: "1",
    name: "Intervention Drug Name"
  },
  "(0018,0035)": {
    tag: "(0018,0035)",
    vr: "TM",
    vm: "1",
    name: "Intervention Drug Start Time"
  },
  "(0018,0036)": {
    tag: "(0018,0036)",
    vr: "SQ",
    vm: "1",
    name: "Intervention Sequence"
  },
  "(0018,0037)": {
    tag: "(0018,0037)",
    vr: "CS",
    vm: "1",
    name: "Therapy Type"
  },
  "(0018,0038)": {
    tag: "(0018,0038)",
    vr: "CS",
    vm: "1",
    name: "Intervention Status"
  },
  "(0018,0039)": {
    tag: "(0018,0039)",
    vr: "CS",
    vm: "1",
    name: "Therapy Description"
  },
  "(0018,003A)": {
    tag: "(0018,003A)",
    vr: "ST",
    vm: "1",
    name: "Intervention Description"
  },
  "(0018,0040)": { tag: "(0018,0040)", vr: "IS", vm: "1", name: "Cine Rate" },
  "(0018,0042)": {
    tag: "(0018,0042)",
    vr: "CS",
    vm: "1",
    name: "Initial Cine Run State"
  },
  "(0018,0050)": {
    tag: "(0018,0050)",
    vr: "DS",
    vm: "1",
    name: "Slice Thickness"
  },
  "(0018,0060)": { tag: "(0018,0060)", vr: "DS", vm: "1", name: "KVP" },
  "(0018,0070)": {
    tag: "(0018,0070)",
    vr: "IS",
    vm: "1",
    name: "Counts Accumulated"
  },
  "(0018,0071)": {
    tag: "(0018,0071)",
    vr: "CS",
    vm: "1",
    name: "Acquisition Termination Condition"
  },
  "(0018,0072)": {
    tag: "(0018,0072)",
    vr: "DS",
    vm: "1",
    name: "Effective Duration"
  },
  "(0018,0073)": {
    tag: "(0018,0073)",
    vr: "CS",
    vm: "1",
    name: "Acquisition Start Condition"
  },
  "(0018,0074)": {
    tag: "(0018,0074)",
    vr: "IS",
    vm: "1",
    name: "Acquisition Start Condition Data"
  },
  "(0018,0075)": {
    tag: "(0018,0075)",
    vr: "IS",
    vm: "1",
    name: "Acquisition Termination Condition Data"
  },
  "(0018,0080)": {
    tag: "(0018,0080)",
    vr: "DS",
    vm: "1",
    name: "Repetition Time"
  },
  "(0018,0081)": { tag: "(0018,0081)", vr: "DS", vm: "1", name: "Echo Time" },
  "(0018,0082)": {
    tag: "(0018,0082)",
    vr: "DS",
    vm: "1",
    name: "Inversion Time"
  },
  "(0018,0083)": {
    tag: "(0018,0083)",
    vr: "DS",
    vm: "1",
    name: "Number Of Averages"
  },
  "(0018,0084)": {
    tag: "(0018,0084)",
    vr: "DS",
    vm: "1",
    name: "Imaging Frequency"
  },
  "(0018,0085)": {
    tag: "(0018,0085)",
    vr: "SH",
    vm: "1",
    name: "Imaged Nucleus"
  },
  "(0018,0086)": {
    tag: "(0018,0086)",
    vr: "IS",
    vm: "1",
    name: "Echo Numbers"
  },
  "(0018,0087)": {
    tag: "(0018,0087)",
    vr: "DS",
    vm: "1",
    name: "Magnetic Field Strength"
  },
  "(0018,0088)": {
    tag: "(0018,0088)",
    vr: "DS",
    vm: "1",
    name: "Spacing Between Slices"
  },
  "(0018,0089)": {
    tag: "(0018,0089)",
    vr: "IS",
    vm: "1",
    name: "Number Of Phase Encoding Steps"
  },
  "(0018,0090)": {
    tag: "(0018,0090)",
    vr: "DS",
    vm: "1",
    name: "Data Collection Diameter"
  },
  "(0018,0091)": {
    tag: "(0018,0091)",
    vr: "IS",
    vm: "1",
    name: "Echo Train Length"
  },
  "(0018,0093)": {
    tag: "(0018,0093)",
    vr: "DS",
    vm: "1",
    name: "Percent Sampling"
  },
  "(0018,0094)": {
    tag: "(0018,0094)",
    vr: "DS",
    vm: "1",
    name: "Percent Phase Field Of View"
  },
  "(0018,0095)": {
    tag: "(0018,0095)",
    vr: "DS",
    vm: "1",
    name: "Pixel Bandwidth"
  },
  "(0018,1000)": {
    tag: "(0018,1000)",
    vr: "LO",
    vm: "1",
    name: "Device Serial Number"
  },
  "(0018,1002)": { tag: "(0018,1002)", vr: "UI", vm: "1", name: "Device UID" },
  "(0018,1003)": { tag: "(0018,1003)", vr: "LO", vm: "1", name: "Device ID" },
  "(0018,1004)": { tag: "(0018,1004)", vr: "LO", vm: "1", name: "Plate ID" },
  "(0018,1005)": {
    tag: "(0018,1005)",
    vr: "LO",
    vm: "1",
    name: "Generator ID"
  },
  "(0018,1006)": { tag: "(0018,1006)", vr: "LO", vm: "1", name: "Grid ID" },
  "(0018,1007)": { tag: "(0018,1007)", vr: "LO", vm: "1", name: "Cassette ID" },
  "(0018,1008)": { tag: "(0018,1008)", vr: "LO", vm: "1", name: "Gantry ID" },
  "(0018,1010)": {
    tag: "(0018,1010)",
    vr: "LO",
    vm: "1",
    name: "Secondary Capture Device ID"
  },
  "(0018,1011)": {
    tag: "(0018,1011)",
    vr: "LO",
    vm: "1",
    name: "Hardcopy Creation Device ID"
  },
  "(0018,1012)": {
    tag: "(0018,1012)",
    vr: "DA",
    vm: "1",
    name: "Date Of Secondary Capture"
  },
  "(0018,1014)": {
    tag: "(0018,1014)",
    vr: "TM",
    vm: "1",
    name: "Time Of Secondary Capture"
  },
  "(0018,1016)": {
    tag: "(0018,1016)",
    vr: "LO",
    vm: "1",
    name: "Secondary Capture Device Manufacturer"
  },
  "(0018,1017)": {
    tag: "(0018,1017)",
    vr: "LO",
    vm: "1",
    name: "Hardcopy Device Manufacturer"
  },
  "(0018,1018)": {
    tag: "(0018,1018)",
    vr: "LO",
    vm: "1",
    name: "Secondary Capture Device Manufacturer Model Name"
  },
  "(0018,1019)": {
    tag: "(0018,1019)",
    vr: "LO",
    vm: "1",
    name: "Secondary Capture Device Software Versions"
  },
  "(0018,101A)": {
    tag: "(0018,101A)",
    vr: "LO",
    vm: "1",
    name: "Hardcopy Device Software Version"
  },
  "(0018,101B)": {
    tag: "(0018,101B)",
    vr: "LO",
    vm: "1",
    name: "Hardcopy Device Manufacturer Model Name"
  },
  "(0018,1020)": {
    tag: "(0018,1020)",
    vr: "LO",
    vm: "1",
    name: "Software Versions"
  },
  "(0018,1022)": {
    tag: "(0018,1022)",
    vr: "SH",
    vm: "1",
    name: "Video Image Format Acquired"
  },
  "(0018,1023)": {
    tag: "(0018,1023)",
    vr: "LO",
    vm: "1",
    name: "Digital Image Format Acquired"
  },
  "(0018,1030)": {
    tag: "(0018,1030)",
    vr: "LO",
    vm: "1",
    name: "Protocol Name"
  },
  "(0018,1040)": {
    tag: "(0018,1040)",
    vr: "LO",
    vm: "1",
    name: "Contrast Bolus Route"
  },
  "(0018,1041)": {
    tag: "(0018,1041)",
    vr: "DS",
    vm: "1",
    name: "Contrast Bolus Volume"
  },
  "(0018,1042)": {
    tag: "(0018,1042)",
    vr: "TM",
    vm: "1",
    name: "Contrast Bolus Start Time"
  },
  "(0018,1043)": {
    tag: "(0018,1043)",
    vr: "TM",
    vm: "1",
    name: "Contrast Bolus Stop Time"
  },
  "(0018,1044)": {
    tag: "(0018,1044)",
    vr: "DS",
    vm: "1",
    name: "Contrast Bolus Total Dose"
  },
  "(0018,1045)": {
    tag: "(0018,1045)",
    vr: "IS",
    vm: "1",
    name: "Syringe Counts"
  },
  "(0018,1046)": {
    tag: "(0018,1046)",
    vr: "DS",
    vm: "1",
    name: "Contrast Flow Rate"
  },
  "(0018,1047)": {
    tag: "(0018,1047)",
    vr: "DS",
    vm: "1",
    name: "Contrast Flow Duration"
  },
  "(0018,1048)": {
    tag: "(0018,1048)",
    vr: "CS",
    vm: "1",
    name: "Contrast Bolus Ingredient"
  },
  "(0018,1049)": {
    tag: "(0018,1049)",
    vr: "DS",
    vm: "1",
    name: "Contrast Bolus Ingredient Concentration"
  },
  "(0018,1050)": {
    tag: "(0018,1050)",
    vr: "DS",
    vm: "1",
    name: "Spatial Resolution"
  },
  "(0018,1060)": {
    tag: "(0018,1060)",
    vr: "DS",
    vm: "1",
    name: "Trigger Time"
  },
  "(0018,1061)": {
    tag: "(0018,1061)",
    vr: "LO",
    vm: "1",
    name: "Trigger Source Or Type"
  },
  "(0018,1062)": {
    tag: "(0018,1062)",
    vr: "IS",
    vm: "1",
    name: "Nominal Interval"
  },
  "(0018,1063)": { tag: "(0018,1063)", vr: "DS", vm: "1", name: "Frame Time" },
  "(0018,1064)": {
    tag: "(0018,1064)",
    vr: "LO",
    vm: "1",
    name: "Cardiac Framing Type"
  },
  "(0018,1065)": {
    tag: "(0018,1065)",
    vr: "DS",
    vm: "1",
    name: "Frame Time Vector"
  },
  "(0018,1066)": { tag: "(0018,1066)", vr: "DS", vm: "1", name: "Frame Delay" },
  "(0018,1067)": {
    tag: "(0018,1067)",
    vr: "DS",
    vm: "1",
    name: "Image Trigger Delay"
  },
  "(0018,1068)": {
    tag: "(0018,1068)",
    vr: "DS",
    vm: "1",
    name: "Multiplex Group Time Offset"
  },
  "(0018,1069)": {
    tag: "(0018,1069)",
    vr: "DS",
    vm: "1",
    name: "Trigger Time Offset"
  },
  "(0018,106A)": {
    tag: "(0018,106A)",
    vr: "CS",
    vm: "1",
    name: "Synchronization Trigger"
  },
  "(0018,106C)": {
    tag: "(0018,106C)",
    vr: "US",
    vm: "2",
    name: "Synchronization Channel"
  },
  "(0018,106E)": {
    tag: "(0018,106E)",
    vr: "UL",
    vm: "1",
    name: "Trigger Sample Position"
  },
  "(0018,1070)": {
    tag: "(0018,1070)",
    vr: "LO",
    vm: "1",
    name: "Radiopharmaceutical Route"
  },
  "(0018,1071)": {
    tag: "(0018,1071)",
    vr: "DS",
    vm: "1",
    name: "Radiopharmaceutical Volume"
  },
  "(0018,1072)": {
    tag: "(0018,1072)",
    vr: "TM",
    vm: "1",
    name: "Radiopharmaceutical Start Time"
  },
  "(0018,1073)": {
    tag: "(0018,1073)",
    vr: "TM",
    vm: "1",
    name: "Radiopharmaceutical Stop Time"
  },
  "(0018,1074)": {
    tag: "(0018,1074)",
    vr: "DS",
    vm: "1",
    name: "Radionuclide Total Dose"
  },
  "(0018,1075)": {
    tag: "(0018,1075)",
    vr: "DS",
    vm: "1",
    name: "Radionuclide Half Life"
  },
  "(0018,1076)": {
    tag: "(0018,1076)",
    vr: "DS",
    vm: "1",
    name: "Radionuclide Positron Fraction"
  },
  "(0018,1077)": {
    tag: "(0018,1077)",
    vr: "DS",
    vm: "1",
    name: "Radiopharmaceutical Specific Activity"
  },
  "(0018,1078)": {
    tag: "(0018,1078)",
    vr: "DT",
    vm: "1",
    name: "Radiopharmaceutical Start Date Time"
  },
  "(0018,1079)": {
    tag: "(0018,1079)",
    vr: "DT",
    vm: "1",
    name: "Radiopharmaceutical Stop Date Time"
  },
  "(0018,1080)": {
    tag: "(0018,1080)",
    vr: "CS",
    vm: "1",
    name: "Beat Rejection Flag"
  },
  "(0018,1081)": { tag: "(0018,1081)", vr: "IS", vm: "1", name: "Low RRValue" },
  "(0018,1082)": {
    tag: "(0018,1082)",
    vr: "IS",
    vm: "1",
    name: "High RRValue"
  },
  "(0018,1083)": {
    tag: "(0018,1083)",
    vr: "IS",
    vm: "1",
    name: "Intervals Acquired"
  },
  "(0018,1084)": {
    tag: "(0018,1084)",
    vr: "IS",
    vm: "1",
    name: "Intervals Rejected"
  },
  "(0018,1085)": {
    tag: "(0018,1085)",
    vr: "LO",
    vm: "1",
    name: "PVCRejection"
  },
  "(0018,1086)": { tag: "(0018,1086)", vr: "IS", vm: "1", name: "Skip Beats" },
  "(0018,1088)": { tag: "(0018,1088)", vr: "IS", vm: "1", name: "Heart Rate" },
  "(0018,1090)": {
    tag: "(0018,1090)",
    vr: "IS",
    vm: "1",
    name: "Cardiac Number Of Images"
  },
  "(0018,1094)": {
    tag: "(0018,1094)",
    vr: "IS",
    vm: "1",
    name: "Trigger Window"
  },
  "(0018,1100)": {
    tag: "(0018,1100)",
    vr: "DS",
    vm: "1",
    name: "Reconstruction Diameter"
  },
  "(0018,1110)": {
    tag: "(0018,1110)",
    vr: "DS",
    vm: "1",
    name: "Distance Source To Detector"
  },
  "(0018,1111)": {
    tag: "(0018,1111)",
    vr: "DS",
    vm: "1",
    name: "Distance Source To Patient"
  },
  "(0018,1114)": {
    tag: "(0018,1114)",
    vr: "DS",
    vm: "1",
    name: "Estimated Radiographic Magnification Factor"
  },
  "(0018,1120)": {
    tag: "(0018,1120)",
    vr: "DS",
    vm: "1",
    name: "Gantry Detector Tilt"
  },
  "(0018,1121)": {
    tag: "(0018,1121)",
    vr: "DS",
    vm: "1",
    name: "Gantry Detector Slew"
  },
  "(0018,1130)": {
    tag: "(0018,1130)",
    vr: "DS",
    vm: "1",
    name: "Table Height"
  },
  "(0018,1131)": {
    tag: "(0018,1131)",
    vr: "DS",
    vm: "1",
    name: "Table Traverse"
  },
  "(0018,1134)": {
    tag: "(0018,1134)",
    vr: "CS",
    vm: "1",
    name: "Table Motion"
  },
  "(0018,1135)": {
    tag: "(0018,1135)",
    vr: "DS",
    vm: "1",
    name: "Table Vertical Increment"
  },
  "(0018,1136)": {
    tag: "(0018,1136)",
    vr: "DS",
    vm: "1",
    name: "Table Lateral Increment"
  },
  "(0018,1137)": {
    tag: "(0018,1137)",
    vr: "DS",
    vm: "1",
    name: "Table Longitudinal Increment"
  },
  "(0018,1138)": { tag: "(0018,1138)", vr: "DS", vm: "1", name: "Table Angle" },
  "(0018,113A)": { tag: "(0018,113A)", vr: "CS", vm: "1", name: "Table Type" },
  "(0018,1140)": {
    tag: "(0018,1140)",
    vr: "CS",
    vm: "1",
    name: "Rotation Direction"
  },
  "(0018,1141)": {
    tag: "(0018,1141)",
    vr: "DS",
    vm: "1",
    name: "Angular Position"
  },
  "(0018,1142)": {
    tag: "(0018,1142)",
    vr: "DS",
    vm: "1",
    name: "Radial Position"
  },
  "(0018,1143)": { tag: "(0018,1143)", vr: "DS", vm: "1", name: "Scan Arc" },
  "(0018,1144)": {
    tag: "(0018,1144)",
    vr: "DS",
    vm: "1",
    name: "Angular Step"
  },
  "(0018,1145)": {
    tag: "(0018,1145)",
    vr: "DS",
    vm: "1",
    name: "Center Of Rotation Offset"
  },
  "(0018,1146)": {
    tag: "(0018,1146)",
    vr: "DS",
    vm: "1",
    name: "Rotation Offset"
  },
  "(0018,1147)": {
    tag: "(0018,1147)",
    vr: "CS",
    vm: "1",
    name: "Field Of View Shape"
  },
  "(0018,1149)": {
    tag: "(0018,1149)",
    vr: "IS",
    vm: "1-2",
    name: "Field Of View Dimensions"
  },
  "(0018,1150)": {
    tag: "(0018,1150)",
    vr: "IS",
    vm: "1",
    name: "Exposure Time"
  },
  "(0018,1151)": {
    tag: "(0018,1151)",
    vr: "IS",
    vm: "1",
    name: "XRay Tube Current"
  },
  "(0018,1152)": { tag: "(0018,1152)", vr: "IS", vm: "1", name: "Exposure" },
  "(0018,1153)": {
    tag: "(0018,1153)",
    vr: "IS",
    vm: "1",
    name: "Exposure Inu As"
  },
  "(0018,1154)": {
    tag: "(0018,1154)",
    vr: "DS",
    vm: "1",
    name: "Average Pulse Width"
  },
  "(0018,1155)": {
    tag: "(0018,1155)",
    vr: "CS",
    vm: "1",
    name: "Radiation Setting"
  },
  "(0018,1156)": {
    tag: "(0018,1156)",
    vr: "CS",
    vm: "1",
    name: "Rectification Type"
  },
  "(0018,115A)": {
    tag: "(0018,115A)",
    vr: "CS",
    vm: "1",
    name: "Radiation Mode"
  },
  "(0018,115E)": {
    tag: "(0018,115E)",
    vr: "DS",
    vm: "1",
    name: "Image And Fluoroscopy Area Dose Product"
  },
  "(0018,1160)": { tag: "(0018,1160)", vr: "SH", vm: "1", name: "Filter Type" },
  "(0018,1161)": {
    tag: "(0018,1161)",
    vr: "LO",
    vm: "1",
    name: "Type Of Filters"
  },
  "(0018,1162)": {
    tag: "(0018,1162)",
    vr: "DS",
    vm: "1",
    name: "Intensifier Size"
  },
  "(0018,1164)": {
    tag: "(0018,1164)",
    vr: "DS",
    vm: "2",
    name: "Imager Pixel Spacing"
  },
  "(0018,1166)": { tag: "(0018,1166)", vr: "CS", vm: "1", name: "Grid" },
  "(0018,1170)": {
    tag: "(0018,1170)",
    vr: "IS",
    vm: "1",
    name: "Generator Power"
  },
  "(0018,1180)": {
    tag: "(0018,1180)",
    vr: "SH",
    vm: "1",
    name: "Collimator Grid Name"
  },
  "(0018,1181)": {
    tag: "(0018,1181)",
    vr: "CS",
    vm: "1",
    name: "Collimator Type"
  },
  "(0018,1182)": {
    tag: "(0018,1182)",
    vr: "IS",
    vm: "1-2",
    name: "Focal Distance"
  },
  "(0018,1183)": {
    tag: "(0018,1183)",
    vr: "DS",
    vm: "1-2",
    name: "XFocus Center"
  },
  "(0018,1184)": {
    tag: "(0018,1184)",
    vr: "DS",
    vm: "1-2",
    name: "YFocus Center"
  },
  "(0018,1190)": {
    tag: "(0018,1190)",
    vr: "DS",
    vm: "1",
    name: "Focal Spots"
  },
  "(0018,1191)": {
    tag: "(0018,1191)",
    vr: "CS",
    vm: "1",
    name: "Anode Target Material"
  },
  "(0018,11A0)": {
    tag: "(0018,11A0)",
    vr: "DS",
    vm: "1",
    name: "Body Part Thickness"
  },
  "(0018,11A2)": {
    tag: "(0018,11A2)",
    vr: "DS",
    vm: "1",
    name: "Compression Force"
  },
  "(0018,1200)": {
    tag: "(0018,1200)",
    vr: "DA",
    vm: "1",
    name: "Date Of Last Calibration"
  },
  "(0018,1201)": {
    tag: "(0018,1201)",
    vr: "TM",
    vm: "1",
    name: "Time Of Last Calibration"
  },
  "(0018,1210)": {
    tag: "(0018,1210)",
    vr: "SH",
    vm: "1",
    name: "Convolution Kernel"
  },
  "(0018,1240)": {
    tag: "(0018,1240)",
    vr: "IS",
    vm: "1",
    name: "Upper Lower Pixel Values"
  },
  "(0018,1242)": {
    tag: "(0018,1242)",
    vr: "IS",
    vm: "1",
    name: "Actual Frame Duration"
  },
  "(0018,1243)": { tag: "(0018,1243)", vr: "IS", vm: "1", name: "Count Rate" },
  "(0018,1244)": {
    tag: "(0018,1244)",
    vr: "US",
    vm: "1",
    name: "Preferred Playback Sequencing"
  },
  "(0018,1250)": {
    tag: "(0018,1250)",
    vr: "SH",
    vm: "1",
    name: "Receive Coil Name"
  },
  "(0018,1251)": {
    tag: "(0018,1251)",
    vr: "SH",
    vm: "1",
    name: "Transmit Coil Name"
  },
  "(0018,1260)": { tag: "(0018,1260)", vr: "SH", vm: "1", name: "Plate Type" },
  "(0018,1261)": {
    tag: "(0018,1261)",
    vr: "LO",
    vm: "1",
    name: "Phosphor Type"
  },
  "(0018,1300)": {
    tag: "(0018,1300)",
    vr: "DS",
    vm: "1",
    name: "Scan Velocity"
  },
  "(0018,1301)": {
    tag: "(0018,1301)",
    vr: "CS",
    vm: "1",
    name: "Whole Body Technique"
  },
  "(0018,1302)": { tag: "(0018,1302)", vr: "IS", vm: "1", name: "Scan Length" },
  "(0018,1310)": {
    tag: "(0018,1310)",
    vr: "US",
    vm: "4",
    name: "Acquisition Matrix"
  },
  "(0018,1312)": {
    tag: "(0018,1312)",
    vr: "CS",
    vm: "1",
    name: "In Plane Phase Encoding Direction"
  },
  "(0018,1314)": { tag: "(0018,1314)", vr: "DS", vm: "1", name: "Flip Angle" },
  "(0018,1315)": {
    tag: "(0018,1315)",
    vr: "CS",
    vm: "1",
    name: "Variable Flip Angle Flag"
  },
  "(0018,1316)": { tag: "(0018,1316)", vr: "DS", vm: "1", name: "SAR" },
  "(0018,1318)": { tag: "(0018,1318)", vr: "DS", vm: "1", name: "d Bdt" },
  "(0018,1400)": {
    tag: "(0018,1400)",
    vr: "LO",
    vm: "1",
    name: "Acquisition Device Processing Description"
  },
  "(0018,1401)": {
    tag: "(0018,1401)",
    vr: "LO",
    vm: "1",
    name: "Acquisition Device Processing Code"
  },
  "(0018,1402)": {
    tag: "(0018,1402)",
    vr: "CS",
    vm: "1",
    name: "Cassette Orientation"
  },
  "(0018,1403)": {
    tag: "(0018,1403)",
    vr: "CS",
    vm: "1",
    name: "Cassette Size"
  },
  "(0018,1404)": {
    tag: "(0018,1404)",
    vr: "US",
    vm: "1",
    name: "Exposures On Plate"
  },
  "(0018,1405)": {
    tag: "(0018,1405)",
    vr: "IS",
    vm: "1",
    name: "Relative XRay Exposure"
  },
  "(0018,1411)": {
    tag: "(0018,1411)",
    vr: "DS",
    vm: "1",
    name: "Exposure Index"
  },
  "(0018,1412)": {
    tag: "(0018,1412)",
    vr: "DS",
    vm: "1",
    name: "Target Exposure Index"
  },
  "(0018,1413)": {
    tag: "(0018,1413)",
    vr: "DS",
    vm: "1",
    name: "Deviation Index"
  },
  "(0018,1450)": {
    tag: "(0018,1450)",
    vr: "DS",
    vm: "1",
    name: "Column Angulation"
  },
  "(0018,1460)": {
    tag: "(0018,1460)",
    vr: "DS",
    vm: "1",
    name: "Tomo Layer Height"
  },
  "(0018,1470)": { tag: "(0018,1470)", vr: "DS", vm: "1", name: "Tomo Angle" },
  "(0018,1480)": { tag: "(0018,1480)", vr: "DS", vm: "1", name: "Tomo Time" },
  "(0018,1490)": { tag: "(0018,1490)", vr: "CS", vm: "1", name: "Tomo Type" },
  "(0018,1491)": { tag: "(0018,1491)", vr: "CS", vm: "1", name: "Tomo Class" },
  "(0018,1495)": {
    tag: "(0018,1495)",
    vr: "IS",
    vm: "1",
    name: "Number Of Tomosynthesis Source Images"
  },
  "(0018,1500)": {
    tag: "(0018,1500)",
    vr: "CS",
    vm: "1",
    name: "Positioner Motion"
  },
  "(0018,1508)": {
    tag: "(0018,1508)",
    vr: "CS",
    vm: "1",
    name: "Positioner Type"
  },
  "(0018,1510)": {
    tag: "(0018,1510)",
    vr: "DS",
    vm: "1",
    name: "Positioner Primary Angle"
  },
  "(0018,1511)": {
    tag: "(0018,1511)",
    vr: "DS",
    vm: "1",
    name: "Positioner Secondary Angle"
  },
  "(0018,1520)": {
    tag: "(0018,1520)",
    vr: "DS",
    vm: "1",
    name: "Positioner Primary Angle Increment"
  },
  "(0018,1521)": {
    tag: "(0018,1521)",
    vr: "DS",
    vm: "1",
    name: "Positioner Secondary Angle Increment"
  },
  "(0018,1530)": {
    tag: "(0018,1530)",
    vr: "DS",
    vm: "1",
    name: "Detector Primary Angle"
  },
  "(0018,1531)": {
    tag: "(0018,1531)",
    vr: "DS",
    vm: "1",
    name: "Detector Secondary Angle"
  },
  "(0018,1600)": {
    tag: "(0018,1600)",
    vr: "CS",
    vm: "1-3",
    name: "Shutter Shape"
  },
  "(0018,1602)": {
    tag: "(0018,1602)",
    vr: "IS",
    vm: "1",
    name: "Shutter Left Vertical Edge"
  },
  "(0018,1604)": {
    tag: "(0018,1604)",
    vr: "IS",
    vm: "1",
    name: "Shutter Right Vertical Edge"
  },
  "(0018,1606)": {
    tag: "(0018,1606)",
    vr: "IS",
    vm: "1",
    name: "Shutter Upper Horizontal Edge"
  },
  "(0018,1608)": {
    tag: "(0018,1608)",
    vr: "IS",
    vm: "1",
    name: "Shutter Lower Horizontal Edge"
  },
  "(0018,1610)": {
    tag: "(0018,1610)",
    vr: "IS",
    vm: "2",
    name: "Center Of Circular Shutter"
  },
  "(0018,1612)": {
    tag: "(0018,1612)",
    vr: "IS",
    vm: "1",
    name: "Radius Of Circular Shutter"
  },
  "(0018,1620)": {
    tag: "(0018,1620)",
    vr: "IS",
    vm: "2-2n",
    name: "Vertices Of The Polygonal Shutter"
  },
  "(0018,1622)": {
    tag: "(0018,1622)",
    vr: "US",
    vm: "1",
    name: "Shutter Presentation Value"
  },
  "(0018,1623)": {
    tag: "(0018,1623)",
    vr: "US",
    vm: "1",
    name: "Shutter Overlay Group"
  },
  "(0018,1624)": {
    tag: "(0018,1624)",
    vr: "US",
    vm: "3",
    name: "Shutter Presentation Color CIELab Value"
  },
  "(0018,1700)": {
    tag: "(0018,1700)",
    vr: "CS",
    vm: "1-3",
    name: "Collimator Shape"
  },
  "(0018,1702)": {
    tag: "(0018,1702)",
    vr: "IS",
    vm: "1",
    name: "Collimator Left Vertical Edge"
  },
  "(0018,1704)": {
    tag: "(0018,1704)",
    vr: "IS",
    vm: "1",
    name: "Collimator Right Vertical Edge"
  },
  "(0018,1706)": {
    tag: "(0018,1706)",
    vr: "IS",
    vm: "1",
    name: "Collimator Upper Horizontal Edge"
  },
  "(0018,1708)": {
    tag: "(0018,1708)",
    vr: "IS",
    vm: "1",
    name: "Collimator Lower Horizontal Edge"
  },
  "(0018,1710)": {
    tag: "(0018,1710)",
    vr: "IS",
    vm: "2",
    name: "Center Of Circular Collimator"
  },
  "(0018,1712)": {
    tag: "(0018,1712)",
    vr: "IS",
    vm: "1",
    name: "Radius Of Circular Collimator"
  },
  "(0018,1720)": {
    tag: "(0018,1720)",
    vr: "IS",
    vm: "2-2n",
    name: "Vertices Of The Polygonal Collimator"
  },
  "(0018,1800)": {
    tag: "(0018,1800)",
    vr: "CS",
    vm: "1",
    name: "Acquisition Time Synchronized"
  },
  "(0018,1801)": { tag: "(0018,1801)", vr: "SH", vm: "1", name: "Time Source" },
  "(0018,1802)": {
    tag: "(0018,1802)",
    vr: "CS",
    vm: "1",
    name: "Time Distribution Protocol"
  },
  "(0018,1803)": {
    tag: "(0018,1803)",
    vr: "LO",
    vm: "1",
    name: "NTPSource Address"
  },
  "(0018,2001)": {
    tag: "(0018,2001)",
    vr: "IS",
    vm: "1",
    name: "Page Number Vector"
  },
  "(0018,2002)": {
    tag: "(0018,2002)",
    vr: "SH",
    vm: "1",
    name: "Frame Label Vector"
  },
  "(0018,2003)": {
    tag: "(0018,2003)",
    vr: "DS",
    vm: "1",
    name: "Frame Primary Angle Vector"
  },
  "(0018,2004)": {
    tag: "(0018,2004)",
    vr: "DS",
    vm: "1",
    name: "Frame Secondary Angle Vector"
  },
  "(0018,2005)": {
    tag: "(0018,2005)",
    vr: "DS",
    vm: "1",
    name: "Slice Location Vector"
  },
  "(0018,2006)": {
    tag: "(0018,2006)",
    vr: "SH",
    vm: "1",
    name: "Display Window Label Vector"
  },
  "(0018,2010)": {
    tag: "(0018,2010)",
    vr: "DS",
    vm: "2",
    name: "Nominal Scanned Pixel Spacing"
  },
  "(0018,2020)": {
    tag: "(0018,2020)",
    vr: "CS",
    vm: "1",
    name: "Digitizing Device Transport Direction"
  },
  "(0018,2030)": {
    tag: "(0018,2030)",
    vr: "DS",
    vm: "1",
    name: "Rotation Of Scanned Film"
  },
  "(0018,3100)": {
    tag: "(0018,3100)",
    vr: "CS",
    vm: "1",
    name: "IVUSAcquisition"
  },
  "(0018,3101)": {
    tag: "(0018,3101)",
    vr: "DS",
    vm: "1",
    name: "IVUSPullback Rate"
  },
  "(0018,3102)": {
    tag: "(0018,3102)",
    vr: "DS",
    vm: "1",
    name: "IVUSGated Rate"
  },
  "(0018,3103)": {
    tag: "(0018,3103)",
    vr: "IS",
    vm: "1",
    name: "IVUSPullback Start Frame Number"
  },
  "(0018,3104)": {
    tag: "(0018,3104)",
    vr: "IS",
    vm: "1",
    name: "IVUSPullback Stop Frame Number"
  },
  "(0018,3105)": {
    tag: "(0018,3105)",
    vr: "IS",
    vm: "1",
    name: "Lesion Number"
  },
  "(0018,4000)": {
    tag: "(0018,4000)",
    vr: "LT",
    vm: "1",
    name: "Acquisition Comments"
  },
  "(0018,5000)": {
    tag: "(0018,5000)",
    vr: "SH",
    vm: "1",
    name: "Output Power"
  },
  "(0018,5010)": {
    tag: "(0018,5010)",
    vr: "LO",
    vm: "1",
    name: "Transducer Data"
  },
  "(0018,5012)": { tag: "(0018,5012)", vr: "DS", vm: "1", name: "Focus Depth" },
  "(0018,5020)": {
    tag: "(0018,5020)",
    vr: "LO",
    vm: "1",
    name: "Processing Function"
  },
  "(0018,5021)": {
    tag: "(0018,5021)",
    vr: "LO",
    vm: "1",
    name: "Postprocessing Function"
  },
  "(0018,5022)": {
    tag: "(0018,5022)",
    vr: "DS",
    vm: "1",
    name: "Mechanical Index"
  },
  "(0018,5024)": {
    tag: "(0018,5024)",
    vr: "DS",
    vm: "1",
    name: "Bone Thermal Index"
  },
  "(0018,5026)": {
    tag: "(0018,5026)",
    vr: "DS",
    vm: "1",
    name: "Cranial Thermal Index"
  },
  "(0018,5027)": {
    tag: "(0018,5027)",
    vr: "DS",
    vm: "1",
    name: "Soft Tissue Thermal Index"
  },
  "(0018,5028)": {
    tag: "(0018,5028)",
    vr: "DS",
    vm: "1",
    name: "Soft Tissue Focus Thermal Index"
  },
  "(0018,5029)": {
    tag: "(0018,5029)",
    vr: "DS",
    vm: "1",
    name: "Soft Tissue Surface Thermal Index"
  },
  "(0018,5030)": {
    tag: "(0018,5030)",
    vr: "DS",
    vm: "1",
    name: "Dynamic Range"
  },
  "(0018,5040)": { tag: "(0018,5040)", vr: "DS", vm: "1", name: "Total Gain" },
  "(0018,5050)": {
    tag: "(0018,5050)",
    vr: "IS",
    vm: "1",
    name: "Depth Of Scan Field"
  },
  "(0018,5100)": {
    tag: "(0018,5100)",
    vr: "CS",
    vm: "1",
    name: "Patient Position"
  },
  "(0018,5101)": {
    tag: "(0018,5101)",
    vr: "CS",
    vm: "1",
    name: "View Position"
  },
  "(0018,5104)": {
    tag: "(0018,5104)",
    vr: "SQ",
    vm: "1",
    name: "Projection Eponymous Name Code Sequence"
  },
  "(0018,5210)": {
    tag: "(0018,5210)",
    vr: "DS",
    vm: "6",
    name: "Image Transformation Matrix"
  },
  "(0018,5212)": {
    tag: "(0018,5212)",
    vr: "DS",
    vm: "3",
    name: "Image Translation Vector"
  },
  "(0018,6000)": { tag: "(0018,6000)", vr: "DS", vm: "1", name: "Sensitivity" },
  "(0018,6011)": {
    tag: "(0018,6011)",
    vr: "SQ",
    vm: "1",
    name: "Sequence Of Ultrasound Regions"
  },
  "(0018,6012)": {
    tag: "(0018,6012)",
    vr: "US",
    vm: "1",
    name: "Region Spatial Format"
  },
  "(0018,6014)": {
    tag: "(0018,6014)",
    vr: "US",
    vm: "1",
    name: "Region Data Type"
  },
  "(0018,6016)": {
    tag: "(0018,6016)",
    vr: "UL",
    vm: "1",
    name: "Region Flags"
  },
  "(0018,6018)": {
    tag: "(0018,6018)",
    vr: "UL",
    vm: "1",
    name: "Region Location Min X0"
  },
  "(0018,601A)": {
    tag: "(0018,601A)",
    vr: "UL",
    vm: "1",
    name: "Region Location Min Y0"
  },
  "(0018,601C)": {
    tag: "(0018,601C)",
    vr: "UL",
    vm: "1",
    name: "Region Location Max X1"
  },
  "(0018,601E)": {
    tag: "(0018,601E)",
    vr: "UL",
    vm: "1",
    name: "Region Location Max Y1"
  },
  "(0018,6020)": {
    tag: "(0018,6020)",
    vr: "SL",
    vm: "1",
    name: "Reference Pixel X0"
  },
  "(0018,6022)": {
    tag: "(0018,6022)",
    vr: "SL",
    vm: "1",
    name: "Reference Pixel Y0"
  },
  "(0018,6024)": {
    tag: "(0018,6024)",
    vr: "US",
    vm: "1",
    name: "Physical Units XDirection"
  },
  "(0018,6026)": {
    tag: "(0018,6026)",
    vr: "US",
    vm: "1",
    name: "Physical Units YDirection"
  },
  "(0018,6028)": {
    tag: "(0018,6028)",
    vr: "FD",
    vm: "1",
    name: "Reference Pixel Physical Value X"
  },
  "(0018,602A)": {
    tag: "(0018,602A)",
    vr: "FD",
    vm: "1",
    name: "Reference Pixel Physical Value Y"
  },
  "(0018,602C)": {
    tag: "(0018,602C)",
    vr: "FD",
    vm: "1",
    name: "Physical Delta X"
  },
  "(0018,602E)": {
    tag: "(0018,602E)",
    vr: "FD",
    vm: "1",
    name: "Physical Delta Y"
  },
  "(0018,6030)": {
    tag: "(0018,6030)",
    vr: "UL",
    vm: "1",
    name: "Transducer Frequency"
  },
  "(0018,6031)": {
    tag: "(0018,6031)",
    vr: "CS",
    vm: "1",
    name: "Transducer Type"
  },
  "(0018,6032)": {
    tag: "(0018,6032)",
    vr: "UL",
    vm: "1",
    name: "Pulse Repetition Frequency"
  },
  "(0018,6034)": {
    tag: "(0018,6034)",
    vr: "FD",
    vm: "1",
    name: "Doppler Correction Angle"
  },
  "(0018,6036)": {
    tag: "(0018,6036)",
    vr: "FD",
    vm: "1",
    name: "Steering Angle"
  },
  "(0018,6038)": {
    tag: "(0018,6038)",
    vr: "UL",
    vm: "1",
    name: "Doppler Sample Volume XPosition Retired"
  },
  "(0018,6039)": {
    tag: "(0018,6039)",
    vr: "SL",
    vm: "1",
    name: "Doppler Sample Volume XPosition"
  },
  "(0018,603A)": {
    tag: "(0018,603A)",
    vr: "UL",
    vm: "1",
    name: "Doppler Sample Volume YPosition Retired"
  },
  "(0018,603B)": {
    tag: "(0018,603B)",
    vr: "SL",
    vm: "1",
    name: "Doppler Sample Volume YPosition"
  },
  "(0018,603C)": {
    tag: "(0018,603C)",
    vr: "UL",
    vm: "1",
    name: "TMLine Position X0Retired"
  },
  "(0018,603D)": {
    tag: "(0018,603D)",
    vr: "SL",
    vm: "1",
    name: "TMLine Position X0"
  },
  "(0018,603E)": {
    tag: "(0018,603E)",
    vr: "UL",
    vm: "1",
    name: "TMLine Position Y0Retired"
  },
  "(0018,603F)": {
    tag: "(0018,603F)",
    vr: "SL",
    vm: "1",
    name: "TMLine Position Y0"
  },
  "(0018,6040)": {
    tag: "(0018,6040)",
    vr: "UL",
    vm: "1",
    name: "TMLine Position X1Retired"
  },
  "(0018,6041)": {
    tag: "(0018,6041)",
    vr: "SL",
    vm: "1",
    name: "TMLine Position X1"
  },
  "(0018,6042)": {
    tag: "(0018,6042)",
    vr: "UL",
    vm: "1",
    name: "TMLine Position Y1Retired"
  },
  "(0018,6043)": {
    tag: "(0018,6043)",
    vr: "SL",
    vm: "1",
    name: "TMLine Position Y1"
  },
  "(0018,6044)": {
    tag: "(0018,6044)",
    vr: "US",
    vm: "1",
    name: "Pixel Component Organization"
  },
  "(0018,6046)": {
    tag: "(0018,6046)",
    vr: "UL",
    vm: "1",
    name: "Pixel Component Mask"
  },
  "(0018,6048)": {
    tag: "(0018,6048)",
    vr: "UL",
    vm: "1",
    name: "Pixel Component Range Start"
  },
  "(0018,604A)": {
    tag: "(0018,604A)",
    vr: "UL",
    vm: "1",
    name: "Pixel Component Range Stop"
  },
  "(0018,604C)": {
    tag: "(0018,604C)",
    vr: "US",
    vm: "1",
    name: "Pixel Component Physical Units"
  },
  "(0018,604E)": {
    tag: "(0018,604E)",
    vr: "US",
    vm: "1",
    name: "Pixel Component Data Type"
  },
  "(0018,6050)": {
    tag: "(0018,6050)",
    vr: "UL",
    vm: "1",
    name: "Number Of Table Break Points"
  },
  "(0018,6052)": {
    tag: "(0018,6052)",
    vr: "UL",
    vm: "1",
    name: "Table Of XBreak Points"
  },
  "(0018,6054)": {
    tag: "(0018,6054)",
    vr: "FD",
    vm: "1",
    name: "Table Of YBreak Points"
  },
  "(0018,6056)": {
    tag: "(0018,6056)",
    vr: "UL",
    vm: "1",
    name: "Number Of Table Entries"
  },
  "(0018,6058)": {
    tag: "(0018,6058)",
    vr: "UL",
    vm: "1",
    name: "Table Of Pixel Values"
  },
  "(0018,605A)": {
    tag: "(0018,605A)",
    vr: "FL",
    vm: "1",
    name: "Table Of Parameter Values"
  },
  "(0018,6060)": {
    tag: "(0018,6060)",
    vr: "FL",
    vm: "1",
    name: "RWave Time Vector"
  },
  "(0018,7000)": {
    tag: "(0018,7000)",
    vr: "CS",
    vm: "1",
    name: "Detector Conditions Nominal Flag"
  },
  "(0018,7001)": {
    tag: "(0018,7001)",
    vr: "DS",
    vm: "1",
    name: "Detector Temperature"
  },
  "(0018,7004)": {
    tag: "(0018,7004)",
    vr: "CS",
    vm: "1",
    name: "Detector Type"
  },
  "(0018,7005)": {
    tag: "(0018,7005)",
    vr: "CS",
    vm: "1",
    name: "Detector Configuration"
  },
  "(0018,7006)": {
    tag: "(0018,7006)",
    vr: "LT",
    vm: "1",
    name: "Detector Description"
  },
  "(0018,7008)": {
    tag: "(0018,7008)",
    vr: "LT",
    vm: "1",
    name: "Detector Mode"
  },
  "(0018,700A)": { tag: "(0018,700A)", vr: "SH", vm: "1", name: "Detector ID" },
  "(0018,700C)": {
    tag: "(0018,700C)",
    vr: "DA",
    vm: "1",
    name: "Date Of Last Detector Calibration"
  },
  "(0018,700E)": {
    tag: "(0018,700E)",
    vr: "TM",
    vm: "1",
    name: "Time Of Last Detector Calibration"
  },
  "(0018,7010)": {
    tag: "(0018,7010)",
    vr: "IS",
    vm: "1",
    name: "Exposures On Detector Since Last Calibration"
  },
  "(0018,7011)": {
    tag: "(0018,7011)",
    vr: "IS",
    vm: "1",
    name: "Exposures On Detector Since Manufactured"
  },
  "(0018,7012)": {
    tag: "(0018,7012)",
    vr: "DS",
    vm: "1",
    name: "Detector Time Since Last Exposure"
  },
  "(0018,7014)": {
    tag: "(0018,7014)",
    vr: "DS",
    vm: "1",
    name: "Detector Active Time"
  },
  "(0018,7016)": {
    tag: "(0018,7016)",
    vr: "DS",
    vm: "1",
    name: "Detector Activation Offset From Exposure"
  },
  "(0018,701A)": {
    tag: "(0018,701A)",
    vr: "DS",
    vm: "2",
    name: "Detector Binning"
  },
  "(0018,7020)": {
    tag: "(0018,7020)",
    vr: "DS",
    vm: "2",
    name: "Detector Element Physical Size"
  },
  "(0018,7022)": {
    tag: "(0018,7022)",
    vr: "DS",
    vm: "2",
    name: "Detector Element Spacing"
  },
  "(0018,7024)": {
    tag: "(0018,7024)",
    vr: "CS",
    vm: "1",
    name: "Detector Active Shape"
  },
  "(0018,7026)": {
    tag: "(0018,7026)",
    vr: "DS",
    vm: "1-2",
    name: "Detector Active Dimensions"
  },
  "(0018,7028)": {
    tag: "(0018,7028)",
    vr: "DS",
    vm: "2",
    name: "Detector Active Origin"
  },
  "(0018,702A)": {
    tag: "(0018,702A)",
    vr: "LO",
    vm: "1",
    name: "Detector Manufacturer Name"
  },
  "(0018,702B)": {
    tag: "(0018,702B)",
    vr: "LO",
    vm: "1",
    name: "Detector Manufacturer Model Name"
  },
  "(0018,7030)": {
    tag: "(0018,7030)",
    vr: "DS",
    vm: "2",
    name: "Field Of View Origin"
  },
  "(0018,7032)": {
    tag: "(0018,7032)",
    vr: "DS",
    vm: "1",
    name: "Field Of View Rotation"
  },
  "(0018,7034)": {
    tag: "(0018,7034)",
    vr: "CS",
    vm: "1",
    name: "Field Of View Horizontal Flip"
  },
  "(0018,7036)": {
    tag: "(0018,7036)",
    vr: "FL",
    vm: "2",
    name: "Pixel Data Area Origin Relative To FOV"
  },
  "(0018,7038)": {
    tag: "(0018,7038)",
    vr: "FL",
    vm: "1",
    name: "Pixel Data Area Rotation Angle Relative To FOV"
  },
  "(0018,7040)": {
    tag: "(0018,7040)",
    vr: "LT",
    vm: "1",
    name: "Grid Absorbing Material"
  },
  "(0018,7041)": {
    tag: "(0018,7041)",
    vr: "LT",
    vm: "1",
    name: "Grid Spacing Material"
  },
  "(0018,7042)": {
    tag: "(0018,7042)",
    vr: "DS",
    vm: "1",
    name: "Grid Thickness"
  },
  "(0018,7044)": { tag: "(0018,7044)", vr: "DS", vm: "1", name: "Grid Pitch" },
  "(0018,7046)": {
    tag: "(0018,7046)",
    vr: "IS",
    vm: "2",
    name: "Grid Aspect Ratio"
  },
  "(0018,7048)": { tag: "(0018,7048)", vr: "DS", vm: "1", name: "Grid Period" },
  "(0018,704C)": {
    tag: "(0018,704C)",
    vr: "DS",
    vm: "1",
    name: "Grid Focal Distance"
  },
  "(0018,7050)": {
    tag: "(0018,7050)",
    vr: "CS",
    vm: "1",
    name: "Filter Material"
  },
  "(0018,7052)": {
    tag: "(0018,7052)",
    vr: "DS",
    vm: "1",
    name: "Filter Thickness Minimum"
  },
  "(0018,7054)": {
    tag: "(0018,7054)",
    vr: "DS",
    vm: "1",
    name: "Filter Thickness Maximum"
  },
  "(0018,7056)": {
    tag: "(0018,7056)",
    vr: "FL",
    vm: "1",
    name: "Filter Beam Path Length Minimum"
  },
  "(0018,7058)": {
    tag: "(0018,7058)",
    vr: "FL",
    vm: "1",
    name: "Filter Beam Path Length Maximum"
  },
  "(0018,7060)": {
    tag: "(0018,7060)",
    vr: "CS",
    vm: "1",
    name: "Exposure Control Mode"
  },
  "(0018,7062)": {
    tag: "(0018,7062)",
    vr: "LT",
    vm: "1",
    name: "Exposure Control Mode Description"
  },
  "(0018,7064)": {
    tag: "(0018,7064)",
    vr: "CS",
    vm: "1",
    name: "Exposure Status"
  },
  "(0018,7065)": {
    tag: "(0018,7065)",
    vr: "DS",
    vm: "1",
    name: "Phototimer Setting"
  },
  "(0018,8150)": {
    tag: "(0018,8150)",
    vr: "DS",
    vm: "1",
    name: "Exposure Time Inu S"
  },
  "(0018,8151)": {
    tag: "(0018,8151)",
    vr: "DS",
    vm: "1",
    name: "XRay Tube Current Inu A"
  },
  "(0018,9004)": {
    tag: "(0018,9004)",
    vr: "CS",
    vm: "1",
    name: "Content Qualification"
  },
  "(0018,9005)": {
    tag: "(0018,9005)",
    vr: "SH",
    vm: "1",
    name: "Pulse Sequence Name"
  },
  "(0018,9006)": {
    tag: "(0018,9006)",
    vr: "SQ",
    vm: "1",
    name: "MRImaging Modifier Sequence"
  },
  "(0018,9008)": {
    tag: "(0018,9008)",
    vr: "CS",
    vm: "1",
    name: "Echo Pulse Sequence"
  },
  "(0018,9009)": {
    tag: "(0018,9009)",
    vr: "CS",
    vm: "1",
    name: "Inversion Recovery"
  },
  "(0018,9010)": {
    tag: "(0018,9010)",
    vr: "CS",
    vm: "1",
    name: "Flow Compensation"
  },
  "(0018,9011)": {
    tag: "(0018,9011)",
    vr: "CS",
    vm: "1",
    name: "Multiple Spin Echo"
  },
  "(0018,9012)": {
    tag: "(0018,9012)",
    vr: "CS",
    vm: "1",
    name: "Multi Planar Excitation"
  },
  "(0018,9014)": {
    tag: "(0018,9014)",
    vr: "CS",
    vm: "1",
    name: "Phase Contrast"
  },
  "(0018,9015)": {
    tag: "(0018,9015)",
    vr: "CS",
    vm: "1",
    name: "Time Of Flight Contrast"
  },
  "(0018,9016)": { tag: "(0018,9016)", vr: "CS", vm: "1", name: "Spoiling" },
  "(0018,9017)": {
    tag: "(0018,9017)",
    vr: "CS",
    vm: "1",
    name: "Steady State Pulse Sequence"
  },
  "(0018,9018)": {
    tag: "(0018,9018)",
    vr: "CS",
    vm: "1",
    name: "Echo Planar Pulse Sequence"
  },
  "(0018,9019)": {
    tag: "(0018,9019)",
    vr: "FD",
    vm: "1",
    name: "Tag Angle First Axis"
  },
  "(0018,9020)": {
    tag: "(0018,9020)",
    vr: "CS",
    vm: "1",
    name: "Magnetization Transfer"
  },
  "(0018,9021)": {
    tag: "(0018,9021)",
    vr: "CS",
    vm: "1",
    name: "T2Preparation"
  },
  "(0018,9022)": {
    tag: "(0018,9022)",
    vr: "CS",
    vm: "1",
    name: "Blood Signal Nulling"
  },
  "(0018,9024)": {
    tag: "(0018,9024)",
    vr: "CS",
    vm: "1",
    name: "Saturation Recovery"
  },
  "(0018,9025)": {
    tag: "(0018,9025)",
    vr: "CS",
    vm: "1",
    name: "Spectrally Selected Suppression"
  },
  "(0018,9026)": {
    tag: "(0018,9026)",
    vr: "CS",
    vm: "1",
    name: "Spectrally Selected Excitation"
  },
  "(0018,9027)": {
    tag: "(0018,9027)",
    vr: "CS",
    vm: "1",
    name: "Spatial Presaturation"
  },
  "(0018,9028)": { tag: "(0018,9028)", vr: "CS", vm: "1", name: "Tagging" },
  "(0018,9029)": {
    tag: "(0018,9029)",
    vr: "CS",
    vm: "1",
    name: "Oversampling Phase"
  },
  "(0018,9030)": {
    tag: "(0018,9030)",
    vr: "FD",
    vm: "1",
    name: "Tag Spacing First Dimension"
  },
  "(0018,9032)": {
    tag: "(0018,9032)",
    vr: "CS",
    vm: "1",
    name: "Geometry Of KSpace Traversal"
  },
  "(0018,9033)": {
    tag: "(0018,9033)",
    vr: "CS",
    vm: "1",
    name: "Segmented KSpace Traversal"
  },
  "(0018,9034)": {
    tag: "(0018,9034)",
    vr: "CS",
    vm: "1",
    name: "Rectilinear Phase Encode Reordering"
  },
  "(0018,9035)": {
    tag: "(0018,9035)",
    vr: "FD",
    vm: "1",
    name: "Tag Thickness"
  },
  "(0018,9036)": {
    tag: "(0018,9036)",
    vr: "CS",
    vm: "1",
    name: "Partial Fourier Direction"
  },
  "(0018,9037)": {
    tag: "(0018,9037)",
    vr: "CS",
    vm: "1",
    name: "Cardiac Synchronization Technique"
  },
  "(0018,9041)": {
    tag: "(0018,9041)",
    vr: "LO",
    vm: "1",
    name: "Receive Coil Manufacturer Name"
  },
  "(0018,9042)": {
    tag: "(0018,9042)",
    vr: "SQ",
    vm: "1",
    name: "MRReceive Coil Sequence"
  },
  "(0018,9043)": {
    tag: "(0018,9043)",
    vr: "CS",
    vm: "1",
    name: "Receive Coil Type"
  },
  "(0018,9044)": {
    tag: "(0018,9044)",
    vr: "CS",
    vm: "1",
    name: "Quadrature Receive Coil"
  },
  "(0018,9045)": {
    tag: "(0018,9045)",
    vr: "SQ",
    vm: "1",
    name: "Multi Coil Definition Sequence"
  },
  "(0018,9046)": {
    tag: "(0018,9046)",
    vr: "LO",
    vm: "1",
    name: "Multi Coil Configuration"
  },
  "(0018,9047)": {
    tag: "(0018,9047)",
    vr: "SH",
    vm: "1",
    name: "Multi Coil Element Name"
  },
  "(0018,9048)": {
    tag: "(0018,9048)",
    vr: "CS",
    vm: "1",
    name: "Multi Coil Element Used"
  },
  "(0018,9049)": {
    tag: "(0018,9049)",
    vr: "SQ",
    vm: "1",
    name: "MRTransmit Coil Sequence"
  },
  "(0018,9050)": {
    tag: "(0018,9050)",
    vr: "LO",
    vm: "1",
    name: "Transmit Coil Manufacturer Name"
  },
  "(0018,9051)": {
    tag: "(0018,9051)",
    vr: "CS",
    vm: "1",
    name: "Transmit Coil Type"
  },
  "(0018,9052)": {
    tag: "(0018,9052)",
    vr: "FD",
    vm: "1-2",
    name: "Spectral Width"
  },
  "(0018,9053)": {
    tag: "(0018,9053)",
    vr: "FD",
    vm: "1-2",
    name: "Chemical Shift Reference"
  },
  "(0018,9054)": {
    tag: "(0018,9054)",
    vr: "CS",
    vm: "1",
    name: "Volume Localization Technique"
  },
  "(0018,9058)": {
    tag: "(0018,9058)",
    vr: "US",
    vm: "1",
    name: "MRAcquisition Frequency Encoding Steps"
  },
  "(0018,9059)": { tag: "(0018,9059)", vr: "CS", vm: "1", name: "Decoupling" },
  "(0018,9060)": {
    tag: "(0018,9060)",
    vr: "CS",
    vm: "1-2",
    name: "Decoupled Nucleus"
  },
  "(0018,9061)": {
    tag: "(0018,9061)",
    vr: "FD",
    vm: "1-2",
    name: "Decoupling Frequency"
  },
  "(0018,9062)": {
    tag: "(0018,9062)",
    vr: "CS",
    vm: "1",
    name: "Decoupling Method"
  },
  "(0018,9063)": {
    tag: "(0018,9063)",
    vr: "FD",
    vm: "1-2",
    name: "Decoupling Chemical Shift Reference"
  },
  "(0018,9064)": {
    tag: "(0018,9064)",
    vr: "CS",
    vm: "1",
    name: "KSpace Filtering"
  },
  "(0018,9065)": {
    tag: "(0018,9065)",
    vr: "CS",
    vm: "1-2",
    name: "Time Domain Filtering"
  },
  "(0018,9066)": {
    tag: "(0018,9066)",
    vr: "US",
    vm: "1-2",
    name: "Number Of Zero Fills"
  },
  "(0018,9067)": {
    tag: "(0018,9067)",
    vr: "CS",
    vm: "1",
    name: "Baseline Correction"
  },
  "(0018,9069)": {
    tag: "(0018,9069)",
    vr: "FD",
    vm: "1",
    name: "Parallel Reduction Factor In Plane"
  },
  "(0018,9070)": {
    tag: "(0018,9070)",
    vr: "FD",
    vm: "1",
    name: "Cardiac RRInterval Specified"
  },
  "(0018,9073)": {
    tag: "(0018,9073)",
    vr: "FD",
    vm: "1",
    name: "Acquisition Duration"
  },
  "(0018,9074)": {
    tag: "(0018,9074)",
    vr: "DT",
    vm: "1",
    name: "Frame Acquisition Date Time"
  },
  "(0018,9075)": {
    tag: "(0018,9075)",
    vr: "CS",
    vm: "1",
    name: "Diffusion Directionality"
  },
  "(0018,9076)": {
    tag: "(0018,9076)",
    vr: "SQ",
    vm: "1",
    name: "Diffusion Gradient Direction Sequence"
  },
  "(0018,9077)": {
    tag: "(0018,9077)",
    vr: "CS",
    vm: "1",
    name: "Parallel Acquisition"
  },
  "(0018,9078)": {
    tag: "(0018,9078)",
    vr: "CS",
    vm: "1",
    name: "Parallel Acquisition Technique"
  },
  "(0018,9079)": {
    tag: "(0018,9079)",
    vr: "FD",
    vm: "1",
    name: "Inversion Times"
  },
  "(0018,9080)": {
    tag: "(0018,9080)",
    vr: "ST",
    vm: "1",
    name: "Metabolite Map Description"
  },
  "(0018,9081)": {
    tag: "(0018,9081)",
    vr: "CS",
    vm: "1",
    name: "Partial Fourier"
  },
  "(0018,9082)": {
    tag: "(0018,9082)",
    vr: "FD",
    vm: "1",
    name: "Effective Echo Time"
  },
  "(0018,9083)": {
    tag: "(0018,9083)",
    vr: "SQ",
    vm: "1",
    name: "Metabolite Map Code Sequence"
  },
  "(0018,9084)": {
    tag: "(0018,9084)",
    vr: "SQ",
    vm: "1",
    name: "Chemical Shift Sequence"
  },
  "(0018,9085)": {
    tag: "(0018,9085)",
    vr: "CS",
    vm: "1",
    name: "Cardiac Signal Source"
  },
  "(0018,9087)": {
    tag: "(0018,9087)",
    vr: "FD",
    vm: "1",
    name: "Diffusion BValue"
  },
  "(0018,9089)": {
    tag: "(0018,9089)",
    vr: "FD",
    vm: "3",
    name: "Diffusion Gradient Orientation"
  },
  "(0018,9090)": {
    tag: "(0018,9090)",
    vr: "FD",
    vm: "3",
    name: "Velocity Encoding Direction"
  },
  "(0018,9091)": {
    tag: "(0018,9091)",
    vr: "FD",
    vm: "1",
    name: "Velocity Encoding Minimum Value"
  },
  "(0018,9092)": {
    tag: "(0018,9092)",
    vr: "SQ",
    vm: "1",
    name: "Velocity Encoding Acquisition Sequence"
  },
  "(0018,9093)": {
    tag: "(0018,9093)",
    vr: "US",
    vm: "1",
    name: "Number Of KSpace Trajectories"
  },
  "(0018,9094)": {
    tag: "(0018,9094)",
    vr: "CS",
    vm: "1",
    name: "Coverage Of KSpace"
  },
  "(0018,9095)": {
    tag: "(0018,9095)",
    vr: "UL",
    vm: "1",
    name: "Spectroscopy Acquisition Phase Rows"
  },
  "(0018,9096)": {
    tag: "(0018,9096)",
    vr: "FD",
    vm: "1",
    name: "Parallel Reduction Factor In Plane Retired"
  },
  "(0018,9098)": {
    tag: "(0018,9098)",
    vr: "FD",
    vm: "1-2",
    name: "Transmitter Frequency"
  },
  "(0018,9100)": {
    tag: "(0018,9100)",
    vr: "CS",
    vm: "1-2",
    name: "Resonant Nucleus"
  },
  "(0018,9101)": {
    tag: "(0018,9101)",
    vr: "CS",
    vm: "1",
    name: "Frequency Correction"
  },
  "(0018,9103)": {
    tag: "(0018,9103)",
    vr: "SQ",
    vm: "1",
    name: "MRSpectroscopy FOVGeometry Sequence"
  },
  "(0018,9104)": {
    tag: "(0018,9104)",
    vr: "FD",
    vm: "1",
    name: "Slab Thickness"
  },
  "(0018,9105)": {
    tag: "(0018,9105)",
    vr: "FD",
    vm: "3",
    name: "Slab Orientation"
  },
  "(0018,9106)": {
    tag: "(0018,9106)",
    vr: "FD",
    vm: "3",
    name: "Mid Slab Position"
  },
  "(0018,9107)": {
    tag: "(0018,9107)",
    vr: "SQ",
    vm: "1",
    name: "MRSpatial Saturation Sequence"
  },
  "(0018,9112)": {
    tag: "(0018,9112)",
    vr: "SQ",
    vm: "1",
    name: "MRTiming And Related Parameters Sequence"
  },
  "(0018,9114)": {
    tag: "(0018,9114)",
    vr: "SQ",
    vm: "1",
    name: "MREcho Sequence"
  },
  "(0018,9115)": {
    tag: "(0018,9115)",
    vr: "SQ",
    vm: "1",
    name: "MRModifier Sequence"
  },
  "(0018,9117)": {
    tag: "(0018,9117)",
    vr: "SQ",
    vm: "1",
    name: "MRDiffusion Sequence"
  },
  "(0018,9118)": {
    tag: "(0018,9118)",
    vr: "SQ",
    vm: "1",
    name: "Cardiac Synchronization Sequence"
  },
  "(0018,9119)": {
    tag: "(0018,9119)",
    vr: "SQ",
    vm: "1",
    name: "MRAverages Sequence"
  },
  "(0018,9125)": {
    tag: "(0018,9125)",
    vr: "SQ",
    vm: "1",
    name: "MRFOVGeometry Sequence"
  },
  "(0018,9126)": {
    tag: "(0018,9126)",
    vr: "SQ",
    vm: "1",
    name: "Volume Localization Sequence"
  },
  "(0018,9127)": {
    tag: "(0018,9127)",
    vr: "UL",
    vm: "1",
    name: "Spectroscopy Acquisition Data Columns"
  },
  "(0018,9147)": {
    tag: "(0018,9147)",
    vr: "CS",
    vm: "1",
    name: "Diffusion Anisotropy Type"
  },
  "(0018,9151)": {
    tag: "(0018,9151)",
    vr: "DT",
    vm: "1",
    name: "Frame Reference Date Time"
  },
  "(0018,9152)": {
    tag: "(0018,9152)",
    vr: "SQ",
    vm: "1",
    name: "MRMetabolite Map Sequence"
  },
  "(0018,9155)": {
    tag: "(0018,9155)",
    vr: "FD",
    vm: "1",
    name: "Parallel Reduction Factor Out Of Plane"
  },
  "(0018,9159)": {
    tag: "(0018,9159)",
    vr: "UL",
    vm: "1",
    name: "Spectroscopy Acquisition Out Of Plane Phase Steps"
  },
  "(0018,9166)": {
    tag: "(0018,9166)",
    vr: "CS",
    vm: "1",
    name: "Bulk Motion Status"
  },
  "(0018,9168)": {
    tag: "(0018,9168)",
    vr: "FD",
    vm: "1",
    name: "Parallel Reduction Factor Second In Plane"
  },
  "(0018,9169)": {
    tag: "(0018,9169)",
    vr: "CS",
    vm: "1",
    name: "Cardiac Beat Rejection Technique"
  },
  "(0018,9170)": {
    tag: "(0018,9170)",
    vr: "CS",
    vm: "1",
    name: "Respiratory Motion Compensation Technique"
  },
  "(0018,9171)": {
    tag: "(0018,9171)",
    vr: "CS",
    vm: "1",
    name: "Respiratory Signal Source"
  },
  "(0018,9172)": {
    tag: "(0018,9172)",
    vr: "CS",
    vm: "1",
    name: "Bulk Motion Compensation Technique"
  },
  "(0018,9173)": {
    tag: "(0018,9173)",
    vr: "CS",
    vm: "1",
    name: "Bulk Motion Signal Source"
  },
  "(0018,9174)": {
    tag: "(0018,9174)",
    vr: "CS",
    vm: "1",
    name: "Applicable Safety Standard Agency"
  },
  "(0018,9175)": {
    tag: "(0018,9175)",
    vr: "LO",
    vm: "1",
    name: "Applicable Safety Standard Description"
  },
  "(0018,9176)": {
    tag: "(0018,9176)",
    vr: "SQ",
    vm: "1",
    name: "Operating Mode Sequence"
  },
  "(0018,9177)": {
    tag: "(0018,9177)",
    vr: "CS",
    vm: "1",
    name: "Operating Mode Type"
  },
  "(0018,9178)": {
    tag: "(0018,9178)",
    vr: "CS",
    vm: "1",
    name: "Operating Mode"
  },
  "(0018,9179)": {
    tag: "(0018,9179)",
    vr: "CS",
    vm: "1",
    name: "Specific Absorption Rate Definition"
  },
  "(0018,9180)": {
    tag: "(0018,9180)",
    vr: "CS",
    vm: "1",
    name: "Gradient Output Type"
  },
  "(0018,9181)": {
    tag: "(0018,9181)",
    vr: "FD",
    vm: "1",
    name: "Specific Absorption Rate Value"
  },
  "(0018,9182)": {
    tag: "(0018,9182)",
    vr: "FD",
    vm: "1",
    name: "Gradient Output"
  },
  "(0018,9183)": {
    tag: "(0018,9183)",
    vr: "CS",
    vm: "1",
    name: "Flow Compensation Direction"
  },
  "(0018,9184)": {
    tag: "(0018,9184)",
    vr: "FD",
    vm: "1",
    name: "Tagging Delay"
  },
  "(0018,9185)": {
    tag: "(0018,9185)",
    vr: "ST",
    vm: "1",
    name: "Respiratory Motion Compensation Technique Description"
  },
  "(0018,9186)": {
    tag: "(0018,9186)",
    vr: "SH",
    vm: "1",
    name: "Respiratory Signal Source ID"
  },
  "(0018,9195)": {
    tag: "(0018,9195)",
    vr: "FD",
    vm: "1",
    name: "Chemical Shift Minimum Integration Limit In Hz"
  },
  "(0018,9196)": {
    tag: "(0018,9196)",
    vr: "FD",
    vm: "1",
    name: "Chemical Shift Maximum Integration Limit In Hz"
  },
  "(0018,9197)": {
    tag: "(0018,9197)",
    vr: "SQ",
    vm: "1",
    name: "MRVelocity Encoding Sequence"
  },
  "(0018,9198)": {
    tag: "(0018,9198)",
    vr: "CS",
    vm: "1",
    name: "First Order Phase Correction"
  },
  "(0018,9199)": {
    tag: "(0018,9199)",
    vr: "CS",
    vm: "1",
    name: "Water Referenced Phase Correction"
  },
  "(0018,9200)": {
    tag: "(0018,9200)",
    vr: "CS",
    vm: "1",
    name: "MRSpectroscopy Acquisition Type"
  },
  "(0018,9214)": {
    tag: "(0018,9214)",
    vr: "CS",
    vm: "1",
    name: "Respiratory Cycle Position"
  },
  "(0018,9217)": {
    tag: "(0018,9217)",
    vr: "FD",
    vm: "1",
    name: "Velocity Encoding Maximum Value"
  },
  "(0018,9218)": {
    tag: "(0018,9218)",
    vr: "FD",
    vm: "1",
    name: "Tag Spacing Second Dimension"
  },
  "(0018,9219)": {
    tag: "(0018,9219)",
    vr: "SS",
    vm: "1",
    name: "Tag Angle Second Axis"
  },
  "(0018,9220)": {
    tag: "(0018,9220)",
    vr: "FD",
    vm: "1",
    name: "Frame Acquisition Duration"
  },
  "(0018,9226)": {
    tag: "(0018,9226)",
    vr: "SQ",
    vm: "1",
    name: "MRImage Frame Type Sequence"
  },
  "(0018,9227)": {
    tag: "(0018,9227)",
    vr: "SQ",
    vm: "1",
    name: "MRSpectroscopy Frame Type Sequence"
  },
  "(0018,9231)": {
    tag: "(0018,9231)",
    vr: "US",
    vm: "1",
    name: "MRAcquisition Phase Encoding Steps In Plane"
  },
  "(0018,9232)": {
    tag: "(0018,9232)",
    vr: "US",
    vm: "1",
    name: "MRAcquisition Phase Encoding Steps Out Of Plane"
  },
  "(0018,9234)": {
    tag: "(0018,9234)",
    vr: "UL",
    vm: "1",
    name: "Spectroscopy Acquisition Phase Columns"
  },
  "(0018,9236)": {
    tag: "(0018,9236)",
    vr: "CS",
    vm: "1",
    name: "Cardiac Cycle Position"
  },
  "(0018,9239)": {
    tag: "(0018,9239)",
    vr: "SQ",
    vm: "1",
    name: "Specific Absorption Rate Sequence"
  },
  "(0018,9240)": {
    tag: "(0018,9240)",
    vr: "US",
    vm: "1",
    name: "RFEcho Train Length"
  },
  "(0018,9241)": {
    tag: "(0018,9241)",
    vr: "US",
    vm: "1",
    name: "Gradient Echo Train Length"
  },
  "(0018,9250)": {
    tag: "(0018,9250)",
    vr: "CS",
    vm: "1",
    name: "Arterial Spin Labeling Contrast"
  },
  "(0018,9251)": {
    tag: "(0018,9251)",
    vr: "SQ",
    vm: "1",
    name: "MRArterial Spin Labeling Sequence"
  },
  "(0018,9252)": {
    tag: "(0018,9252)",
    vr: "LO",
    vm: "1",
    name: "ASLTechnique Description"
  },
  "(0018,9253)": {
    tag: "(0018,9253)",
    vr: "US",
    vm: "1",
    name: "ASLSlab Number"
  },
  "(0018,9254)": {
    tag: "(0018,9254)",
    vr: "FD",
    vm: "1 ",
    name: "ASLSlab Thickness"
  },
  "(0018,9255)": {
    tag: "(0018,9255)",
    vr: "FD",
    vm: "3 ",
    name: "ASLSlab Orientation"
  },
  "(0018,9256)": {
    tag: "(0018,9256)",
    vr: "FD",
    vm: "3",
    name: "ASLMid Slab Position"
  },
  "(0018,9257)": { tag: "(0018,9257)", vr: "CS", vm: "1 ", name: "ASLContext" },
  "(0018,9258)": {
    tag: "(0018,9258)",
    vr: "UL",
    vm: "1",
    name: "ASLPulse Train Duration"
  },
  "(0018,9259)": {
    tag: "(0018,9259)",
    vr: "CS",
    vm: "1 ",
    name: "ASLCrusher Flag"
  },
  "(0018,925A)": {
    tag: "(0018,925A)",
    vr: "FD",
    vm: "1",
    name: "ASLCrusher Flow"
  },
  "(0018,925B)": {
    tag: "(0018,925B)",
    vr: "LO",
    vm: "1",
    name: "ASLCrusher Description"
  },
  "(0018,925C)": {
    tag: "(0018,925C)",
    vr: "CS",
    vm: "1 ",
    name: "ASLBolus Cutoff Flag"
  },
  "(0018,925D)": {
    tag: "(0018,925D)",
    vr: "SQ",
    vm: "1",
    name: "ASLBolus Cutoff Timing Sequence"
  },
  "(0018,925E)": {
    tag: "(0018,925E)",
    vr: "LO",
    vm: "1",
    name: "ASLBolus Cutoff Technique"
  },
  "(0018,925F)": {
    tag: "(0018,925F)",
    vr: "UL",
    vm: "1",
    name: "ASLBolus Cutoff Delay Time"
  },
  "(0018,9260)": {
    tag: "(0018,9260)",
    vr: "SQ",
    vm: "1",
    name: "ASLSlab Sequence"
  },
  "(0018,9295)": {
    tag: "(0018,9295)",
    vr: "FD",
    vm: "1",
    name: "Chemical Shift Minimum Integration Limit Inppm"
  },
  "(0018,9296)": {
    tag: "(0018,9296)",
    vr: "FD",
    vm: "1",
    name: "Chemical Shift Maximum Integration Limit Inppm"
  },
  "(0018,9301)": {
    tag: "(0018,9301)",
    vr: "SQ",
    vm: "1",
    name: "CTAcquisition Type Sequence"
  },
  "(0018,9302)": {
    tag: "(0018,9302)",
    vr: "CS",
    vm: "1",
    name: "Acquisition Type"
  },
  "(0018,9303)": { tag: "(0018,9303)", vr: "FD", vm: "1", name: "Tube Angle" },
  "(0018,9304)": {
    tag: "(0018,9304)",
    vr: "SQ",
    vm: "1",
    name: "CTAcquisition Details Sequence"
  },
  "(0018,9305)": {
    tag: "(0018,9305)",
    vr: "FD",
    vm: "1",
    name: "Revolution Time"
  },
  "(0018,9306)": {
    tag: "(0018,9306)",
    vr: "FD",
    vm: "1",
    name: "Single Collimation Width"
  },
  "(0018,9307)": {
    tag: "(0018,9307)",
    vr: "FD",
    vm: "1",
    name: "Total Collimation Width"
  },
  "(0018,9308)": {
    tag: "(0018,9308)",
    vr: "SQ",
    vm: "1",
    name: "CTTable Dynamics Sequence"
  },
  "(0018,9309)": { tag: "(0018,9309)", vr: "FD", vm: "1", name: "Table Speed" },
  "(0018,9310)": {
    tag: "(0018,9310)",
    vr: "FD",
    vm: "1",
    name: "Table Feed Per Rotation"
  },
  "(0018,9311)": {
    tag: "(0018,9311)",
    vr: "FD",
    vm: "1",
    name: "Spiral Pitch Factor"
  },
  "(0018,9312)": {
    tag: "(0018,9312)",
    vr: "SQ",
    vm: "1",
    name: "CTGeometry Sequence"
  },
  "(0018,9313)": {
    tag: "(0018,9313)",
    vr: "FD",
    vm: "3",
    name: "Data Collection Center Patient"
  },
  "(0018,9314)": {
    tag: "(0018,9314)",
    vr: "SQ",
    vm: "1",
    name: "CTReconstruction Sequence"
  },
  "(0018,9315)": {
    tag: "(0018,9315)",
    vr: "CS",
    vm: "1",
    name: "Reconstruction Algorithm"
  },
  "(0018,9316)": {
    tag: "(0018,9316)",
    vr: "CS",
    vm: "1",
    name: "Convolution Kernel Group"
  },
  "(0018,9317)": {
    tag: "(0018,9317)",
    vr: "FD",
    vm: "2",
    name: "Reconstruction Field Of View"
  },
  "(0018,9318)": {
    tag: "(0018,9318)",
    vr: "FD",
    vm: "3",
    name: "Reconstruction Target Center Patient"
  },
  "(0018,9319)": {
    tag: "(0018,9319)",
    vr: "FD",
    vm: "1",
    name: "Reconstruction Angle"
  },
  "(0018,9320)": {
    tag: "(0018,9320)",
    vr: "SH",
    vm: "1",
    name: "Image Filter"
  },
  "(0018,9321)": {
    tag: "(0018,9321)",
    vr: "SQ",
    vm: "1",
    name: "CTExposure Sequence"
  },
  "(0018,9322)": {
    tag: "(0018,9322)",
    vr: "FD",
    vm: "2",
    name: "Reconstruction Pixel Spacing"
  },
  "(0018,9323)": {
    tag: "(0018,9323)",
    vr: "CS",
    vm: "1",
    name: "Exposure Modulation Type"
  },
  "(0018,9324)": {
    tag: "(0018,9324)",
    vr: "FD",
    vm: "1",
    name: "Estimated Dose Saving"
  },
  "(0018,9325)": {
    tag: "(0018,9325)",
    vr: "SQ",
    vm: "1",
    name: "CTXRay Details Sequence"
  },
  "(0018,9326)": {
    tag: "(0018,9326)",
    vr: "SQ",
    vm: "1",
    name: "CTPosition Sequence"
  },
  "(0018,9327)": {
    tag: "(0018,9327)",
    vr: "FD",
    vm: "1",
    name: "Table Position"
  },
  "(0018,9328)": {
    tag: "(0018,9328)",
    vr: "FD",
    vm: "1",
    name: "Exposure Time Inms"
  },
  "(0018,9329)": {
    tag: "(0018,9329)",
    vr: "SQ",
    vm: "1",
    name: "CTImage Frame Type Sequence"
  },
  "(0018,9330)": {
    tag: "(0018,9330)",
    vr: "FD",
    vm: "1",
    name: "XRay Tube Current Inm A"
  },
  "(0018,9332)": {
    tag: "(0018,9332)",
    vr: "FD",
    vm: "1",
    name: "Exposure Inm As"
  },
  "(0018,9333)": {
    tag: "(0018,9333)",
    vr: "CS",
    vm: "1",
    name: "Constant Volume Flag"
  },
  "(0018,9334)": {
    tag: "(0018,9334)",
    vr: "CS",
    vm: "1",
    name: "Fluoroscopy Flag"
  },
  "(0018,9335)": {
    tag: "(0018,9335)",
    vr: "FD",
    vm: "1",
    name: "Distance Source To Data Collection Center"
  },
  "(0018,9337)": {
    tag: "(0018,9337)",
    vr: "US",
    vm: "1",
    name: "Contrast Bolus Agent Number"
  },
  "(0018,9338)": {
    tag: "(0018,9338)",
    vr: "SQ",
    vm: "1",
    name: "Contrast Bolus Ingredient Code Sequence"
  },
  "(0018,9340)": {
    tag: "(0018,9340)",
    vr: "SQ",
    vm: "1",
    name: "Contrast Administration Profile Sequence"
  },
  "(0018,9341)": {
    tag: "(0018,9341)",
    vr: "SQ",
    vm: "1",
    name: "Contrast Bolus Usage Sequence"
  },
  "(0018,9342)": {
    tag: "(0018,9342)",
    vr: "CS",
    vm: "1",
    name: "Contrast Bolus Agent Administered"
  },
  "(0018,9343)": {
    tag: "(0018,9343)",
    vr: "CS",
    vm: "1",
    name: "Contrast Bolus Agent Detected"
  },
  "(0018,9344)": {
    tag: "(0018,9344)",
    vr: "CS",
    vm: "1",
    name: "Contrast Bolus Agent Phase"
  },
  "(0018,9345)": { tag: "(0018,9345)", vr: "FD", vm: "1", name: "CTDIvol" },
  "(0018,9346)": {
    tag: "(0018,9346)",
    vr: "SQ",
    vm: "1",
    name: "CTDIPhantom Type Code Sequence"
  },
  "(0018,9351)": {
    tag: "(0018,9351)",
    vr: "FL",
    vm: "1",
    name: "Calcium Scoring Mass Factor Patient"
  },
  "(0018,9352)": {
    tag: "(0018,9352)",
    vr: "FL",
    vm: "3",
    name: "Calcium Scoring Mass Factor Device"
  },
  "(0018,9353)": {
    tag: "(0018,9353)",
    vr: "FL",
    vm: "1",
    name: "Energy Weighting Factor"
  },
  "(0018,9360)": {
    tag: "(0018,9360)",
    vr: "SQ",
    vm: "1",
    name: "CTAdditional XRay Source Sequence"
  },
  "(0018,9401)": {
    tag: "(0018,9401)",
    vr: "SQ",
    vm: "1",
    name: "Projection Pixel Calibration Sequence"
  },
  "(0018,9402)": {
    tag: "(0018,9402)",
    vr: "FL",
    vm: "1",
    name: "Distance Source To Isocenter"
  },
  "(0018,9403)": {
    tag: "(0018,9403)",
    vr: "FL",
    vm: "1",
    name: "Distance Object To Table Top"
  },
  "(0018,9404)": {
    tag: "(0018,9404)",
    vr: "FL",
    vm: "2",
    name: "Object Pixel Spacing In Center Of Beam"
  },
  "(0018,9405)": {
    tag: "(0018,9405)",
    vr: "SQ",
    vm: "1",
    name: "Positioner Position Sequence"
  },
  "(0018,9406)": {
    tag: "(0018,9406)",
    vr: "SQ",
    vm: "1",
    name: "Table Position Sequence"
  },
  "(0018,9407)": {
    tag: "(0018,9407)",
    vr: "SQ",
    vm: "1",
    name: "Collimator Shape Sequence"
  },
  "(0018,9410)": {
    tag: "(0018,9410)",
    vr: "CS",
    vm: "1",
    name: "Planes In Acquisition"
  },
  "(0018,9412)": {
    tag: "(0018,9412)",
    vr: "SQ",
    vm: "1",
    name: "XAXRFFrame Characteristics Sequence"
  },
  "(0018,9417)": {
    tag: "(0018,9417)",
    vr: "SQ",
    vm: "1",
    name: "Frame Acquisition Sequence"
  },
  "(0018,9420)": {
    tag: "(0018,9420)",
    vr: "CS",
    vm: "1",
    name: "XRay Receptor Type"
  },
  "(0018,9423)": {
    tag: "(0018,9423)",
    vr: "LO",
    vm: "1",
    name: "Acquisition Protocol Name"
  },
  "(0018,9424)": {
    tag: "(0018,9424)",
    vr: "LT",
    vm: "1",
    name: "Acquisition Protocol Description"
  },
  "(0018,9425)": {
    tag: "(0018,9425)",
    vr: "CS",
    vm: "1",
    name: "Contrast Bolus Ingredient Opaque"
  },
  "(0018,9426)": {
    tag: "(0018,9426)",
    vr: "FL",
    vm: "1",
    name: "Distance Receptor Plane To Detector Housing"
  },
  "(0018,9427)": {
    tag: "(0018,9427)",
    vr: "CS",
    vm: "1",
    name: "Intensifier Active Shape"
  },
  "(0018,9428)": {
    tag: "(0018,9428)",
    vr: "FL",
    vm: "1-2",
    name: "Intensifier Active Dimensions"
  },
  "(0018,9429)": {
    tag: "(0018,9429)",
    vr: "FL",
    vm: "2",
    name: "Physical Detector Size"
  },
  "(0018,9430)": {
    tag: "(0018,9430)",
    vr: "FL",
    vm: "2",
    name: "Position Of Isocenter Projection"
  },
  "(0018,9432)": {
    tag: "(0018,9432)",
    vr: "SQ",
    vm: "1",
    name: "Field Of View Sequence"
  },
  "(0018,9433)": {
    tag: "(0018,9433)",
    vr: "LO",
    vm: "1",
    name: "Field Of View Description"
  },
  "(0018,9434)": {
    tag: "(0018,9434)",
    vr: "SQ",
    vm: "1",
    name: "Exposure Control Sensing Regions Sequence"
  },
  "(0018,9435)": {
    tag: "(0018,9435)",
    vr: "CS",
    vm: "1",
    name: "Exposure Control Sensing Region Shape"
  },
  "(0018,9436)": {
    tag: "(0018,9436)",
    vr: "SS",
    vm: "1",
    name: "Exposure Control Sensing Region Left Vertical Edge"
  },
  "(0018,9437)": {
    tag: "(0018,9437)",
    vr: "SS",
    vm: "1",
    name: "Exposure Control Sensing Region Right Vertical Edge"
  },
  "(0018,9438)": {
    tag: "(0018,9438)",
    vr: "SS",
    vm: "1",
    name: "Exposure Control Sensing Region Upper Horizontal Edge"
  },
  "(0018,9439)": {
    tag: "(0018,9439)",
    vr: "SS",
    vm: "1",
    name: "Exposure Control Sensing Region Lower Horizontal Edge"
  },
  "(0018,9440)": {
    tag: "(0018,9440)",
    vr: "SS",
    vm: "2",
    name: "Center Of Circular Exposure Control Sensing Region"
  },
  "(0018,9441)": {
    tag: "(0018,9441)",
    vr: "US",
    vm: "1",
    name: "Radius Of Circular Exposure Control Sensing Region"
  },
  "(0018,9442)": {
    tag: "(0018,9442)",
    vr: "SS",
    vm: "2",
    name: "Vertices Of The Polygonal Exposure Control Sensing Region"
  },
  "(0018,9447)": {
    tag: "(0018,9447)",
    vr: "FL",
    vm: "1",
    name: "Column Angulation Patient"
  },
  "(0018,9449)": { tag: "(0018,9449)", vr: "FL", vm: "1", name: "Beam Angle" },
  "(0018,9451)": {
    tag: "(0018,9451)",
    vr: "SQ",
    vm: "1",
    name: "Frame Detector Parameters Sequence"
  },
  "(0018,9452)": {
    tag: "(0018,9452)",
    vr: "FL",
    vm: "1",
    name: "Calculated Anatomy Thickness"
  },
  "(0018,9455)": {
    tag: "(0018,9455)",
    vr: "SQ",
    vm: "1",
    name: "Calibration Sequence"
  },
  "(0018,9456)": {
    tag: "(0018,9456)",
    vr: "SQ",
    vm: "1",
    name: "Object Thickness Sequence"
  },
  "(0018,9457)": {
    tag: "(0018,9457)",
    vr: "CS",
    vm: "1",
    name: "Plane Identification"
  },
  "(0018,9461)": {
    tag: "(0018,9461)",
    vr: "FL",
    vm: "1-2",
    name: "Field Of View Dimensions In Float"
  },
  "(0018,9462)": {
    tag: "(0018,9462)",
    vr: "SQ",
    vm: "1",
    name: "Isocenter Reference System Sequence"
  },
  "(0018,9463)": {
    tag: "(0018,9463)",
    vr: "FL",
    vm: "1",
    name: "Positioner Isocenter Primary Angle"
  },
  "(0018,9464)": {
    tag: "(0018,9464)",
    vr: "FL",
    vm: "1",
    name: "Positioner Isocenter Secondary Angle"
  },
  "(0018,9465)": {
    tag: "(0018,9465)",
    vr: "FL",
    vm: "1",
    name: "Positioner Isocenter Detector Rotation Angle"
  },
  "(0018,9466)": {
    tag: "(0018,9466)",
    vr: "FL",
    vm: "1",
    name: "Table XPosition To Isocenter"
  },
  "(0018,9467)": {
    tag: "(0018,9467)",
    vr: "FL",
    vm: "1",
    name: "Table YPosition To Isocenter"
  },
  "(0018,9468)": {
    tag: "(0018,9468)",
    vr: "FL",
    vm: "1",
    name: "Table ZPosition To Isocenter"
  },
  "(0018,9469)": {
    tag: "(0018,9469)",
    vr: "FL",
    vm: "1",
    name: "Table Horizontal Rotation Angle"
  },
  "(0018,9470)": {
    tag: "(0018,9470)",
    vr: "FL",
    vm: "1",
    name: "Table Head Tilt Angle"
  },
  "(0018,9471)": {
    tag: "(0018,9471)",
    vr: "FL",
    vm: "1",
    name: "Table Cradle Tilt Angle"
  },
  "(0018,9472)": {
    tag: "(0018,9472)",
    vr: "SQ",
    vm: "1",
    name: "Frame Display Shutter Sequence"
  },
  "(0018,9473)": {
    tag: "(0018,9473)",
    vr: "FL",
    vm: "1",
    name: "Acquired Image Area Dose Product"
  },
  "(0018,9474)": {
    tag: "(0018,9474)",
    vr: "CS",
    vm: "1",
    name: "CArm Positioner Tabletop Relationship"
  },
  "(0018,9476)": {
    tag: "(0018,9476)",
    vr: "SQ",
    vm: "1",
    name: "XRay Geometry Sequence"
  },
  "(0018,9477)": {
    tag: "(0018,9477)",
    vr: "SQ",
    vm: "1",
    name: "Irradiation Event Identification Sequence"
  },
  "(0018,9504)": {
    tag: "(0018,9504)",
    vr: "SQ",
    vm: "1",
    name: "XRay3DFrame Type Sequence"
  },
  "(0018,9506)": {
    tag: "(0018,9506)",
    vr: "SQ",
    vm: "1",
    name: "Contributing Sources Sequence"
  },
  "(0018,9507)": {
    tag: "(0018,9507)",
    vr: "SQ",
    vm: "1",
    name: "XRay3DAcquisition Sequence"
  },
  "(0018,9508)": {
    tag: "(0018,9508)",
    vr: "FL",
    vm: "1",
    name: "Primary Positioner Scan Arc"
  },
  "(0018,9509)": {
    tag: "(0018,9509)",
    vr: "FL",
    vm: "1",
    name: "Secondary Positioner Scan Arc"
  },
  "(0018,9510)": {
    tag: "(0018,9510)",
    vr: "FL",
    vm: "1",
    name: "Primary Positioner Scan Start Angle"
  },
  "(0018,9511)": {
    tag: "(0018,9511)",
    vr: "FL",
    vm: "1",
    name: "Secondary Positioner Scan Start Angle"
  },
  "(0018,9514)": {
    tag: "(0018,9514)",
    vr: "FL",
    vm: "1",
    name: "Primary Positioner Increment"
  },
  "(0018,9515)": {
    tag: "(0018,9515)",
    vr: "FL",
    vm: "1",
    name: "Secondary Positioner Increment"
  },
  "(0018,9516)": {
    tag: "(0018,9516)",
    vr: "DT",
    vm: "1",
    name: "Start Acquisition Date Time"
  },
  "(0018,9517)": {
    tag: "(0018,9517)",
    vr: "DT",
    vm: "1",
    name: "End Acquisition Date Time"
  },
  "(0018,9524)": {
    tag: "(0018,9524)",
    vr: "LO",
    vm: "1",
    name: "Application Name"
  },
  "(0018,9525)": {
    tag: "(0018,9525)",
    vr: "LO",
    vm: "1",
    name: "Application Version"
  },
  "(0018,9526)": {
    tag: "(0018,9526)",
    vr: "LO",
    vm: "1",
    name: "Application Manufacturer"
  },
  "(0018,9527)": {
    tag: "(0018,9527)",
    vr: "CS",
    vm: "1",
    name: "Algorithm Type"
  },
  "(0018,9528)": {
    tag: "(0018,9528)",
    vr: "LO",
    vm: "1",
    name: "Algorithm Description"
  },
  "(0018,9530)": {
    tag: "(0018,9530)",
    vr: "SQ",
    vm: "1",
    name: "XRay3DReconstruction Sequence"
  },
  "(0018,9531)": {
    tag: "(0018,9531)",
    vr: "LO",
    vm: "1",
    name: "Reconstruction Description"
  },
  "(0018,9538)": {
    tag: "(0018,9538)",
    vr: "SQ",
    vm: "1",
    name: "Per Projection Acquisition Sequence"
  },
  "(0018,9601)": {
    tag: "(0018,9601)",
    vr: "SQ",
    vm: "1",
    name: "Diffusion BMatrix Sequence"
  },
  "(0018,9602)": {
    tag: "(0018,9602)",
    vr: "FD",
    vm: "1",
    name: "Diffusion BValue XX"
  },
  "(0018,9603)": {
    tag: "(0018,9603)",
    vr: "FD",
    vm: "1",
    name: "Diffusion BValue XY"
  },
  "(0018,9604)": {
    tag: "(0018,9604)",
    vr: "FD",
    vm: "1",
    name: "Diffusion BValue XZ"
  },
  "(0018,9605)": {
    tag: "(0018,9605)",
    vr: "FD",
    vm: "1",
    name: "Diffusion BValue YY"
  },
  "(0018,9606)": {
    tag: "(0018,9606)",
    vr: "FD",
    vm: "1",
    name: "Diffusion BValue YZ"
  },
  "(0018,9607)": {
    tag: "(0018,9607)",
    vr: "FD",
    vm: "1",
    name: "Diffusion BValue ZZ"
  },
  "(0018,9701)": {
    tag: "(0018,9701)",
    vr: "DT",
    vm: "1",
    name: "Decay Correction Date Time"
  },
  "(0018,9715)": {
    tag: "(0018,9715)",
    vr: "FD",
    vm: "1",
    name: "Start Density Threshold"
  },
  "(0018,9716)": {
    tag: "(0018,9716)",
    vr: "FD",
    vm: "1",
    name: "Start Relative Density Difference Threshold"
  },
  "(0018,9717)": {
    tag: "(0018,9717)",
    vr: "FD",
    vm: "1",
    name: "Start Cardiac Trigger Count Threshold"
  },
  "(0018,9718)": {
    tag: "(0018,9718)",
    vr: "FD",
    vm: "1",
    name: "Start Respiratory Trigger Count Threshold"
  },
  "(0018,9719)": {
    tag: "(0018,9719)",
    vr: "FD",
    vm: "1",
    name: "Termination Counts Threshold"
  },
  "(0018,9720)": {
    tag: "(0018,9720)",
    vr: "FD",
    vm: "1",
    name: "Termination Density Threshold"
  },
  "(0018,9721)": {
    tag: "(0018,9721)",
    vr: "FD",
    vm: "1",
    name: "Termination Relative Density Threshold"
  },
  "(0018,9722)": {
    tag: "(0018,9722)",
    vr: "FD",
    vm: "1",
    name: "Termination Time Threshold"
  },
  "(0018,9723)": {
    tag: "(0018,9723)",
    vr: "FD",
    vm: "1",
    name: "Termination Cardiac Trigger Count Threshold"
  },
  "(0018,9724)": {
    tag: "(0018,9724)",
    vr: "FD",
    vm: "1",
    name: "Termination Respiratory Trigger Count Threshold"
  },
  "(0018,9725)": {
    tag: "(0018,9725)",
    vr: "CS",
    vm: "1",
    name: "Detector Geometry"
  },
  "(0018,9726)": {
    tag: "(0018,9726)",
    vr: "FD",
    vm: "1",
    name: "Transverse Detector Separation"
  },
  "(0018,9727)": {
    tag: "(0018,9727)",
    vr: "FD",
    vm: "1",
    name: "Axial Detector Dimension"
  },
  "(0018,9729)": {
    tag: "(0018,9729)",
    vr: "US",
    vm: "1",
    name: "Radiopharmaceutical Agent Number"
  },
  "(0018,9732)": {
    tag: "(0018,9732)",
    vr: "SQ",
    vm: "1",
    name: "PETFrame Acquisition Sequence"
  },
  "(0018,9733)": {
    tag: "(0018,9733)",
    vr: "SQ",
    vm: "1",
    name: "PETDetector Motion Details Sequence"
  },
  "(0018,9734)": {
    tag: "(0018,9734)",
    vr: "SQ",
    vm: "1",
    name: "PETTable Dynamics Sequence"
  },
  "(0018,9735)": {
    tag: "(0018,9735)",
    vr: "SQ",
    vm: "1",
    name: "PETPosition Sequence"
  },
  "(0018,9736)": {
    tag: "(0018,9736)",
    vr: "SQ",
    vm: "1",
    name: "PETFrame Correction Factors Sequence"
  },
  "(0018,9737)": {
    tag: "(0018,9737)",
    vr: "SQ",
    vm: "1",
    name: "Radiopharmaceutical Usage Sequence"
  },
  "(0018,9738)": {
    tag: "(0018,9738)",
    vr: "CS",
    vm: "1",
    name: "Attenuation Correction Source"
  },
  "(0018,9739)": {
    tag: "(0018,9739)",
    vr: "US",
    vm: "1",
    name: "Number Of Iterations"
  },
  "(0018,9740)": {
    tag: "(0018,9740)",
    vr: "US",
    vm: "1",
    name: "Number Of Subsets"
  },
  "(0018,9749)": {
    tag: "(0018,9749)",
    vr: "SQ",
    vm: "1",
    name: "PETReconstruction Sequence"
  },
  "(0018,9751)": {
    tag: "(0018,9751)",
    vr: "SQ",
    vm: "1",
    name: "PETFrame Type Sequence"
  },
  "(0018,9755)": {
    tag: "(0018,9755)",
    vr: "CS",
    vm: "1",
    name: "Time Of Flight Information Used"
  },
  "(0018,9756)": {
    tag: "(0018,9756)",
    vr: "CS",
    vm: "1",
    name: "Reconstruction Type"
  },
  "(0018,9758)": {
    tag: "(0018,9758)",
    vr: "CS",
    vm: "1",
    name: "Decay Corrected"
  },
  "(0018,9759)": {
    tag: "(0018,9759)",
    vr: "CS",
    vm: "1",
    name: "Attenuation Corrected"
  },
  "(0018,9760)": {
    tag: "(0018,9760)",
    vr: "CS",
    vm: "1",
    name: "Scatter Corrected"
  },
  "(0018,9761)": {
    tag: "(0018,9761)",
    vr: "CS",
    vm: "1",
    name: "Dead Time Corrected"
  },
  "(0018,9762)": {
    tag: "(0018,9762)",
    vr: "CS",
    vm: "1",
    name: "Gantry Motion Corrected"
  },
  "(0018,9763)": {
    tag: "(0018,9763)",
    vr: "CS",
    vm: "1",
    name: "Patient Motion Corrected"
  },
  "(0018,9764)": {
    tag: "(0018,9764)",
    vr: "CS",
    vm: "1",
    name: "Count Loss Normalization Corrected"
  },
  "(0018,9765)": {
    tag: "(0018,9765)",
    vr: "CS",
    vm: "1",
    name: "Randoms Corrected"
  },
  "(0018,9766)": {
    tag: "(0018,9766)",
    vr: "CS",
    vm: "1",
    name: "Non Uniform Radial Sampling Corrected"
  },
  "(0018,9767)": {
    tag: "(0018,9767)",
    vr: "CS",
    vm: "1",
    name: "Sensitivity Calibrated"
  },
  "(0018,9768)": {
    tag: "(0018,9768)",
    vr: "CS",
    vm: "1",
    name: "Detector Normalization Correction"
  },
  "(0018,9769)": {
    tag: "(0018,9769)",
    vr: "CS",
    vm: "1",
    name: "Iterative Reconstruction Method"
  },
  "(0018,9770)": {
    tag: "(0018,9770)",
    vr: "CS",
    vm: "1",
    name: "Attenuation Correction Temporal Relationship"
  },
  "(0018,9771)": {
    tag: "(0018,9771)",
    vr: "SQ",
    vm: "1",
    name: "Patient Physiological State Sequence"
  },
  "(0018,9772)": {
    tag: "(0018,9772)",
    vr: "SQ",
    vm: "1",
    name: "Patient Physiological State Code Sequence"
  },
  "(0018,9801)": {
    tag: "(0018,9801)",
    vr: "FD",
    vm: "1",
    name: "Depths Of Focus"
  },
  "(0018,9803)": {
    tag: "(0018,9803)",
    vr: "SQ",
    vm: "1",
    name: "Excluded Intervals Sequence"
  },
  "(0018,9804)": {
    tag: "(0018,9804)",
    vr: "DT",
    vm: "1",
    name: "Exclusion Start Datetime"
  },
  "(0018,9805)": {
    tag: "(0018,9805)",
    vr: "FD",
    vm: "1",
    name: "Exclusion Duration"
  },
  "(0018,9806)": {
    tag: "(0018,9806)",
    vr: "SQ",
    vm: "1",
    name: "USImage Description Sequence"
  },
  "(0018,9807)": {
    tag: "(0018,9807)",
    vr: "SQ",
    vm: "1",
    name: "Image Data Type Sequence"
  },
  "(0018,9808)": { tag: "(0018,9808)", vr: "CS", vm: "1", name: "Data Type" },
  "(0018,9809)": {
    tag: "(0018,9809)",
    vr: "SQ",
    vm: "1",
    name: "Transducer Scan Pattern Code Sequence"
  },
  "(0018,980B)": {
    tag: "(0018,980B)",
    vr: "CS",
    vm: "1",
    name: "Aliased Data Type"
  },
  "(0018,980C)": {
    tag: "(0018,980C)",
    vr: "CS",
    vm: "1",
    name: "Position Measuring Device Used"
  },
  "(0018,980D)": {
    tag: "(0018,980D)",
    vr: "SQ",
    vm: "1",
    name: "Transducer Geometry Code Sequence"
  },
  "(0018,980E)": {
    tag: "(0018,980E)",
    vr: "SQ",
    vm: "1",
    name: "Transducer Beam Steering Code Sequence"
  },
  "(0018,980F)": {
    tag: "(0018,980F)",
    vr: "SQ",
    vm: "1",
    name: "Transducer Application Code Sequence"
  },
  "(0018,A001)": {
    tag: "(0018,A001)",
    vr: "SQ",
    vm: "1",
    name: "Contributing Equipment Sequence"
  },
  "(0018,A002)": {
    tag: "(0018,A002)",
    vr: "DT",
    vm: "1",
    name: "Contribution Date Time"
  },
  "(0018,A003)": {
    tag: "(0018,A003)",
    vr: "ST",
    vm: "1",
    name: "Contribution Description"
  },
  "(0020,000D)": {
    tag: "(0020,000D)",
    vr: "UI",
    vm: "1",
    name: "Study Instance UID"
  },
  "(0020,000E)": {
    tag: "(0020,000E)",
    vr: "UI",
    vm: "1",
    name: "Series Instance UID"
  },
  "(0020,0010)": { tag: "(0020,0010)", vr: "SH", vm: "1", name: "Study ID" },
  "(0020,0011)": {
    tag: "(0020,0011)",
    vr: "IS",
    vm: "1",
    name: "Series Number"
  },
  "(0020,0012)": {
    tag: "(0020,0012)",
    vr: "IS",
    vm: "1",
    name: "Acquisition Number"
  },
  "(0020,0013)": {
    tag: "(0020,0013)",
    vr: "IS",
    vm: "1",
    name: "Instance Number"
  },
  "(0020,0014)": {
    tag: "(0020,0014)",
    vr: "IS",
    vm: "1",
    name: "Isotope Number"
  },
  "(0020,0015)": {
    tag: "(0020,0015)",
    vr: "IS",
    vm: "1",
    name: "Phase Number"
  },
  "(0020,0016)": {
    tag: "(0020,0016)",
    vr: "IS",
    vm: "1",
    name: "Interval Number"
  },
  "(0020,0017)": {
    tag: "(0020,0017)",
    vr: "IS",
    vm: "1",
    name: "Time Slot Number"
  },
  "(0020,0018)": {
    tag: "(0020,0018)",
    vr: "IS",
    vm: "1",
    name: "Angle Number"
  },
  "(0020,0019)": { tag: "(0020,0019)", vr: "IS", vm: "1", name: "Item Number" },
  "(0020,0020)": {
    tag: "(0020,0020)",
    vr: "CS",
    vm: "2",
    name: "Patient Orientation"
  },
  "(0020,0022)": {
    tag: "(0020,0022)",
    vr: "IS",
    vm: "1",
    name: "Overlay Number"
  },
  "(0020,0024)": {
    tag: "(0020,0024)",
    vr: "IS",
    vm: "1",
    name: "Curve Number"
  },
  "(0020,0026)": { tag: "(0020,0026)", vr: "IS", vm: "1", name: "LUTNumber" },
  "(0020,0030)": {
    tag: "(0020,0030)",
    vr: "DS",
    vm: "3",
    name: "Image Position"
  },
  "(0020,0032)": {
    tag: "(0020,0032)",
    vr: "DS",
    vm: "3",
    name: "Image Position Patient"
  },
  "(0020,0035)": {
    tag: "(0020,0035)",
    vr: "DS",
    vm: "6",
    name: "Image Orientation"
  },
  "(0020,0037)": {
    tag: "(0020,0037)",
    vr: "DS",
    vm: "6",
    name: "Image Orientation Patient"
  },
  "(0020,0050)": { tag: "(0020,0050)", vr: "DS", vm: "1", name: "Location" },
  "(0020,0052)": {
    tag: "(0020,0052)",
    vr: "UI",
    vm: "1",
    name: "Frame Of Reference UID"
  },
  "(0020,0060)": { tag: "(0020,0060)", vr: "CS", vm: "1", name: "Laterality" },
  "(0020,0062)": {
    tag: "(0020,0062)",
    vr: "CS",
    vm: "1",
    name: "Image Laterality"
  },
  "(0020,0070)": {
    tag: "(0020,0070)",
    vr: "LO",
    vm: "1",
    name: "Image Geometry Type"
  },
  "(0020,0080)": {
    tag: "(0020,0080)",
    vr: "CS",
    vm: "1",
    name: "Masking Image"
  },
  "(0020,00AA)": {
    tag: "(0020,00AA)",
    vr: "IS",
    vm: "1",
    name: "Report Number"
  },
  "(0020,0100)": {
    tag: "(0020,0100)",
    vr: "IS",
    vm: "1",
    name: "Temporal Position Identifier"
  },
  "(0020,0105)": {
    tag: "(0020,0105)",
    vr: "IS",
    vm: "1",
    name: "Number Of Temporal Positions"
  },
  "(0020,0110)": {
    tag: "(0020,0110)",
    vr: "DS",
    vm: "1",
    name: "Temporal Resolution"
  },
  "(0020,0200)": {
    tag: "(0020,0200)",
    vr: "UI",
    vm: "1",
    name: "Synchronization Frame Of Reference UID"
  },
  "(0020,0242)": {
    tag: "(0020,0242)",
    vr: "UI",
    vm: "1",
    name: "SOPInstance UIDOf Concatenation Source"
  },
  "(0020,1000)": {
    tag: "(0020,1000)",
    vr: "IS",
    vm: "1",
    name: "Series In Study"
  },
  "(0020,1001)": {
    tag: "(0020,1001)",
    vr: "IS",
    vm: "1",
    name: "Acquisitions In Series"
  },
  "(0020,1002)": {
    tag: "(0020,1002)",
    vr: "IS",
    vm: "1",
    name: "Images In Acquisition"
  },
  "(0020,1003)": {
    tag: "(0020,1003)",
    vr: "IS",
    vm: "1",
    name: "Images In Series"
  },
  "(0020,1004)": {
    tag: "(0020,1004)",
    vr: "IS",
    vm: "1",
    name: "Acquisitions In Study"
  },
  "(0020,1005)": {
    tag: "(0020,1005)",
    vr: "IS",
    vm: "1",
    name: "Images In Study"
  },
  "(0020,1020)": { tag: "(0020,1020)", vr: "LO", vm: "1", name: "Reference" },
  "(0020,1040)": {
    tag: "(0020,1040)",
    vr: "LO",
    vm: "1",
    name: "Position Reference Indicator"
  },
  "(0020,1041)": {
    tag: "(0020,1041)",
    vr: "DS",
    vm: "1",
    name: "Slice Location"
  },
  "(0020,1070)": {
    tag: "(0020,1070)",
    vr: "IS",
    vm: "1",
    name: "Other Study Numbers"
  },
  "(0020,1200)": {
    tag: "(0020,1200)",
    vr: "IS",
    vm: "1",
    name: "Number Of Patient Related Studies"
  },
  "(0020,1202)": {
    tag: "(0020,1202)",
    vr: "IS",
    vm: "1",
    name: "Number Of Patient Related Series"
  },
  "(0020,1204)": {
    tag: "(0020,1204)",
    vr: "IS",
    vm: "1",
    name: "Number Of Patient Related Instances"
  },
  "(0020,1206)": {
    tag: "(0020,1206)",
    vr: "IS",
    vm: "1",
    name: "Number Of Study Related Series"
  },
  "(0020,1208)": {
    tag: "(0020,1208)",
    vr: "IS",
    vm: "1",
    name: "Number Of Study Related Instances"
  },
  "(0020,1209)": {
    tag: "(0020,1209)",
    vr: "IS",
    vm: "1",
    name: "Number Of Series Related Instances"
  },
  "(0020,31xx)": {
    tag: "(0020,31xx)",
    vr: "CS",
    vm: "1",
    name: "Source Image IDs"
  },
  "(0020,3401)": {
    tag: "(0020,3401)",
    vr: "CS",
    vm: "1",
    name: "Modifying Device ID"
  },
  "(0020,3402)": {
    tag: "(0020,3402)",
    vr: "CS",
    vm: "1",
    name: "Modified Image ID"
  },
  "(0020,3403)": {
    tag: "(0020,3403)",
    vr: "DA",
    vm: "1",
    name: "Modified Image Date"
  },
  "(0020,3404)": {
    tag: "(0020,3404)",
    vr: "LO",
    vm: "1",
    name: "Modifying Device Manufacturer"
  },
  "(0020,3405)": {
    tag: "(0020,3405)",
    vr: "TM",
    vm: "1",
    name: "Modified Image Time"
  },
  "(0020,3406)": {
    tag: "(0020,3406)",
    vr: "LO",
    vm: "1",
    name: "Modified Image Description"
  },
  "(0020,4000)": {
    tag: "(0020,4000)",
    vr: "LT",
    vm: "1",
    name: "Image Comments"
  },
  "(0020,5000)": {
    tag: "(0020,5000)",
    vr: "AT",
    vm: "1",
    name: "Original Image Identification"
  },
  "(0020,5002)": {
    tag: "(0020,5002)",
    vr: "LO",
    vm: "1",
    name: "Original Image Identification Nomenclature"
  },
  "(0020,9056)": { tag: "(0020,9056)", vr: "SH", vm: "1", name: "Stack ID" },
  "(0020,9057)": {
    tag: "(0020,9057)",
    vr: "UL",
    vm: "1",
    name: "In Stack Position Number"
  },
  "(0020,9071)": {
    tag: "(0020,9071)",
    vr: "SQ",
    vm: "1",
    name: "Frame Anatomy Sequence"
  },
  "(0020,9072)": {
    tag: "(0020,9072)",
    vr: "CS",
    vm: "1",
    name: "Frame Laterality"
  },
  "(0020,9111)": {
    tag: "(0020,9111)",
    vr: "SQ",
    vm: "1",
    name: "Frame Content Sequence"
  },
  "(0020,9113)": {
    tag: "(0020,9113)",
    vr: "SQ",
    vm: "1",
    name: "Plane Position Sequence"
  },
  "(0020,9116)": {
    tag: "(0020,9116)",
    vr: "SQ",
    vm: "1",
    name: "Plane Orientation Sequence"
  },
  "(0020,9128)": {
    tag: "(0020,9128)",
    vr: "UL",
    vm: "1",
    name: "Temporal Position Index"
  },
  "(0020,9153)": {
    tag: "(0020,9153)",
    vr: "FD",
    vm: "1",
    name: "Nominal Cardiac Trigger Delay Time"
  },
  "(0020,9154)": {
    tag: "(0020,9154)",
    vr: "FL",
    vm: "1",
    name: "Nominal Cardiac Trigger Time Prior To RPeak"
  },
  "(0020,9155)": {
    tag: "(0020,9155)",
    vr: "FL",
    vm: "1",
    name: "Actual Cardiac Trigger Time Prior To RPeak"
  },
  "(0020,9156)": {
    tag: "(0020,9156)",
    vr: "US",
    vm: "1",
    name: "Frame Acquisition Number"
  },
  "(0020,9157)": {
    tag: "(0020,9157)",
    vr: "UL",
    vm: "1",
    name: "Dimension Index Values"
  },
  "(0020,9158)": {
    tag: "(0020,9158)",
    vr: "LT",
    vm: "1",
    name: "Frame Comments"
  },
  "(0020,9161)": {
    tag: "(0020,9161)",
    vr: "UI",
    vm: "1",
    name: "Concatenation UID"
  },
  "(0020,9162)": {
    tag: "(0020,9162)",
    vr: "US",
    vm: "1",
    name: "In Concatenation Number"
  },
  "(0020,9163)": {
    tag: "(0020,9163)",
    vr: "US",
    vm: "1",
    name: "In Concatenation Total Number"
  },
  "(0020,9164)": {
    tag: "(0020,9164)",
    vr: "UI",
    vm: "1",
    name: "Dimension Organization UID"
  },
  "(0020,9165)": {
    tag: "(0020,9165)",
    vr: "AT",
    vm: "1",
    name: "Dimension Index Pointer"
  },
  "(0020,9167)": {
    tag: "(0020,9167)",
    vr: "AT",
    vm: "1",
    name: "Functional Group Pointer"
  },
  "(0020,9213)": {
    tag: "(0020,9213)",
    vr: "LO",
    vm: "1",
    name: "Dimension Index Private Creator"
  },
  "(0020,9221)": {
    tag: "(0020,9221)",
    vr: "SQ",
    vm: "1",
    name: "Dimension Organization Sequence"
  },
  "(0020,9222)": {
    tag: "(0020,9222)",
    vr: "SQ",
    vm: "1",
    name: "Dimension Index Sequence"
  },
  "(0020,9228)": {
    tag: "(0020,9228)",
    vr: "UL",
    vm: "1",
    name: "Concatenation Frame Offset Number"
  },
  "(0020,9238)": {
    tag: "(0020,9238)",
    vr: "LO",
    vm: "1",
    name: "Functional Group Private Creator"
  },
  "(0020,9241)": {
    tag: "(0020,9241)",
    vr: "FL",
    vm: "1",
    name: "Nominal Percentage Of Cardiac Phase"
  },
  "(0020,9245)": {
    tag: "(0020,9245)",
    vr: "FL",
    vm: "1",
    name: "Nominal Percentage Of Respiratory Phase"
  },
  "(0020,9246)": {
    tag: "(0020,9246)",
    vr: "FL",
    vm: "1",
    name: "Starting Respiratory Amplitude"
  },
  "(0020,9247)": {
    tag: "(0020,9247)",
    vr: "CS",
    vm: "1",
    name: "Starting Respiratory Phase"
  },
  "(0020,9248)": {
    tag: "(0020,9248)",
    vr: "FL",
    vm: "1",
    name: "Ending Respiratory Amplitude"
  },
  "(0020,9249)": {
    tag: "(0020,9249)",
    vr: "CS",
    vm: "1",
    name: "Ending Respiratory Phase"
  },
  "(0020,9250)": {
    tag: "(0020,9250)",
    vr: "CS",
    vm: "1",
    name: "Respiratory Trigger Type"
  },
  "(0020,9251)": {
    tag: "(0020,9251)",
    vr: "FD",
    vm: "1",
    name: "RRInterval Time Nominal"
  },
  "(0020,9252)": {
    tag: "(0020,9252)",
    vr: "FD",
    vm: "1",
    name: "Actual Cardiac Trigger Delay Time"
  },
  "(0020,9253)": {
    tag: "(0020,9253)",
    vr: "SQ",
    vm: "1",
    name: "Respiratory Synchronization Sequence"
  },
  "(0020,9254)": {
    tag: "(0020,9254)",
    vr: "FD",
    vm: "1",
    name: "Respiratory Interval Time"
  },
  "(0020,9255)": {
    tag: "(0020,9255)",
    vr: "FD",
    vm: "1",
    name: "Nominal Respiratory Trigger Delay Time"
  },
  "(0020,9256)": {
    tag: "(0020,9256)",
    vr: "FD",
    vm: "1",
    name: "Respiratory Trigger Delay Threshold"
  },
  "(0020,9257)": {
    tag: "(0020,9257)",
    vr: "FD",
    vm: "1",
    name: "Actual Respiratory Trigger Delay Time"
  },
  "(0020,9301)": {
    tag: "(0020,9301)",
    vr: "FD",
    vm: "3",
    name: "Image Position Volume"
  },
  "(0020,9302)": {
    tag: "(0020,9302)",
    vr: "FD",
    vm: "6",
    name: "Image Orientation Volume"
  },
  "(0020,9307)": {
    tag: "(0020,9307)",
    vr: "CS",
    vm: "1",
    name: "Ultrasound Acquisition Geometry"
  },
  "(0020,9308)": {
    tag: "(0020,9308)",
    vr: "FD",
    vm: "3",
    name: "Apex Position"
  },
  "(0020,9309)": {
    tag: "(0020,9309)",
    vr: "FD",
    vm: "16",
    name: "Volume To Transducer Mapping Matrix"
  },
  "(0020,930A)": {
    tag: "(0020,930A)",
    vr: "FD",
    vm: "16",
    name: "Volume To Table Mapping Matrix"
  },
  "(0020,930C)": {
    tag: "(0020,930C)",
    vr: "CS",
    vm: "1",
    name: "Patient Frame Of Reference Source"
  },
  "(0020,930D)": {
    tag: "(0020,930D)",
    vr: "FD",
    vm: "1",
    name: "Temporal Position Time Offset"
  },
  "(0020,930E)": {
    tag: "(0020,930E)",
    vr: "SQ",
    vm: "1",
    name: "Plane Position Volume Sequence"
  },
  "(0020,930F)": {
    tag: "(0020,930F)",
    vr: "SQ",
    vm: "1",
    name: "Plane Orientation Volume Sequence"
  },
  "(0020,9310)": {
    tag: "(0020,9310)",
    vr: "SQ",
    vm: "1",
    name: "Temporal Position Sequence"
  },
  "(0020,9311)": {
    tag: "(0020,9311)",
    vr: "CS",
    vm: "1",
    name: "Dimension Organization Type"
  },
  "(0020,9312)": {
    tag: "(0020,9312)",
    vr: "UI",
    vm: "1",
    name: "Volume Frame Of Reference UID"
  },
  "(0020,9313)": {
    tag: "(0020,9313)",
    vr: "UI",
    vm: "1",
    name: "Table Frame Of Reference UID"
  },
  "(0020,9421)": {
    tag: "(0020,9421)",
    vr: "LO",
    vm: "1",
    name: "Dimension Description Label"
  },
  "(0020,9450)": {
    tag: "(0020,9450)",
    vr: "SQ",
    vm: "1",
    name: "Patient Orientation In Frame Sequence"
  },
  "(0020,9453)": { tag: "(0020,9453)", vr: "LO", vm: "1", name: "Frame Label" },
  "(0020,9518)": {
    tag: "(0020,9518)",
    vr: "US",
    vm: "1",
    name: "Acquisition Index"
  },
  "(0020,9529)": {
    tag: "(0020,9529)",
    vr: "SQ",
    vm: "1",
    name: "Contributing SOPInstances Reference Sequence"
  },
  "(0020,9536)": {
    tag: "(0020,9536)",
    vr: "US",
    vm: "1",
    name: "Reconstruction Index"
  },
  "(0022,0001)": {
    tag: "(0022,0001)",
    vr: "US",
    vm: "1",
    name: "Light Path Filter Pass Through Wavelength"
  },
  "(0022,0002)": {
    tag: "(0022,0002)",
    vr: "US",
    vm: "2",
    name: "Light Path Filter Pass Band"
  },
  "(0022,0003)": {
    tag: "(0022,0003)",
    vr: "US",
    vm: "1",
    name: "Image Path Filter Pass Through Wavelength"
  },
  "(0022,0004)": {
    tag: "(0022,0004)",
    vr: "US",
    vm: "2",
    name: "Image Path Filter Pass Band"
  },
  "(0022,0005)": {
    tag: "(0022,0005)",
    vr: "CS",
    vm: "1",
    name: "Patient Eye Movement Commanded"
  },
  "(0022,0006)": {
    tag: "(0022,0006)",
    vr: "SQ",
    vm: "1",
    name: "Patient Eye Movement Command Code Sequence"
  },
  "(0022,0007)": {
    tag: "(0022,0007)",
    vr: "FL",
    vm: "1",
    name: "Spherical Lens Power"
  },
  "(0022,0008)": {
    tag: "(0022,0008)",
    vr: "FL",
    vm: "1",
    name: "Cylinder Lens Power"
  },
  "(0022,0009)": {
    tag: "(0022,0009)",
    vr: "FL",
    vm: "1",
    name: "Cylinder Axis"
  },
  "(0022,000A)": {
    tag: "(0022,000A)",
    vr: "FL",
    vm: "1",
    name: "Emmetropic Magnification"
  },
  "(0022,000B)": {
    tag: "(0022,000B)",
    vr: "FL",
    vm: "1",
    name: "Intra Ocular Pressure"
  },
  "(0022,000C)": {
    tag: "(0022,000C)",
    vr: "FL",
    vm: "1",
    name: "Horizontal Field Of View"
  },
  "(0022,000D)": {
    tag: "(0022,000D)",
    vr: "CS",
    vm: "1",
    name: "Pupil Dilated"
  },
  "(0022,000E)": {
    tag: "(0022,000E)",
    vr: "FL",
    vm: "1",
    name: "Degree Of Dilation"
  },
  "(0022,0010)": {
    tag: "(0022,0010)",
    vr: "FL",
    vm: "1",
    name: "Stereo Baseline Angle"
  },
  "(0022,0011)": {
    tag: "(0022,0011)",
    vr: "FL",
    vm: "1",
    name: "Stereo Baseline Displacement"
  },
  "(0022,0012)": {
    tag: "(0022,0012)",
    vr: "FL",
    vm: "1",
    name: "Stereo Horizontal Pixel Offset"
  },
  "(0022,0013)": {
    tag: "(0022,0013)",
    vr: "FL",
    vm: "1",
    name: "Stereo Vertical Pixel Offset"
  },
  "(0022,0014)": {
    tag: "(0022,0014)",
    vr: "FL",
    vm: "1",
    name: "Stereo Rotation"
  },
  "(0022,0015)": {
    tag: "(0022,0015)",
    vr: "SQ",
    vm: "1",
    name: "Acquisition Device Type Code Sequence"
  },
  "(0022,0016)": {
    tag: "(0022,0016)",
    vr: "SQ",
    vm: "1",
    name: "Illumination Type Code Sequence"
  },
  "(0022,0017)": {
    tag: "(0022,0017)",
    vr: "SQ",
    vm: "1",
    name: "Light Path Filter Type Stack Code Sequence"
  },
  "(0022,0018)": {
    tag: "(0022,0018)",
    vr: "SQ",
    vm: "1",
    name: "Image Path Filter Type Stack Code Sequence"
  },
  "(0022,0019)": {
    tag: "(0022,0019)",
    vr: "SQ",
    vm: "1",
    name: "Lenses Code Sequence"
  },
  "(0022,001A)": {
    tag: "(0022,001A)",
    vr: "SQ",
    vm: "1",
    name: "Channel Description Code Sequence"
  },
  "(0022,001B)": {
    tag: "(0022,001B)",
    vr: "SQ",
    vm: "1",
    name: "Refractive State Sequence"
  },
  "(0022,001C)": {
    tag: "(0022,001C)",
    vr: "SQ",
    vm: "1",
    name: "Mydriatic Agent Code Sequence"
  },
  "(0022,001D)": {
    tag: "(0022,001D)",
    vr: "SQ",
    vm: "1",
    name: "Relative Image Position Code Sequence"
  },
  "(0022,001E)": {
    tag: "(0022,001E)",
    vr: "FL",
    vm: "1",
    name: "Camera Angle Of View"
  },
  "(0022,0020)": {
    tag: "(0022,0020)",
    vr: "SQ",
    vm: "1",
    name: "Stereo Pairs Sequence"
  },
  "(0022,0021)": {
    tag: "(0022,0021)",
    vr: "SQ",
    vm: "1",
    name: "Left Image Sequence"
  },
  "(0022,0022)": {
    tag: "(0022,0022)",
    vr: "SQ",
    vm: "1",
    name: "Right Image Sequence"
  },
  "(0022,0030)": {
    tag: "(0022,0030)",
    vr: "FL",
    vm: "1",
    name: "Axial Length Of The Eye"
  },
  "(0022,0031)": {
    tag: "(0022,0031)",
    vr: "SQ",
    vm: "1",
    name: "Ophthalmic Frame Location Sequence"
  },
  "(0022,0032)": {
    tag: "(0022,0032)",
    vr: "FL",
    vm: "2-2n",
    name: "Reference Coordinates"
  },
  "(0022,0035)": {
    tag: "(0022,0035)",
    vr: "FL",
    vm: "1",
    name: "Depth Spatial Resolution"
  },
  "(0022,0036)": {
    tag: "(0022,0036)",
    vr: "FL",
    vm: "1",
    name: "Maximum Depth Distortion"
  },
  "(0022,0037)": {
    tag: "(0022,0037)",
    vr: "FL",
    vm: "1",
    name: "Along Scan Spatial Resolution"
  },
  "(0022,0038)": {
    tag: "(0022,0038)",
    vr: "FL",
    vm: "1",
    name: "Maximum Along Scan Distortion"
  },
  "(0022,0039)": {
    tag: "(0022,0039)",
    vr: "CS",
    vm: "1",
    name: "Ophthalmic Image Orientation"
  },
  "(0022,0041)": {
    tag: "(0022,0041)",
    vr: "FL",
    vm: "1",
    name: "Depth Of Transverse Image"
  },
  "(0022,0042)": {
    tag: "(0022,0042)",
    vr: "SQ",
    vm: "1",
    name: "Mydriatic Agent Concentration Units Sequence"
  },
  "(0022,0048)": {
    tag: "(0022,0048)",
    vr: "FL",
    vm: "1",
    name: "Across Scan Spatial Resolution"
  },
  "(0022,0049)": {
    tag: "(0022,0049)",
    vr: "FL",
    vm: "1",
    name: "Maximum Across Scan Distortion"
  },
  "(0022,004E)": {
    tag: "(0022,004E)",
    vr: "DS",
    vm: "1",
    name: "Mydriatic Agent Concentration"
  },
  "(0022,0055)": {
    tag: "(0022,0055)",
    vr: "FL",
    vm: "1",
    name: "Illumination Wave Length"
  },
  "(0022,0056)": {
    tag: "(0022,0056)",
    vr: "FL",
    vm: "1",
    name: "Illumination Power"
  },
  "(0022,0057)": {
    tag: "(0022,0057)",
    vr: "FL",
    vm: "1",
    name: "Illumination Bandwidth"
  },
  "(0022,0058)": {
    tag: "(0022,0058)",
    vr: "SQ",
    vm: "1",
    name: "Mydriatic Agent Sequence"
  },
  "(0022,1007)": {
    tag: "(0022,1007)",
    vr: "SQ",
    vm: "1",
    name: "Ophthalmic Axial Measurements Right Eye Sequence"
  },
  "(0022,1008)": {
    tag: "(0022,1008)",
    vr: "SQ",
    vm: "1",
    name: "Ophthalmic Axial Measurements Left Eye Sequence"
  },
  "(0022,1010)": {
    tag: "(0022,1010)",
    vr: "CS",
    vm: "1",
    name: "Ophthalmic Axial Length Measurements Type"
  },
  "(0022,1019)": {
    tag: "(0022,1019)",
    vr: "FL",
    vm: "1",
    name: "Ophthalmic Axial Length"
  },
  "(0022,1024)": {
    tag: "(0022,1024)",
    vr: "SQ",
    vm: "1",
    name: "Lens Status Code Sequence"
  },
  "(0022,1025)": {
    tag: "(0022,1025)",
    vr: "SQ",
    vm: "1",
    name: "Vitreous Status Code Sequence"
  },
  "(0022,1028)": {
    tag: "(0022,1028)",
    vr: "SQ",
    vm: "1",
    name: "IOLFormula Code Sequence"
  },
  "(0022,1029)": {
    tag: "(0022,1029)",
    vr: "LO",
    vm: "1",
    name: "IOLFormula Detail"
  },
  "(0022,1033)": {
    tag: "(0022,1033)",
    vr: "FL",
    vm: "1",
    name: "Keratometer Index"
  },
  "(0022,1035)": {
    tag: "(0022,1035)",
    vr: "SQ",
    vm: "1",
    name: "Source Of Ophthalmic Axial Length Code Sequence"
  },
  "(0022,1037)": {
    tag: "(0022,1037)",
    vr: "FL",
    vm: "1",
    name: "Target Refraction"
  },
  "(0022,1039)": {
    tag: "(0022,1039)",
    vr: "CS",
    vm: "1",
    name: "Refractive Procedure Occurred"
  },
  "(0022,1040)": {
    tag: "(0022,1040)",
    vr: "SQ",
    vm: "1",
    name: "Refractive Surgery Type Code Sequence"
  },
  "(0022,1044)": {
    tag: "(0022,1044)",
    vr: "SQ",
    vm: "1",
    name: "Ophthalmic Ultrasound Axial Measurements Type Code Sequence"
  },
  "(0022,1050)": {
    tag: "(0022,1050)",
    vr: "SQ",
    vm: "1",
    name: "Ophthalmic Axial Length Measurements Sequence"
  },
  "(0022,1053)": { tag: "(0022,1053)", vr: "FL", vm: "1", name: "IOLPower" },
  "(0022,1054)": {
    tag: "(0022,1054)",
    vr: "FL",
    vm: "1",
    name: "Predicted Refractive Error"
  },
  "(0022,1059)": {
    tag: "(0022,1059)",
    vr: "FL",
    vm: "1",
    name: "Ophthalmic Axial Length Velocity"
  },
  "(0022,1065)": {
    tag: "(0022,1065)",
    vr: "LO",
    vm: "1",
    name: "Lens Status Description"
  },
  "(0022,1066)": {
    tag: "(0022,1066)",
    vr: "LO",
    vm: "1",
    name: "Vitreous Status Description"
  },
  "(0022,1090)": {
    tag: "(0022,1090)",
    vr: "SQ",
    vm: "1",
    name: "IOLPower Sequence"
  },
  "(0022,1092)": {
    tag: "(0022,1092)",
    vr: "SQ",
    vm: "1",
    name: "Lens Constant Sequence"
  },
  "(0022,1093)": {
    tag: "(0022,1093)",
    vr: "LO",
    vm: "1",
    name: "IOLManufacturer"
  },
  "(0022,1094)": {
    tag: "(0022,1094)",
    vr: "LO",
    vm: "1",
    name: "Lens Constant Description"
  },
  "(0022,1096)": {
    tag: "(0022,1096)",
    vr: "SQ",
    vm: "1",
    name: "Keratometry Measurement Type Code Sequence"
  },
  "(0022,1100)": {
    tag: "(0022,1100)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Ophthalmic Axial Measurements Sequence"
  },
  "(0022,1101)": {
    tag: "(0022,1101)",
    vr: "SQ",
    vm: "1",
    name: "Ophthalmic Axial Length Measurements Segment Name Code Sequence"
  },
  "(0022,1103)": {
    tag: "(0022,1103)",
    vr: "SQ",
    vm: "1",
    name: "Refractive Error Before Refractive Surgery Code Sequence"
  },
  "(0022,1121)": {
    tag: "(0022,1121)",
    vr: "FL",
    vm: "1",
    name: "IOLPower For Exact Emmetropia"
  },
  "(0022,1122)": {
    tag: "(0022,1122)",
    vr: "FL",
    vm: "1",
    name: "IOLPower For Exact Target Refraction"
  },
  "(0022,1125)": {
    tag: "(0022,1125)",
    vr: "SQ",
    vm: "1",
    name: "Anterior Chamber Depth Definition Code Sequence"
  },
  "(0022,1130)": {
    tag: "(0022,1130)",
    vr: "FL",
    vm: "1",
    name: "Lens Thickness"
  },
  "(0022,1131)": {
    tag: "(0022,1131)",
    vr: "FL",
    vm: "1",
    name: "Anterior Chamber Depth"
  },
  "(0022,1132)": {
    tag: "(0022,1132)",
    vr: "SQ",
    vm: "1",
    name: "Source Of Lens Thickness Data Code Sequence"
  },
  "(0022,1133)": {
    tag: "(0022,1133)",
    vr: "SQ",
    vm: "1",
    name: "Source Of Anterior Chamber Depth Data Code Sequence"
  },
  "(0022,1135)": {
    tag: "(0022,1135)",
    vr: "SQ",
    vm: "1",
    name: "Source Of Refractive Error Data Code Sequence"
  },
  "(0022,1140)": {
    tag: "(0022,1140)",
    vr: "CS",
    vm: "1",
    name: "Ophthalmic Axial Length Measurement Modified"
  },
  "(0022,1150)": {
    tag: "(0022,1150)",
    vr: "SQ",
    vm: "1",
    name: "Ophthalmic Axial Length Data Source Code Sequence"
  },
  "(0022,1153)": {
    tag: "(0022,1153)",
    vr: "SQ",
    vm: "1",
    name: "Ophthalmic Axial Length Acquisition Method Code Sequence"
  },
  "(0022,1155)": {
    tag: "(0022,1155)",
    vr: "FL",
    vm: "1",
    name: "Signal To Noise Ratio"
  },
  "(0022,1159)": {
    tag: "(0022,1159)",
    vr: "LO",
    vm: "1",
    name: "Ophthalmic Axial Length Data Source Description"
  },
  "(0022,1210)": {
    tag: "(0022,1210)",
    vr: "SQ",
    vm: "1",
    name: "Ophthalmic Axial Length Measurements Total Length Sequence"
  },
  "(0022,1211)": {
    tag: "(0022,1211)",
    vr: "SQ",
    vm: "1",
    name: "Ophthalmic Axial Length Measurements Segmental Length Sequence"
  },
  "(0022,1212)": {
    tag: "(0022,1212)",
    vr: "SQ",
    vm: "1",
    name: "Ophthalmic Axial Length Measurements Length Summation Sequence"
  },
  "(0022,1220)": {
    tag: "(0022,1220)",
    vr: "SQ",
    vm: "1",
    name: "Ultrasound Ophthalmic Axial Length Measurements Sequence"
  },
  "(0022,1225)": {
    tag: "(0022,1225)",
    vr: "SQ",
    vm: "1",
    name: "Optical Ophthalmic Axial Length Measurements Sequence"
  },
  "(0022,1230)": {
    tag: "(0022,1230)",
    vr: "SQ",
    vm: "1",
    name: "Ultrasound Selected Ophthalmic Axial Length Sequence"
  },
  "(0022,1250)": {
    tag: "(0022,1250)",
    vr: "SQ",
    vm: "1",
    name: "Ophthalmic Axial Length Selection Method Code Sequence"
  },
  "(0022,1255)": {
    tag: "(0022,1255)",
    vr: "SQ",
    vm: "1",
    name: "Optical Selected Ophthalmic Axial Length Sequence"
  },
  "(0022,1257)": {
    tag: "(0022,1257)",
    vr: "SQ",
    vm: "1",
    name: "Selected Segmental Ophthalmic Axial Length Sequence"
  },
  "(0022,1260)": {
    tag: "(0022,1260)",
    vr: "SQ",
    vm: "1",
    name: "Selected Total Ophthalmic Axial Length Sequence"
  },
  "(0022,1262)": {
    tag: "(0022,1262)",
    vr: "SQ",
    vm: "1",
    name: "Ophthalmic Axial Length Quality Metric Sequence"
  },
  "(0022,1273)": {
    tag: "(0022,1273)",
    vr: "LO",
    vm: "1",
    name: "Ophthalmic Axial Length Quality Metric Type Description"
  },
  "(0022,1300)": {
    tag: "(0022,1300)",
    vr: "SQ",
    vm: "1",
    name: "Intraocular Lens Calculations Right Eye Sequence"
  },
  "(0022,1310)": {
    tag: "(0022,1310)",
    vr: "SQ",
    vm: "1",
    name: "Intraocular Lens Calculations Left Eye Sequence"
  },
  "(0022,1330)": {
    tag: "(0022,1330)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Ophthalmic Axial Length Measurement QCImage Sequence"
  },
  "(0024,0010)": {
    tag: "(0024,0010)",
    vr: "FL",
    vm: "1",
    name: "Visual Field Horizontal Extent"
  },
  "(0024,0011)": {
    tag: "(0024,0011)",
    vr: "FL",
    vm: "1",
    name: "Visual Field Vertical Extent"
  },
  "(0024,0012)": {
    tag: "(0024,0012)",
    vr: "CS",
    vm: "1",
    name: "Visual Field Shape"
  },
  "(0024,0016)": {
    tag: "(0024,0016)",
    vr: "SQ",
    vm: "1",
    name: "Screening Test Mode Code Sequence"
  },
  "(0024,0018)": {
    tag: "(0024,0018)",
    vr: "FL",
    vm: "1",
    name: "Maximum Stimulus Luminance"
  },
  "(0024,0020)": {
    tag: "(0024,0020)",
    vr: "FL",
    vm: "1",
    name: "Background Luminance"
  },
  "(0024,0021)": {
    tag: "(0024,0021)",
    vr: "SQ",
    vm: "1",
    name: "Stimulus Color Code Sequence"
  },
  "(0024,0024)": {
    tag: "(0024,0024)",
    vr: "SQ",
    vm: "1",
    name: "Background Illumination Color Code Sequence"
  },
  "(0024,0025)": {
    tag: "(0024,0025)",
    vr: "FL",
    vm: "1",
    name: "Stimulus Area"
  },
  "(0024,0028)": {
    tag: "(0024,0028)",
    vr: "FL",
    vm: "1",
    name: "Stimulus Presentation Time"
  },
  "(0024,0032)": {
    tag: "(0024,0032)",
    vr: "SQ",
    vm: "1",
    name: "Fixation Sequence"
  },
  "(0024,0033)": {
    tag: "(0024,0033)",
    vr: "SQ",
    vm: "1",
    name: "Fixation Monitoring Code Sequence"
  },
  "(0024,0034)": {
    tag: "(0024,0034)",
    vr: "SQ",
    vm: "1",
    name: "Visual Field Catch Trial Sequence"
  },
  "(0024,0035)": {
    tag: "(0024,0035)",
    vr: "US",
    vm: "1",
    name: "Fixation Checked Quantity"
  },
  "(0024,0036)": {
    tag: "(0024,0036)",
    vr: "US",
    vm: "1",
    name: "Patient Not Properly Fixated Quantity"
  },
  "(0024,0037)": {
    tag: "(0024,0037)",
    vr: "CS",
    vm: "1",
    name: "Presented Visual Stimuli Data Flag"
  },
  "(0024,0038)": {
    tag: "(0024,0038)",
    vr: "US",
    vm: "1",
    name: "Number Of Visual Stimuli"
  },
  "(0024,0039)": {
    tag: "(0024,0039)",
    vr: "CS",
    vm: "1",
    name: "Excessive Fixation Losses Data Flag"
  },
  "(0024,0040)": {
    tag: "(0024,0040)",
    vr: "CS",
    vm: "1",
    name: "Excessive Fixation Losses"
  },
  "(0024,0042)": {
    tag: "(0024,0042)",
    vr: "US",
    vm: "1",
    name: "Stimuli Retesting Quantity"
  },
  "(0024,0044)": {
    tag: "(0024,0044)",
    vr: "LT",
    vm: "1",
    name: "Comments On Patient Performance Of Visual Field"
  },
  "(0024,0045)": {
    tag: "(0024,0045)",
    vr: "CS",
    vm: "1",
    name: "False Negatives Estimate Flag"
  },
  "(0024,0046)": {
    tag: "(0024,0046)",
    vr: "FL",
    vm: "1",
    name: "False Negatives Estimate"
  },
  "(0024,0048)": {
    tag: "(0024,0048)",
    vr: "US",
    vm: "1",
    name: "Negative Catch Trials Quantity"
  },
  "(0024,0050)": {
    tag: "(0024,0050)",
    vr: "US",
    vm: "1",
    name: "False Negatives Quantity"
  },
  "(0024,0051)": {
    tag: "(0024,0051)",
    vr: "CS",
    vm: "1",
    name: "Excessive False Negatives Data Flag"
  },
  "(0024,0052)": {
    tag: "(0024,0052)",
    vr: "CS",
    vm: "1",
    name: "Excessive False Negatives"
  },
  "(0024,0053)": {
    tag: "(0024,0053)",
    vr: "CS",
    vm: "1",
    name: "False Positives Estimate Flag"
  },
  "(0024,0054)": {
    tag: "(0024,0054)",
    vr: "FL",
    vm: "1",
    name: "False Positives Estimate"
  },
  "(0024,0055)": {
    tag: "(0024,0055)",
    vr: "CS",
    vm: "1",
    name: "Catch Trials Data Flag"
  },
  "(0024,0056)": {
    tag: "(0024,0056)",
    vr: "US",
    vm: "1",
    name: "Positive Catch Trials Quantity"
  },
  "(0024,0057)": {
    tag: "(0024,0057)",
    vr: "CS",
    vm: "1",
    name: "Test Point Normals Data Flag"
  },
  "(0024,0058)": {
    tag: "(0024,0058)",
    vr: "SQ",
    vm: "1",
    name: "Test Point Normals Sequence"
  },
  "(0024,0059)": {
    tag: "(0024,0059)",
    vr: "CS",
    vm: "1",
    name: "Global Deviation Probability Normals Flag"
  },
  "(0024,0060)": {
    tag: "(0024,0060)",
    vr: "US",
    vm: "1",
    name: "False Positives Quantity"
  },
  "(0024,0061)": {
    tag: "(0024,0061)",
    vr: "CS",
    vm: "1",
    name: "Excessive False Positives Data Flag"
  },
  "(0024,0062)": {
    tag: "(0024,0062)",
    vr: "CS",
    vm: "1",
    name: "Excessive False Positives"
  },
  "(0024,0063)": {
    tag: "(0024,0063)",
    vr: "CS",
    vm: "1",
    name: "Visual Field Test Normals Flag"
  },
  "(0024,0064)": {
    tag: "(0024,0064)",
    vr: "SQ",
    vm: "1",
    name: "Results Normals Sequence"
  },
  "(0024,0065)": {
    tag: "(0024,0065)",
    vr: "SQ",
    vm: "1",
    name: "Age Corrected Sensitivity Deviation Algorithm Sequence"
  },
  "(0024,0066)": {
    tag: "(0024,0066)",
    vr: "FL",
    vm: "1",
    name: "Global Deviation From Normal"
  },
  "(0024,0067)": {
    tag: "(0024,0067)",
    vr: "SQ",
    vm: "1",
    name: "Generalized Defect Sensitivity Deviation Algorithm Sequence"
  },
  "(0024,0068)": {
    tag: "(0024,0068)",
    vr: "FL",
    vm: "1",
    name: "Localized Deviationfrom Normal"
  },
  "(0024,0069)": {
    tag: "(0024,0069)",
    vr: "LO",
    vm: "1",
    name: "Patient Reliability Indicator"
  },
  "(0024,0070)": {
    tag: "(0024,0070)",
    vr: "FL",
    vm: "1",
    name: "Visual Field Mean Sensitivity"
  },
  "(0024,0071)": {
    tag: "(0024,0071)",
    vr: "FL",
    vm: "1",
    name: "Global Deviation Probability"
  },
  "(0024,0072)": {
    tag: "(0024,0072)",
    vr: "CS",
    vm: "1",
    name: "Local Deviation Probability Normals Flag"
  },
  "(0024,0073)": {
    tag: "(0024,0073)",
    vr: "FL",
    vm: "1",
    name: "Localized Deviation Probability"
  },
  "(0024,0074)": {
    tag: "(0024,0074)",
    vr: "CS",
    vm: "1",
    name: "Short Term Fluctuation Calculated"
  },
  "(0024,0075)": {
    tag: "(0024,0075)",
    vr: "FL",
    vm: "1",
    name: "Short Term Fluctuation"
  },
  "(0024,0076)": {
    tag: "(0024,0076)",
    vr: "CS",
    vm: "1",
    name: "Short Term Fluctuation Probability Calculated"
  },
  "(0024,0077)": {
    tag: "(0024,0077)",
    vr: "FL",
    vm: "1",
    name: "Short Term Fluctuation Probability"
  },
  "(0024,0078)": {
    tag: "(0024,0078)",
    vr: "CS",
    vm: "1",
    name: "Corrected Localized Deviation From Normal Calculated"
  },
  "(0024,0079)": {
    tag: "(0024,0079)",
    vr: "FL",
    vm: "1",
    name: "Corrected Localized Deviation From Normal"
  },
  "(0024,0080)": {
    tag: "(0024,0080)",
    vr: "CS",
    vm: "1",
    name: "Corrected Localized Deviation From Normal Probability Calculated"
  },
  "(0024,0081)": {
    tag: "(0024,0081)",
    vr: "FL",
    vm: "1",
    name: "Corrected Localized Deviation From Normal Probability"
  },
  "(0024,0083)": {
    tag: "(0024,0083)",
    vr: "SQ",
    vm: "1",
    name: "Global Deviation Probability Sequence"
  },
  "(0024,0085)": {
    tag: "(0024,0085)",
    vr: "SQ",
    vm: "1",
    name: "Localized Deviation Probability Sequence"
  },
  "(0024,0086)": {
    tag: "(0024,0086)",
    vr: "CS",
    vm: "1",
    name: "Foveal Sensitivity Measured"
  },
  "(0024,0087)": {
    tag: "(0024,0087)",
    vr: "FL",
    vm: "1",
    name: "Foveal Sensitivity"
  },
  "(0024,0088)": {
    tag: "(0024,0088)",
    vr: "FL",
    vm: "1",
    name: "Visual Field Test Duration"
  },
  "(0024,0089)": {
    tag: "(0024,0089)",
    vr: "SQ",
    vm: "1",
    name: "Visual Field Test Point Sequence"
  },
  "(0024,0090)": {
    tag: "(0024,0090)",
    vr: "FL",
    vm: "1",
    name: "Visual Field Test Point XCoordinate"
  },
  "(0024,0091)": {
    tag: "(0024,0091)",
    vr: "FL",
    vm: "1",
    name: "Visual Field Test Point YCoordinate"
  },
  "(0024,0092)": {
    tag: "(0024,0092)",
    vr: "FL",
    vm: "1",
    name: "Age Corrected Sensitivity Deviation Value"
  },
  "(0024,0093)": {
    tag: "(0024,0093)",
    vr: "CS",
    vm: "1",
    name: "Stimulus Results"
  },
  "(0024,0094)": {
    tag: "(0024,0094)",
    vr: "FL",
    vm: "1",
    name: "Sensitivity Value"
  },
  "(0024,0095)": {
    tag: "(0024,0095)",
    vr: "CS",
    vm: "1",
    name: "Retest Stimulus Seen"
  },
  "(0024,0096)": {
    tag: "(0024,0096)",
    vr: "FL",
    vm: "1",
    name: "Retest Sensitivity Value"
  },
  "(0024,0097)": {
    tag: "(0024,0097)",
    vr: "SQ",
    vm: "1",
    name: "Visual Field Test Point Normals Sequence"
  },
  "(0024,0098)": {
    tag: "(0024,0098)",
    vr: "FL",
    vm: "1",
    name: "Quantified Defect"
  },
  "(0024,0100)": {
    tag: "(0024,0100)",
    vr: "FL",
    vm: "1",
    name: "Age Corrected Sensitivity Deviation Probability Value"
  },
  "(0024,0102)": {
    tag: "(0024,0102)",
    vr: "CS",
    vm: "1",
    name: "Generalized Defect Corrected Sensitivity Deviation Flag "
  },
  "(0024,0103)": {
    tag: "(0024,0103)",
    vr: "FL",
    vm: "1",
    name: "Generalized Defect Corrected Sensitivity Deviation Value "
  },
  "(0024,0104)": {
    tag: "(0024,0104)",
    vr: "FL",
    vm: "1",
    name: "Generalized Defect Corrected Sensitivity Deviation Probability Value"
  },
  "(0024,0105)": {
    tag: "(0024,0105)",
    vr: "FL",
    vm: "1",
    name: "Minimum Sensitivity Value"
  },
  "(0024,0106)": {
    tag: "(0024,0106)",
    vr: "CS",
    vm: "1",
    name: "Blind Spot Localized"
  },
  "(0024,0107)": {
    tag: "(0024,0107)",
    vr: "FL",
    vm: "1",
    name: "Blind Spot XCoordinate"
  },
  "(0024,0108)": {
    tag: "(0024,0108)",
    vr: "FL",
    vm: "1",
    name: "Blind Spot YCoordinate "
  },
  "(0024,0110)": {
    tag: "(0024,0110)",
    vr: "SQ",
    vm: "1",
    name: "Visual Acuity Measurement Sequence"
  },
  "(0024,0112)": {
    tag: "(0024,0112)",
    vr: "SQ",
    vm: "1",
    name: "Refractive Parameters Used On Patient Sequence"
  },
  "(0024,0113)": {
    tag: "(0024,0113)",
    vr: "CS",
    vm: "1",
    name: "Measurement Laterality"
  },
  "(0024,0114)": {
    tag: "(0024,0114)",
    vr: "SQ",
    vm: "1",
    name: "Ophthalmic Patient Clinical Information Left Eye Sequence"
  },
  "(0024,0115)": {
    tag: "(0024,0115)",
    vr: "SQ",
    vm: "1",
    name: "Ophthalmic Patient Clinical Information Right Eye Sequence"
  },
  "(0024,0117)": {
    tag: "(0024,0117)",
    vr: "CS",
    vm: "1",
    name: "Foveal Point Normative Data Flag"
  },
  "(0024,0118)": {
    tag: "(0024,0118)",
    vr: "FL",
    vm: "1",
    name: "Foveal Point Probability Value"
  },
  "(0024,0120)": {
    tag: "(0024,0120)",
    vr: "CS",
    vm: "1",
    name: "Screening Baseline Measured"
  },
  "(0024,0122)": {
    tag: "(0024,0122)",
    vr: "SQ",
    vm: "1",
    name: "Screening Baseline Measured Sequence"
  },
  "(0024,0124)": {
    tag: "(0024,0124)",
    vr: "CS",
    vm: "1",
    name: "Screening Baseline Type"
  },
  "(0024,0126)": {
    tag: "(0024,0126)",
    vr: "FL",
    vm: "1",
    name: "Screening Baseline Value"
  },
  "(0024,0202)": {
    tag: "(0024,0202)",
    vr: "LO",
    vm: "1",
    name: "Algorithm Source"
  },
  "(0024,0306)": {
    tag: "(0024,0306)",
    vr: "LO",
    vm: "1",
    name: "Data Set Name"
  },
  "(0024,0307)": {
    tag: "(0024,0307)",
    vr: "LO",
    vm: "1",
    name: "Data Set Version"
  },
  "(0024,0308)": {
    tag: "(0024,0308)",
    vr: "LO",
    vm: "1",
    name: "Data Set Source"
  },
  "(0024,0309)": {
    tag: "(0024,0309)",
    vr: "LO",
    vm: "1",
    name: "Data Set Description"
  },
  "(0024,0317)": {
    tag: "(0024,0317)",
    vr: "SQ",
    vm: "1",
    name: "Visual Field Test Reliability Global Index Sequence"
  },
  "(0024,0320)": {
    tag: "(0024,0320)",
    vr: "SQ",
    vm: "1",
    name: "Visual Field Global Results Index Sequence"
  },
  "(0024,0325)": {
    tag: "(0024,0325)",
    vr: "SQ",
    vm: "1",
    name: "Data Observation Sequence"
  },
  "(0024,0338)": {
    tag: "(0024,0338)",
    vr: "CS",
    vm: "1",
    name: "Index Normals Flag"
  },
  "(0024,0341)": {
    tag: "(0024,0341)",
    vr: "FL",
    vm: "1",
    name: "Index Probability"
  },
  "(0024,0344)": {
    tag: "(0024,0344)",
    vr: "SQ",
    vm: "1",
    name: "Index Probability Sequence"
  },
  "(0028,0002)": {
    tag: "(0028,0002)",
    vr: "US",
    vm: "1",
    name: "Samples Per Pixel"
  },
  "(0028,0003)": {
    tag: "(0028,0003)",
    vr: "US",
    vm: "1",
    name: "Samples Per Pixel Used"
  },
  "(0028,0004)": {
    tag: "(0028,0004)",
    vr: "CS",
    vm: "1",
    name: "Photometric Interpretation"
  },
  "(0028,0005)": {
    tag: "(0028,0005)",
    vr: "US",
    vm: "1",
    name: "Image Dimensions"
  },
  "(0028,0006)": {
    tag: "(0028,0006)",
    vr: "US",
    vm: "1",
    name: "Planar Configuration"
  },
  "(0028,0008)": {
    tag: "(0028,0008)",
    vr: "IS",
    vm: "1",
    name: "Number Of Frames"
  },
  "(0028,0009)": {
    tag: "(0028,0009)",
    vr: "AT",
    vm: "1",
    name: "Frame Increment Pointer"
  },
  "(0028,000A)": {
    tag: "(0028,000A)",
    vr: "AT",
    vm: "1",
    name: "Frame Dimension Pointer"
  },
  "(0028,0010)": { tag: "(0028,0010)", vr: "US", vm: "1", name: "Rows" },
  "(0028,0011)": { tag: "(0028,0011)", vr: "US", vm: "1", name: "Columns" },
  "(0028,0012)": { tag: "(0028,0012)", vr: "US", vm: "1", name: "Planes" },
  "(0028,0014)": {
    tag: "(0028,0014)",
    vr: "US",
    vm: "1",
    name: "Ultrasound Color Data Present"
  },
  "(0028,0030)": {
    tag: "(0028,0030)",
    vr: "DS",
    vm: "2",
    name: "Pixel Spacing"
  },
  "(0028,0031)": { tag: "(0028,0031)", vr: "DS", vm: "2", name: "Zoom Factor" },
  "(0028,0032)": { tag: "(0028,0032)", vr: "DS", vm: "2", name: "Zoom Center" },
  "(0028,0034)": {
    tag: "(0028,0034)",
    vr: "IS",
    vm: "2",
    name: "Pixel Aspect Ratio"
  },
  "(0028,0040)": {
    tag: "(0028,0040)",
    vr: "CS",
    vm: "1",
    name: "Image Format"
  },
  "(0028,0050)": {
    tag: "(0028,0050)",
    vr: "LO",
    vm: "1",
    name: "Manipulated Image"
  },
  "(0028,0051)": {
    tag: "(0028,0051)",
    vr: "CS",
    vm: "1",
    name: "Corrected Image"
  },
  "(0028,005F)": {
    tag: "(0028,005F)",
    vr: "LO",
    vm: "1",
    name: "Compression Recognition Code"
  },
  "(0028,0060)": {
    tag: "(0028,0060)",
    vr: "CS",
    vm: "1",
    name: "Compression Code"
  },
  "(0028,0061)": {
    tag: "(0028,0061)",
    vr: "SH",
    vm: "1",
    name: "Compression Originator"
  },
  "(0028,0062)": {
    tag: "(0028,0062)",
    vr: "LO",
    vm: "1",
    name: "Compression Label"
  },
  "(0028,0063)": {
    tag: "(0028,0063)",
    vr: "SH",
    vm: "1",
    name: "Compression Description"
  },
  "(0028,0065)": {
    tag: "(0028,0065)",
    vr: "CS",
    vm: "1",
    name: "Compression Sequence"
  },
  "(0028,0066)": {
    tag: "(0028,0066)",
    vr: "AT",
    vm: "1",
    name: "Compression Step Pointers"
  },
  "(0028,0068)": {
    tag: "(0028,0068)",
    vr: "US",
    vm: "1",
    name: "Repeat Interval"
  },
  "(0028,0069)": {
    tag: "(0028,0069)",
    vr: "US",
    vm: "1",
    name: "Bits Grouped"
  },
  "(0028,0070)": {
    tag: "(0028,0070)",
    vr: "US",
    vm: "1",
    name: "Perimeter Table"
  },
  "(0028,0071)": {
    tag: "(0028,0071)",
    vr: "US|SS",
    vm: "1",
    name: "Perimeter Value"
  },
  "(0028,0080)": {
    tag: "(0028,0080)",
    vr: "US",
    vm: "1",
    name: "Predictor Rows"
  },
  "(0028,0081)": {
    tag: "(0028,0081)",
    vr: "US",
    vm: "1",
    name: "Predictor Columns"
  },
  "(0028,0082)": {
    tag: "(0028,0082)",
    vr: "US",
    vm: "1",
    name: "Predictor Constants"
  },
  "(0028,0090)": {
    tag: "(0028,0090)",
    vr: "CS",
    vm: "1",
    name: "Blocked Pixels"
  },
  "(0028,0091)": { tag: "(0028,0091)", vr: "US", vm: "1", name: "Block Rows" },
  "(0028,0092)": {
    tag: "(0028,0092)",
    vr: "US",
    vm: "1",
    name: "Block Columns"
  },
  "(0028,0093)": { tag: "(0028,0093)", vr: "US", vm: "1", name: "Row Overlap" },
  "(0028,0094)": {
    tag: "(0028,0094)",
    vr: "US",
    vm: "1",
    name: "Column Overlap"
  },
  "(0028,0100)": {
    tag: "(0028,0100)",
    vr: "US",
    vm: "1",
    name: "Bits Allocated"
  },
  "(0028,0101)": { tag: "(0028,0101)", vr: "US", vm: "1", name: "Bits Stored" },
  "(0028,0102)": { tag: "(0028,0102)", vr: "US", vm: "1", name: "High Bit" },
  "(0028,0103)": {
    tag: "(0028,0103)",
    vr: "US",
    vm: "1",
    name: "Pixel Representation"
  },
  "(0028,0104)": {
    tag: "(0028,0104)",
    vr: "US|SS",
    vm: "1",
    name: "Smallest Valid Pixel Value"
  },
  "(0028,0105)": {
    tag: "(0028,0105)",
    vr: "US|SS",
    vm: "1",
    name: "Largest Valid Pixel Value"
  },
  "(0028,0106)": {
    tag: "(0028,0106)",
    vr: "US|SS",
    vm: "1",
    name: "Smallest Image Pixel Value"
  },
  "(0028,0107)": {
    tag: "(0028,0107)",
    vr: "US|SS",
    vm: "1",
    name: "Largest Image Pixel Value"
  },
  "(0028,0108)": {
    tag: "(0028,0108)",
    vr: "US|SS",
    vm: "1",
    name: "Smallest Pixel Value In Series"
  },
  "(0028,0109)": {
    tag: "(0028,0109)",
    vr: "US|SS",
    vm: "1",
    name: "Largest Pixel Value In Series"
  },
  "(0028,0110)": {
    tag: "(0028,0110)",
    vr: "US|SS",
    vm: "1",
    name: "Smallest Image Pixel Value In Plane"
  },
  "(0028,0111)": {
    tag: "(0028,0111)",
    vr: "US|SS",
    vm: "1",
    name: "Largest Image Pixel Value In Plane"
  },
  "(0028,0120)": {
    tag: "(0028,0120)",
    vr: "US|SS",
    vm: "1",
    name: "Pixel Padding Value"
  },
  "(0028,0121)": {
    tag: "(0028,0121)",
    vr: "US|SS",
    vm: "1",
    name: "Pixel Padding Range Limit"
  },
  "(0028,0200)": {
    tag: "(0028,0200)",
    vr: "US",
    vm: "1",
    name: "Image Location"
  },
  "(0028,0300)": {
    tag: "(0028,0300)",
    vr: "CS",
    vm: "1",
    name: "Quality Control Image"
  },
  "(0028,0301)": {
    tag: "(0028,0301)",
    vr: "CS",
    vm: "1",
    name: "Burned In Annotation"
  },
  "(0028,0302)": {
    tag: "(0028,0302)",
    vr: "CS",
    vm: "1",
    name: "Recognizable Visual Features"
  },
  "(0028,0303)": {
    tag: "(0028,0303)",
    vr: "CS",
    vm: "1",
    name: "Longitudinal Temporal Information Modified"
  },
  "(0028,0400)": {
    tag: "(0028,0400)",
    vr: "LO",
    vm: "1",
    name: "Transform Label"
  },
  "(0028,0401)": {
    tag: "(0028,0401)",
    vr: "LO",
    vm: "1",
    name: "Transform Version Number"
  },
  "(0028,0402)": {
    tag: "(0028,0402)",
    vr: "US",
    vm: "1",
    name: "Number Of Transform Steps"
  },
  "(0028,0403)": {
    tag: "(0028,0403)",
    vr: "LO",
    vm: "1",
    name: "Sequence Of Compressed Data"
  },
  "(0028,0404)": {
    tag: "(0028,0404)",
    vr: "AT",
    vm: "1",
    name: "Details Of Coefficients"
  },
  "(0028,04x0)": {
    tag: "(0028,04x0)",
    vr: "US",
    vm: "1",
    name: "Rows For Nth Order Coefficients"
  },
  "(0028,04x1)": {
    tag: "(0028,04x1)",
    vr: "US",
    vm: "1",
    name: "Columns For Nth Order Coefficients"
  },
  "(0028,04x2)": {
    tag: "(0028,04x2)",
    vr: "LO",
    vm: "1",
    name: "Coefficient Coding"
  },
  "(0028,04x3)": {
    tag: "(0028,04x3)",
    vr: "AT",
    vm: "1",
    name: "Coefficient Coding Pointers"
  },
  "(0028,0700)": { tag: "(0028,0700)", vr: "LO", vm: "1", name: "DCTLabel" },
  "(0028,0701)": {
    tag: "(0028,0701)",
    vr: "CS",
    vm: "1",
    name: "Data Block Description"
  },
  "(0028,0702)": {
    tag: "(0028,0702)",
    vr: "AT",
    vm: "1",
    name: "Data Block"
  },
  "(0028,0710)": {
    tag: "(0028,0710)",
    vr: "US",
    vm: "1",
    name: "Normalization Factor Format"
  },
  "(0028,0720)": {
    tag: "(0028,0720)",
    vr: "US",
    vm: "1",
    name: "Zonal Map Number Format"
  },
  "(0028,0721)": {
    tag: "(0028,0721)",
    vr: "AT",
    vm: "1",
    name: "Zonal Map Location"
  },
  "(0028,0722)": {
    tag: "(0028,0722)",
    vr: "US",
    vm: "1",
    name: "Zonal Map Format"
  },
  "(0028,0730)": {
    tag: "(0028,0730)",
    vr: "US",
    vm: "1",
    name: "Adaptive Map Format"
  },
  "(0028,0740)": {
    tag: "(0028,0740)",
    vr: "US",
    vm: "1",
    name: "Code Number Format"
  },
  "(0028,08x0)": {
    tag: "(0028,08x0)",
    vr: "CS",
    vm: "1",
    name: "Code Label"
  },
  "(0028,08x2)": {
    tag: "(0028,08x2)",
    vr: "US",
    vm: "1",
    name: "Number Of Tables"
  },
  "(0028,08x3)": {
    tag: "(0028,08x3)",
    vr: "AT",
    vm: "1",
    name: "Code Table Location"
  },
  "(0028,08x4)": {
    tag: "(0028,08x4)",
    vr: "US",
    vm: "1",
    name: "Bits For Code Word"
  },
  "(0028,08x8)": {
    tag: "(0028,08x8)",
    vr: "AT",
    vm: "1",
    name: "Image Data Location"
  },
  "(0028,0A02)": {
    tag: "(0028,0A02)",
    vr: "CS",
    vm: "1",
    name: "Pixel Spacing Calibration Type"
  },
  "(0028,0A04)": {
    tag: "(0028,0A04)",
    vr: "LO",
    vm: "1",
    name: "Pixel Spacing Calibration Description"
  },
  "(0028,1040)": {
    tag: "(0028,1040)",
    vr: "CS",
    vm: "1",
    name: "Pixel Intensity Relationship"
  },
  "(0028,1041)": {
    tag: "(0028,1041)",
    vr: "SS",
    vm: "1",
    name: "Pixel Intensity Relationship Sign"
  },
  "(0028,1050)": {
    tag: "(0028,1050)",
    vr: "DS",
    vm: "1",
    name: "Window Center"
  },
  "(0028,1051)": {
    tag: "(0028,1051)",
    vr: "DS",
    vm: "1",
    name: "Window Width"
  },
  "(0028,1052)": {
    tag: "(0028,1052)",
    vr: "DS",
    vm: "1",
    name: "Rescale Intercept"
  },
  "(0028,1053)": {
    tag: "(0028,1053)",
    vr: "DS",
    vm: "1",
    name: "Rescale Slope"
  },
  "(0028,1054)": {
    tag: "(0028,1054)",
    vr: "LO",
    vm: "1",
    name: "Rescale Type"
  },
  "(0028,1055)": {
    tag: "(0028,1055)",
    vr: "LO",
    vm: "1",
    name: "Window Center Width Explanation"
  },
  "(0028,1056)": {
    tag: "(0028,1056)",
    vr: "CS",
    vm: "1",
    name: "VOILUTFunction"
  },
  "(0028,1080)": { tag: "(0028,1080)", vr: "CS", vm: "1", name: "Gray Scale" },
  "(0028,1090)": {
    tag: "(0028,1090)",
    vr: "CS",
    vm: "1",
    name: "Recommended Viewing Mode"
  },
  "(0028,1100)": {
    tag: "(0028,1100)",
    vr: "US|SS",
    vm: "3",
    name: "Gray Lookup Table Descriptor"
  },
  "(0028,1101)": {
    tag: "(0028,1101)",
    vr: "US|SS",
    vm: "3",
    name: "Red Palette Color Lookup Table Descriptor"
  },
  "(0028,1102)": {
    tag: "(0028,1102)",
    vr: "US|SS",
    vm: "3",
    name: "Green Palette Color Lookup Table Descriptor"
  },
  "(0028,1103)": {
    tag: "(0028,1103)",
    vr: "US|SS",
    vm: "3",
    name: "Blue Palette Color Lookup Table Descriptor"
  },
  "(0028,1104)": {
    tag: "(0028,1104)",
    vr: "US",
    vm: "3",
    name: "Alpha Palette Color Lookup Table Descriptor"
  },
  "(0028,1111)": {
    tag: "(0028,1111)",
    vr: "US|SS",
    vm: "4",
    name: "Large Red Palette Color Lookup Table Descriptor"
  },
  "(0028,1112)": {
    tag: "(0028,1112)",
    vr: "US|SS",
    vm: "4",
    name: "Large Green Palette Color Lookup Table Descriptor"
  },
  "(0028,1113)": {
    tag: "(0028,1113)",
    vr: "US|SS",
    vm: "4",
    name: "Large Blue Palette Color Lookup Table Descriptor"
  },
  "(0028,1199)": {
    tag: "(0028,1199)",
    vr: "UI",
    vm: "1",
    name: "Palette Color Lookup Table UID"
  },
  "(0028,1200)": {
    tag: "(0028,1200)",
    vr: "US|SS|OW",
    vm: "11",
    name: "Gray Lookup Table Data"
  },
  "(0028,1201)": {
    tag: "(0028,1201)",
    vr: "OW",
    vm: "1",
    name: "Red Palette Color Lookup Table Data"
  },
  "(0028,1202)": {
    tag: "(0028,1202)",
    vr: "OW",
    vm: "1",
    name: "Green Palette Color Lookup Table Data"
  },
  "(0028,1203)": {
    tag: "(0028,1203)",
    vr: "OW",
    vm: "1",
    name: "Blue Palette Color Lookup Table Data"
  },
  "(0028,1204)": {
    tag: "(0028,1204)",
    vr: "OW",
    vm: "1",
    name: "Alpha Palette Color Lookup Table Data"
  },
  "(0028,1211)": {
    tag: "(0028,1211)",
    vr: "OW",
    vm: "1",
    name: "Large Red Palette Color Lookup Table Data"
  },
  "(0028,1212)": {
    tag: "(0028,1212)",
    vr: "OW",
    vm: "1",
    name: "Large Green Palette Color Lookup Table Data"
  },
  "(0028,1213)": {
    tag: "(0028,1213)",
    vr: "OW",
    vm: "1",
    name: "Large Blue Palette Color Lookup Table Data"
  },
  "(0028,1214)": {
    tag: "(0028,1214)",
    vr: "UI",
    vm: "1",
    name: "Large Palette Color Lookup Table UID"
  },
  "(0028,1221)": {
    tag: "(0028,1221)",
    vr: "OW",
    vm: "1",
    name: "Segmented Red Palette Color Lookup Table Data"
  },
  "(0028,1222)": {
    tag: "(0028,1222)",
    vr: "OW",
    vm: "1",
    name: "Segmented Green Palette Color Lookup Table Data"
  },
  "(0028,1223)": {
    tag: "(0028,1223)",
    vr: "OW",
    vm: "1",
    name: "Segmented Blue Palette Color Lookup Table Data"
  },
  "(0028,1300)": {
    tag: "(0028,1300)",
    vr: "CS",
    vm: "1",
    name: "Breast Implant Present"
  },
  "(0028,1350)": {
    tag: "(0028,1350)",
    vr: "CS",
    vm: "1",
    name: "Partial View"
  },
  "(0028,1351)": {
    tag: "(0028,1351)",
    vr: "ST",
    vm: "1",
    name: "Partial View Description"
  },
  "(0028,1352)": {
    tag: "(0028,1352)",
    vr: "SQ",
    vm: "1",
    name: "Partial View Code Sequence"
  },
  "(0028,135A)": {
    tag: "(0028,135A)",
    vr: "CS",
    vm: "1",
    name: "Spatial Locations Preserved"
  },
  "(0028,1401)": {
    tag: "(0028,1401)",
    vr: "SQ",
    vm: "1",
    name: "Data Frame Assignment Sequence"
  },
  "(0028,1402)": {
    tag: "(0028,1402)",
    vr: "CS",
    vm: "1",
    name: "Data Path Assignment"
  },
  "(0028,1403)": {
    tag: "(0028,1403)",
    vr: "US",
    vm: "1",
    name: "Bits Mapped To Color Lookup Table"
  },
  "(0028,1404)": {
    tag: "(0028,1404)",
    vr: "SQ",
    vm: "1",
    name: "Blending LUT1Sequence"
  },
  "(0028,1405)": {
    tag: "(0028,1405)",
    vr: "CS",
    vm: "1",
    name: "Blending LUT1Transfer Function"
  },
  "(0028,1406)": {
    tag: "(0028,1406)",
    vr: "FD",
    vm: "1",
    name: "Blending Weight Constant"
  },
  "(0028,1407)": {
    tag: "(0028,1407)",
    vr: "US",
    vm: "3",
    name: "Blending Lookup Table Descriptor"
  },
  "(0028,1408)": {
    tag: "(0028,1408)",
    vr: "OW",
    vm: "1",
    name: "Blending Lookup Table Data"
  },
  "(0028,140B)": {
    tag: "(0028,140B)",
    vr: "SQ",
    vm: "1",
    name: "Enhanced Palette Color Lookup Table Sequence"
  },
  "(0028,140C)": {
    tag: "(0028,140C)",
    vr: "SQ",
    vm: "1",
    name: "Blending LUT2Sequence"
  },
  "(0028,140D)": {
    tag: "(0028,140D)",
    vr: "CS",
    vm: "1",
    name: "Blending LUT2Transfer Function"
  },
  "(0028,140E)": {
    tag: "(0028,140E)",
    vr: "CS",
    vm: "1",
    name: "Data Path ID"
  },
  "(0028,140F)": {
    tag: "(0028,140F)",
    vr: "CS",
    vm: "1",
    name: "RGBLUTTransfer Function"
  },
  "(0028,1410)": {
    tag: "(0028,1410)",
    vr: "CS",
    vm: "1",
    name: "Alpha LUTTransfer Function"
  },
  "(0028,2000)": { tag: "(0028,2000)", vr: "OB", vm: "1", name: "ICCProfile" },
  "(0028,2110)": {
    tag: "(0028,2110)",
    vr: "CS",
    vm: "1",
    name: "Lossy Image Compression"
  },
  "(0028,2112)": {
    tag: "(0028,2112)",
    vr: "DS",
    vm: "1",
    name: "Lossy Image Compression Ratio"
  },
  "(0028,2114)": {
    tag: "(0028,2114)",
    vr: "CS",
    vm: "1",
    name: "Lossy Image Compression Method"
  },
  "(0028,3000)": {
    tag: "(0028,3000)",
    vr: "SQ",
    vm: "1",
    name: "Modality LUTSequence"
  },
  "(0028,3002)": {
    tag: "(0028,3002)",
    vr: "US|SS",
    vm: "3",
    name: "LUTDescriptor"
  },
  "(0028,3003)": {
    tag: "(0028,3003)",
    vr: "LO",
    vm: "1",
    name: "LUTExplanation"
  },
  "(0028,3004)": {
    tag: "(0028,3004)",
    vr: "LO",
    vm: "1",
    name: "Modality LUTType"
  },
  "(0028,3006)": {
    tag: "(0028,3006)",
    vr: "US|OW",
    vm: "11",
    name: "LUTData"
  },
  "(0028,3010)": {
    tag: "(0028,3010)",
    vr: "SQ",
    vm: "1",
    name: "VOILUTSequence"
  },
  "(0028,3110)": {
    tag: "(0028,3110)",
    vr: "SQ",
    vm: "1",
    name: "Softcopy VOILUTSequence"
  },
  "(0028,4000)": {
    tag: "(0028,4000)",
    vr: "LT",
    vm: "1",
    name: "Image Presentation Comments"
  },
  "(0028,5000)": {
    tag: "(0028,5000)",
    vr: "SQ",
    vm: "1",
    name: "Bi Plane Acquisition Sequence"
  },
  "(0028,6010)": {
    tag: "(0028,6010)",
    vr: "US",
    vm: "1",
    name: "Representative Frame Number"
  },
  "(0028,6020)": {
    tag: "(0028,6020)",
    vr: "US",
    vm: "1",
    name: "Frame Numbers Of Interest"
  },
  "(0028,6022)": {
    tag: "(0028,6022)",
    vr: "LO",
    vm: "1",
    name: "Frame Of Interest Description"
  },
  "(0028,6023)": {
    tag: "(0028,6023)",
    vr: "CS",
    vm: "1",
    name: "Frame Of Interest Type"
  },
  "(0028,6030)": {
    tag: "(0028,6030)",
    vr: "US",
    vm: "1",
    name: "Mask Pointers"
  },
  "(0028,6040)": {
    tag: "(0028,6040)",
    vr: "US",
    vm: "1",
    name: "RWave Pointer"
  },
  "(0028,6100)": {
    tag: "(0028,6100)",
    vr: "SQ",
    vm: "1",
    name: "Mask Subtraction Sequence"
  },
  "(0028,6101)": {
    tag: "(0028,6101)",
    vr: "CS",
    vm: "1",
    name: "Mask Operation"
  },
  "(0028,6102)": {
    tag: "(0028,6102)",
    vr: "US",
    vm: "2-2n",
    name: "Applicable Frame Range"
  },
  "(0028,6110)": {
    tag: "(0028,6110)",
    vr: "US",
    vm: "1",
    name: "Mask Frame Numbers"
  },
  "(0028,6112)": {
    tag: "(0028,6112)",
    vr: "US",
    vm: "1",
    name: "Contrast Frame Averaging"
  },
  "(0028,6114)": {
    tag: "(0028,6114)",
    vr: "FL",
    vm: "2",
    name: "Mask Sub Pixel Shift"
  },
  "(0028,6120)": { tag: "(0028,6120)", vr: "SS", vm: "1", name: "TIDOffset" },
  "(0028,6190)": {
    tag: "(0028,6190)",
    vr: "ST",
    vm: "1",
    name: "Mask Operation Explanation"
  },
  "(0028,7FE0)": {
    tag: "(0028,7FE0)",
    vr: "UT",
    vm: "1",
    name: "Pixel Data Provider URL"
  },
  "(0028,9001)": {
    tag: "(0028,9001)",
    vr: "UL",
    vm: "1",
    name: "Data Point Rows"
  },
  "(0028,9002)": {
    tag: "(0028,9002)",
    vr: "UL",
    vm: "1",
    name: "Data Point Columns"
  },
  "(0028,9003)": {
    tag: "(0028,9003)",
    vr: "CS",
    vm: "1",
    name: "Signal Domain Columns"
  },
  "(0028,9099)": {
    tag: "(0028,9099)",
    vr: "US",
    vm: "1",
    name: "Largest Monochrome Pixel Value"
  },
  "(0028,9108)": {
    tag: "(0028,9108)",
    vr: "CS",
    vm: "1",
    name: "Data Representation"
  },
  "(0028,9110)": {
    tag: "(0028,9110)",
    vr: "SQ",
    vm: "1",
    name: "Pixel Measures Sequence"
  },
  "(0028,9132)": {
    tag: "(0028,9132)",
    vr: "SQ",
    vm: "1",
    name: "Frame VOILUTSequence"
  },
  "(0028,9145)": {
    tag: "(0028,9145)",
    vr: "SQ",
    vm: "1",
    name: "Pixel Value Transformation Sequence"
  },
  "(0028,9235)": {
    tag: "(0028,9235)",
    vr: "CS",
    vm: "1",
    name: "Signal Domain Rows"
  },
  "(0028,9411)": {
    tag: "(0028,9411)",
    vr: "FL",
    vm: "1",
    name: "Display Filter Percentage"
  },
  "(0028,9415)": {
    tag: "(0028,9415)",
    vr: "SQ",
    vm: "1",
    name: "Frame Pixel Shift Sequence"
  },
  "(0028,9416)": {
    tag: "(0028,9416)",
    vr: "US",
    vm: "1",
    name: "Subtraction Item ID"
  },
  "(0028,9422)": {
    tag: "(0028,9422)",
    vr: "SQ",
    vm: "1",
    name: "Pixel Intensity Relationship LUTSequence"
  },
  "(0028,9443)": {
    tag: "(0028,9443)",
    vr: "SQ",
    vm: "1",
    name: "Frame Pixel Data Properties Sequence"
  },
  "(0028,9444)": {
    tag: "(0028,9444)",
    vr: "CS",
    vm: "1",
    name: "Geometrical Properties"
  },
  "(0028,9445)": {
    tag: "(0028,9445)",
    vr: "FL",
    vm: "1",
    name: "Geometric Maximum Distortion"
  },
  "(0028,9446)": {
    tag: "(0028,9446)",
    vr: "CS",
    vm: "1",
    name: "Image Processing Applied"
  },
  "(0028,9454)": {
    tag: "(0028,9454)",
    vr: "CS",
    vm: "1",
    name: "Mask Selection Mode"
  },
  "(0028,9474)": { tag: "(0028,9474)", vr: "CS", vm: "1", name: "LUTFunction" },
  "(0028,9478)": {
    tag: "(0028,9478)",
    vr: "FL",
    vm: "1",
    name: "Mask Visibility Percentage"
  },
  "(0028,9501)": {
    tag: "(0028,9501)",
    vr: "SQ",
    vm: "1",
    name: "Pixel Shift Sequence"
  },
  "(0028,9502)": {
    tag: "(0028,9502)",
    vr: "SQ",
    vm: "1",
    name: "Region Pixel Shift Sequence"
  },
  "(0028,9503)": {
    tag: "(0028,9503)",
    vr: "SS",
    vm: "2-2n",
    name: "Vertices Of The Region"
  },
  "(0028,9505)": {
    tag: "(0028,9505)",
    vr: "SQ",
    vm: "1",
    name: "Multi Frame Presentation Sequence"
  },
  "(0028,9506)": {
    tag: "(0028,9506)",
    vr: "US",
    vm: "2-2n",
    name: "Pixel Shift Frame Range"
  },
  "(0028,9507)": {
    tag: "(0028,9507)",
    vr: "US",
    vm: "2-2n",
    name: "LUTFrame Range"
  },
  "(0028,9520)": {
    tag: "(0028,9520)",
    vr: "DS",
    vm: "16",
    name: "Image To Equipment Mapping Matrix"
  },
  "(0028,9537)": {
    tag: "(0028,9537)",
    vr: "CS",
    vm: "1",
    name: "Equipment Coordinate System Identification"
  },
  "(0032,000A)": {
    tag: "(0032,000A)",
    vr: "CS",
    vm: "1",
    name: "Study Status ID"
  },
  "(0032,000C)": {
    tag: "(0032,000C)",
    vr: "CS",
    vm: "1",
    name: "Study Priority ID"
  },
  "(0032,0012)": {
    tag: "(0032,0012)",
    vr: "LO",
    vm: "1",
    name: "Study IDIssuer"
  },
  "(0032,0032)": {
    tag: "(0032,0032)",
    vr: "DA",
    vm: "1",
    name: "Study Verified Date"
  },
  "(0032,0033)": {
    tag: "(0032,0033)",
    vr: "TM",
    vm: "1",
    name: "Study Verified Time"
  },
  "(0032,0034)": {
    tag: "(0032,0034)",
    vr: "DA",
    vm: "1",
    name: "Study Read Date"
  },
  "(0032,0035)": {
    tag: "(0032,0035)",
    vr: "TM",
    vm: "1",
    name: "Study Read Time"
  },
  "(0032,1000)": {
    tag: "(0032,1000)",
    vr: "DA",
    vm: "1",
    name: "Scheduled Study Start Date"
  },
  "(0032,1001)": {
    tag: "(0032,1001)",
    vr: "TM",
    vm: "1",
    name: "Scheduled Study Start Time"
  },
  "(0032,1010)": {
    tag: "(0032,1010)",
    vr: "DA",
    vm: "1",
    name: "Scheduled Study Stop Date"
  },
  "(0032,1011)": {
    tag: "(0032,1011)",
    vr: "TM",
    vm: "1",
    name: "Scheduled Study Stop Time"
  },
  "(0032,1020)": {
    tag: "(0032,1020)",
    vr: "LO",
    vm: "1",
    name: "Scheduled Study Location"
  },
  "(0032,1021)": {
    tag: "(0032,1021)",
    vr: "AE",
    vm: "1",
    name: "Scheduled Study Location AETitle"
  },
  "(0032,1030)": {
    tag: "(0032,1030)",
    vr: "LO",
    vm: "1",
    name: "Reason For Study"
  },
  "(0032,1031)": {
    tag: "(0032,1031)",
    vr: "SQ",
    vm: "1",
    name: "Requesting Physician Identification Sequence"
  },
  "(0032,1032)": {
    tag: "(0032,1032)",
    vr: "PN",
    vm: "1",
    name: "Requesting Physician"
  },
  "(0032,1033)": {
    tag: "(0032,1033)",
    vr: "LO",
    vm: "1",
    name: "Requesting Service"
  },
  "(0032,1034)": {
    tag: "(0032,1034)",
    vr: "SQ",
    vm: "1",
    name: "Requesting Service Code Sequence"
  },
  "(0032,1040)": {
    tag: "(0032,1040)",
    vr: "DA",
    vm: "1",
    name: "Study Arrival Date"
  },
  "(0032,1041)": {
    tag: "(0032,1041)",
    vr: "TM",
    vm: "1",
    name: "Study Arrival Time"
  },
  "(0032,1050)": {
    tag: "(0032,1050)",
    vr: "DA",
    vm: "1",
    name: "Study Completion Date"
  },
  "(0032,1051)": {
    tag: "(0032,1051)",
    vr: "TM",
    vm: "1",
    name: "Study Completion Time"
  },
  "(0032,1055)": {
    tag: "(0032,1055)",
    vr: "CS",
    vm: "1",
    name: "Study Component Status ID"
  },
  "(0032,1060)": {
    tag: "(0032,1060)",
    vr: "LO",
    vm: "1",
    name: "Requested Procedure Description"
  },
  "(0032,1064)": {
    tag: "(0032,1064)",
    vr: "SQ",
    vm: "1",
    name: "Requested Procedure Code Sequence"
  },
  "(0032,1070)": {
    tag: "(0032,1070)",
    vr: "LO",
    vm: "1",
    name: "Requested Contrast Agent"
  },
  "(0032,4000)": {
    tag: "(0032,4000)",
    vr: "LT",
    vm: "1",
    name: "Study Comments"
  },
  "(0038,0004)": {
    tag: "(0038,0004)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Patient Alias Sequence"
  },
  "(0038,0008)": {
    tag: "(0038,0008)",
    vr: "CS",
    vm: "1",
    name: "Visit Status ID"
  },
  "(0038,0010)": {
    tag: "(0038,0010)",
    vr: "LO",
    vm: "1",
    name: "Admission ID"
  },
  "(0038,0011)": {
    tag: "(0038,0011)",
    vr: "LO",
    vm: "1",
    name: "Issuer Of Admission ID"
  },
  "(0038,0014)": {
    tag: "(0038,0014)",
    vr: "SQ",
    vm: "1",
    name: "Issuer Of Admission IDSequence"
  },
  "(0038,0016)": {
    tag: "(0038,0016)",
    vr: "LO",
    vm: "1",
    name: "Route Of Admissions"
  },
  "(0038,001A)": {
    tag: "(0038,001A)",
    vr: "DA",
    vm: "1",
    name: "Scheduled Admission Date"
  },
  "(0038,001B)": {
    tag: "(0038,001B)",
    vr: "TM",
    vm: "1",
    name: "Scheduled Admission Time"
  },
  "(0038,001C)": {
    tag: "(0038,001C)",
    vr: "DA",
    vm: "1",
    name: "Scheduled Discharge Date"
  },
  "(0038,001D)": {
    tag: "(0038,001D)",
    vr: "TM",
    vm: "1",
    name: "Scheduled Discharge Time"
  },
  "(0038,001E)": {
    tag: "(0038,001E)",
    vr: "LO",
    vm: "1",
    name: "Scheduled Patient Institution Residence"
  },
  "(0038,0020)": {
    tag: "(0038,0020)",
    vr: "DA",
    vm: "1",
    name: "Admitting Date"
  },
  "(0038,0021)": {
    tag: "(0038,0021)",
    vr: "TM",
    vm: "1",
    name: "Admitting Time"
  },
  "(0038,0030)": {
    tag: "(0038,0030)",
    vr: "DA",
    vm: "1",
    name: "Discharge Date"
  },
  "(0038,0032)": {
    tag: "(0038,0032)",
    vr: "TM",
    vm: "1",
    name: "Discharge Time"
  },
  "(0038,0040)": {
    tag: "(0038,0040)",
    vr: "LO",
    vm: "1",
    name: "Discharge Diagnosis Description"
  },
  "(0038,0044)": {
    tag: "(0038,0044)",
    vr: "SQ",
    vm: "1",
    name: "Discharge Diagnosis Code Sequence"
  },
  "(0038,0050)": {
    tag: "(0038,0050)",
    vr: "LO",
    vm: "1",
    name: "Special Needs"
  },
  "(0038,0060)": {
    tag: "(0038,0060)",
    vr: "LO",
    vm: "1",
    name: "Service Episode ID"
  },
  "(0038,0061)": {
    tag: "(0038,0061)",
    vr: "LO",
    vm: "1",
    name: "Issuer Of Service Episode ID"
  },
  "(0038,0062)": {
    tag: "(0038,0062)",
    vr: "LO",
    vm: "1",
    name: "Service Episode Description"
  },
  "(0038,0064)": {
    tag: "(0038,0064)",
    vr: "SQ",
    vm: "1",
    name: "Issuer Of Service Episode IDSequence"
  },
  "(0038,0100)": {
    tag: "(0038,0100)",
    vr: "SQ",
    vm: "1",
    name: "Pertinent Documents Sequence"
  },
  "(0038,0300)": {
    tag: "(0038,0300)",
    vr: "LO",
    vm: "1",
    name: "Current Patient Location"
  },
  "(0038,0400)": {
    tag: "(0038,0400)",
    vr: "LO",
    vm: "1",
    name: "Patient Institution Residence"
  },
  "(0038,0500)": {
    tag: "(0038,0500)",
    vr: "LO",
    vm: "1",
    name: "Patient State"
  },
  "(0038,0502)": {
    tag: "(0038,0502)",
    vr: "SQ",
    vm: "1",
    name: "Patient Clinical Trial Participation Sequence"
  },
  "(0038,4000)": {
    tag: "(0038,4000)",
    vr: "LT",
    vm: "1",
    name: "Visit Comments"
  },
  "(003A,0004)": {
    tag: "(003A,0004)",
    vr: "CS",
    vm: "1",
    name: "Waveform Originality"
  },
  "(003A,0005)": {
    tag: "(003A,0005)",
    vr: "US",
    vm: "1",
    name: "Number Of Waveform Channels"
  },
  "(003A,0010)": {
    tag: "(003A,0010)",
    vr: "UL",
    vm: "1",
    name: "Number Of Waveform Samples"
  },
  "(003A,001A)": {
    tag: "(003A,001A)",
    vr: "DS",
    vm: "1",
    name: "Sampling Frequency"
  },
  "(003A,0020)": {
    tag: "(003A,0020)",
    vr: "SH",
    vm: "1",
    name: "Multiplex Group Label"
  },
  "(003A,0200)": {
    tag: "(003A,0200)",
    vr: "SQ",
    vm: "1",
    name: "Channel Definition Sequence"
  },
  "(003A,0202)": {
    tag: "(003A,0202)",
    vr: "IS",
    vm: "1",
    name: "Waveform Channel Number"
  },
  "(003A,0203)": {
    tag: "(003A,0203)",
    vr: "SH",
    vm: "1",
    name: "Channel Label"
  },
  "(003A,0205)": {
    tag: "(003A,0205)",
    vr: "CS",
    vm: "1",
    name: "Channel Status"
  },
  "(003A,0208)": {
    tag: "(003A,0208)",
    vr: "SQ",
    vm: "1",
    name: "Channel Source Sequence"
  },
  "(003A,0209)": {
    tag: "(003A,0209)",
    vr: "SQ",
    vm: "1",
    name: "Channel Source Modifiers Sequence"
  },
  "(003A,020A)": {
    tag: "(003A,020A)",
    vr: "SQ",
    vm: "1",
    name: "Source Waveform Sequence"
  },
  "(003A,020C)": {
    tag: "(003A,020C)",
    vr: "LO",
    vm: "1",
    name: "Channel Derivation Description"
  },
  "(003A,0210)": {
    tag: "(003A,0210)",
    vr: "DS",
    vm: "1",
    name: "Channel Sensitivity"
  },
  "(003A,0211)": {
    tag: "(003A,0211)",
    vr: "SQ",
    vm: "1",
    name: "Channel Sensitivity Units Sequence"
  },
  "(003A,0212)": {
    tag: "(003A,0212)",
    vr: "DS",
    vm: "1",
    name: "Channel Sensitivity Correction Factor"
  },
  "(003A,0213)": {
    tag: "(003A,0213)",
    vr: "DS",
    vm: "1",
    name: "Channel Baseline"
  },
  "(003A,0214)": {
    tag: "(003A,0214)",
    vr: "DS",
    vm: "1",
    name: "Channel Time Skew"
  },
  "(003A,0215)": {
    tag: "(003A,0215)",
    vr: "DS",
    vm: "1",
    name: "Channel Sample Skew"
  },
  "(003A,0218)": {
    tag: "(003A,0218)",
    vr: "DS",
    vm: "1",
    name: "Channel Offset"
  },
  "(003A,021A)": {
    tag: "(003A,021A)",
    vr: "US",
    vm: "1",
    name: "Waveform Bits Stored"
  },
  "(003A,0220)": {
    tag: "(003A,0220)",
    vr: "DS",
    vm: "1",
    name: "Filter Low Frequency"
  },
  "(003A,0221)": {
    tag: "(003A,0221)",
    vr: "DS",
    vm: "1",
    name: "Filter High Frequency"
  },
  "(003A,0222)": {
    tag: "(003A,0222)",
    vr: "DS",
    vm: "1",
    name: "Notch Filter Frequency"
  },
  "(003A,0223)": {
    tag: "(003A,0223)",
    vr: "DS",
    vm: "1",
    name: "Notch Filter Bandwidth"
  },
  "(003A,0230)": {
    tag: "(003A,0230)",
    vr: "FL",
    vm: "1",
    name: "Waveform Data Display Scale"
  },
  "(003A,0231)": {
    tag: "(003A,0231)",
    vr: "US",
    vm: "3",
    name: "Waveform Display Background CIELab Value"
  },
  "(003A,0240)": {
    tag: "(003A,0240)",
    vr: "SQ",
    vm: "1",
    name: "Waveform Presentation Group Sequence"
  },
  "(003A,0241)": {
    tag: "(003A,0241)",
    vr: "US",
    vm: "1",
    name: "Presentation Group Number"
  },
  "(003A,0242)": {
    tag: "(003A,0242)",
    vr: "SQ",
    vm: "1",
    name: "Channel Display Sequence"
  },
  "(003A,0244)": {
    tag: "(003A,0244)",
    vr: "US",
    vm: "3",
    name: "Channel Recommended Display CIELab Value"
  },
  "(003A,0245)": {
    tag: "(003A,0245)",
    vr: "FL",
    vm: "1",
    name: "Channel Position"
  },
  "(003A,0246)": {
    tag: "(003A,0246)",
    vr: "CS",
    vm: "1",
    name: "Display Shading Flag"
  },
  "(003A,0247)": {
    tag: "(003A,0247)",
    vr: "FL",
    vm: "1",
    name: "Fractional Channel Display Scale"
  },
  "(003A,0248)": {
    tag: "(003A,0248)",
    vr: "FL",
    vm: "1",
    name: "Absolute Channel Display Scale"
  },
  "(003A,0300)": {
    tag: "(003A,0300)",
    vr: "SQ",
    vm: "1",
    name: "Multiplexed Audio Channels Description Code Sequence"
  },
  "(003A,0301)": {
    tag: "(003A,0301)",
    vr: "IS",
    vm: "1",
    name: "Channel Identification Code"
  },
  "(003A,0302)": {
    tag: "(003A,0302)",
    vr: "CS",
    vm: "1",
    name: "Channel Mode"
  },
  "(0040,0001)": {
    tag: "(0040,0001)",
    vr: "AE",
    vm: "1",
    name: "Scheduled Station AETitle"
  },
  "(0040,0002)": {
    tag: "(0040,0002)",
    vr: "DA",
    vm: "1",
    name: "Scheduled Procedure Step Start Date"
  },
  "(0040,0003)": {
    tag: "(0040,0003)",
    vr: "TM",
    vm: "1",
    name: "Scheduled Procedure Step Start Time"
  },
  "(0040,0004)": {
    tag: "(0040,0004)",
    vr: "DA",
    vm: "1",
    name: "Scheduled Procedure Step End Date"
  },
  "(0040,0005)": {
    tag: "(0040,0005)",
    vr: "TM",
    vm: "1",
    name: "Scheduled Procedure Step End Time"
  },
  "(0040,0006)": {
    tag: "(0040,0006)",
    vr: "PN",
    vm: "1",
    name: "Scheduled Performing Physician Name"
  },
  "(0040,0007)": {
    tag: "(0040,0007)",
    vr: "LO",
    vm: "1",
    name: "Scheduled Procedure Step Description"
  },
  "(0040,0008)": {
    tag: "(0040,0008)",
    vr: "SQ",
    vm: "1",
    name: "Scheduled Protocol Code Sequence"
  },
  "(0040,0009)": {
    tag: "(0040,0009)",
    vr: "SH",
    vm: "1",
    name: "Scheduled Procedure Step ID"
  },
  "(0040,000A)": {
    tag: "(0040,000A)",
    vr: "SQ",
    vm: "1",
    name: "Stage Code Sequence"
  },
  "(0040,000B)": {
    tag: "(0040,000B)",
    vr: "SQ",
    vm: "1",
    name: "Scheduled Performing Physician Identification Sequence"
  },
  "(0040,0010)": {
    tag: "(0040,0010)",
    vr: "SH",
    vm: "1",
    name: "Scheduled Station Name"
  },
  "(0040,0011)": {
    tag: "(0040,0011)",
    vr: "SH",
    vm: "1",
    name: "Scheduled Procedure Step Location"
  },
  "(0040,0012)": {
    tag: "(0040,0012)",
    vr: "LO",
    vm: "1",
    name: "Pre Medication"
  },
  "(0040,0020)": {
    tag: "(0040,0020)",
    vr: "CS",
    vm: "1",
    name: "Scheduled Procedure Step Status"
  },
  "(0040,0026)": {
    tag: "(0040,0026)",
    vr: "SQ",
    vm: "1",
    name: "Order Placer Identifier Sequence"
  },
  "(0040,0027)": {
    tag: "(0040,0027)",
    vr: "SQ",
    vm: "1",
    name: "Order Filler Identifier Sequence"
  },
  "(0040,0031)": {
    tag: "(0040,0031)",
    vr: "UT",
    vm: "1",
    name: "Local Namespace Entity ID"
  },
  "(0040,0032)": {
    tag: "(0040,0032)",
    vr: "UT",
    vm: "1",
    name: "Universal Entity ID"
  },
  "(0040,0033)": {
    tag: "(0040,0033)",
    vr: "CS",
    vm: "1",
    name: "Universal Entity IDType"
  },
  "(0040,0035)": {
    tag: "(0040,0035)",
    vr: "CS",
    vm: "1",
    name: "Identifier Type Code"
  },
  "(0040,0036)": {
    tag: "(0040,0036)",
    vr: "SQ",
    vm: "1",
    name: "Assigning Facility Sequence"
  },
  "(0040,0039)": {
    tag: "(0040,0039)",
    vr: "SQ",
    vm: "1",
    name: "Assigning Jurisdiction Code Sequence"
  },
  "(0040,003A)": {
    tag: "(0040,003A)",
    vr: "SQ",
    vm: "1",
    name: "Assigning Agency Or Department Code Sequence"
  },
  "(0040,0100)": {
    tag: "(0040,0100)",
    vr: "SQ",
    vm: "1",
    name: "Scheduled Procedure Step Sequence"
  },
  "(0040,0220)": {
    tag: "(0040,0220)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Non Image Composite SOPInstance Sequence"
  },
  "(0040,0241)": {
    tag: "(0040,0241)",
    vr: "AE",
    vm: "1",
    name: "Performed Station AETitle"
  },
  "(0040,0242)": {
    tag: "(0040,0242)",
    vr: "SH",
    vm: "1",
    name: "Performed Station Name"
  },
  "(0040,0243)": {
    tag: "(0040,0243)",
    vr: "SH",
    vm: "1",
    name: "Performed Location"
  },
  "(0040,0244)": {
    tag: "(0040,0244)",
    vr: "DA",
    vm: "1",
    name: "Performed Procedure Step Start Date"
  },
  "(0040,0245)": {
    tag: "(0040,0245)",
    vr: "TM",
    vm: "1",
    name: "Performed Procedure Step Start Time"
  },
  "(0040,0250)": {
    tag: "(0040,0250)",
    vr: "DA",
    vm: "1",
    name: "Performed Procedure Step End Date"
  },
  "(0040,0251)": {
    tag: "(0040,0251)",
    vr: "TM",
    vm: "1",
    name: "Performed Procedure Step End Time"
  },
  "(0040,0252)": {
    tag: "(0040,0252)",
    vr: "CS",
    vm: "1",
    name: "Performed Procedure Step Status"
  },
  "(0040,0253)": {
    tag: "(0040,0253)",
    vr: "SH",
    vm: "1",
    name: "Performed Procedure Step ID"
  },
  "(0040,0254)": {
    tag: "(0040,0254)",
    vr: "LO",
    vm: "1",
    name: "Performed Procedure Step Description"
  },
  "(0040,0255)": {
    tag: "(0040,0255)",
    vr: "LO",
    vm: "1",
    name: "Performed Procedure Type Description"
  },
  "(0040,0260)": {
    tag: "(0040,0260)",
    vr: "SQ",
    vm: "1",
    name: "Performed Protocol Code Sequence"
  },
  "(0040,0261)": {
    tag: "(0040,0261)",
    vr: "CS",
    vm: "1",
    name: "Performed Protocol Type"
  },
  "(0040,0270)": {
    tag: "(0040,0270)",
    vr: "SQ",
    vm: "1",
    name: "Scheduled Step Attributes Sequence"
  },
  "(0040,0275)": {
    tag: "(0040,0275)",
    vr: "SQ",
    vm: "1",
    name: "Request Attributes Sequence"
  },
  "(0040,0280)": {
    tag: "(0040,0280)",
    vr: "ST",
    vm: "1",
    name: "Comments On The Performed Procedure Step"
  },
  "(0040,0281)": {
    tag: "(0040,0281)",
    vr: "SQ",
    vm: "1",
    name: "Performed Procedure Step Discontinuation Reason Code Sequence"
  },
  "(0040,0293)": {
    tag: "(0040,0293)",
    vr: "SQ",
    vm: "1",
    name: "Quantity Sequence"
  },
  "(0040,0294)": { tag: "(0040,0294)", vr: "DS", vm: "1", name: "Quantity" },
  "(0040,0295)": {
    tag: "(0040,0295)",
    vr: "SQ",
    vm: "1",
    name: "Measuring Units Sequence"
  },
  "(0040,0296)": {
    tag: "(0040,0296)",
    vr: "SQ",
    vm: "1",
    name: "Billing Item Sequence"
  },
  "(0040,0300)": {
    tag: "(0040,0300)",
    vr: "US",
    vm: "1",
    name: "Total Time Of Fluoroscopy"
  },
  "(0040,0301)": {
    tag: "(0040,0301)",
    vr: "US",
    vm: "1",
    name: "Total Number Of Exposures"
  },
  "(0040,0302)": {
    tag: "(0040,0302)",
    vr: "US",
    vm: "1",
    name: "Entrance Dose"
  },
  "(0040,0303)": {
    tag: "(0040,0303)",
    vr: "US",
    vm: "1-2",
    name: "Exposed Area"
  },
  "(0040,0306)": {
    tag: "(0040,0306)",
    vr: "DS",
    vm: "1",
    name: "Distance Source To Entrance"
  },
  "(0040,0307)": {
    tag: "(0040,0307)",
    vr: "DS",
    vm: "1",
    name: "Distance Source To Support"
  },
  "(0040,030E)": {
    tag: "(0040,030E)",
    vr: "SQ",
    vm: "1",
    name: "Exposure Dose Sequence"
  },
  "(0040,0310)": {
    tag: "(0040,0310)",
    vr: "ST",
    vm: "1",
    name: "Comments On Radiation Dose"
  },
  "(0040,0312)": { tag: "(0040,0312)", vr: "DS", vm: "1", name: "XRay Output" },
  "(0040,0314)": {
    tag: "(0040,0314)",
    vr: "DS",
    vm: "1",
    name: "Half Value Layer"
  },
  "(0040,0316)": { tag: "(0040,0316)", vr: "DS", vm: "1", name: "Organ Dose" },
  "(0040,0318)": {
    tag: "(0040,0318)",
    vr: "CS",
    vm: "1",
    name: "Organ Exposed"
  },
  "(0040,0320)": {
    tag: "(0040,0320)",
    vr: "SQ",
    vm: "1",
    name: "Billing Procedure Step Sequence"
  },
  "(0040,0321)": {
    tag: "(0040,0321)",
    vr: "SQ",
    vm: "1",
    name: "Film Consumption Sequence"
  },
  "(0040,0324)": {
    tag: "(0040,0324)",
    vr: "SQ",
    vm: "1",
    name: "Billing Supplies And Devices Sequence"
  },
  "(0040,0330)": {
    tag: "(0040,0330)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Procedure Step Sequence"
  },
  "(0040,0340)": {
    tag: "(0040,0340)",
    vr: "SQ",
    vm: "1",
    name: "Performed Series Sequence"
  },
  "(0040,0400)": {
    tag: "(0040,0400)",
    vr: "LT",
    vm: "1",
    name: "Comments On The Scheduled Procedure Step"
  },
  "(0040,0440)": {
    tag: "(0040,0440)",
    vr: "SQ",
    vm: "1",
    name: "Protocol Context Sequence"
  },
  "(0040,0441)": {
    tag: "(0040,0441)",
    vr: "SQ",
    vm: "1",
    name: "Content Item Modifier Sequence"
  },
  "(0040,0500)": {
    tag: "(0040,0500)",
    vr: "SQ",
    vm: "1",
    name: "Scheduled Specimen Sequence"
  },
  "(0040,050A)": {
    tag: "(0040,050A)",
    vr: "LO",
    vm: "1",
    name: "Specimen Accession Number"
  },
  "(0040,0512)": {
    tag: "(0040,0512)",
    vr: "LO",
    vm: "1",
    name: "Container Identifier"
  },
  "(0040,0513)": {
    tag: "(0040,0513)",
    vr: "SQ",
    vm: "1",
    name: "Issuer Of The Container Identifier Sequence"
  },
  "(0040,0515)": {
    tag: "(0040,0515)",
    vr: "SQ",
    vm: "1",
    name: "Alternate Container Identifier Sequence"
  },
  "(0040,0518)": {
    tag: "(0040,0518)",
    vr: "SQ",
    vm: "1",
    name: "Container Type Code Sequence"
  },
  "(0040,051A)": {
    tag: "(0040,051A)",
    vr: "LO",
    vm: "1",
    name: "Container Description"
  },
  "(0040,0520)": {
    tag: "(0040,0520)",
    vr: "SQ",
    vm: "1",
    name: "Container Component Sequence"
  },
  "(0040,0550)": {
    tag: "(0040,0550)",
    vr: "SQ",
    vm: "1",
    name: "Specimen Sequence"
  },
  "(0040,0551)": {
    tag: "(0040,0551)",
    vr: "LO",
    vm: "1",
    name: "Specimen Identifier"
  },
  "(0040,0552)": {
    tag: "(0040,0552)",
    vr: "SQ",
    vm: "1",
    name: "Specimen Description Sequence Trial"
  },
  "(0040,0553)": {
    tag: "(0040,0553)",
    vr: "ST",
    vm: "1",
    name: "Specimen Description Trial"
  },
  "(0040,0554)": {
    tag: "(0040,0554)",
    vr: "UI",
    vm: "1",
    name: "Specimen UID"
  },
  "(0040,0555)": {
    tag: "(0040,0555)",
    vr: "SQ",
    vm: "1",
    name: "Acquisition Context Sequence"
  },
  "(0040,0556)": {
    tag: "(0040,0556)",
    vr: "ST",
    vm: "1",
    name: "Acquisition Context Description"
  },
  "(0040,0560)": {
    tag: "(0040,0560)",
    vr: "SQ",
    vm: "1",
    name: "Specimen Description Sequence"
  },
  "(0040,0562)": {
    tag: "(0040,0562)",
    vr: "SQ",
    vm: "1",
    name: "Issuer Of The Specimen Identifier Sequence"
  },
  "(0040,059A)": {
    tag: "(0040,059A)",
    vr: "SQ",
    vm: "1",
    name: "Specimen Type Code Sequence"
  },
  "(0040,0600)": {
    tag: "(0040,0600)",
    vr: "LO",
    vm: "1",
    name: "Specimen Short Description"
  },
  "(0040,0602)": {
    tag: "(0040,0602)",
    vr: "UT",
    vm: "1",
    name: "Specimen Detailed Description"
  },
  "(0040,0610)": {
    tag: "(0040,0610)",
    vr: "SQ",
    vm: "1",
    name: "Specimen Preparation Sequence"
  },
  "(0040,0612)": {
    tag: "(0040,0612)",
    vr: "SQ",
    vm: "1",
    name: "Specimen Preparation Step Content Item Sequence"
  },
  "(0040,0620)": {
    tag: "(0040,0620)",
    vr: "SQ",
    vm: "1",
    name: "Specimen Localization Content Item Sequence"
  },
  "(0040,06FA)": {
    tag: "(0040,06FA)",
    vr: "LO",
    vm: "1",
    name: "Slide Identifier"
  },
  "(0040,071A)": {
    tag: "(0040,071A)",
    vr: "SQ",
    vm: "1",
    name: "Image Center Point Coordinates Sequence"
  },
  "(0040,072A)": {
    tag: "(0040,072A)",
    vr: "DS",
    vm: "1",
    name: "XOffset In Slide Coordinate System"
  },
  "(0040,073A)": {
    tag: "(0040,073A)",
    vr: "DS",
    vm: "1",
    name: "YOffset In Slide Coordinate System"
  },
  "(0040,074A)": {
    tag: "(0040,074A)",
    vr: "DS",
    vm: "1",
    name: "ZOffset In Slide Coordinate System"
  },
  "(0040,08D8)": {
    tag: "(0040,08D8)",
    vr: "SQ",
    vm: "1",
    name: "Pixel Spacing Sequence"
  },
  "(0040,08DA)": {
    tag: "(0040,08DA)",
    vr: "SQ",
    vm: "1",
    name: "Coordinate System Axis Code Sequence"
  },
  "(0040,08EA)": {
    tag: "(0040,08EA)",
    vr: "SQ",
    vm: "1",
    name: "Measurement Units Code Sequence"
  },
  "(0040,09F8)": {
    tag: "(0040,09F8)",
    vr: "SQ",
    vm: "1",
    name: "Vital Stain Code Sequence Trial"
  },
  "(0040,1001)": {
    tag: "(0040,1001)",
    vr: "SH",
    vm: "1",
    name: "Requested Procedure ID"
  },
  "(0040,1002)": {
    tag: "(0040,1002)",
    vr: "LO",
    vm: "1",
    name: "Reason For The Requested Procedure"
  },
  "(0040,1003)": {
    tag: "(0040,1003)",
    vr: "SH",
    vm: "1",
    name: "Requested Procedure Priority"
  },
  "(0040,1004)": {
    tag: "(0040,1004)",
    vr: "LO",
    vm: "1",
    name: "Patient Transport Arrangements"
  },
  "(0040,1005)": {
    tag: "(0040,1005)",
    vr: "LO",
    vm: "1",
    name: "Requested Procedure Location"
  },
  "(0040,1006)": {
    tag: "(0040,1006)",
    vr: "SH",
    vm: "1",
    name: "Placer Order Number Procedure"
  },
  "(0040,1007)": {
    tag: "(0040,1007)",
    vr: "SH",
    vm: "1",
    name: "Filler Order Number Procedure"
  },
  "(0040,1008)": {
    tag: "(0040,1008)",
    vr: "LO",
    vm: "1",
    name: "Confidentiality Code"
  },
  "(0040,1009)": {
    tag: "(0040,1009)",
    vr: "SH",
    vm: "1",
    name: "Reporting Priority"
  },
  "(0040,100A)": {
    tag: "(0040,100A)",
    vr: "SQ",
    vm: "1",
    name: "Reason For Requested Procedure Code Sequence"
  },
  "(0040,1010)": {
    tag: "(0040,1010)",
    vr: "PN",
    vm: "1",
    name: "Names Of Intended Recipients Of Results"
  },
  "(0040,1011)": {
    tag: "(0040,1011)",
    vr: "SQ",
    vm: "1",
    name: "Intended Recipients Of Results Identification Sequence"
  },
  "(0040,1012)": {
    tag: "(0040,1012)",
    vr: "SQ",
    vm: "1",
    name: "Reason For Performed Procedure Code Sequence"
  },
  "(0040,1060)": {
    tag: "(0040,1060)",
    vr: "LO",
    vm: "1",
    name: "Requested Procedure Description Trial"
  },
  "(0040,1101)": {
    tag: "(0040,1101)",
    vr: "SQ",
    vm: "1",
    name: "Person Identification Code Sequence"
  },
  "(0040,1102)": {
    tag: "(0040,1102)",
    vr: "ST",
    vm: "1",
    name: "Person Address"
  },
  "(0040,1103)": {
    tag: "(0040,1103)",
    vr: "LO",
    vm: "1",
    name: "Person Telephone Numbers"
  },
  "(0040,1400)": {
    tag: "(0040,1400)",
    vr: "LT",
    vm: "1",
    name: "Requested Procedure Comments"
  },
  "(0040,2001)": {
    tag: "(0040,2001)",
    vr: "LO",
    vm: "1",
    name: "Reason For The Imaging Service Request"
  },
  "(0040,2004)": {
    tag: "(0040,2004)",
    vr: "DA",
    vm: "1",
    name: "Issue Date Of Imaging Service Request"
  },
  "(0040,2005)": {
    tag: "(0040,2005)",
    vr: "TM",
    vm: "1",
    name: "Issue Time Of Imaging Service Request"
  },
  "(0040,2006)": {
    tag: "(0040,2006)",
    vr: "SH",
    vm: "1",
    name: "Placer Order Number Imaging Service Request Retired"
  },
  "(0040,2007)": {
    tag: "(0040,2007)",
    vr: "SH",
    vm: "1",
    name: "Filler Order Number Imaging Service Request Retired"
  },
  "(0040,2008)": {
    tag: "(0040,2008)",
    vr: "PN",
    vm: "1",
    name: "Order Entered By"
  },
  "(0040,2009)": {
    tag: "(0040,2009)",
    vr: "SH",
    vm: "1",
    name: "Order Enterer Location"
  },
  "(0040,2010)": {
    tag: "(0040,2010)",
    vr: "SH",
    vm: "1",
    name: "Order Callback Phone Number"
  },
  "(0040,2016)": {
    tag: "(0040,2016)",
    vr: "LO",
    vm: "1",
    name: "Placer Order Number Imaging Service Request"
  },
  "(0040,2017)": {
    tag: "(0040,2017)",
    vr: "LO",
    vm: "1",
    name: "Filler Order Number Imaging Service Request"
  },
  "(0040,2400)": {
    tag: "(0040,2400)",
    vr: "LT",
    vm: "1",
    name: "Imaging Service Request Comments"
  },
  "(0040,3001)": {
    tag: "(0040,3001)",
    vr: "LO",
    vm: "1",
    name: "Confidentiality Constraint On Patient Data Description"
  },
  "(0040,4001)": {
    tag: "(0040,4001)",
    vr: "CS",
    vm: "1",
    name: "General Purpose Scheduled Procedure Step Status"
  },
  "(0040,4002)": {
    tag: "(0040,4002)",
    vr: "CS",
    vm: "1",
    name: "General Purpose Performed Procedure Step Status"
  },
  "(0040,4003)": {
    tag: "(0040,4003)",
    vr: "CS",
    vm: "1",
    name: "General Purpose Scheduled Procedure Step Priority"
  },
  "(0040,4004)": {
    tag: "(0040,4004)",
    vr: "SQ",
    vm: "1",
    name: "Scheduled Processing Applications Code Sequence"
  },
  "(0040,4005)": {
    tag: "(0040,4005)",
    vr: "DT",
    vm: "1",
    name: "Scheduled Procedure Step Start Date Time"
  },
  "(0040,4006)": {
    tag: "(0040,4006)",
    vr: "CS",
    vm: "1",
    name: "Multiple Copies Flag"
  },
  "(0040,4007)": {
    tag: "(0040,4007)",
    vr: "SQ",
    vm: "1",
    name: "Performed Processing Applications Code Sequence"
  },
  "(0040,4009)": {
    tag: "(0040,4009)",
    vr: "SQ",
    vm: "1",
    name: "Human Performer Code Sequence"
  },
  "(0040,4010)": {
    tag: "(0040,4010)",
    vr: "DT",
    vm: "1",
    name: "Scheduled Procedure Step Modification Date Time"
  },
  "(0040,4011)": {
    tag: "(0040,4011)",
    vr: "DT",
    vm: "1",
    name: "Expected Completion Date Time"
  },
  "(0040,4015)": {
    tag: "(0040,4015)",
    vr: "SQ",
    vm: "1",
    name: "Resulting General Purpose Performed Procedure Steps Sequence"
  },
  "(0040,4016)": {
    tag: "(0040,4016)",
    vr: "SQ",
    vm: "1",
    name: "Referenced General Purpose Scheduled Procedure Step Sequence"
  },
  "(0040,4018)": {
    tag: "(0040,4018)",
    vr: "SQ",
    vm: "1",
    name: "Scheduled Workitem Code Sequence"
  },
  "(0040,4019)": {
    tag: "(0040,4019)",
    vr: "SQ",
    vm: "1",
    name: "Performed Workitem Code Sequence"
  },
  "(0040,4020)": {
    tag: "(0040,4020)",
    vr: "CS",
    vm: "1",
    name: "Input Availability Flag"
  },
  "(0040,4021)": {
    tag: "(0040,4021)",
    vr: "SQ",
    vm: "1",
    name: "Input Information Sequence"
  },
  "(0040,4022)": {
    tag: "(0040,4022)",
    vr: "SQ",
    vm: "1",
    name: "Relevant Information Sequence"
  },
  "(0040,4023)": {
    tag: "(0040,4023)",
    vr: "UI",
    vm: "1",
    name: "Referenced General Purpose Scheduled Procedure Step Transaction UID"
  },
  "(0040,4025)": {
    tag: "(0040,4025)",
    vr: "SQ",
    vm: "1",
    name: "Scheduled Station Name Code Sequence"
  },
  "(0040,4026)": {
    tag: "(0040,4026)",
    vr: "SQ",
    vm: "1",
    name: "Scheduled Station Class Code Sequence"
  },
  "(0040,4027)": {
    tag: "(0040,4027)",
    vr: "SQ",
    vm: "1",
    name: "Scheduled Station Geographic Location Code Sequence"
  },
  "(0040,4028)": {
    tag: "(0040,4028)",
    vr: "SQ",
    vm: "1",
    name: "Performed Station Name Code Sequence"
  },
  "(0040,4029)": {
    tag: "(0040,4029)",
    vr: "SQ",
    vm: "1",
    name: "Performed Station Class Code Sequence"
  },
  "(0040,4030)": {
    tag: "(0040,4030)",
    vr: "SQ",
    vm: "1",
    name: "Performed Station Geographic Location Code Sequence"
  },
  "(0040,4031)": {
    tag: "(0040,4031)",
    vr: "SQ",
    vm: "1",
    name: "Requested Subsequent Workitem Code Sequence"
  },
  "(0040,4032)": {
    tag: "(0040,4032)",
    vr: "SQ",
    vm: "1",
    name: "Non DICOMOutput Code Sequence"
  },
  "(0040,4033)": {
    tag: "(0040,4033)",
    vr: "SQ",
    vm: "1",
    name: "Output Information Sequence"
  },
  "(0040,4034)": {
    tag: "(0040,4034)",
    vr: "SQ",
    vm: "1",
    name: "Scheduled Human Performers Sequence"
  },
  "(0040,4035)": {
    tag: "(0040,4035)",
    vr: "SQ",
    vm: "1",
    name: "Actual Human Performers Sequence"
  },
  "(0040,4036)": {
    tag: "(0040,4036)",
    vr: "LO",
    vm: "1",
    name: "Human Performer Organization"
  },
  "(0040,4037)": {
    tag: "(0040,4037)",
    vr: "PN",
    vm: "1",
    name: "Human Performer Name"
  },
  "(0040,4040)": {
    tag: "(0040,4040)",
    vr: "CS",
    vm: "1",
    name: "Raw Data Handling"
  },
  "(0040,4041)": {
    tag: "(0040,4041)",
    vr: "CS",
    vm: "1",
    name: "Input Readiness State"
  },
  "(0040,4050)": {
    tag: "(0040,4050)",
    vr: "DT",
    vm: "1",
    name: "Performed Procedure Step Start Date Time"
  },
  "(0040,4051)": {
    tag: "(0040,4051)",
    vr: "DT",
    vm: "1",
    name: "Performed Procedure Step End Date Time"
  },
  "(0040,4052)": {
    tag: "(0040,4052)",
    vr: "DT",
    vm: "1",
    name: "Procedure Step Cancellation Date Time"
  },
  "(0040,8302)": {
    tag: "(0040,8302)",
    vr: "DS",
    vm: "1",
    name: "Entrance Dose Inm Gy"
  },
  "(0040,9094)": {
    tag: "(0040,9094)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Image Real World Value Mapping Sequence"
  },
  "(0040,9096)": {
    tag: "(0040,9096)",
    vr: "SQ",
    vm: "1",
    name: "Real World Value Mapping Sequence"
  },
  "(0040,9098)": {
    tag: "(0040,9098)",
    vr: "SQ",
    vm: "1",
    name: "Pixel Value Mapping Code Sequence"
  },
  "(0040,9210)": { tag: "(0040,9210)", vr: "SH", vm: "1", name: "LUTLabel" },
  "(0040,9211)": {
    tag: "(0040,9211)",
    vr: "US|SS",
    vm: "1",
    name: "Real World Value Last Value Mapped"
  },
  "(0040,9212)": {
    tag: "(0040,9212)",
    vr: "FD",
    vm: "1",
    name: "Real World Value LUTData"
  },
  "(0040,9216)": {
    tag: "(0040,9216)",
    vr: "US|SS",
    vm: "1",
    name: "Real World Value First Value Mapped"
  },
  "(0040,9224)": {
    tag: "(0040,9224)",
    vr: "FD",
    vm: "1",
    name: "Real World Value Intercept"
  },
  "(0040,9225)": {
    tag: "(0040,9225)",
    vr: "FD",
    vm: "1",
    name: "Real World Value Slope"
  },
  "(0040,A007)": {
    tag: "(0040,A007)",
    vr: "CS",
    vm: "1",
    name: "Findings Flag Trial"
  },
  "(0040,A010)": {
    tag: "(0040,A010)",
    vr: "CS",
    vm: "1",
    name: "Relationship Type"
  },
  "(0040,A020)": {
    tag: "(0040,A020)",
    vr: "SQ",
    vm: "1",
    name: "Findings Sequence Trial"
  },
  "(0040,A021)": {
    tag: "(0040,A021)",
    vr: "UI",
    vm: "1",
    name: "Findings Group UIDTrial"
  },
  "(0040,A022)": {
    tag: "(0040,A022)",
    vr: "UI",
    vm: "1",
    name: "Referenced Findings Group UIDTrial"
  },
  "(0040,A023)": {
    tag: "(0040,A023)",
    vr: "DA",
    vm: "1",
    name: "Findings Group Recording Date Trial"
  },
  "(0040,A024)": {
    tag: "(0040,A024)",
    vr: "TM",
    vm: "1",
    name: "Findings Group Recording Time Trial"
  },
  "(0040,A026)": {
    tag: "(0040,A026)",
    vr: "SQ",
    vm: "1",
    name: "Findings Source Category Code Sequence Trial"
  },
  "(0040,A027)": {
    tag: "(0040,A027)",
    vr: "LO",
    vm: "1",
    name: "Verifying Organization"
  },
  "(0040,A028)": {
    tag: "(0040,A028)",
    vr: "SQ",
    vm: "1",
    name: "Documenting Organization Identifier Code Sequence Trial"
  },
  "(0040,A030)": {
    tag: "(0040,A030)",
    vr: "DT",
    vm: "1",
    name: "Verification Date Time"
  },
  "(0040,A032)": {
    tag: "(0040,A032)",
    vr: "DT",
    vm: "1",
    name: "Observation Date Time"
  },
  "(0040,A040)": { tag: "(0040,A040)", vr: "CS", vm: "1", name: "Value Type" },
  "(0040,A043)": {
    tag: "(0040,A043)",
    vr: "SQ",
    vm: "1",
    name: "Concept Name Code Sequence"
  },
  "(0040,A047)": {
    tag: "(0040,A047)",
    vr: "LO",
    vm: "1",
    name: "Measurement Precision Description Trial"
  },
  "(0040,A050)": {
    tag: "(0040,A050)",
    vr: "CS",
    vm: "1",
    name: "Continuity Of Content"
  },
  "(0040,A057)": {
    tag: "(0040,A057)",
    vr: "CS",
    vm: "1",
    name: "Urgency Or Priority Alerts Trial"
  },
  "(0040,A060)": {
    tag: "(0040,A060)",
    vr: "LO",
    vm: "1",
    name: "Sequencing Indicator Trial"
  },
  "(0040,A066)": {
    tag: "(0040,A066)",
    vr: "SQ",
    vm: "1",
    name: "Document Identifier Code Sequence Trial"
  },
  "(0040,A067)": {
    tag: "(0040,A067)",
    vr: "PN",
    vm: "1",
    name: "Document Author Trial"
  },
  "(0040,A068)": {
    tag: "(0040,A068)",
    vr: "SQ",
    vm: "1",
    name: "Document Author Identifier Code Sequence Trial"
  },
  "(0040,A070)": {
    tag: "(0040,A070)",
    vr: "SQ",
    vm: "1",
    name: "Identifier Code Sequence Trial"
  },
  "(0040,A073)": {
    tag: "(0040,A073)",
    vr: "SQ",
    vm: "1",
    name: "Verifying Observer Sequence"
  },
  "(0040,A074)": {
    tag: "(0040,A074)",
    vr: "OB",
    vm: "1",
    name: "Object Binary Identifier Trial"
  },
  "(0040,A075)": {
    tag: "(0040,A075)",
    vr: "PN",
    vm: "1",
    name: "Verifying Observer Name"
  },
  "(0040,A076)": {
    tag: "(0040,A076)",
    vr: "SQ",
    vm: "1",
    name: "Documenting Observer Identifier Code Sequence Trial"
  },
  "(0040,A078)": {
    tag: "(0040,A078)",
    vr: "SQ",
    vm: "1",
    name: "Author Observer Sequence"
  },
  "(0040,A07A)": {
    tag: "(0040,A07A)",
    vr: "SQ",
    vm: "1",
    name: "Participant Sequence"
  },
  "(0040,A07C)": {
    tag: "(0040,A07C)",
    vr: "SQ",
    vm: "1",
    name: "Custodial Organization Sequence"
  },
  "(0040,A080)": {
    tag: "(0040,A080)",
    vr: "CS",
    vm: "1",
    name: "Participation Type"
  },
  "(0040,A082)": {
    tag: "(0040,A082)",
    vr: "DT",
    vm: "1",
    name: "Participation Date Time"
  },
  "(0040,A084)": {
    tag: "(0040,A084)",
    vr: "CS",
    vm: "1",
    name: "Observer Type"
  },
  "(0040,A085)": {
    tag: "(0040,A085)",
    vr: "SQ",
    vm: "1",
    name: "Procedure Identifier Code Sequence Trial"
  },
  "(0040,A088)": {
    tag: "(0040,A088)",
    vr: "SQ",
    vm: "1",
    name: "Verifying Observer Identification Code Sequence"
  },
  "(0040,A089)": {
    tag: "(0040,A089)",
    vr: "OB",
    vm: "1",
    name: "Object Directory Binary Identifier Trial"
  },
  "(0040,A090)": {
    tag: "(0040,A090)",
    vr: "SQ",
    vm: "1",
    name: "Equivalent CDADocument Sequence"
  },
  "(0040,A0B0)": {
    tag: "(0040,A0B0)",
    vr: "US",
    vm: "2-2n",
    name: "Referenced Waveform Channels"
  },
  "(0040,A110)": {
    tag: "(0040,A110)",
    vr: "DA",
    vm: "1",
    name: "Date Of Document Or Verbal Transaction Trial"
  },
  "(0040,A112)": {
    tag: "(0040,A112)",
    vr: "TM",
    vm: "1",
    name: "Time Of Document Creation Or Verbal Transaction Trial"
  },
  "(0040,A120)": { tag: "(0040,A120)", vr: "DT", vm: "1", name: "Date Time" },
  "(0040,A121)": { tag: "(0040,A121)", vr: "DA", vm: "1", name: "Date" },
  "(0040,A122)": { tag: "(0040,A122)", vr: "TM", vm: "1", name: "Time" },
  "(0040,A123)": { tag: "(0040,A123)", vr: "PN", vm: "1", name: "Person Name" },
  "(0040,A124)": { tag: "(0040,A124)", vr: "UI", vm: "1", name: "UID" },
  "(0040,A125)": {
    tag: "(0040,A125)",
    vr: "CS",
    vm: "2",
    name: "Report Status IDTrial"
  },
  "(0040,A130)": {
    tag: "(0040,A130)",
    vr: "CS",
    vm: "1",
    name: "Temporal Range Type"
  },
  "(0040,A132)": {
    tag: "(0040,A132)",
    vr: "UL",
    vm: "1",
    name: "Referenced Sample Positions"
  },
  "(0040,A136)": {
    tag: "(0040,A136)",
    vr: "US",
    vm: "1",
    name: "Referenced Frame Numbers"
  },
  "(0040,A138)": {
    tag: "(0040,A138)",
    vr: "DS",
    vm: "1",
    name: "Referenced Time Offsets"
  },
  "(0040,A13A)": {
    tag: "(0040,A13A)",
    vr: "DT",
    vm: "1",
    name: "Referenced Date Time"
  },
  "(0040,A160)": { tag: "(0040,A160)", vr: "UT", vm: "1", name: "Text Value" },
  "(0040,A167)": {
    tag: "(0040,A167)",
    vr: "SQ",
    vm: "1",
    name: "Observation Category Code Sequence Trial"
  },
  "(0040,A168)": {
    tag: "(0040,A168)",
    vr: "SQ",
    vm: "1",
    name: "Concept Code Sequence"
  },
  "(0040,A16A)": {
    tag: "(0040,A16A)",
    vr: "ST",
    vm: "1",
    name: "Bibliographic Citation Trial"
  },
  "(0040,A170)": {
    tag: "(0040,A170)",
    vr: "SQ",
    vm: "1",
    name: "Purpose Of Reference Code Sequence"
  },
  "(0040,A171)": {
    tag: "(0040,A171)",
    vr: "UI",
    vm: "1",
    name: "Observation UIDTrial"
  },
  "(0040,A172)": {
    tag: "(0040,A172)",
    vr: "UI",
    vm: "1",
    name: "Referenced Observation UIDTrial"
  },
  "(0040,A173)": {
    tag: "(0040,A173)",
    vr: "CS",
    vm: "1",
    name: "Referenced Observation Class Trial"
  },
  "(0040,A174)": {
    tag: "(0040,A174)",
    vr: "CS",
    vm: "1",
    name: "Referenced Object Observation Class Trial"
  },
  "(0040,A180)": {
    tag: "(0040,A180)",
    vr: "US",
    vm: "1",
    name: "Annotation Group Number"
  },
  "(0040,A192)": {
    tag: "(0040,A192)",
    vr: "DA",
    vm: "1",
    name: "Observation Date Trial"
  },
  "(0040,A193)": {
    tag: "(0040,A193)",
    vr: "TM",
    vm: "1",
    name: "Observation Time Trial"
  },
  "(0040,A194)": {
    tag: "(0040,A194)",
    vr: "CS",
    vm: "1",
    name: "Measurement Automation Trial"
  },
  "(0040,A195)": {
    tag: "(0040,A195)",
    vr: "SQ",
    vm: "1",
    name: "Modifier Code Sequence"
  },
  "(0040,A224)": {
    tag: "(0040,A224)",
    vr: "ST",
    vm: "1",
    name: "Identification Description Trial"
  },
  "(0040,A290)": {
    tag: "(0040,A290)",
    vr: "CS",
    vm: "1",
    name: "Coordinates Set Geometric Type Trial"
  },
  "(0040,A296)": {
    tag: "(0040,A296)",
    vr: "SQ",
    vm: "1",
    name: "Algorithm Code Sequence Trial"
  },
  "(0040,A297)": {
    tag: "(0040,A297)",
    vr: "ST",
    vm: "1",
    name: "Algorithm Description Trial"
  },
  "(0040,A29A)": {
    tag: "(0040,A29A)",
    vr: "SL",
    vm: "2-2n",
    name: "Pixel Coordinates Set Trial"
  },
  "(0040,A300)": {
    tag: "(0040,A300)",
    vr: "SQ",
    vm: "1",
    name: "Measured Value Sequence"
  },
  "(0040,A301)": {
    tag: "(0040,A301)",
    vr: "SQ",
    vm: "1",
    name: "Numeric Value Qualifier Code Sequence"
  },
  "(0040,A307)": {
    tag: "(0040,A307)",
    vr: "PN",
    vm: "1",
    name: "Current Observer Trial"
  },
  "(0040,A30A)": {
    tag: "(0040,A30A)",
    vr: "DS",
    vm: "1",
    name: "Numeric Value"
  },
  "(0040,A313)": {
    tag: "(0040,A313)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Accession Sequence Trial"
  },
  "(0040,A33A)": {
    tag: "(0040,A33A)",
    vr: "ST",
    vm: "1",
    name: "Report Status Comment Trial"
  },
  "(0040,A340)": {
    tag: "(0040,A340)",
    vr: "SQ",
    vm: "1",
    name: "Procedure Context Sequence Trial"
  },
  "(0040,A352)": {
    tag: "(0040,A352)",
    vr: "PN",
    vm: "1",
    name: "Verbal Source Trial"
  },
  "(0040,A353)": {
    tag: "(0040,A353)",
    vr: "ST",
    vm: "1",
    name: "Address Trial"
  },
  "(0040,A354)": {
    tag: "(0040,A354)",
    vr: "LO",
    vm: "1",
    name: "Telephone Number Trial"
  },
  "(0040,A358)": {
    tag: "(0040,A358)",
    vr: "SQ",
    vm: "1",
    name: "Verbal Source Identifier Code Sequence Trial"
  },
  "(0040,A360)": {
    tag: "(0040,A360)",
    vr: "SQ",
    vm: "1",
    name: "Predecessor Documents Sequence"
  },
  "(0040,A370)": {
    tag: "(0040,A370)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Request Sequence"
  },
  "(0040,A372)": {
    tag: "(0040,A372)",
    vr: "SQ",
    vm: "1",
    name: "Performed Procedure Code Sequence"
  },
  "(0040,A375)": {
    tag: "(0040,A375)",
    vr: "SQ",
    vm: "1",
    name: "Current Requested Procedure Evidence Sequence"
  },
  "(0040,A380)": {
    tag: "(0040,A380)",
    vr: "SQ",
    vm: "1",
    name: "Report Detail Sequence Trial"
  },
  "(0040,A385)": {
    tag: "(0040,A385)",
    vr: "SQ",
    vm: "1",
    name: "Pertinent Other Evidence Sequence"
  },
  "(0040,A390)": {
    tag: "(0040,A390)",
    vr: "SQ",
    vm: "1",
    name: "HL7Structured Document Reference Sequence"
  },
  "(0040,A402)": {
    tag: "(0040,A402)",
    vr: "UI",
    vm: "1",
    name: "Observation Subject UIDTrial"
  },
  "(0040,A403)": {
    tag: "(0040,A403)",
    vr: "CS",
    vm: "1",
    name: "Observation Subject Class Trial"
  },
  "(0040,A404)": {
    tag: "(0040,A404)",
    vr: "SQ",
    vm: "1",
    name: "Observation Subject Type Code Sequence Trial"
  },
  "(0040,A491)": {
    tag: "(0040,A491)",
    vr: "CS",
    vm: "1",
    name: "Completion Flag"
  },
  "(0040,A492)": {
    tag: "(0040,A492)",
    vr: "LO",
    vm: "1",
    name: "Completion Flag Description"
  },
  "(0040,A493)": {
    tag: "(0040,A493)",
    vr: "CS",
    vm: "1",
    name: "Verification Flag"
  },
  "(0040,A494)": {
    tag: "(0040,A494)",
    vr: "CS",
    vm: "1",
    name: "Archive Requested"
  },
  "(0040,A496)": {
    tag: "(0040,A496)",
    vr: "CS",
    vm: "1",
    name: "Preliminary Flag"
  },
  "(0040,A504)": {
    tag: "(0040,A504)",
    vr: "SQ",
    vm: "1",
    name: "Content Template Sequence"
  },
  "(0040,A525)": {
    tag: "(0040,A525)",
    vr: "SQ",
    vm: "1",
    name: "Identical Documents Sequence"
  },
  "(0040,A600)": {
    tag: "(0040,A600)",
    vr: "CS",
    vm: "1",
    name: "Observation Subject Context Flag Trial"
  },
  "(0040,A601)": {
    tag: "(0040,A601)",
    vr: "CS",
    vm: "1",
    name: "Observer Context Flag Trial"
  },
  "(0040,A603)": {
    tag: "(0040,A603)",
    vr: "CS",
    vm: "1",
    name: "Procedure Context Flag Trial"
  },
  "(0040,A730)": {
    tag: "(0040,A730)",
    vr: "SQ",
    vm: "1",
    name: "Content Sequence"
  },
  "(0040,A731)": {
    tag: "(0040,A731)",
    vr: "SQ",
    vm: "1",
    name: "Relationship Sequence Trial"
  },
  "(0040,A732)": {
    tag: "(0040,A732)",
    vr: "SQ",
    vm: "1",
    name: "Relationship Type Code Sequence Trial"
  },
  "(0040,A744)": {
    tag: "(0040,A744)",
    vr: "SQ",
    vm: "1",
    name: "Language Code Sequence Trial"
  },
  "(0040,A992)": {
    tag: "(0040,A992)",
    vr: "ST",
    vm: "1",
    name: "Uniform Resource Locator Trial"
  },
  "(0040,B020)": {
    tag: "(0040,B020)",
    vr: "SQ",
    vm: "1",
    name: "Waveform Annotation Sequence"
  },
  "(0040,DB00)": {
    tag: "(0040,DB00)",
    vr: "CS",
    vm: "1",
    name: "Template Identifier"
  },
  "(0040,DB06)": {
    tag: "(0040,DB06)",
    vr: "DT",
    vm: "1",
    name: "Template Version"
  },
  "(0040,DB07)": {
    tag: "(0040,DB07)",
    vr: "DT",
    vm: "1",
    name: "Template Local Version"
  },
  "(0040,DB0B)": {
    tag: "(0040,DB0B)",
    vr: "CS",
    vm: "1",
    name: "Template Extension Flag"
  },
  "(0040,DB0C)": {
    tag: "(0040,DB0C)",
    vr: "UI",
    vm: "1",
    name: "Template Extension Organization UID"
  },
  "(0040,DB0D)": {
    tag: "(0040,DB0D)",
    vr: "UI",
    vm: "1",
    name: "Template Extension Creator UID"
  },
  "(0040,DB73)": {
    tag: "(0040,DB73)",
    vr: "UL",
    vm: "1",
    name: "Referenced Content Item Identifier"
  },
  "(0040,E001)": {
    tag: "(0040,E001)",
    vr: "ST",
    vm: "1",
    name: "HL7Instance Identifier"
  },
  "(0040,E004)": {
    tag: "(0040,E004)",
    vr: "DT",
    vm: "1",
    name: "HL7Document Effective Time"
  },
  "(0040,E006)": {
    tag: "(0040,E006)",
    vr: "SQ",
    vm: "1",
    name: "HL7Document Type Code Sequence"
  },
  "(0040,E008)": {
    tag: "(0040,E008)",
    vr: "SQ",
    vm: "1",
    name: "Document Class Code Sequence"
  },
  "(0040,E010)": {
    tag: "(0040,E010)",
    vr: "UT",
    vm: "1",
    name: "Retrieve URI"
  },
  "(0040,E011)": {
    tag: "(0040,E011)",
    vr: "UI",
    vm: "1",
    name: "Retrieve Location UID"
  },
  "(0040,E020)": {
    tag: "(0040,E020)",
    vr: "CS",
    vm: "1",
    name: "Type Of Instances"
  },
  "(0040,E021)": {
    tag: "(0040,E021)",
    vr: "SQ",
    vm: "1",
    name: "DICOMRetrieval Sequence"
  },
  "(0040,E022)": {
    tag: "(0040,E022)",
    vr: "SQ",
    vm: "1",
    name: "DICOMMedia Retrieval Sequence"
  },
  "(0040,E023)": {
    tag: "(0040,E023)",
    vr: "SQ",
    vm: "1",
    name: "WADORetrieval Sequence"
  },
  "(0040,E024)": {
    tag: "(0040,E024)",
    vr: "SQ",
    vm: "1",
    name: "XDSRetrieval Sequence"
  },
  "(0040,E030)": {
    tag: "(0040,E030)",
    vr: "UI",
    vm: "1",
    name: "Repository Unique ID"
  },
  "(0040,E031)": {
    tag: "(0040,E031)",
    vr: "UI",
    vm: "1",
    name: "Home Community ID"
  },
  "(0042,0010)": {
    tag: "(0042,0010)",
    vr: "ST",
    vm: "1",
    name: "Document Title"
  },
  "(0042,0011)": {
    tag: "(0042,0011)",
    vr: "OB",
    vm: "1",
    name: "Encapsulated Document"
  },
  "(0042,0012)": {
    tag: "(0042,0012)",
    vr: "LO",
    vm: "1",
    name: "MIMEType Of Encapsulated Document"
  },
  "(0042,0013)": {
    tag: "(0042,0013)",
    vr: "SQ",
    vm: "1",
    name: "Source Instance Sequence"
  },
  "(0042,0014)": {
    tag: "(0042,0014)",
    vr: "LO",
    vm: "1",
    name: "List Of MIMETypes"
  },
  "(0044,0001)": {
    tag: "(0044,0001)",
    vr: "ST",
    vm: "1",
    name: "Product Package Identifier"
  },
  "(0044,0002)": {
    tag: "(0044,0002)",
    vr: "CS",
    vm: "1",
    name: "Substance Administration Approval"
  },
  "(0044,0003)": {
    tag: "(0044,0003)",
    vr: "LT",
    vm: "1",
    name: "Approval Status Further Description"
  },
  "(0044,0004)": {
    tag: "(0044,0004)",
    vr: "DT",
    vm: "1",
    name: "Approval Status Date Time"
  },
  "(0044,0007)": {
    tag: "(0044,0007)",
    vr: "SQ",
    vm: "1",
    name: "Product Type Code Sequence"
  },
  "(0044,0008)": {
    tag: "(0044,0008)",
    vr: "LO",
    vm: "1",
    name: "Product Name"
  },
  "(0044,0009)": {
    tag: "(0044,0009)",
    vr: "LT",
    vm: "1",
    name: "Product Description"
  },
  "(0044,000A)": {
    tag: "(0044,000A)",
    vr: "LO",
    vm: "1",
    name: "Product Lot Identifier"
  },
  "(0044,000B)": {
    tag: "(0044,000B)",
    vr: "DT",
    vm: "1",
    name: "Product Expiration Date Time"
  },
  "(0044,0010)": {
    tag: "(0044,0010)",
    vr: "DT",
    vm: "1",
    name: "Substance Administration Date Time"
  },
  "(0044,0011)": {
    tag: "(0044,0011)",
    vr: "LO",
    vm: "1",
    name: "Substance Administration Notes"
  },
  "(0044,0012)": {
    tag: "(0044,0012)",
    vr: "LO",
    vm: "1",
    name: "Substance Administration Device ID"
  },
  "(0044,0013)": {
    tag: "(0044,0013)",
    vr: "SQ",
    vm: "1",
    name: "Product Parameter Sequence"
  },
  "(0044,0019)": {
    tag: "(0044,0019)",
    vr: "SQ",
    vm: "1",
    name: "Substance Administration Parameter Sequence"
  },
  "(0046,0012)": {
    tag: "(0046,0012)",
    vr: "LO",
    vm: "1",
    name: "Lens Description"
  },
  "(0046,0014)": {
    tag: "(0046,0014)",
    vr: "SQ",
    vm: "1",
    name: "Right Lens Sequence"
  },
  "(0046,0015)": {
    tag: "(0046,0015)",
    vr: "SQ",
    vm: "1",
    name: "Left Lens Sequence"
  },
  "(0046,0016)": {
    tag: "(0046,0016)",
    vr: "SQ",
    vm: "1",
    name: "Unspecified Laterality Lens Sequence"
  },
  "(0046,0018)": {
    tag: "(0046,0018)",
    vr: "SQ",
    vm: "1",
    name: "Cylinder Sequence"
  },
  "(0046,0028)": {
    tag: "(0046,0028)",
    vr: "SQ",
    vm: "1",
    name: "Prism Sequence"
  },
  "(0046,0030)": {
    tag: "(0046,0030)",
    vr: "FD",
    vm: "1",
    name: "Horizontal Prism Power"
  },
  "(0046,0032)": {
    tag: "(0046,0032)",
    vr: "CS",
    vm: "1",
    name: "Horizontal Prism Base"
  },
  "(0046,0034)": {
    tag: "(0046,0034)",
    vr: "FD",
    vm: "1",
    name: "Vertical Prism Power"
  },
  "(0046,0036)": {
    tag: "(0046,0036)",
    vr: "CS",
    vm: "1",
    name: "Vertical Prism Base"
  },
  "(0046,0038)": {
    tag: "(0046,0038)",
    vr: "CS",
    vm: "1",
    name: "Lens Segment Type"
  },
  "(0046,0040)": {
    tag: "(0046,0040)",
    vr: "FD",
    vm: "1",
    name: "Optical Transmittance"
  },
  "(0046,0042)": {
    tag: "(0046,0042)",
    vr: "FD",
    vm: "1",
    name: "Channel Width"
  },
  "(0046,0044)": { tag: "(0046,0044)", vr: "FD", vm: "1", name: "Pupil Size" },
  "(0046,0046)": {
    tag: "(0046,0046)",
    vr: "FD",
    vm: "1",
    name: "Corneal Size"
  },
  "(0046,0050)": {
    tag: "(0046,0050)",
    vr: "SQ",
    vm: "1",
    name: "Autorefraction Right Eye Sequence"
  },
  "(0046,0052)": {
    tag: "(0046,0052)",
    vr: "SQ",
    vm: "1",
    name: "Autorefraction Left Eye Sequence"
  },
  "(0046,0060)": {
    tag: "(0046,0060)",
    vr: "FD",
    vm: "1",
    name: "Distance Pupillary Distance"
  },
  "(0046,0062)": {
    tag: "(0046,0062)",
    vr: "FD",
    vm: "1",
    name: "Near Pupillary Distance"
  },
  "(0046,0063)": {
    tag: "(0046,0063)",
    vr: "FD",
    vm: "1",
    name: "Intermediate Pupillary Distance"
  },
  "(0046,0064)": {
    tag: "(0046,0064)",
    vr: "FD",
    vm: "1",
    name: "Other Pupillary Distance"
  },
  "(0046,0070)": {
    tag: "(0046,0070)",
    vr: "SQ",
    vm: "1",
    name: "Keratometry Right Eye Sequence"
  },
  "(0046,0071)": {
    tag: "(0046,0071)",
    vr: "SQ",
    vm: "1",
    name: "Keratometry Left Eye Sequence"
  },
  "(0046,0074)": {
    tag: "(0046,0074)",
    vr: "SQ",
    vm: "1",
    name: "Steep Keratometric Axis Sequence"
  },
  "(0046,0075)": {
    tag: "(0046,0075)",
    vr: "FD",
    vm: "1",
    name: "Radius Of Curvature"
  },
  "(0046,0076)": {
    tag: "(0046,0076)",
    vr: "FD",
    vm: "1",
    name: "Keratometric Power"
  },
  "(0046,0077)": {
    tag: "(0046,0077)",
    vr: "FD",
    vm: "1",
    name: "Keratometric Axis"
  },
  "(0046,0080)": {
    tag: "(0046,0080)",
    vr: "SQ",
    vm: "1",
    name: "Flat Keratometric Axis Sequence"
  },
  "(0046,0092)": {
    tag: "(0046,0092)",
    vr: "CS",
    vm: "1",
    name: "Background Color"
  },
  "(0046,0094)": { tag: "(0046,0094)", vr: "CS", vm: "1", name: "Optotype" },
  "(0046,0095)": {
    tag: "(0046,0095)",
    vr: "CS",
    vm: "1",
    name: "Optotype Presentation"
  },
  "(0046,0097)": {
    tag: "(0046,0097)",
    vr: "SQ",
    vm: "1",
    name: "Subjective Refraction Right Eye Sequence"
  },
  "(0046,0098)": {
    tag: "(0046,0098)",
    vr: "SQ",
    vm: "1",
    name: "Subjective Refraction Left Eye Sequence"
  },
  "(0046,0100)": {
    tag: "(0046,0100)",
    vr: "SQ",
    vm: "1",
    name: "Add Near Sequence"
  },
  "(0046,0101)": {
    tag: "(0046,0101)",
    vr: "SQ",
    vm: "1",
    name: "Add Intermediate Sequence"
  },
  "(0046,0102)": {
    tag: "(0046,0102)",
    vr: "SQ",
    vm: "1",
    name: "Add Other Sequence"
  },
  "(0046,0104)": { tag: "(0046,0104)", vr: "FD", vm: "1", name: "Add Power" },
  "(0046,0106)": {
    tag: "(0046,0106)",
    vr: "FD",
    vm: "1",
    name: "Viewing Distance"
  },
  "(0046,0121)": {
    tag: "(0046,0121)",
    vr: "SQ",
    vm: "1",
    name: "Visual Acuity Type Code Sequence"
  },
  "(0046,0122)": {
    tag: "(0046,0122)",
    vr: "SQ",
    vm: "1",
    name: "Visual Acuity Right Eye Sequence"
  },
  "(0046,0123)": {
    tag: "(0046,0123)",
    vr: "SQ",
    vm: "1",
    name: "Visual Acuity Left Eye Sequence"
  },
  "(0046,0124)": {
    tag: "(0046,0124)",
    vr: "SQ",
    vm: "1",
    name: "Visual Acuity Both Eyes Open Sequence"
  },
  "(0046,0125)": {
    tag: "(0046,0125)",
    vr: "CS",
    vm: "1",
    name: "Viewing Distance Type"
  },
  "(0046,0135)": {
    tag: "(0046,0135)",
    vr: "SS",
    vm: "2",
    name: "Visual Acuity Modifiers"
  },
  "(0046,0137)": {
    tag: "(0046,0137)",
    vr: "FD",
    vm: "1",
    name: "Decimal Visual Acuity"
  },
  "(0046,0139)": {
    tag: "(0046,0139)",
    vr: "LO",
    vm: "1",
    name: "Optotype Detailed Definition"
  },
  "(0046,0145)": {
    tag: "(0046,0145)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Refractive Measurements Sequence"
  },
  "(0046,0146)": {
    tag: "(0046,0146)",
    vr: "FD",
    vm: "1",
    name: "Sphere Power"
  },
  "(0046,0147)": {
    tag: "(0046,0147)",
    vr: "FD",
    vm: "1",
    name: "Cylinder Power"
  },
  "(0048,0001)": {
    tag: "(0048,0001)",
    vr: "FL",
    vm: "1",
    name: "Imaged Volume Width"
  },
  "(0048,0002)": {
    tag: "(0048,0002)",
    vr: "FL",
    vm: "1",
    name: "Imaged Volume Height"
  },
  "(0048,0003)": {
    tag: "(0048,0003)",
    vr: "FL",
    vm: "1",
    name: "Imaged Volume Depth"
  },
  "(0048,0006)": {
    tag: "(0048,0006)",
    vr: "UL",
    vm: "1",
    name: "Total Pixel Matrix Columns"
  },
  "(0048,0007)": {
    tag: "(0048,0007)",
    vr: "UL",
    vm: "1",
    name: "Total Pixel Matrix Rows"
  },
  "(0048,0008)": {
    tag: "(0048,0008)",
    vr: "SQ",
    vm: "1",
    name: "Total Pixel Matrix Origin Sequence"
  },
  "(0048,0010)": {
    tag: "(0048,0010)",
    vr: "CS",
    vm: "1",
    name: "Specimen Label In Image"
  },
  "(0048,0011)": {
    tag: "(0048,0011)",
    vr: "CS",
    vm: "1",
    name: "Focus Method"
  },
  "(0048,0012)": {
    tag: "(0048,0012)",
    vr: "CS",
    vm: "1",
    name: "Extended Depth Of Field"
  },
  "(0048,0013)": {
    tag: "(0048,0013)",
    vr: "US",
    vm: "1",
    name: "Number Of Focal Planes"
  },
  "(0048,0014)": {
    tag: "(0048,0014)",
    vr: "FL",
    vm: "1",
    name: "Distance Between Focal Planes"
  },
  "(0048,0015)": {
    tag: "(0048,0015)",
    vr: "US",
    vm: "3",
    name: "Recommended Absent Pixel CIELab Value"
  },
  "(0048,0100)": {
    tag: "(0048,0100)",
    vr: "SQ",
    vm: "1",
    name: "Illuminator Type Code Sequence"
  },
  "(0048,0102)": {
    tag: "(0048,0102)",
    vr: "DS",
    vm: "6",
    name: "Image Orientation Slide"
  },
  "(0048,0105)": {
    tag: "(0048,0105)",
    vr: "SQ",
    vm: "1",
    name: "Optical Path Sequence"
  },
  "(0048,0106)": {
    tag: "(0048,0106)",
    vr: "SH",
    vm: "1",
    name: "Optical Path Identifier"
  },
  "(0048,0107)": {
    tag: "(0048,0107)",
    vr: "ST",
    vm: "1",
    name: "Optical Path Description"
  },
  "(0048,0108)": {
    tag: "(0048,0108)",
    vr: "SQ",
    vm: "1",
    name: "Illumination Color Code Sequence"
  },
  "(0048,0110)": {
    tag: "(0048,0110)",
    vr: "SQ",
    vm: "1",
    name: "Specimen Reference Sequence"
  },
  "(0048,0111)": {
    tag: "(0048,0111)",
    vr: "DS",
    vm: "1",
    name: "Condenser Lens Power"
  },
  "(0048,0112)": {
    tag: "(0048,0112)",
    vr: "DS",
    vm: "1",
    name: "Objective Lens Power"
  },
  "(0048,0113)": {
    tag: "(0048,0113)",
    vr: "DS",
    vm: "1",
    name: "Objective Lens Numerical Aperture"
  },
  "(0048,0120)": {
    tag: "(0048,0120)",
    vr: "SQ",
    vm: "1",
    name: "Palette Color Lookup Table Sequence"
  },
  "(0048,0200)": {
    tag: "(0048,0200)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Image Navigation Sequence"
  },
  "(0048,0201)": {
    tag: "(0048,0201)",
    vr: "US",
    vm: "2",
    name: "Top Left Hand Corner Of Localizer Area"
  },
  "(0048,0202)": {
    tag: "(0048,0202)",
    vr: "US",
    vm: "2",
    name: "Bottom Right Hand Corner Of Localizer Area"
  },
  "(0048,0207)": {
    tag: "(0048,0207)",
    vr: "SQ",
    vm: "1",
    name: "Optical Path Identification Sequence"
  },
  "(0048,021A)": {
    tag: "(0048,021A)",
    vr: "SQ",
    vm: "1",
    name: "Plane Position Slide Sequence"
  },
  "(0048,021E)": {
    tag: "(0048,021E)",
    vr: "SL",
    vm: "1",
    name: "Row Position In Total Image Pixel Matrix"
  },
  "(0048,021F)": {
    tag: "(0048,021F)",
    vr: "SL",
    vm: "1",
    name: "Column Position In Total Image Pixel Matrix"
  },
  "(0048,0301)": {
    tag: "(0048,0301)",
    vr: "CS",
    vm: "1",
    name: "Pixel Origin Interpretation"
  },
  "(0050,0004)": {
    tag: "(0050,0004)",
    vr: "CS",
    vm: "1",
    name: "Calibration Image"
  },
  "(0050,0010)": {
    tag: "(0050,0010)",
    vr: "SQ",
    vm: "1",
    name: "Device Sequence"
  },
  "(0050,0012)": {
    tag: "(0050,0012)",
    vr: "SQ",
    vm: "1",
    name: "Container Component Type Code Sequence"
  },
  "(0050,0013)": {
    tag: "(0050,0013)",
    vr: "FD",
    vm: "1",
    name: "Container Component Thickness"
  },
  "(0050,0014)": {
    tag: "(0050,0014)",
    vr: "DS",
    vm: "1",
    name: "Device Length"
  },
  "(0050,0015)": {
    tag: "(0050,0015)",
    vr: "FD",
    vm: "1",
    name: "Container Component Width"
  },
  "(0050,0016)": {
    tag: "(0050,0016)",
    vr: "DS",
    vm: "1",
    name: "Device Diameter"
  },
  "(0050,0017)": {
    tag: "(0050,0017)",
    vr: "CS",
    vm: "1",
    name: "Device Diameter Units"
  },
  "(0050,0018)": {
    tag: "(0050,0018)",
    vr: "DS",
    vm: "1",
    name: "Device Volume"
  },
  "(0050,0019)": {
    tag: "(0050,0019)",
    vr: "DS",
    vm: "1",
    name: "Inter Marker Distance"
  },
  "(0050,001A)": {
    tag: "(0050,001A)",
    vr: "CS",
    vm: "1",
    name: "Container Component Material"
  },
  "(0050,001B)": {
    tag: "(0050,001B)",
    vr: "LO",
    vm: "1",
    name: "Container Component ID"
  },
  "(0050,001C)": {
    tag: "(0050,001C)",
    vr: "FD",
    vm: "1",
    name: "Container Component Length"
  },
  "(0050,001D)": {
    tag: "(0050,001D)",
    vr: "FD",
    vm: "1",
    name: "Container Component Diameter"
  },
  "(0050,001E)": {
    tag: "(0050,001E)",
    vr: "LO",
    vm: "1",
    name: "Container Component Description"
  },
  "(0050,0020)": {
    tag: "(0050,0020)",
    vr: "LO",
    vm: "1",
    name: "Device Description"
  },
  "(0052,0001)": {
    tag: "(0052,0001)",
    vr: "FL",
    vm: "1",
    name: "Contrast Bolus Ingredient Percent By Volume"
  },
  "(0052,0002)": {
    tag: "(0052,0002)",
    vr: "FD",
    vm: "1",
    name: "OCTFocal Distance"
  },
  "(0052,0003)": {
    tag: "(0052,0003)",
    vr: "FD",
    vm: "1",
    name: "Beam Spot Size"
  },
  "(0052,0004)": {
    tag: "(0052,0004)",
    vr: "FD",
    vm: "1",
    name: "Effective Refractive Index"
  },
  "(0052,0006)": {
    tag: "(0052,0006)",
    vr: "CS",
    vm: "1",
    name: "OCTAcquisition Domain"
  },
  "(0052,0007)": {
    tag: "(0052,0007)",
    vr: "FD",
    vm: "1",
    name: "OCTOptical Center Wavelength"
  },
  "(0052,0008)": {
    tag: "(0052,0008)",
    vr: "FD",
    vm: "1",
    name: "Axial Resolution"
  },
  "(0052,0009)": {
    tag: "(0052,0009)",
    vr: "FD",
    vm: "1",
    name: "Ranging Depth"
  },
  "(0052,0011)": { tag: "(0052,0011)", vr: "FD", vm: "1", name: "ALine Rate" },
  "(0052,0012)": {
    tag: "(0052,0012)",
    vr: "US",
    vm: "1",
    name: "ALines Per Frame"
  },
  "(0052,0013)": {
    tag: "(0052,0013)",
    vr: "FD",
    vm: "1",
    name: "Catheter Rotational Rate"
  },
  "(0052,0014)": {
    tag: "(0052,0014)",
    vr: "FD",
    vm: "1",
    name: "ALine Pixel Spacing"
  },
  "(0052,0016)": {
    tag: "(0052,0016)",
    vr: "SQ",
    vm: "1",
    name: "Mode Of Percutaneous Access Sequence"
  },
  "(0052,0025)": {
    tag: "(0052,0025)",
    vr: "SQ",
    vm: "1",
    name: "Intravascular OCTFrame Type Sequence"
  },
  "(0052,0026)": {
    tag: "(0052,0026)",
    vr: "CS",
    vm: "1",
    name: "OCTZOffset Applied"
  },
  "(0052,0027)": {
    tag: "(0052,0027)",
    vr: "SQ",
    vm: "1",
    name: "Intravascular Frame Content Sequence"
  },
  "(0052,0028)": {
    tag: "(0052,0028)",
    vr: "FD",
    vm: "1",
    name: "Intravascular Longitudinal Distance"
  },
  "(0052,0029)": {
    tag: "(0052,0029)",
    vr: "SQ",
    vm: "1",
    name: "Intravascular OCTFrame Content Sequence"
  },
  "(0052,0030)": {
    tag: "(0052,0030)",
    vr: "SS",
    vm: "1",
    name: "OCTZOffset Correction"
  },
  "(0052,0031)": {
    tag: "(0052,0031)",
    vr: "CS",
    vm: "1",
    name: "Catheter Direction Of Rotation"
  },
  "(0052,0033)": {
    tag: "(0052,0033)",
    vr: "FD",
    vm: "1",
    name: "Seam Line Location"
  },
  "(0052,0034)": {
    tag: "(0052,0034)",
    vr: "FD",
    vm: "1",
    name: "First ALine Location"
  },
  "(0052,0036)": {
    tag: "(0052,0036)",
    vr: "US",
    vm: "1",
    name: "Seam Line Index"
  },
  "(0052,0038)": {
    tag: "(0052,0038)",
    vr: "US",
    vm: "1",
    name: "Number Of Padded Alines"
  },
  "(0052,0039)": {
    tag: "(0052,0039)",
    vr: "CS",
    vm: "1",
    name: "Interpolation Type"
  },
  "(0052,003A)": {
    tag: "(0052,003A)",
    vr: "CS",
    vm: "1",
    name: "Refractive Index Applied"
  },
  "(0054,0011)": {
    tag: "(0054,0011)",
    vr: "US",
    vm: "1",
    name: "Number Of Energy Windows"
  },
  "(0054,0012)": {
    tag: "(0054,0012)",
    vr: "SQ",
    vm: "1",
    name: "Energy Window Information Sequence"
  },
  "(0054,0013)": {
    tag: "(0054,0013)",
    vr: "SQ",
    vm: "1",
    name: "Energy Window Range Sequence"
  },
  "(0054,0014)": {
    tag: "(0054,0014)",
    vr: "DS",
    vm: "1",
    name: "Energy Window Lower Limit"
  },
  "(0054,0015)": {
    tag: "(0054,0015)",
    vr: "DS",
    vm: "1",
    name: "Energy Window Upper Limit"
  },
  "(0054,0016)": {
    tag: "(0054,0016)",
    vr: "SQ",
    vm: "1",
    name: "Radiopharmaceutical Information Sequence"
  },
  "(0054,0017)": {
    tag: "(0054,0017)",
    vr: "IS",
    vm: "1",
    name: "Residual Syringe Counts"
  },
  "(0054,0018)": {
    tag: "(0054,0018)",
    vr: "SH",
    vm: "1",
    name: "Energy Window Name"
  },
  "(0054,0020)": {
    tag: "(0054,0020)",
    vr: "US",
    vm: "1",
    name: "Detector Vector"
  },
  "(0054,0021)": {
    tag: "(0054,0021)",
    vr: "US",
    vm: "1",
    name: "Number Of Detectors"
  },
  "(0054,0022)": {
    tag: "(0054,0022)",
    vr: "SQ",
    vm: "1",
    name: "Detector Information Sequence"
  },
  "(0054,0030)": {
    tag: "(0054,0030)",
    vr: "US",
    vm: "1",
    name: "Phase Vector"
  },
  "(0054,0031)": {
    tag: "(0054,0031)",
    vr: "US",
    vm: "1",
    name: "Number Of Phases"
  },
  "(0054,0032)": {
    tag: "(0054,0032)",
    vr: "SQ",
    vm: "1",
    name: "Phase Information Sequence"
  },
  "(0054,0033)": {
    tag: "(0054,0033)",
    vr: "US",
    vm: "1",
    name: "Number Of Frames In Phase"
  },
  "(0054,0036)": { tag: "(0054,0036)", vr: "IS", vm: "1", name: "Phase Delay" },
  "(0054,0038)": {
    tag: "(0054,0038)",
    vr: "IS",
    vm: "1",
    name: "Pause Between Frames"
  },
  "(0054,0039)": {
    tag: "(0054,0039)",
    vr: "CS",
    vm: "1",
    name: "Phase Description"
  },
  "(0054,0050)": {
    tag: "(0054,0050)",
    vr: "US",
    vm: "1",
    name: "Rotation Vector"
  },
  "(0054,0051)": {
    tag: "(0054,0051)",
    vr: "US",
    vm: "1",
    name: "Number Of Rotations"
  },
  "(0054,0052)": {
    tag: "(0054,0052)",
    vr: "SQ",
    vm: "1",
    name: "Rotation Information Sequence"
  },
  "(0054,0053)": {
    tag: "(0054,0053)",
    vr: "US",
    vm: "1",
    name: "Number Of Frames In Rotation"
  },
  "(0054,0060)": {
    tag: "(0054,0060)",
    vr: "US",
    vm: "1",
    name: "RRInterval Vector"
  },
  "(0054,0061)": {
    tag: "(0054,0061)",
    vr: "US",
    vm: "1",
    name: "Number Of RRIntervals"
  },
  "(0054,0062)": {
    tag: "(0054,0062)",
    vr: "SQ",
    vm: "1",
    name: "Gated Information Sequence"
  },
  "(0054,0063)": {
    tag: "(0054,0063)",
    vr: "SQ",
    vm: "1",
    name: "Data Information Sequence"
  },
  "(0054,0070)": {
    tag: "(0054,0070)",
    vr: "US",
    vm: "1",
    name: "Time Slot Vector"
  },
  "(0054,0071)": {
    tag: "(0054,0071)",
    vr: "US",
    vm: "1",
    name: "Number Of Time Slots"
  },
  "(0054,0072)": {
    tag: "(0054,0072)",
    vr: "SQ",
    vm: "1",
    name: "Time Slot Information Sequence"
  },
  "(0054,0073)": {
    tag: "(0054,0073)",
    vr: "DS",
    vm: "1",
    name: "Time Slot Time"
  },
  "(0054,0080)": {
    tag: "(0054,0080)",
    vr: "US",
    vm: "1",
    name: "Slice Vector"
  },
  "(0054,0081)": {
    tag: "(0054,0081)",
    vr: "US",
    vm: "1",
    name: "Number Of Slices"
  },
  "(0054,0090)": {
    tag: "(0054,0090)",
    vr: "US",
    vm: "1",
    name: "Angular View Vector"
  },
  "(0054,0100)": {
    tag: "(0054,0100)",
    vr: "US",
    vm: "1",
    name: "Time Slice Vector"
  },
  "(0054,0101)": {
    tag: "(0054,0101)",
    vr: "US",
    vm: "1",
    name: "Number Of Time Slices"
  },
  "(0054,0200)": { tag: "(0054,0200)", vr: "DS", vm: "1", name: "Start Angle" },
  "(0054,0202)": {
    tag: "(0054,0202)",
    vr: "CS",
    vm: "1",
    name: "Type Of Detector Motion"
  },
  "(0054,0210)": {
    tag: "(0054,0210)",
    vr: "IS",
    vm: "1",
    name: "Trigger Vector"
  },
  "(0054,0211)": {
    tag: "(0054,0211)",
    vr: "US",
    vm: "1",
    name: "Number Of Triggers In Phase"
  },
  "(0054,0220)": {
    tag: "(0054,0220)",
    vr: "SQ",
    vm: "1",
    name: "View Code Sequence"
  },
  "(0054,0222)": {
    tag: "(0054,0222)",
    vr: "SQ",
    vm: "1",
    name: "View Modifier Code Sequence"
  },
  "(0054,0300)": {
    tag: "(0054,0300)",
    vr: "SQ",
    vm: "1",
    name: "Radionuclide Code Sequence"
  },
  "(0054,0302)": {
    tag: "(0054,0302)",
    vr: "SQ",
    vm: "1",
    name: "Administration Route Code Sequence"
  },
  "(0054,0304)": {
    tag: "(0054,0304)",
    vr: "SQ",
    vm: "1",
    name: "Radiopharmaceutical Code Sequence"
  },
  "(0054,0306)": {
    tag: "(0054,0306)",
    vr: "SQ",
    vm: "1",
    name: "Calibration Data Sequence"
  },
  "(0054,0308)": {
    tag: "(0054,0308)",
    vr: "US",
    vm: "1",
    name: "Energy Window Number"
  },
  "(0054,0400)": { tag: "(0054,0400)", vr: "SH", vm: "1", name: "Image ID" },
  "(0054,0410)": {
    tag: "(0054,0410)",
    vr: "SQ",
    vm: "1",
    name: "Patient Orientation Code Sequence"
  },
  "(0054,0412)": {
    tag: "(0054,0412)",
    vr: "SQ",
    vm: "1",
    name: "Patient Orientation Modifier Code Sequence"
  },
  "(0054,0414)": {
    tag: "(0054,0414)",
    vr: "SQ",
    vm: "1",
    name: "Patient Gantry Relationship Code Sequence"
  },
  "(0054,0500)": {
    tag: "(0054,0500)",
    vr: "CS",
    vm: "1",
    name: "Slice Progression Direction"
  },
  "(0054,1000)": { tag: "(0054,1000)", vr: "CS", vm: "2", name: "Series Type" },
  "(0054,1001)": { tag: "(0054,1001)", vr: "CS", vm: "1", name: "Units" },
  "(0054,1002)": {
    tag: "(0054,1002)",
    vr: "CS",
    vm: "1",
    name: "Counts Source"
  },
  "(0054,1004)": {
    tag: "(0054,1004)",
    vr: "CS",
    vm: "1",
    name: "Reprojection Method"
  },
  "(0054,1006)": { tag: "(0054,1006)", vr: "CS", vm: "1", name: "SUVType" },
  "(0054,1100)": {
    tag: "(0054,1100)",
    vr: "CS",
    vm: "1",
    name: "Randoms Correction Method"
  },
  "(0054,1101)": {
    tag: "(0054,1101)",
    vr: "LO",
    vm: "1",
    name: "Attenuation Correction Method"
  },
  "(0054,1102)": {
    tag: "(0054,1102)",
    vr: "CS",
    vm: "1",
    name: "Decay Correction"
  },
  "(0054,1103)": {
    tag: "(0054,1103)",
    vr: "LO",
    vm: "1",
    name: "Reconstruction Method"
  },
  "(0054,1104)": {
    tag: "(0054,1104)",
    vr: "LO",
    vm: "1",
    name: "Detector Lines Of Response Used"
  },
  "(0054,1105)": {
    tag: "(0054,1105)",
    vr: "LO",
    vm: "1",
    name: "Scatter Correction Method"
  },
  "(0054,1200)": {
    tag: "(0054,1200)",
    vr: "DS",
    vm: "1",
    name: "Axial Acceptance"
  },
  "(0054,1201)": { tag: "(0054,1201)", vr: "IS", vm: "2", name: "Axial Mash" },
  "(0054,1202)": {
    tag: "(0054,1202)",
    vr: "IS",
    vm: "1",
    name: "Transverse Mash"
  },
  "(0054,1203)": {
    tag: "(0054,1203)",
    vr: "DS",
    vm: "2",
    name: "Detector Element Size"
  },
  "(0054,1210)": {
    tag: "(0054,1210)",
    vr: "DS",
    vm: "1",
    name: "Coincidence Window Width"
  },
  "(0054,1220)": {
    tag: "(0054,1220)",
    vr: "CS",
    vm: "1",
    name: "Secondary Counts Type"
  },
  "(0054,1300)": {
    tag: "(0054,1300)",
    vr: "DS",
    vm: "1",
    name: "Frame Reference Time"
  },
  "(0054,1310)": {
    tag: "(0054,1310)",
    vr: "IS",
    vm: "1",
    name: "Primary Prompts Counts Accumulated"
  },
  "(0054,1311)": {
    tag: "(0054,1311)",
    vr: "IS",
    vm: "1",
    name: "Secondary Counts Accumulated"
  },
  "(0054,1320)": {
    tag: "(0054,1320)",
    vr: "DS",
    vm: "1",
    name: "Slice Sensitivity Factor"
  },
  "(0054,1321)": {
    tag: "(0054,1321)",
    vr: "DS",
    vm: "1",
    name: "Decay Factor"
  },
  "(0054,1322)": {
    tag: "(0054,1322)",
    vr: "DS",
    vm: "1",
    name: "Dose Calibration Factor"
  },
  "(0054,1323)": {
    tag: "(0054,1323)",
    vr: "DS",
    vm: "1",
    name: "Scatter Fraction Factor"
  },
  "(0054,1324)": {
    tag: "(0054,1324)",
    vr: "DS",
    vm: "1",
    name: "Dead Time Factor"
  },
  "(0054,1330)": { tag: "(0054,1330)", vr: "US", vm: "1", name: "Image Index" },
  "(0054,1400)": {
    tag: "(0054,1400)",
    vr: "CS",
    vm: "1",
    name: "Counts Included"
  },
  "(0054,1401)": {
    tag: "(0054,1401)",
    vr: "CS",
    vm: "1",
    name: "Dead Time Correction Flag"
  },
  "(0060,3000)": {
    tag: "(0060,3000)",
    vr: "SQ",
    vm: "1",
    name: "Histogram Sequence"
  },
  "(0060,3002)": {
    tag: "(0060,3002)",
    vr: "US",
    vm: "1",
    name: "Histogram Number Of Bins"
  },
  "(0060,3004)": {
    tag: "(0060,3004)",
    vr: "US|SS",
    vm: "1",
    name: "Histogram First Bin Value"
  },
  "(0060,3006)": {
    tag: "(0060,3006)",
    vr: "US|SS",
    vm: "1",
    name: "Histogram Last Bin Value"
  },
  "(0060,3008)": {
    tag: "(0060,3008)",
    vr: "US",
    vm: "1",
    name: "Histogram Bin Width"
  },
  "(0060,3010)": {
    tag: "(0060,3010)",
    vr: "LO",
    vm: "1",
    name: "Histogram Explanation"
  },
  "(0060,3020)": {
    tag: "(0060,3020)",
    vr: "UL",
    vm: "1",
    name: "Histogram Data"
  },
  "(0062,0001)": {
    tag: "(0062,0001)",
    vr: "CS",
    vm: "1",
    name: "Segmentation Type"
  },
  "(0062,0002)": {
    tag: "(0062,0002)",
    vr: "SQ",
    vm: "1",
    name: "Segment Sequence"
  },
  "(0062,0003)": {
    tag: "(0062,0003)",
    vr: "SQ",
    vm: "1",
    name: "Segmented Property Category Code Sequence"
  },
  "(0062,0004)": {
    tag: "(0062,0004)",
    vr: "US",
    vm: "1",
    name: "Segment Number"
  },
  "(0062,0005)": {
    tag: "(0062,0005)",
    vr: "LO",
    vm: "1",
    name: "Segment Label"
  },
  "(0062,0006)": {
    tag: "(0062,0006)",
    vr: "ST",
    vm: "1",
    name: "Segment Description"
  },
  "(0062,0008)": {
    tag: "(0062,0008)",
    vr: "CS",
    vm: "1",
    name: "Segment Algorithm Type"
  },
  "(0062,0009)": {
    tag: "(0062,0009)",
    vr: "LO",
    vm: "1",
    name: "Segment Algorithm Name"
  },
  "(0062,000A)": {
    tag: "(0062,000A)",
    vr: "SQ",
    vm: "1",
    name: "Segment Identification Sequence"
  },
  "(0062,000B)": {
    tag: "(0062,000B)",
    vr: "US",
    vm: "1",
    name: "Referenced Segment Number"
  },
  "(0062,000C)": {
    tag: "(0062,000C)",
    vr: "US",
    vm: "1",
    name: "Recommended Display Grayscale Value"
  },
  "(0062,000D)": {
    tag: "(0062,000D)",
    vr: "US",
    vm: "3",
    name: "Recommended Display CIELab Value"
  },
  "(0062,000E)": {
    tag: "(0062,000E)",
    vr: "US",
    vm: "1",
    name: "Maximum Fractional Value"
  },
  "(0062,000F)": {
    tag: "(0062,000F)",
    vr: "SQ",
    vm: "1",
    name: "Segmented Property Type Code Sequence"
  },
  "(0062,0010)": {
    tag: "(0062,0010)",
    vr: "CS",
    vm: "1",
    name: "Segmentation Fractional Type"
  },
  "(0064,0002)": {
    tag: "(0064,0002)",
    vr: "SQ",
    vm: "1",
    name: "Deformable Registration Sequence"
  },
  "(0064,0003)": {
    tag: "(0064,0003)",
    vr: "UI",
    vm: "1",
    name: "Source Frame Of Reference UID"
  },
  "(0064,0005)": {
    tag: "(0064,0005)",
    vr: "SQ",
    vm: "1",
    name: "Deformable Registration Grid Sequence"
  },
  "(0064,0007)": {
    tag: "(0064,0007)",
    vr: "UL",
    vm: "3",
    name: "Grid Dimensions"
  },
  "(0064,0008)": {
    tag: "(0064,0008)",
    vr: "FD",
    vm: "3",
    name: "Grid Resolution"
  },
  "(0064,0009)": {
    tag: "(0064,0009)",
    vr: "OF",
    vm: "1",
    name: "Vector Grid Data"
  },
  "(0064,000F)": {
    tag: "(0064,000F)",
    vr: "SQ",
    vm: "1",
    name: "Pre Deformation Matrix Registration Sequence"
  },
  "(0064,0010)": {
    tag: "(0064,0010)",
    vr: "SQ",
    vm: "1",
    name: "Post Deformation Matrix Registration Sequence"
  },
  "(0066,0001)": {
    tag: "(0066,0001)",
    vr: "UL",
    vm: "1",
    name: "Number Of Surfaces"
  },
  "(0066,0002)": {
    tag: "(0066,0002)",
    vr: "SQ",
    vm: "1",
    name: "Surface Sequence"
  },
  "(0066,0003)": {
    tag: "(0066,0003)",
    vr: "UL",
    vm: "1",
    name: "Surface Number"
  },
  "(0066,0004)": {
    tag: "(0066,0004)",
    vr: "LT",
    vm: "1",
    name: "Surface Comments"
  },
  "(0066,0009)": {
    tag: "(0066,0009)",
    vr: "CS",
    vm: "1",
    name: "Surface Processing"
  },
  "(0066,000A)": {
    tag: "(0066,000A)",
    vr: "FL",
    vm: "1",
    name: "Surface Processing Ratio"
  },
  "(0066,000B)": {
    tag: "(0066,000B)",
    vr: "LO",
    vm: "1",
    name: "Surface Processing Description"
  },
  "(0066,000C)": {
    tag: "(0066,000C)",
    vr: "FL",
    vm: "1",
    name: "Recommended Presentation Opacity"
  },
  "(0066,000D)": {
    tag: "(0066,000D)",
    vr: "CS",
    vm: "1",
    name: "Recommended Presentation Type"
  },
  "(0066,000E)": {
    tag: "(0066,000E)",
    vr: "CS",
    vm: "1",
    name: "Finite Volume"
  },
  "(0066,0010)": { tag: "(0066,0010)", vr: "CS", vm: "1", name: "Manifold" },
  "(0066,0011)": {
    tag: "(0066,0011)",
    vr: "SQ",
    vm: "1",
    name: "Surface Points Sequence"
  },
  "(0066,0012)": {
    tag: "(0066,0012)",
    vr: "SQ",
    vm: "1",
    name: "Surface Points Normals Sequence"
  },
  "(0066,0013)": {
    tag: "(0066,0013)",
    vr: "SQ",
    vm: "1",
    name: "Surface Mesh Primitives Sequence"
  },
  "(0066,0015)": {
    tag: "(0066,0015)",
    vr: "UL",
    vm: "1",
    name: "Number Of Surface Points"
  },
  "(0066,0016)": {
    tag: "(0066,0016)",
    vr: "OF",
    vm: "1",
    name: "Point Coordinates Data"
  },
  "(0066,0017)": {
    tag: "(0066,0017)",
    vr: "FL",
    vm: "3",
    name: "Point Position Accuracy"
  },
  "(0066,0018)": {
    tag: "(0066,0018)",
    vr: "FL",
    vm: "1",
    name: "Mean Point Distance"
  },
  "(0066,0019)": {
    tag: "(0066,0019)",
    vr: "FL",
    vm: "1",
    name: "Maximum Point Distance"
  },
  "(0066,001A)": {
    tag: "(0066,001A)",
    vr: "FL",
    vm: "6",
    name: "Points Bounding Box Coordinates"
  },
  "(0066,001B)": {
    tag: "(0066,001B)",
    vr: "FL",
    vm: "3",
    name: "Axis Of Rotation"
  },
  "(0066,001C)": {
    tag: "(0066,001C)",
    vr: "FL",
    vm: "3",
    name: "Center Of Rotation"
  },
  "(0066,001E)": {
    tag: "(0066,001E)",
    vr: "UL",
    vm: "1",
    name: "Number Of Vectors"
  },
  "(0066,001F)": {
    tag: "(0066,001F)",
    vr: "US",
    vm: "1",
    name: "Vector Dimensionality"
  },
  "(0066,0020)": {
    tag: "(0066,0020)",
    vr: "FL",
    vm: "1",
    name: "Vector Accuracy"
  },
  "(0066,0021)": {
    tag: "(0066,0021)",
    vr: "OF",
    vm: "1",
    name: "Vector Coordinate Data"
  },
  "(0066,0023)": {
    tag: "(0066,0023)",
    vr: "OW",
    vm: "1",
    name: "Triangle Point Index List"
  },
  "(0066,0024)": {
    tag: "(0066,0024)",
    vr: "OW",
    vm: "1",
    name: "Edge Point Index List"
  },
  "(0066,0025)": {
    tag: "(0066,0025)",
    vr: "OW",
    vm: "1",
    name: "Vertex Point Index List"
  },
  "(0066,0026)": {
    tag: "(0066,0026)",
    vr: "SQ",
    vm: "1",
    name: "Triangle Strip Sequence"
  },
  "(0066,0027)": {
    tag: "(0066,0027)",
    vr: "SQ",
    vm: "1",
    name: "Triangle Fan Sequence"
  },
  "(0066,0028)": {
    tag: "(0066,0028)",
    vr: "SQ",
    vm: "1",
    name: "Line Sequence"
  },
  "(0066,0029)": {
    tag: "(0066,0029)",
    vr: "OW",
    vm: "1",
    name: "Primitive Point Index List"
  },
  "(0066,002A)": {
    tag: "(0066,002A)",
    vr: "UL",
    vm: "1",
    name: "Surface Count"
  },
  "(0066,002B)": {
    tag: "(0066,002B)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Surface Sequence"
  },
  "(0066,002C)": {
    tag: "(0066,002C)",
    vr: "UL",
    vm: "1",
    name: "Referenced Surface Number"
  },
  "(0066,002D)": {
    tag: "(0066,002D)",
    vr: "SQ",
    vm: "1",
    name: "Segment Surface Generation Algorithm Identification Sequence"
  },
  "(0066,002E)": {
    tag: "(0066,002E)",
    vr: "SQ",
    vm: "1",
    name: "Segment Surface Source Instance Sequence"
  },
  "(0066,002F)": {
    tag: "(0066,002F)",
    vr: "SQ",
    vm: "1",
    name: "Algorithm Family Code Sequence"
  },
  "(0066,0030)": {
    tag: "(0066,0030)",
    vr: "SQ",
    vm: "1",
    name: "Algorithm Name Code Sequence"
  },
  "(0066,0031)": {
    tag: "(0066,0031)",
    vr: "LO",
    vm: "1",
    name: "Algorithm Version"
  },
  "(0066,0032)": {
    tag: "(0066,0032)",
    vr: "LT",
    vm: "1",
    name: "Algorithm Parameters"
  },
  "(0066,0034)": {
    tag: "(0066,0034)",
    vr: "SQ",
    vm: "1",
    name: "Facet Sequence"
  },
  "(0066,0035)": {
    tag: "(0066,0035)",
    vr: "SQ",
    vm: "1",
    name: "Surface Processing Algorithm Identification Sequence"
  },
  "(0066,0036)": {
    tag: "(0066,0036)",
    vr: "LO",
    vm: "1",
    name: "Algorithm Name"
  },
  "(0068,6210)": {
    tag: "(0068,6210)",
    vr: "LO",
    vm: "1",
    name: "Implant Size"
  },
  "(0068,6221)": {
    tag: "(0068,6221)",
    vr: "LO",
    vm: "1",
    name: "Implant Template Version"
  },
  "(0068,6222)": {
    tag: "(0068,6222)",
    vr: "SQ",
    vm: "1",
    name: "Replaced Implant Template Sequence"
  },
  "(0068,6223)": {
    tag: "(0068,6223)",
    vr: "CS",
    vm: "1",
    name: "Implant Type"
  },
  "(0068,6224)": {
    tag: "(0068,6224)",
    vr: "SQ",
    vm: "1",
    name: "Derivation Implant Template Sequence"
  },
  "(0068,6225)": {
    tag: "(0068,6225)",
    vr: "SQ",
    vm: "1",
    name: "Original Implant Template Sequence"
  },
  "(0068,6226)": {
    tag: "(0068,6226)",
    vr: "DT",
    vm: "1",
    name: "Effective Date Time"
  },
  "(0068,6230)": {
    tag: "(0068,6230)",
    vr: "SQ",
    vm: "1",
    name: "Implant Target Anatomy Sequence"
  },
  "(0068,6260)": {
    tag: "(0068,6260)",
    vr: "SQ",
    vm: "1",
    name: "Information From Manufacturer Sequence"
  },
  "(0068,6265)": {
    tag: "(0068,6265)",
    vr: "SQ",
    vm: "1",
    name: "Notification From Manufacturer Sequence"
  },
  "(0068,6270)": {
    tag: "(0068,6270)",
    vr: "DT",
    vm: "1",
    name: "Information Issue Date Time"
  },
  "(0068,6280)": {
    tag: "(0068,6280)",
    vr: "ST",
    vm: "1",
    name: "Information Summary"
  },
  "(0068,62A0)": {
    tag: "(0068,62A0)",
    vr: "SQ",
    vm: "1",
    name: "Implant Regulatory Disapproval Code Sequence"
  },
  "(0068,62A5)": {
    tag: "(0068,62A5)",
    vr: "FD",
    vm: "1",
    name: "Overall Template Spatial Tolerance"
  },
  "(0068,62C0)": {
    tag: "(0068,62C0)",
    vr: "SQ",
    vm: "1",
    name: "HPGLDocument Sequence"
  },
  "(0068,62D0)": {
    tag: "(0068,62D0)",
    vr: "US",
    vm: "1",
    name: "HPGLDocument ID"
  },
  "(0068,62D5)": {
    tag: "(0068,62D5)",
    vr: "LO",
    vm: "1",
    name: "HPGLDocument Label"
  },
  "(0068,62E0)": {
    tag: "(0068,62E0)",
    vr: "SQ",
    vm: "1",
    name: "View Orientation Code Sequence"
  },
  "(0068,62F0)": {
    tag: "(0068,62F0)",
    vr: "FD",
    vm: "9",
    name: "View Orientation Modifier"
  },
  "(0068,62F2)": {
    tag: "(0068,62F2)",
    vr: "FD",
    vm: "1",
    name: "HPGLDocument Scaling"
  },
  "(0068,6300)": {
    tag: "(0068,6300)",
    vr: "OB",
    vm: "1",
    name: "HPGLDocument"
  },
  "(0068,6310)": {
    tag: "(0068,6310)",
    vr: "US",
    vm: "1",
    name: "HPGLContour Pen Number"
  },
  "(0068,6320)": {
    tag: "(0068,6320)",
    vr: "SQ",
    vm: "1",
    name: "HPGLPen Sequence"
  },
  "(0068,6330)": {
    tag: "(0068,6330)",
    vr: "US",
    vm: "1",
    name: "HPGLPen Number"
  },
  "(0068,6340)": {
    tag: "(0068,6340)",
    vr: "LO",
    vm: "1",
    name: "HPGLPen Label"
  },
  "(0068,6345)": {
    tag: "(0068,6345)",
    vr: "ST",
    vm: "1",
    name: "HPGLPen Description"
  },
  "(0068,6346)": {
    tag: "(0068,6346)",
    vr: "FD",
    vm: "2",
    name: "Recommended Rotation Point"
  },
  "(0068,6347)": {
    tag: "(0068,6347)",
    vr: "FD",
    vm: "4",
    name: "Bounding Rectangle"
  },
  "(0068,6350)": {
    tag: "(0068,6350)",
    vr: "US",
    vm: "1",
    name: "Implant Template3DModel Surface Number"
  },
  "(0068,6360)": {
    tag: "(0068,6360)",
    vr: "SQ",
    vm: "1",
    name: "Surface Model Description Sequence"
  },
  "(0068,6380)": {
    tag: "(0068,6380)",
    vr: "LO",
    vm: "1",
    name: "Surface Model Label"
  },
  "(0068,6390)": {
    tag: "(0068,6390)",
    vr: "FD",
    vm: "1",
    name: "Surface Model Scaling Factor"
  },
  "(0068,63A0)": {
    tag: "(0068,63A0)",
    vr: "SQ",
    vm: "1",
    name: "Materials Code Sequence"
  },
  "(0068,63A4)": {
    tag: "(0068,63A4)",
    vr: "SQ",
    vm: "1",
    name: "Coating Materials Code Sequence"
  },
  "(0068,63A8)": {
    tag: "(0068,63A8)",
    vr: "SQ",
    vm: "1",
    name: "Implant Type Code Sequence"
  },
  "(0068,63AC)": {
    tag: "(0068,63AC)",
    vr: "SQ",
    vm: "1",
    name: "Fixation Method Code Sequence"
  },
  "(0068,63B0)": {
    tag: "(0068,63B0)",
    vr: "SQ",
    vm: "1",
    name: "Mating Feature Sets Sequence"
  },
  "(0068,63C0)": {
    tag: "(0068,63C0)",
    vr: "US",
    vm: "1",
    name: "Mating Feature Set ID"
  },
  "(0068,63D0)": {
    tag: "(0068,63D0)",
    vr: "LO",
    vm: "1",
    name: "Mating Feature Set Label"
  },
  "(0068,63E0)": {
    tag: "(0068,63E0)",
    vr: "SQ",
    vm: "1",
    name: "Mating Feature Sequence"
  },
  "(0068,63F0)": {
    tag: "(0068,63F0)",
    vr: "US",
    vm: "1",
    name: "Mating Feature ID"
  },
  "(0068,6400)": {
    tag: "(0068,6400)",
    vr: "SQ",
    vm: "1",
    name: "Mating Feature Degree Of Freedom Sequence"
  },
  "(0068,6410)": {
    tag: "(0068,6410)",
    vr: "US",
    vm: "1",
    name: "Degree Of Freedom ID"
  },
  "(0068,6420)": {
    tag: "(0068,6420)",
    vr: "CS",
    vm: "1",
    name: "Degree Of Freedom Type"
  },
  "(0068,6430)": {
    tag: "(0068,6430)",
    vr: "SQ",
    vm: "1",
    name: "Two DMating Feature Coordinates Sequence"
  },
  "(0068,6440)": {
    tag: "(0068,6440)",
    vr: "US",
    vm: "1",
    name: "Referenced HPGLDocument ID"
  },
  "(0068,6450)": {
    tag: "(0068,6450)",
    vr: "FD",
    vm: "2",
    name: "Two DMating Point"
  },
  "(0068,6460)": {
    tag: "(0068,6460)",
    vr: "FD",
    vm: "4",
    name: "Two DMating Axes"
  },
  "(0068,6470)": {
    tag: "(0068,6470)",
    vr: "SQ",
    vm: "1",
    name: "Two DDegree Of Freedom Sequence"
  },
  "(0068,6490)": {
    tag: "(0068,6490)",
    vr: "FD",
    vm: "3",
    name: "Three DDegree Of Freedom Axis"
  },
  "(0068,64A0)": {
    tag: "(0068,64A0)",
    vr: "FD",
    vm: "2",
    name: "Range Of Freedom"
  },
  "(0068,64C0)": {
    tag: "(0068,64C0)",
    vr: "FD",
    vm: "3",
    name: "Three DMating Point"
  },
  "(0068,64D0)": {
    tag: "(0068,64D0)",
    vr: "FD",
    vm: "9",
    name: "Three DMating Axes"
  },
  "(0068,64F0)": {
    tag: "(0068,64F0)",
    vr: "FD",
    vm: "3",
    name: "Two DDegree Of Freedom Axis"
  },
  "(0068,6500)": {
    tag: "(0068,6500)",
    vr: "SQ",
    vm: "1",
    name: "Planning Landmark Point Sequence"
  },
  "(0068,6510)": {
    tag: "(0068,6510)",
    vr: "SQ",
    vm: "1",
    name: "Planning Landmark Line Sequence"
  },
  "(0068,6520)": {
    tag: "(0068,6520)",
    vr: "SQ",
    vm: "1",
    name: "Planning Landmark Plane Sequence"
  },
  "(0068,6530)": {
    tag: "(0068,6530)",
    vr: "US",
    vm: "1",
    name: "Planning Landmark ID"
  },
  "(0068,6540)": {
    tag: "(0068,6540)",
    vr: "LO",
    vm: "1",
    name: "Planning Landmark Description"
  },
  "(0068,6545)": {
    tag: "(0068,6545)",
    vr: "SQ",
    vm: "1",
    name: "Planning Landmark Identification Code Sequence"
  },
  "(0068,6550)": {
    tag: "(0068,6550)",
    vr: "SQ",
    vm: "1",
    name: "Two DPoint Coordinates Sequence"
  },
  "(0068,6560)": {
    tag: "(0068,6560)",
    vr: "FD",
    vm: "2",
    name: "Two DPoint Coordinates"
  },
  "(0068,6590)": {
    tag: "(0068,6590)",
    vr: "FD",
    vm: "3",
    name: "Three DPoint Coordinates"
  },
  "(0068,65A0)": {
    tag: "(0068,65A0)",
    vr: "SQ",
    vm: "1",
    name: "Two DLine Coordinates Sequence"
  },
  "(0068,65B0)": {
    tag: "(0068,65B0)",
    vr: "FD",
    vm: "4",
    name: "Two DLine Coordinates"
  },
  "(0068,65D0)": {
    tag: "(0068,65D0)",
    vr: "FD",
    vm: "6",
    name: "Three DLine Coordinates"
  },
  "(0068,65E0)": {
    tag: "(0068,65E0)",
    vr: "SQ",
    vm: "1",
    name: "Two DPlane Coordinates Sequence"
  },
  "(0068,65F0)": {
    tag: "(0068,65F0)",
    vr: "FD",
    vm: "4",
    name: "Two DPlane Intersection"
  },
  "(0068,6610)": {
    tag: "(0068,6610)",
    vr: "FD",
    vm: "3",
    name: "Three DPlane Origin"
  },
  "(0068,6620)": {
    tag: "(0068,6620)",
    vr: "FD",
    vm: "3",
    name: "Three DPlane Normal"
  },
  "(0070,0001)": {
    tag: "(0070,0001)",
    vr: "SQ",
    vm: "1",
    name: "Graphic Annotation Sequence"
  },
  "(0070,0002)": {
    tag: "(0070,0002)",
    vr: "CS",
    vm: "1",
    name: "Graphic Layer"
  },
  "(0070,0003)": {
    tag: "(0070,0003)",
    vr: "CS",
    vm: "1",
    name: "Bounding Box Annotation Units"
  },
  "(0070,0004)": {
    tag: "(0070,0004)",
    vr: "CS",
    vm: "1",
    name: "Anchor Point Annotation Units"
  },
  "(0070,0005)": {
    tag: "(0070,0005)",
    vr: "CS",
    vm: "1",
    name: "Graphic Annotation Units"
  },
  "(0070,0006)": {
    tag: "(0070,0006)",
    vr: "ST",
    vm: "1",
    name: "Unformatted Text Value"
  },
  "(0070,0008)": {
    tag: "(0070,0008)",
    vr: "SQ",
    vm: "1",
    name: "Text Object Sequence"
  },
  "(0070,0009)": {
    tag: "(0070,0009)",
    vr: "SQ",
    vm: "1",
    name: "Graphic Object Sequence"
  },
  "(0070,0010)": {
    tag: "(0070,0010)",
    vr: "FL",
    vm: "2",
    name: "Bounding Box Top Left Hand Corner"
  },
  "(0070,0011)": {
    tag: "(0070,0011)",
    vr: "FL",
    vm: "2",
    name: "Bounding Box Bottom Right Hand Corner"
  },
  "(0070,0012)": {
    tag: "(0070,0012)",
    vr: "CS",
    vm: "1",
    name: "Bounding Box Text Horizontal Justification"
  },
  "(0070,0014)": {
    tag: "(0070,0014)",
    vr: "FL",
    vm: "2",
    name: "Anchor Point"
  },
  "(0070,0015)": {
    tag: "(0070,0015)",
    vr: "CS",
    vm: "1",
    name: "Anchor Point Visibility"
  },
  "(0070,0020)": {
    tag: "(0070,0020)",
    vr: "US",
    vm: "1",
    name: "Graphic Dimensions"
  },
  "(0070,0021)": {
    tag: "(0070,0021)",
    vr: "US",
    vm: "1",
    name: "Number Of Graphic Points"
  },
  "(0070,0022)": {
    tag: "(0070,0022)",
    vr: "FL",
    vm: "2",
    name: "Graphic Data"
  },
  "(0070,0023)": {
    tag: "(0070,0023)",
    vr: "CS",
    vm: "1",
    name: "Graphic Type"
  },
  "(0070,0024)": {
    tag: "(0070,0024)",
    vr: "CS",
    vm: "1",
    name: "Graphic Filled"
  },
  "(0070,0040)": {
    tag: "(0070,0040)",
    vr: "IS",
    vm: "1",
    name: "Image Rotation Retired"
  },
  "(0070,0041)": {
    tag: "(0070,0041)",
    vr: "CS",
    vm: "1",
    name: "Image Horizontal Flip"
  },
  "(0070,0042)": {
    tag: "(0070,0042)",
    vr: "US",
    vm: "1",
    name: "Image Rotation"
  },
  "(0070,0050)": {
    tag: "(0070,0050)",
    vr: "US",
    vm: "2",
    name: "Displayed Area Top Left Hand Corner Trial"
  },
  "(0070,0051)": {
    tag: "(0070,0051)",
    vr: "US",
    vm: "2",
    name: "Displayed Area Bottom Right Hand Corner Trial"
  },
  "(0070,0052)": {
    tag: "(0070,0052)",
    vr: "SL",
    vm: "2",
    name: "Displayed Area Top Left Hand Corner"
  },
  "(0070,0053)": {
    tag: "(0070,0053)",
    vr: "SL",
    vm: "2",
    name: "Displayed Area Bottom Right Hand Corner"
  },
  "(0070,005A)": {
    tag: "(0070,005A)",
    vr: "SQ",
    vm: "1",
    name: "Displayed Area Selection Sequence"
  },
  "(0070,0060)": {
    tag: "(0070,0060)",
    vr: "SQ",
    vm: "1",
    name: "Graphic Layer Sequence"
  },
  "(0070,0062)": {
    tag: "(0070,0062)",
    vr: "IS",
    vm: "1",
    name: "Graphic Layer Order"
  },
  "(0070,0066)": {
    tag: "(0070,0066)",
    vr: "US",
    vm: "1",
    name: "Graphic Layer Recommended Display Grayscale Value"
  },
  "(0070,0067)": {
    tag: "(0070,0067)",
    vr: "US",
    vm: "3",
    name: "Graphic Layer Recommended Display RGBValue"
  },
  "(0070,0068)": {
    tag: "(0070,0068)",
    vr: "LO",
    vm: "1",
    name: "Graphic Layer Description"
  },
  "(0070,0080)": {
    tag: "(0070,0080)",
    vr: "CS",
    vm: "1",
    name: "Content Label"
  },
  "(0070,0081)": {
    tag: "(0070,0081)",
    vr: "LO",
    vm: "1",
    name: "Content Description"
  },
  "(0070,0082)": {
    tag: "(0070,0082)",
    vr: "DA",
    vm: "1",
    name: "Presentation Creation Date"
  },
  "(0070,0083)": {
    tag: "(0070,0083)",
    vr: "TM",
    vm: "1",
    name: "Presentation Creation Time"
  },
  "(0070,0084)": {
    tag: "(0070,0084)",
    vr: "PN",
    vm: "1",
    name: "Content Creator Name"
  },
  "(0070,0086)": {
    tag: "(0070,0086)",
    vr: "SQ",
    vm: "1",
    name: "Content Creator Identification Code Sequence"
  },
  "(0070,0087)": {
    tag: "(0070,0087)",
    vr: "SQ",
    vm: "1",
    name: "Alternate Content Description Sequence"
  },
  "(0070,0100)": {
    tag: "(0070,0100)",
    vr: "CS",
    vm: "1",
    name: "Presentation Size Mode"
  },
  "(0070,0101)": {
    tag: "(0070,0101)",
    vr: "DS",
    vm: "2",
    name: "Presentation Pixel Spacing"
  },
  "(0070,0102)": {
    tag: "(0070,0102)",
    vr: "IS",
    vm: "2",
    name: "Presentation Pixel Aspect Ratio"
  },
  "(0070,0103)": {
    tag: "(0070,0103)",
    vr: "FL",
    vm: "1",
    name: "Presentation Pixel Magnification Ratio"
  },
  "(0070,0207)": {
    tag: "(0070,0207)",
    vr: "LO",
    vm: "1",
    name: "Graphic Group Label"
  },
  "(0070,0208)": {
    tag: "(0070,0208)",
    vr: "ST",
    vm: "1",
    name: "Graphic Group Description"
  },
  "(0070,0209)": {
    tag: "(0070,0209)",
    vr: "SQ",
    vm: "1",
    name: "Compound Graphic Sequence"
  },
  "(0070,0226)": {
    tag: "(0070,0226)",
    vr: "UL",
    vm: "1",
    name: "Compound Graphic Instance ID"
  },
  "(0070,0227)": { tag: "(0070,0227)", vr: "LO", vm: "1", name: "Font Name" },
  "(0070,0228)": {
    tag: "(0070,0228)",
    vr: "CS",
    vm: "1",
    name: "Font Name Type"
  },
  "(0070,0229)": {
    tag: "(0070,0229)",
    vr: "LO",
    vm: "1",
    name: "CSSFont Name"
  },
  "(0070,0230)": {
    tag: "(0070,0230)",
    vr: "FD",
    vm: "1",
    name: "Rotation Angle"
  },
  "(0070,0231)": {
    tag: "(0070,0231)",
    vr: "SQ",
    vm: "1",
    name: "Text Style Sequence"
  },
  "(0070,0232)": {
    tag: "(0070,0232)",
    vr: "SQ",
    vm: "1",
    name: "Line Style Sequence"
  },
  "(0070,0233)": {
    tag: "(0070,0233)",
    vr: "SQ",
    vm: "1",
    name: "Fill Style Sequence"
  },
  "(0070,0234)": {
    tag: "(0070,0234)",
    vr: "SQ",
    vm: "1",
    name: "Graphic Group Sequence"
  },
  "(0070,0241)": {
    tag: "(0070,0241)",
    vr: "US",
    vm: "3",
    name: "Text Color CIELab Value"
  },
  "(0070,0242)": {
    tag: "(0070,0242)",
    vr: "CS",
    vm: "1",
    name: "Horizontal Alignment"
  },
  "(0070,0243)": {
    tag: "(0070,0243)",
    vr: "CS",
    vm: "1",
    name: "Vertical Alignment"
  },
  "(0070,0244)": {
    tag: "(0070,0244)",
    vr: "CS",
    vm: "1",
    name: "Shadow Style"
  },
  "(0070,0245)": {
    tag: "(0070,0245)",
    vr: "FL",
    vm: "1",
    name: "Shadow Offset X"
  },
  "(0070,0246)": {
    tag: "(0070,0246)",
    vr: "FL",
    vm: "1",
    name: "Shadow Offset Y"
  },
  "(0070,0247)": {
    tag: "(0070,0247)",
    vr: "US",
    vm: "3",
    name: "Shadow Color CIELab Value"
  },
  "(0070,0248)": { tag: "(0070,0248)", vr: "CS", vm: "1", name: "Underlined" },
  "(0070,0249)": { tag: "(0070,0249)", vr: "CS", vm: "1", name: "Bold" },
  "(0070,0250)": { tag: "(0070,0250)", vr: "CS", vm: "1", name: "Italic" },
  "(0070,0251)": {
    tag: "(0070,0251)",
    vr: "US",
    vm: "3",
    name: "Pattern On Color CIELab Value"
  },
  "(0070,0252)": {
    tag: "(0070,0252)",
    vr: "US",
    vm: "3",
    name: "Pattern Off Color CIELab Value"
  },
  "(0070,0253)": {
    tag: "(0070,0253)",
    vr: "FL",
    vm: "1",
    name: "Line Thickness"
  },
  "(0070,0254)": {
    tag: "(0070,0254)",
    vr: "CS",
    vm: "1",
    name: "Line Dashing Style"
  },
  "(0070,0255)": {
    tag: "(0070,0255)",
    vr: "UL",
    vm: "1",
    name: "Line Pattern"
  },
  "(0070,0256)": {
    tag: "(0070,0256)",
    vr: "OB",
    vm: "1",
    name: "Fill Pattern"
  },
  "(0070,0257)": { tag: "(0070,0257)", vr: "CS", vm: "1", name: "Fill Mode" },
  "(0070,0258)": {
    tag: "(0070,0258)",
    vr: "FL",
    vm: "1",
    name: "Shadow Opacity"
  },
  "(0070,0261)": { tag: "(0070,0261)", vr: "FL", vm: "1", name: "Gap Length" },
  "(0070,0262)": {
    tag: "(0070,0262)",
    vr: "FL",
    vm: "1",
    name: "Diameter Of Visibility"
  },
  "(0070,0273)": {
    tag: "(0070,0273)",
    vr: "FL",
    vm: "2",
    name: "Rotation Point"
  },
  "(0070,0274)": {
    tag: "(0070,0274)",
    vr: "CS",
    vm: "1",
    name: "Tick Alignment"
  },
  "(0070,0278)": {
    tag: "(0070,0278)",
    vr: "CS",
    vm: "1",
    name: "Show Tick Label"
  },
  "(0070,0279)": {
    tag: "(0070,0279)",
    vr: "CS",
    vm: "1",
    name: "Tick Label Alignment"
  },
  "(0070,0282)": {
    tag: "(0070,0282)",
    vr: "CS",
    vm: "1",
    name: "Compound Graphic Units"
  },
  "(0070,0284)": {
    tag: "(0070,0284)",
    vr: "FL",
    vm: "1",
    name: "Pattern On Opacity"
  },
  "(0070,0285)": {
    tag: "(0070,0285)",
    vr: "FL",
    vm: "1",
    name: "Pattern Off Opacity"
  },
  "(0070,0287)": {
    tag: "(0070,0287)",
    vr: "SQ",
    vm: "1",
    name: "Major Ticks Sequence"
  },
  "(0070,0288)": {
    tag: "(0070,0288)",
    vr: "FL",
    vm: "1",
    name: "Tick Position"
  },
  "(0070,0289)": { tag: "(0070,0289)", vr: "SH", vm: "1", name: "Tick Label" },
  "(0070,0294)": {
    tag: "(0070,0294)",
    vr: "CS",
    vm: "1",
    name: "Compound Graphic Type"
  },
  "(0070,0295)": {
    tag: "(0070,0295)",
    vr: "UL",
    vm: "1",
    name: "Graphic Group ID"
  },
  "(0070,0306)": { tag: "(0070,0306)", vr: "CS", vm: "1", name: "Shape Type" },
  "(0070,0308)": {
    tag: "(0070,0308)",
    vr: "SQ",
    vm: "1",
    name: "Registration Sequence"
  },
  "(0070,0309)": {
    tag: "(0070,0309)",
    vr: "SQ",
    vm: "1",
    name: "Matrix Registration Sequence"
  },
  "(0070,030A)": {
    tag: "(0070,030A)",
    vr: "SQ",
    vm: "1",
    name: "Matrix Sequence"
  },
  "(0070,030C)": {
    tag: "(0070,030C)",
    vr: "CS",
    vm: "1",
    name: "Frame Of Reference Transformation Matrix Type"
  },
  "(0070,030D)": {
    tag: "(0070,030D)",
    vr: "SQ",
    vm: "1",
    name: "Registration Type Code Sequence"
  },
  "(0070,030F)": {
    tag: "(0070,030F)",
    vr: "ST",
    vm: "1",
    name: "Fiducial Description"
  },
  "(0070,0310)": {
    tag: "(0070,0310)",
    vr: "SH",
    vm: "1",
    name: "Fiducial Identifier"
  },
  "(0070,0311)": {
    tag: "(0070,0311)",
    vr: "SQ",
    vm: "1",
    name: "Fiducial Identifier Code Sequence"
  },
  "(0070,0312)": {
    tag: "(0070,0312)",
    vr: "FD",
    vm: "1",
    name: "Contour Uncertainty Radius"
  },
  "(0070,0314)": {
    tag: "(0070,0314)",
    vr: "SQ",
    vm: "1",
    name: "Used Fiducials Sequence"
  },
  "(0070,0318)": {
    tag: "(0070,0318)",
    vr: "SQ",
    vm: "1",
    name: "Graphic Coordinates Data Sequence"
  },
  "(0070,031A)": {
    tag: "(0070,031A)",
    vr: "UI",
    vm: "1",
    name: "Fiducial UID"
  },
  "(0070,031C)": {
    tag: "(0070,031C)",
    vr: "SQ",
    vm: "1",
    name: "Fiducial Set Sequence"
  },
  "(0070,031E)": {
    tag: "(0070,031E)",
    vr: "SQ",
    vm: "1",
    name: "Fiducial Sequence"
  },
  "(0070,0401)": {
    tag: "(0070,0401)",
    vr: "US",
    vm: "3",
    name: "Graphic Layer Recommended Display CIELab Value"
  },
  "(0070,0402)": {
    tag: "(0070,0402)",
    vr: "SQ",
    vm: "1",
    name: "Blending Sequence"
  },
  "(0070,0403)": {
    tag: "(0070,0403)",
    vr: "FL",
    vm: "1",
    name: "Relative Opacity"
  },
  "(0070,0404)": {
    tag: "(0070,0404)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Spatial Registration Sequence"
  },
  "(0070,0405)": {
    tag: "(0070,0405)",
    vr: "CS",
    vm: "1",
    name: "Blending Position"
  },
  "(0072,0002)": {
    tag: "(0072,0002)",
    vr: "SH",
    vm: "1",
    name: "Hanging Protocol Name"
  },
  "(0072,0004)": {
    tag: "(0072,0004)",
    vr: "LO",
    vm: "1",
    name: "Hanging Protocol Description"
  },
  "(0072,0006)": {
    tag: "(0072,0006)",
    vr: "CS",
    vm: "1",
    name: "Hanging Protocol Level"
  },
  "(0072,0008)": {
    tag: "(0072,0008)",
    vr: "LO",
    vm: "1",
    name: "Hanging Protocol Creator"
  },
  "(0072,000A)": {
    tag: "(0072,000A)",
    vr: "DT",
    vm: "1",
    name: "Hanging Protocol Creation Date Time"
  },
  "(0072,000C)": {
    tag: "(0072,000C)",
    vr: "SQ",
    vm: "1",
    name: "Hanging Protocol Definition Sequence"
  },
  "(0072,000E)": {
    tag: "(0072,000E)",
    vr: "SQ",
    vm: "1",
    name: "Hanging Protocol User Identification Code Sequence"
  },
  "(0072,0010)": {
    tag: "(0072,0010)",
    vr: "LO",
    vm: "1",
    name: "Hanging Protocol User Group Name"
  },
  "(0072,0012)": {
    tag: "(0072,0012)",
    vr: "SQ",
    vm: "1",
    name: "Source Hanging Protocol Sequence"
  },
  "(0072,0014)": {
    tag: "(0072,0014)",
    vr: "US",
    vm: "1",
    name: "Number Of Priors Referenced"
  },
  "(0072,0020)": {
    tag: "(0072,0020)",
    vr: "SQ",
    vm: "1",
    name: "Image Sets Sequence"
  },
  "(0072,0022)": {
    tag: "(0072,0022)",
    vr: "SQ",
    vm: "1",
    name: "Image Set Selector Sequence"
  },
  "(0072,0024)": {
    tag: "(0072,0024)",
    vr: "CS",
    vm: "1",
    name: "Image Set Selector Usage Flag"
  },
  "(0072,0026)": {
    tag: "(0072,0026)",
    vr: "AT",
    vm: "1",
    name: "Selector Attribute"
  },
  "(0072,0028)": {
    tag: "(0072,0028)",
    vr: "US",
    vm: "1",
    name: "Selector Value Number"
  },
  "(0072,0030)": {
    tag: "(0072,0030)",
    vr: "SQ",
    vm: "1",
    name: "Time Based Image Sets Sequence"
  },
  "(0072,0032)": {
    tag: "(0072,0032)",
    vr: "US",
    vm: "1",
    name: "Image Set Number"
  },
  "(0072,0034)": {
    tag: "(0072,0034)",
    vr: "CS",
    vm: "1",
    name: "Image Set Selector Category"
  },
  "(0072,0038)": {
    tag: "(0072,0038)",
    vr: "US",
    vm: "2",
    name: "Relative Time"
  },
  "(0072,003A)": {
    tag: "(0072,003A)",
    vr: "CS",
    vm: "1",
    name: "Relative Time Units"
  },
  "(0072,003C)": {
    tag: "(0072,003C)",
    vr: "SS",
    vm: "2",
    name: "Abstract Prior Value"
  },
  "(0072,003E)": {
    tag: "(0072,003E)",
    vr: "SQ",
    vm: "1",
    name: "Abstract Prior Code Sequence"
  },
  "(0072,0040)": {
    tag: "(0072,0040)",
    vr: "LO",
    vm: "1",
    name: "Image Set Label"
  },
  "(0072,0050)": {
    tag: "(0072,0050)",
    vr: "CS",
    vm: "1",
    name: "Selector Attribute VR"
  },
  "(0072,0052)": {
    tag: "(0072,0052)",
    vr: "AT",
    vm: "1",
    name: "Selector Sequence Pointer"
  },
  "(0072,0054)": {
    tag: "(0072,0054)",
    vr: "LO",
    vm: "1",
    name: "Selector Sequence Pointer Private Creator"
  },
  "(0072,0056)": {
    tag: "(0072,0056)",
    vr: "LO",
    vm: "1",
    name: "Selector Attribute Private Creator"
  },
  "(0072,0060)": {
    tag: "(0072,0060)",
    vr: "AT",
    vm: "1",
    name: "Selector ATValue"
  },
  "(0072,0062)": {
    tag: "(0072,0062)",
    vr: "CS",
    vm: "1",
    name: "Selector CSValue"
  },
  "(0072,0064)": {
    tag: "(0072,0064)",
    vr: "IS",
    vm: "1",
    name: "Selector ISValue"
  },
  "(0072,0066)": {
    tag: "(0072,0066)",
    vr: "LO",
    vm: "1",
    name: "Selector LOValue"
  },
  "(0072,0068)": {
    tag: "(0072,0068)",
    vr: "LT",
    vm: "1",
    name: "Selector LTValue"
  },
  "(0072,006A)": {
    tag: "(0072,006A)",
    vr: "PN",
    vm: "1",
    name: "Selector PNValue"
  },
  "(0072,006C)": {
    tag: "(0072,006C)",
    vr: "SH",
    vm: "1",
    name: "Selector SHValue"
  },
  "(0072,006E)": {
    tag: "(0072,006E)",
    vr: "ST",
    vm: "1",
    name: "Selector STValue"
  },
  "(0072,0070)": {
    tag: "(0072,0070)",
    vr: "UT",
    vm: "1",
    name: "Selector UTValue"
  },
  "(0072,0072)": {
    tag: "(0072,0072)",
    vr: "DS",
    vm: "1",
    name: "Selector DSValue"
  },
  "(0072,0074)": {
    tag: "(0072,0074)",
    vr: "FD",
    vm: "1",
    name: "Selector FDValue"
  },
  "(0072,0076)": {
    tag: "(0072,0076)",
    vr: "FL",
    vm: "1",
    name: "Selector FLValue"
  },
  "(0072,0078)": {
    tag: "(0072,0078)",
    vr: "UL",
    vm: "1",
    name: "Selector ULValue"
  },
  "(0072,007A)": {
    tag: "(0072,007A)",
    vr: "US",
    vm: "1",
    name: "Selector USValue"
  },
  "(0072,007C)": {
    tag: "(0072,007C)",
    vr: "SL",
    vm: "1",
    name: "Selector SLValue"
  },
  "(0072,007E)": {
    tag: "(0072,007E)",
    vr: "SS",
    vm: "1",
    name: "Selector SSValue"
  },
  "(0072,0080)": {
    tag: "(0072,0080)",
    vr: "SQ",
    vm: "1",
    name: "Selector Code Sequence Value"
  },
  "(0072,0100)": {
    tag: "(0072,0100)",
    vr: "US",
    vm: "1",
    name: "Number Of Screens"
  },
  "(0072,0102)": {
    tag: "(0072,0102)",
    vr: "SQ",
    vm: "1",
    name: "Nominal Screen Definition Sequence"
  },
  "(0072,0104)": {
    tag: "(0072,0104)",
    vr: "US",
    vm: "1",
    name: "Number Of Vertical Pixels"
  },
  "(0072,0106)": {
    tag: "(0072,0106)",
    vr: "US",
    vm: "1",
    name: "Number Of Horizontal Pixels"
  },
  "(0072,0108)": {
    tag: "(0072,0108)",
    vr: "FD",
    vm: "4",
    name: "Display Environment Spatial Position"
  },
  "(0072,010A)": {
    tag: "(0072,010A)",
    vr: "US",
    vm: "1",
    name: "Screen Minimum Grayscale Bit Depth"
  },
  "(0072,010C)": {
    tag: "(0072,010C)",
    vr: "US",
    vm: "1",
    name: "Screen Minimum Color Bit Depth"
  },
  "(0072,010E)": {
    tag: "(0072,010E)",
    vr: "US",
    vm: "1",
    name: "Application Maximum Repaint Time"
  },
  "(0072,0200)": {
    tag: "(0072,0200)",
    vr: "SQ",
    vm: "1",
    name: "Display Sets Sequence"
  },
  "(0072,0202)": {
    tag: "(0072,0202)",
    vr: "US",
    vm: "1",
    name: "Display Set Number"
  },
  "(0072,0203)": {
    tag: "(0072,0203)",
    vr: "LO",
    vm: "1",
    name: "Display Set Label"
  },
  "(0072,0204)": {
    tag: "(0072,0204)",
    vr: "US",
    vm: "1",
    name: "Display Set Presentation Group"
  },
  "(0072,0206)": {
    tag: "(0072,0206)",
    vr: "LO",
    vm: "1",
    name: "Display Set Presentation Group Description"
  },
  "(0072,0208)": {
    tag: "(0072,0208)",
    vr: "CS",
    vm: "1",
    name: "Partial Data Display Handling"
  },
  "(0072,0210)": {
    tag: "(0072,0210)",
    vr: "SQ",
    vm: "1",
    name: "Synchronized Scrolling Sequence"
  },
  "(0072,0212)": {
    tag: "(0072,0212)",
    vr: "US",
    vm: "2",
    name: "Display Set Scrolling Group"
  },
  "(0072,0214)": {
    tag: "(0072,0214)",
    vr: "SQ",
    vm: "1",
    name: "Navigation Indicator Sequence"
  },
  "(0072,0216)": {
    tag: "(0072,0216)",
    vr: "US",
    vm: "1",
    name: "Navigation Display Set"
  },
  "(0072,0218)": {
    tag: "(0072,0218)",
    vr: "US",
    vm: "1",
    name: "Reference Display Sets"
  },
  "(0072,0300)": {
    tag: "(0072,0300)",
    vr: "SQ",
    vm: "1",
    name: "Image Boxes Sequence"
  },
  "(0072,0302)": {
    tag: "(0072,0302)",
    vr: "US",
    vm: "1",
    name: "Image Box Number"
  },
  "(0072,0304)": {
    tag: "(0072,0304)",
    vr: "CS",
    vm: "1",
    name: "Image Box Layout Type"
  },
  "(0072,0306)": {
    tag: "(0072,0306)",
    vr: "US",
    vm: "1",
    name: "Image Box Tile Horizontal Dimension"
  },
  "(0072,0308)": {
    tag: "(0072,0308)",
    vr: "US",
    vm: "1",
    name: "Image Box Tile Vertical Dimension"
  },
  "(0072,0310)": {
    tag: "(0072,0310)",
    vr: "CS",
    vm: "1",
    name: "Image Box Scroll Direction"
  },
  "(0072,0312)": {
    tag: "(0072,0312)",
    vr: "CS",
    vm: "1",
    name: "Image Box Small Scroll Type"
  },
  "(0072,0314)": {
    tag: "(0072,0314)",
    vr: "US",
    vm: "1",
    name: "Image Box Small Scroll Amount"
  },
  "(0072,0316)": {
    tag: "(0072,0316)",
    vr: "CS",
    vm: "1",
    name: "Image Box Large Scroll Type"
  },
  "(0072,0318)": {
    tag: "(0072,0318)",
    vr: "US",
    vm: "1",
    name: "Image Box Large Scroll Amount"
  },
  "(0072,0320)": {
    tag: "(0072,0320)",
    vr: "US",
    vm: "1",
    name: "Image Box Overlap Priority"
  },
  "(0072,0330)": {
    tag: "(0072,0330)",
    vr: "FD",
    vm: "1",
    name: "Cine Relative To Real Time"
  },
  "(0072,0400)": {
    tag: "(0072,0400)",
    vr: "SQ",
    vm: "1",
    name: "Filter Operations Sequence"
  },
  "(0072,0402)": {
    tag: "(0072,0402)",
    vr: "CS",
    vm: "1",
    name: "Filter By Category"
  },
  "(0072,0404)": {
    tag: "(0072,0404)",
    vr: "CS",
    vm: "1",
    name: "Filter By Attribute Presence"
  },
  "(0072,0406)": {
    tag: "(0072,0406)",
    vr: "CS",
    vm: "1",
    name: "Filter By Operator"
  },
  "(0072,0420)": {
    tag: "(0072,0420)",
    vr: "US",
    vm: "3",
    name: "Structured Display Background CIELab Value"
  },
  "(0072,0421)": {
    tag: "(0072,0421)",
    vr: "US",
    vm: "3",
    name: "Empty Image Box CIELab Value"
  },
  "(0072,0422)": {
    tag: "(0072,0422)",
    vr: "SQ",
    vm: "1",
    name: "Structured Display Image Box Sequence"
  },
  "(0072,0424)": {
    tag: "(0072,0424)",
    vr: "SQ",
    vm: "1",
    name: "Structured Display Text Box Sequence"
  },
  "(0072,0427)": {
    tag: "(0072,0427)",
    vr: "SQ",
    vm: "1",
    name: "Referenced First Frame Sequence"
  },
  "(0072,0430)": {
    tag: "(0072,0430)",
    vr: "SQ",
    vm: "1",
    name: "Image Box Synchronization Sequence"
  },
  "(0072,0432)": {
    tag: "(0072,0432)",
    vr: "US",
    vm: "2",
    name: "Synchronized Image Box List"
  },
  "(0072,0434)": {
    tag: "(0072,0434)",
    vr: "CS",
    vm: "1",
    name: "Type Of Synchronization"
  },
  "(0072,0500)": {
    tag: "(0072,0500)",
    vr: "CS",
    vm: "1",
    name: "Blending Operation Type"
  },
  "(0072,0510)": {
    tag: "(0072,0510)",
    vr: "CS",
    vm: "1",
    name: "Reformatting Operation Type"
  },
  "(0072,0512)": {
    tag: "(0072,0512)",
    vr: "FD",
    vm: "1",
    name: "Reformatting Thickness"
  },
  "(0072,0514)": {
    tag: "(0072,0514)",
    vr: "FD",
    vm: "1",
    name: "Reformatting Interval"
  },
  "(0072,0516)": {
    tag: "(0072,0516)",
    vr: "CS",
    vm: "1",
    name: "Reformatting Operation Initial View Direction"
  },
  "(0072,0520)": {
    tag: "(0072,0520)",
    vr: "CS",
    vm: "1",
    name: "Three DRendering Type"
  },
  "(0072,0600)": {
    tag: "(0072,0600)",
    vr: "SQ",
    vm: "1",
    name: "Sorting Operations Sequence"
  },
  "(0072,0602)": {
    tag: "(0072,0602)",
    vr: "CS",
    vm: "1",
    name: "Sort By Category"
  },
  "(0072,0604)": {
    tag: "(0072,0604)",
    vr: "CS",
    vm: "1",
    name: "Sorting Direction"
  },
  "(0072,0700)": {
    tag: "(0072,0700)",
    vr: "CS",
    vm: "2",
    name: "Display Set Patient Orientation"
  },
  "(0072,0702)": { tag: "(0072,0702)", vr: "CS", vm: "1", name: "VOIType" },
  "(0072,0704)": {
    tag: "(0072,0704)",
    vr: "CS",
    vm: "1",
    name: "Pseudo Color Type"
  },
  "(0072,0705)": {
    tag: "(0072,0705)",
    vr: "SQ",
    vm: "1",
    name: "Pseudo Color Palette Instance Reference Sequence"
  },
  "(0072,0706)": {
    tag: "(0072,0706)",
    vr: "CS",
    vm: "1",
    name: "Show Grayscale Inverted"
  },
  "(0072,0710)": {
    tag: "(0072,0710)",
    vr: "CS",
    vm: "1",
    name: "Show Image True Size Flag"
  },
  "(0072,0712)": {
    tag: "(0072,0712)",
    vr: "CS",
    vm: "1",
    name: "Show Graphic Annotation Flag"
  },
  "(0072,0714)": {
    tag: "(0072,0714)",
    vr: "CS",
    vm: "1",
    name: "Show Patient Demographics Flag"
  },
  "(0072,0716)": {
    tag: "(0072,0716)",
    vr: "CS",
    vm: "1",
    name: "Show Acquisition Techniques Flag"
  },
  "(0072,0717)": {
    tag: "(0072,0717)",
    vr: "CS",
    vm: "1",
    name: "Display Set Horizontal Justification"
  },
  "(0072,0718)": {
    tag: "(0072,0718)",
    vr: "CS",
    vm: "1",
    name: "Display Set Vertical Justification"
  },
  "(0074,0120)": {
    tag: "(0074,0120)",
    vr: "FD",
    vm: "1",
    name: "Continuation Start Meterset"
  },
  "(0074,0121)": {
    tag: "(0074,0121)",
    vr: "FD",
    vm: "1",
    name: "Continuation End Meterset"
  },
  "(0074,1000)": {
    tag: "(0074,1000)",
    vr: "CS",
    vm: "1",
    name: "Procedure Step State"
  },
  "(0074,1002)": {
    tag: "(0074,1002)",
    vr: "SQ",
    vm: "1",
    name: "Procedure Step Progress Information Sequence"
  },
  "(0074,1004)": {
    tag: "(0074,1004)",
    vr: "DS",
    vm: "1",
    name: "Procedure Step Progress"
  },
  "(0074,1006)": {
    tag: "(0074,1006)",
    vr: "ST",
    vm: "1",
    name: "Procedure Step Progress Description"
  },
  "(0074,1008)": {
    tag: "(0074,1008)",
    vr: "SQ",
    vm: "1",
    name: "Procedure Step Communications URISequence"
  },
  "(0074,100a)": { tag: "(0074,100a)", vr: "ST", vm: "1", name: "Contact URI" },
  "(0074,100c)": {
    tag: "(0074,100c)",
    vr: "LO",
    vm: "1",
    name: "Contact Display Name"
  },
  "(0074,100e)": {
    tag: "(0074,100e)",
    vr: "SQ",
    vm: "1",
    name: "Procedure Step Discontinuation Reason Code Sequence"
  },
  "(0074,1020)": {
    tag: "(0074,1020)",
    vr: "SQ",
    vm: "1",
    name: "Beam Task Sequence"
  },
  "(0074,1022)": {
    tag: "(0074,1022)",
    vr: "CS",
    vm: "1",
    name: "Beam Task Type"
  },
  "(0074,1024)": {
    tag: "(0074,1024)",
    vr: "IS",
    vm: "1",
    name: "Beam Order Index Trial"
  },
  "(0074,1026)": {
    tag: "(0074,1026)",
    vr: "FD",
    vm: "1",
    name: "Table Top Vertical Adjusted Position"
  },
  "(0074,1027)": {
    tag: "(0074,1027)",
    vr: "FD",
    vm: "1",
    name: "Table Top Longitudinal Adjusted Position"
  },
  "(0074,1028)": {
    tag: "(0074,1028)",
    vr: "FD",
    vm: "1",
    name: "Table Top Lateral Adjusted Position"
  },
  "(0074,102A)": {
    tag: "(0074,102A)",
    vr: "FD",
    vm: "1",
    name: "Patient Support Adjusted Angle"
  },
  "(0074,102B)": {
    tag: "(0074,102B)",
    vr: "FD",
    vm: "1",
    name: "Table Top Eccentric Adjusted Angle"
  },
  "(0074,102C)": {
    tag: "(0074,102C)",
    vr: "FD",
    vm: "1",
    name: "Table Top Pitch Adjusted Angle"
  },
  "(0074,102D)": {
    tag: "(0074,102D)",
    vr: "FD",
    vm: "1",
    name: "Table Top Roll Adjusted Angle"
  },
  "(0074,1030)": {
    tag: "(0074,1030)",
    vr: "SQ",
    vm: "1",
    name: "Delivery Verification Image Sequence"
  },
  "(0074,1032)": {
    tag: "(0074,1032)",
    vr: "CS",
    vm: "1",
    name: "Verification Image Timing"
  },
  "(0074,1034)": {
    tag: "(0074,1034)",
    vr: "CS",
    vm: "1",
    name: "Double Exposure Flag"
  },
  "(0074,1036)": {
    tag: "(0074,1036)",
    vr: "CS",
    vm: "1",
    name: "Double Exposure Ordering"
  },
  "(0074,1038)": {
    tag: "(0074,1038)",
    vr: "DS",
    vm: "1",
    name: "Double Exposure Meterset Trial"
  },
  "(0074,103A)": {
    tag: "(0074,103A)",
    vr: "DS",
    vm: "4",
    name: "Double Exposure Field Delta Trial"
  },
  "(0074,1040)": {
    tag: "(0074,1040)",
    vr: "SQ",
    vm: "1",
    name: "Related Reference RTImage Sequence"
  },
  "(0074,1042)": {
    tag: "(0074,1042)",
    vr: "SQ",
    vm: "1",
    name: "General Machine Verification Sequence"
  },
  "(0074,1044)": {
    tag: "(0074,1044)",
    vr: "SQ",
    vm: "1",
    name: "Conventional Machine Verification Sequence"
  },
  "(0074,1046)": {
    tag: "(0074,1046)",
    vr: "SQ",
    vm: "1",
    name: "Ion Machine Verification Sequence"
  },
  "(0074,1048)": {
    tag: "(0074,1048)",
    vr: "SQ",
    vm: "1",
    name: "Failed Attributes Sequence"
  },
  "(0074,104A)": {
    tag: "(0074,104A)",
    vr: "SQ",
    vm: "1",
    name: "Overridden Attributes Sequence"
  },
  "(0074,104C)": {
    tag: "(0074,104C)",
    vr: "SQ",
    vm: "1",
    name: "Conventional Control Point Verification Sequence"
  },
  "(0074,104E)": {
    tag: "(0074,104E)",
    vr: "SQ",
    vm: "1",
    name: "Ion Control Point Verification Sequence"
  },
  "(0074,1050)": {
    tag: "(0074,1050)",
    vr: "SQ",
    vm: "1",
    name: "Attribute Occurrence Sequence"
  },
  "(0074,1052)": {
    tag: "(0074,1052)",
    vr: "AT",
    vm: "1",
    name: "Attribute Occurrence Pointer"
  },
  "(0074,1054)": {
    tag: "(0074,1054)",
    vr: "UL",
    vm: "1",
    name: "Attribute Item Selector"
  },
  "(0074,1056)": {
    tag: "(0074,1056)",
    vr: "LO",
    vm: "1",
    name: "Attribute Occurrence Private Creator"
  },
  "(0074,1057)": {
    tag: "(0074,1057)",
    vr: "IS",
    vm: "1",
    name: "Selector Sequence Pointer Items"
  },
  "(0074,1200)": {
    tag: "(0074,1200)",
    vr: "CS",
    vm: "1",
    name: "Scheduled Procedure Step Priority"
  },
  "(0074,1202)": {
    tag: "(0074,1202)",
    vr: "LO",
    vm: "1",
    name: "Worklist Label"
  },
  "(0074,1204)": {
    tag: "(0074,1204)",
    vr: "LO",
    vm: "1",
    name: "Procedure Step Label"
  },
  "(0074,1210)": {
    tag: "(0074,1210)",
    vr: "SQ",
    vm: "1",
    name: "Scheduled Processing Parameters Sequence"
  },
  "(0074,1212)": {
    tag: "(0074,1212)",
    vr: "SQ",
    vm: "1",
    name: "Performed Processing Parameters Sequence"
  },
  "(0074,1216)": {
    tag: "(0074,1216)",
    vr: "SQ",
    vm: "1",
    name: "Unified Procedure Step Performed Procedure Sequence"
  },
  "(0074,1220)": {
    tag: "(0074,1220)",
    vr: "SQ",
    vm: "1",
    name: "Related Procedure Step Sequence"
  },
  "(0074,1222)": {
    tag: "(0074,1222)",
    vr: "LO",
    vm: "1",
    name: "Procedure Step Relationship Type"
  },
  "(0074,1224)": {
    tag: "(0074,1224)",
    vr: "SQ",
    vm: "1",
    name: "Replaced Procedure Step Sequence"
  },
  "(0074,1230)": {
    tag: "(0074,1230)",
    vr: "LO",
    vm: "1",
    name: "Deletion Lock"
  },
  "(0074,1234)": {
    tag: "(0074,1234)",
    vr: "AE",
    vm: "1",
    name: "Receiving AE"
  },
  "(0074,1236)": {
    tag: "(0074,1236)",
    vr: "AE",
    vm: "1",
    name: "Requesting AE"
  },
  "(0074,1238)": {
    tag: "(0074,1238)",
    vr: "LT",
    vm: "1",
    name: "Reason For Cancellation"
  },
  "(0074,1242)": { tag: "(0074,1242)", vr: "CS", vm: "1", name: "SCPStatus" },
  "(0074,1244)": {
    tag: "(0074,1244)",
    vr: "CS",
    vm: "1",
    name: "Subscription List Status"
  },
  "(0074,1246)": {
    tag: "(0074,1246)",
    vr: "CS",
    vm: "1",
    name: "Unified Procedure Step List Status"
  },
  "(0074,1324)": {
    tag: "(0074,1324)",
    vr: "UL",
    vm: "1",
    name: "Beam Order Index"
  },
  "(0074,1338)": {
    tag: "(0074,1338)",
    vr: "FD",
    vm: "1",
    name: "Double Exposure Meterset"
  },
  "(0074,133A)": {
    tag: "(0074,133A)",
    vr: "FD",
    vm: "4",
    name: "Double Exposure Field Delta"
  },
  "(0076,0001)": {
    tag: "(0076,0001)",
    vr: "LO",
    vm: "1",
    name: "Implant Assembly Template Name"
  },
  "(0076,0003)": {
    tag: "(0076,0003)",
    vr: "LO",
    vm: "1",
    name: "Implant Assembly Template Issuer"
  },
  "(0076,0006)": {
    tag: "(0076,0006)",
    vr: "LO",
    vm: "1",
    name: "Implant Assembly Template Version"
  },
  "(0076,0008)": {
    tag: "(0076,0008)",
    vr: "SQ",
    vm: "1",
    name: "Replaced Implant Assembly Template Sequence"
  },
  "(0076,000A)": {
    tag: "(0076,000A)",
    vr: "CS",
    vm: "1",
    name: "Implant Assembly Template Type"
  },
  "(0076,000C)": {
    tag: "(0076,000C)",
    vr: "SQ",
    vm: "1",
    name: "Original Implant Assembly Template Sequence"
  },
  "(0076,000E)": {
    tag: "(0076,000E)",
    vr: "SQ",
    vm: "1",
    name: "Derivation Implant Assembly Template Sequence"
  },
  "(0076,0010)": {
    tag: "(0076,0010)",
    vr: "SQ",
    vm: "1",
    name: "Implant Assembly Template Target Anatomy Sequence"
  },
  "(0076,0020)": {
    tag: "(0076,0020)",
    vr: "SQ",
    vm: "1",
    name: "Procedure Type Code Sequence"
  },
  "(0076,0030)": {
    tag: "(0076,0030)",
    vr: "LO",
    vm: "1",
    name: "Surgical Technique"
  },
  "(0076,0032)": {
    tag: "(0076,0032)",
    vr: "SQ",
    vm: "1",
    name: "Component Types Sequence"
  },
  "(0076,0034)": {
    tag: "(0076,0034)",
    vr: "CS",
    vm: "1",
    name: "Component Type Code Sequence"
  },
  "(0076,0036)": {
    tag: "(0076,0036)",
    vr: "CS",
    vm: "1",
    name: "Exclusive Component Type"
  },
  "(0076,0038)": {
    tag: "(0076,0038)",
    vr: "CS",
    vm: "1",
    name: "Mandatory Component Type"
  },
  "(0076,0040)": {
    tag: "(0076,0040)",
    vr: "SQ",
    vm: "1",
    name: "Component Sequence"
  },
  "(0076,0055)": {
    tag: "(0076,0055)",
    vr: "US",
    vm: "1",
    name: "Component ID"
  },
  "(0076,0060)": {
    tag: "(0076,0060)",
    vr: "SQ",
    vm: "1",
    name: "Component Assembly Sequence"
  },
  "(0076,0070)": {
    tag: "(0076,0070)",
    vr: "US",
    vm: "1",
    name: "Component1Referenced ID"
  },
  "(0076,0080)": {
    tag: "(0076,0080)",
    vr: "US",
    vm: "1",
    name: "Component1Referenced Mating Feature Set ID"
  },
  "(0076,0090)": {
    tag: "(0076,0090)",
    vr: "US",
    vm: "1",
    name: "Component1Referenced Mating Feature ID"
  },
  "(0076,00A0)": {
    tag: "(0076,00A0)",
    vr: "US",
    vm: "1",
    name: "Component2Referenced ID"
  },
  "(0076,00B0)": {
    tag: "(0076,00B0)",
    vr: "US",
    vm: "1",
    name: "Component2Referenced Mating Feature Set ID"
  },
  "(0076,00C0)": {
    tag: "(0076,00C0)",
    vr: "US",
    vm: "1",
    name: "Component2Referenced Mating Feature ID"
  },
  "(0078,0001)": {
    tag: "(0078,0001)",
    vr: "LO",
    vm: "1",
    name: "Implant Template Group Name"
  },
  "(0078,0010)": {
    tag: "(0078,0010)",
    vr: "ST",
    vm: "1",
    name: "Implant Template Group Description"
  },
  "(0078,0020)": {
    tag: "(0078,0020)",
    vr: "LO",
    vm: "1",
    name: "Implant Template Group Issuer"
  },
  "(0078,0024)": {
    tag: "(0078,0024)",
    vr: "LO",
    vm: "1",
    name: "Implant Template Group Version"
  },
  "(0078,0026)": {
    tag: "(0078,0026)",
    vr: "SQ",
    vm: "1",
    name: "Replaced Implant Template Group Sequence"
  },
  "(0078,0028)": {
    tag: "(0078,0028)",
    vr: "SQ",
    vm: "1",
    name: "Implant Template Group Target Anatomy Sequence"
  },
  "(0078,002A)": {
    tag: "(0078,002A)",
    vr: "SQ",
    vm: "1",
    name: "Implant Template Group Members Sequence"
  },
  "(0078,002E)": {
    tag: "(0078,002E)",
    vr: "US",
    vm: "1",
    name: "Implant Template Group Member ID"
  },
  "(0078,0050)": {
    tag: "(0078,0050)",
    vr: "FD",
    vm: "3",
    name: "Three DImplant Template Group Member Matching Point"
  },
  "(0078,0060)": {
    tag: "(0078,0060)",
    vr: "FD",
    vm: "9",
    name: "Three DImplant Template Group Member Matching Axes"
  },
  "(0078,0070)": {
    tag: "(0078,0070)",
    vr: "SQ",
    vm: "1",
    name: "Implant Template Group Member Matching2DCoordinates Sequence"
  },
  "(0078,0090)": {
    tag: "(0078,0090)",
    vr: "FD",
    vm: "2",
    name: "Two DImplant Template Group Member Matching Point"
  },
  "(0078,00A0)": {
    tag: "(0078,00A0)",
    vr: "FD",
    vm: "4",
    name: "Two DImplant Template Group Member Matching Axes"
  },
  "(0078,00B0)": {
    tag: "(0078,00B0)",
    vr: "SQ",
    vm: "1",
    name: "Implant Template Group Variation Dimension Sequence"
  },
  "(0078,00B2)": {
    tag: "(0078,00B2)",
    vr: "LO",
    vm: "1",
    name: "Implant Template Group Variation Dimension Name"
  },
  "(0078,00B4)": {
    tag: "(0078,00B4)",
    vr: "SQ",
    vm: "1",
    name: "Implant Template Group Variation Dimension Rank Sequence"
  },
  "(0078,00B6)": {
    tag: "(0078,00B6)",
    vr: "US",
    vm: "1",
    name: "Referenced Implant Template Group Member ID"
  },
  "(0078,00B8)": {
    tag: "(0078,00B8)",
    vr: "US",
    vm: "1",
    name: "Implant Template Group Variation Dimension Rank"
  },
  "(0088,0130)": {
    tag: "(0088,0130)",
    vr: "SH",
    vm: "1",
    name: "Storage Media File Set ID"
  },
  "(0088,0140)": {
    tag: "(0088,0140)",
    vr: "UI",
    vm: "1",
    name: "Storage Media File Set UID"
  },
  "(0088,0200)": {
    tag: "(0088,0200)",
    vr: "SQ",
    vm: "1",
    name: "Icon Image Sequence"
  },
  "(0088,0904)": { tag: "(0088,0904)", vr: "LO", vm: "1", name: "Topic Title" },
  "(0088,0906)": {
    tag: "(0088,0906)",
    vr: "ST",
    vm: "1",
    name: "Topic Subject"
  },
  "(0088,0910)": {
    tag: "(0088,0910)",
    vr: "LO",
    vm: "1",
    name: "Topic Author"
  },
  "(0088,0912)": {
    tag: "(0088,0912)",
    vr: "LO",
    vm: "1-32",
    name: "Topic Keywords"
  },
  "(0100,0410)": {
    tag: "(0100,0410)",
    vr: "CS",
    vm: "1",
    name: "SOPInstance Status"
  },
  "(0100,0420)": {
    tag: "(0100,0420)",
    vr: "DT",
    vm: "1",
    name: "SOPAuthorization Date Time"
  },
  "(0100,0424)": {
    tag: "(0100,0424)",
    vr: "LT",
    vm: "1",
    name: "SOPAuthorization Comment"
  },
  "(0100,0426)": {
    tag: "(0100,0426)",
    vr: "LO",
    vm: "1",
    name: "Authorization Equipment Certification Number"
  },
  "(0400,0005)": { tag: "(0400,0005)", vr: "US", vm: "1", name: "MACIDNumber" },
  "(0400,0010)": {
    tag: "(0400,0010)",
    vr: "UI",
    vm: "1",
    name: "MACCalculation Transfer Syntax UID"
  },
  "(0400,0015)": {
    tag: "(0400,0015)",
    vr: "CS",
    vm: "1",
    name: "MACAlgorithm"
  },
  "(0400,0020)": {
    tag: "(0400,0020)",
    vr: "AT",
    vm: "1",
    name: "Data Elements Signed"
  },
  "(0400,0100)": {
    tag: "(0400,0100)",
    vr: "UI",
    vm: "1",
    name: "Digital Signature UID"
  },
  "(0400,0105)": {
    tag: "(0400,0105)",
    vr: "DT",
    vm: "1",
    name: "Digital Signature Date Time"
  },
  "(0400,0110)": {
    tag: "(0400,0110)",
    vr: "CS",
    vm: "1",
    name: "Certificate Type"
  },
  "(0400,0115)": {
    tag: "(0400,0115)",
    vr: "OB",
    vm: "1",
    name: "Certificate Of Signer"
  },
  "(0400,0120)": { tag: "(0400,0120)", vr: "OB", vm: "1", name: "Signature" },
  "(0400,0305)": {
    tag: "(0400,0305)",
    vr: "CS",
    vm: "1",
    name: "Certified Timestamp Type"
  },
  "(0400,0310)": {
    tag: "(0400,0310)",
    vr: "OB",
    vm: "1",
    name: "Certified Timestamp"
  },
  "(0400,0401)": {
    tag: "(0400,0401)",
    vr: "SQ",
    vm: "1",
    name: "Digital Signature Purpose Code Sequence"
  },
  "(0400,0402)": {
    tag: "(0400,0402)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Digital Signature Sequence"
  },
  "(0400,0403)": {
    tag: "(0400,0403)",
    vr: "SQ",
    vm: "1",
    name: "Referenced SOPInstance MACSequence"
  },
  "(0400,0404)": { tag: "(0400,0404)", vr: "OB", vm: "1", name: "MAC" },
  "(0400,0500)": {
    tag: "(0400,0500)",
    vr: "SQ",
    vm: "1",
    name: "Encrypted Attributes Sequence"
  },
  "(0400,0510)": {
    tag: "(0400,0510)",
    vr: "UI",
    vm: "1",
    name: "Encrypted Content Transfer Syntax UID"
  },
  "(0400,0520)": {
    tag: "(0400,0520)",
    vr: "OB",
    vm: "1",
    name: "Encrypted Content"
  },
  "(0400,0550)": {
    tag: "(0400,0550)",
    vr: "SQ",
    vm: "1",
    name: "Modified Attributes Sequence"
  },
  "(0400,0561)": {
    tag: "(0400,0561)",
    vr: "SQ",
    vm: "1",
    name: "Original Attributes Sequence"
  },
  "(0400,0562)": {
    tag: "(0400,0562)",
    vr: "DT",
    vm: "1",
    name: "Attribute Modification Date Time"
  },
  "(0400,0563)": {
    tag: "(0400,0563)",
    vr: "LO",
    vm: "1",
    name: "Modifying System"
  },
  "(0400,0564)": {
    tag: "(0400,0564)",
    vr: "LO",
    vm: "1",
    name: "Source Of Previous Values"
  },
  "(0400,0565)": {
    tag: "(0400,0565)",
    vr: "CS",
    vm: "1",
    name: "Reason For The Attribute Modification"
  },
  "(1000,xxx0)": {
    tag: "(1000,xxx0)",
    vr: "US",
    vm: "3",
    name: "Escape Triplet"
  },
  "(1000,xxx1)": {
    tag: "(1000,xxx1)",
    vr: "US",
    vm: "3",
    name: "Run Length Triplet"
  },
  "(1000,xxx2)": {
    tag: "(1000,xxx2)",
    vr: "US",
    vm: "1",
    name: "Huffman Table Size"
  },
  "(1000,xxx3)": {
    tag: "(1000,xxx3)",
    vr: "US",
    vm: "3",
    name: "Huffman Table Triplet"
  },
  "(1000,xxx4)": {
    tag: "(1000,xxx4)",
    vr: "US",
    vm: "1",
    name: "Shift Table Size"
  },
  "(1000,xxx5)": {
    tag: "(1000,xxx5)",
    vr: "US",
    vm: "3",
    name: "Shift Table Triplet"
  },
  "(1010,xxxx)": { tag: "(1010,xxxx)", vr: "US", vm: "1", name: "Zonal Map" },
  "(2000,0010)": {
    tag: "(2000,0010)",
    vr: "IS",
    vm: "1",
    name: "Number Of Copies"
  },
  "(2000,001E)": {
    tag: "(2000,001E)",
    vr: "SQ",
    vm: "1",
    name: "Printer Configuration Sequence"
  },
  "(2000,0020)": {
    tag: "(2000,0020)",
    vr: "CS",
    vm: "1",
    name: "Print Priority"
  },
  "(2000,0030)": { tag: "(2000,0030)", vr: "CS", vm: "1", name: "Medium Type" },
  "(2000,0040)": {
    tag: "(2000,0040)",
    vr: "CS",
    vm: "1",
    name: "Film Destination"
  },
  "(2000,0050)": {
    tag: "(2000,0050)",
    vr: "LO",
    vm: "1",
    name: "Film Session Label"
  },
  "(2000,0060)": {
    tag: "(2000,0060)",
    vr: "IS",
    vm: "1",
    name: "Memory Allocation"
  },
  "(2000,0061)": {
    tag: "(2000,0061)",
    vr: "IS",
    vm: "1",
    name: "Maximum Memory Allocation"
  },
  "(2000,0062)": {
    tag: "(2000,0062)",
    vr: "CS",
    vm: "1",
    name: "Color Image Printing Flag"
  },
  "(2000,0063)": {
    tag: "(2000,0063)",
    vr: "CS",
    vm: "1",
    name: "Collation Flag"
  },
  "(2000,0065)": {
    tag: "(2000,0065)",
    vr: "CS",
    vm: "1",
    name: "Annotation Flag"
  },
  "(2000,0067)": {
    tag: "(2000,0067)",
    vr: "CS",
    vm: "1",
    name: "Image Overlay Flag"
  },
  "(2000,0069)": {
    tag: "(2000,0069)",
    vr: "CS",
    vm: "1",
    name: "Presentation LUTFlag"
  },
  "(2000,006A)": {
    tag: "(2000,006A)",
    vr: "CS",
    vm: "1",
    name: "Image Box Presentation LUTFlag"
  },
  "(2000,00A0)": {
    tag: "(2000,00A0)",
    vr: "US",
    vm: "1",
    name: "Memory Bit Depth"
  },
  "(2000,00A1)": {
    tag: "(2000,00A1)",
    vr: "US",
    vm: "1",
    name: "Printing Bit Depth"
  },
  "(2000,00A2)": {
    tag: "(2000,00A2)",
    vr: "SQ",
    vm: "1",
    name: "Media Installed Sequence"
  },
  "(2000,00A4)": {
    tag: "(2000,00A4)",
    vr: "SQ",
    vm: "1",
    name: "Other Media Available Sequence"
  },
  "(2000,00A8)": {
    tag: "(2000,00A8)",
    vr: "SQ",
    vm: "1",
    name: "Supported Image Display Formats Sequence"
  },
  "(2000,0500)": {
    tag: "(2000,0500)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Film Box Sequence"
  },
  "(2000,0510)": {
    tag: "(2000,0510)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Stored Print Sequence"
  },
  "(2010,0010)": {
    tag: "(2010,0010)",
    vr: "ST",
    vm: "1",
    name: "Image Display Format"
  },
  "(2010,0030)": {
    tag: "(2010,0030)",
    vr: "CS",
    vm: "1",
    name: "Annotation Display Format ID"
  },
  "(2010,0040)": {
    tag: "(2010,0040)",
    vr: "CS",
    vm: "1",
    name: "Film Orientation"
  },
  "(2010,0050)": {
    tag: "(2010,0050)",
    vr: "CS",
    vm: "1",
    name: "Film Size ID"
  },
  "(2010,0052)": {
    tag: "(2010,0052)",
    vr: "CS",
    vm: "1",
    name: "Printer Resolution ID"
  },
  "(2010,0054)": {
    tag: "(2010,0054)",
    vr: "CS",
    vm: "1",
    name: "Default Printer Resolution ID"
  },
  "(2010,0060)": {
    tag: "(2010,0060)",
    vr: "CS",
    vm: "1",
    name: "Magnification Type"
  },
  "(2010,0080)": {
    tag: "(2010,0080)",
    vr: "CS",
    vm: "1",
    name: "Smoothing Type"
  },
  "(2010,00A6)": {
    tag: "(2010,00A6)",
    vr: "CS",
    vm: "1",
    name: "Default Magnification Type"
  },
  "(2010,00A7)": {
    tag: "(2010,00A7)",
    vr: "CS",
    vm: "1",
    name: "Other Magnification Types Available"
  },
  "(2010,00A8)": {
    tag: "(2010,00A8)",
    vr: "CS",
    vm: "1",
    name: "Default Smoothing Type"
  },
  "(2010,00A9)": {
    tag: "(2010,00A9)",
    vr: "CS",
    vm: "1",
    name: "Other Smoothing Types Available"
  },
  "(2010,0100)": {
    tag: "(2010,0100)",
    vr: "CS",
    vm: "1",
    name: "Border Density"
  },
  "(2010,0110)": {
    tag: "(2010,0110)",
    vr: "CS",
    vm: "1",
    name: "Empty Image Density"
  },
  "(2010,0120)": { tag: "(2010,0120)", vr: "US", vm: "1", name: "Min Density" },
  "(2010,0130)": { tag: "(2010,0130)", vr: "US", vm: "1", name: "Max Density" },
  "(2010,0140)": { tag: "(2010,0140)", vr: "CS", vm: "1", name: "Trim" },
  "(2010,0150)": {
    tag: "(2010,0150)",
    vr: "ST",
    vm: "1",
    name: "Configuration Information"
  },
  "(2010,0152)": {
    tag: "(2010,0152)",
    vr: "LT",
    vm: "1",
    name: "Configuration Information Description"
  },
  "(2010,0154)": {
    tag: "(2010,0154)",
    vr: "IS",
    vm: "1",
    name: "Maximum Collated Films"
  },
  "(2010,015E)": {
    tag: "(2010,015E)",
    vr: "US",
    vm: "1",
    name: "Illumination"
  },
  "(2010,0160)": {
    tag: "(2010,0160)",
    vr: "US",
    vm: "1",
    name: "Reflected Ambient Light"
  },
  "(2010,0376)": {
    tag: "(2010,0376)",
    vr: "DS",
    vm: "2",
    name: "Printer Pixel Spacing"
  },
  "(2010,0500)": {
    tag: "(2010,0500)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Film Session Sequence"
  },
  "(2010,0510)": {
    tag: "(2010,0510)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Image Box Sequence"
  },
  "(2010,0520)": {
    tag: "(2010,0520)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Basic Annotation Box Sequence"
  },
  "(2020,0010)": {
    tag: "(2020,0010)",
    vr: "US",
    vm: "1",
    name: "Image Box Position"
  },
  "(2020,0020)": { tag: "(2020,0020)", vr: "CS", vm: "1", name: "Polarity" },
  "(2020,0030)": {
    tag: "(2020,0030)",
    vr: "DS",
    vm: "1",
    name: "Requested Image Size"
  },
  "(2020,0040)": {
    tag: "(2020,0040)",
    vr: "CS",
    vm: "1",
    name: "Requested Decimate Crop Behavior"
  },
  "(2020,0050)": {
    tag: "(2020,0050)",
    vr: "CS",
    vm: "1",
    name: "Requested Resolution ID"
  },
  "(2020,00A0)": {
    tag: "(2020,00A0)",
    vr: "CS",
    vm: "1",
    name: "Requested Image Size Flag"
  },
  "(2020,00A2)": {
    tag: "(2020,00A2)",
    vr: "CS",
    vm: "1",
    name: "Decimate Crop Result"
  },
  "(2020,0110)": {
    tag: "(2020,0110)",
    vr: "SQ",
    vm: "1",
    name: "Basic Grayscale Image Sequence"
  },
  "(2020,0111)": {
    tag: "(2020,0111)",
    vr: "SQ",
    vm: "1",
    name: "Basic Color Image Sequence"
  },
  "(2020,0130)": {
    tag: "(2020,0130)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Image Overlay Box Sequence"
  },
  "(2020,0140)": {
    tag: "(2020,0140)",
    vr: "SQ",
    vm: "1",
    name: "Referenced VOILUTBox Sequence"
  },
  "(2030,0010)": {
    tag: "(2030,0010)",
    vr: "US",
    vm: "1",
    name: "Annotation Position"
  },
  "(2030,0020)": { tag: "(2030,0020)", vr: "LO", vm: "1", name: "Text String" },
  "(2040,0010)": {
    tag: "(2040,0010)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Overlay Plane Sequence"
  },
  "(2040,0011)": {
    tag: "(2040,0011)",
    vr: "US",
    vm: "1-99",
    name: "Referenced Overlay Plane Groups"
  },
  "(2040,0020)": {
    tag: "(2040,0020)",
    vr: "SQ",
    vm: "1",
    name: "Overlay Pixel Data Sequence"
  },
  "(2040,0060)": {
    tag: "(2040,0060)",
    vr: "CS",
    vm: "1",
    name: "Overlay Magnification Type"
  },
  "(2040,0070)": {
    tag: "(2040,0070)",
    vr: "CS",
    vm: "1",
    name: "Overlay Smoothing Type"
  },
  "(2040,0072)": {
    tag: "(2040,0072)",
    vr: "CS",
    vm: "1",
    name: "Overlay Or Image Magnification"
  },
  "(2040,0074)": {
    tag: "(2040,0074)",
    vr: "US",
    vm: "1",
    name: "Magnify To Number Of Columns"
  },
  "(2040,0080)": {
    tag: "(2040,0080)",
    vr: "CS",
    vm: "1",
    name: "Overlay Foreground Density"
  },
  "(2040,0082)": {
    tag: "(2040,0082)",
    vr: "CS",
    vm: "1",
    name: "Overlay Background Density"
  },
  "(2040,0090)": {
    tag: "(2040,0090)",
    vr: "CS",
    vm: "1",
    name: "Overlay Mode"
  },
  "(2040,0100)": {
    tag: "(2040,0100)",
    vr: "CS",
    vm: "1",
    name: "Threshold Density"
  },
  "(2040,0500)": {
    tag: "(2040,0500)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Image Box Sequence Retired"
  },
  "(2050,0010)": {
    tag: "(2050,0010)",
    vr: "SQ",
    vm: "1",
    name: "Presentation LUTSequence"
  },
  "(2050,0020)": {
    tag: "(2050,0020)",
    vr: "CS",
    vm: "1",
    name: "Presentation LUTShape"
  },
  "(2050,0500)": {
    tag: "(2050,0500)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Presentation LUTSequence"
  },
  "(2100,0010)": {
    tag: "(2100,0010)",
    vr: "SH",
    vm: "1",
    name: "Print Job ID"
  },
  "(2100,0020)": {
    tag: "(2100,0020)",
    vr: "CS",
    vm: "1",
    name: "Execution Status"
  },
  "(2100,0030)": {
    tag: "(2100,0030)",
    vr: "CS",
    vm: "1",
    name: "Execution Status Info"
  },
  "(2100,0040)": {
    tag: "(2100,0040)",
    vr: "DA",
    vm: "1",
    name: "Creation Date"
  },
  "(2100,0050)": {
    tag: "(2100,0050)",
    vr: "TM",
    vm: "1",
    name: "Creation Time"
  },
  "(2100,0070)": { tag: "(2100,0070)", vr: "AE", vm: "1", name: "Originator" },
  "(2100,0140)": {
    tag: "(2100,0140)",
    vr: "AE",
    vm: "1",
    name: "Destination AE"
  },
  "(2100,0160)": { tag: "(2100,0160)", vr: "SH", vm: "1", name: "Owner ID" },
  "(2100,0170)": {
    tag: "(2100,0170)",
    vr: "IS",
    vm: "1",
    name: "Number Of Films"
  },
  "(2100,0500)": {
    tag: "(2100,0500)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Print Job Sequence Pull Stored Print"
  },
  "(2110,0010)": {
    tag: "(2110,0010)",
    vr: "CS",
    vm: "1",
    name: "Printer Status"
  },
  "(2110,0020)": {
    tag: "(2110,0020)",
    vr: "CS",
    vm: "1",
    name: "Printer Status Info"
  },
  "(2110,0030)": {
    tag: "(2110,0030)",
    vr: "LO",
    vm: "1",
    name: "Printer Name"
  },
  "(2110,0099)": {
    tag: "(2110,0099)",
    vr: "SH",
    vm: "1",
    name: "Print Queue ID"
  },
  "(2120,0010)": {
    tag: "(2120,0010)",
    vr: "CS",
    vm: "1",
    name: "Queue Status"
  },
  "(2120,0050)": {
    tag: "(2120,0050)",
    vr: "SQ",
    vm: "1",
    name: "Print Job Description Sequence"
  },
  "(2120,0070)": {
    tag: "(2120,0070)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Print Job Sequence"
  },
  "(2130,0010)": {
    tag: "(2130,0010)",
    vr: "SQ",
    vm: "1",
    name: "Print Management Capabilities Sequence"
  },
  "(2130,0015)": {
    tag: "(2130,0015)",
    vr: "SQ",
    vm: "1",
    name: "Printer Characteristics Sequence"
  },
  "(2130,0030)": {
    tag: "(2130,0030)",
    vr: "SQ",
    vm: "1",
    name: "Film Box Content Sequence"
  },
  "(2130,0040)": {
    tag: "(2130,0040)",
    vr: "SQ",
    vm: "1",
    name: "Image Box Content Sequence"
  },
  "(2130,0050)": {
    tag: "(2130,0050)",
    vr: "SQ",
    vm: "1",
    name: "Annotation Content Sequence"
  },
  "(2130,0060)": {
    tag: "(2130,0060)",
    vr: "SQ",
    vm: "1",
    name: "Image Overlay Box Content Sequence"
  },
  "(2130,0080)": {
    tag: "(2130,0080)",
    vr: "SQ",
    vm: "1",
    name: "Presentation LUTContent Sequence"
  },
  "(2130,00A0)": {
    tag: "(2130,00A0)",
    vr: "SQ",
    vm: "1",
    name: "Proposed Study Sequence"
  },
  "(2130,00C0)": {
    tag: "(2130,00C0)",
    vr: "SQ",
    vm: "1",
    name: "Original Image Sequence"
  },
  "(2200,0001)": {
    tag: "(2200,0001)",
    vr: "CS",
    vm: "1",
    name: "Label Using Information Extracted From Instances"
  },
  "(2200,0002)": { tag: "(2200,0002)", vr: "UT", vm: "1", name: "Label Text" },
  "(2200,0003)": {
    tag: "(2200,0003)",
    vr: "CS",
    vm: "1",
    name: "Label Style Selection"
  },
  "(2200,0004)": {
    tag: "(2200,0004)",
    vr: "LT",
    vm: "1",
    name: "Media Disposition"
  },
  "(2200,0005)": {
    tag: "(2200,0005)",
    vr: "LT",
    vm: "1",
    name: "Barcode Value"
  },
  "(2200,0006)": {
    tag: "(2200,0006)",
    vr: "CS",
    vm: "1",
    name: "Barcode Symbology"
  },
  "(2200,0007)": {
    tag: "(2200,0007)",
    vr: "CS",
    vm: "1",
    name: "Allow Media Splitting"
  },
  "(2200,0008)": {
    tag: "(2200,0008)",
    vr: "CS",
    vm: "1",
    name: "Include Non DICOMObjects"
  },
  "(2200,0009)": {
    tag: "(2200,0009)",
    vr: "CS",
    vm: "1",
    name: "Include Display Application"
  },
  "(2200,000A)": {
    tag: "(2200,000A)",
    vr: "CS",
    vm: "1",
    name: "Preserve Composite Instances After Media Creation"
  },
  "(2200,000B)": {
    tag: "(2200,000B)",
    vr: "US",
    vm: "1",
    name: "Total Number Of Pieces Of Media Created"
  },
  "(2200,000C)": {
    tag: "(2200,000C)",
    vr: "LO",
    vm: "1",
    name: "Requested Media Application Profile"
  },
  "(2200,000D)": {
    tag: "(2200,000D)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Storage Media Sequence"
  },
  "(2200,000E)": {
    tag: "(2200,000E)",
    vr: "AT",
    vm: "1",
    name: "Failure Attributes"
  },
  "(2200,000F)": {
    tag: "(2200,000F)",
    vr: "CS",
    vm: "1",
    name: "Allow Lossy Compression"
  },
  "(2200,0020)": {
    tag: "(2200,0020)",
    vr: "CS",
    vm: "1",
    name: "Request Priority"
  },
  "(3002,0002)": {
    tag: "(3002,0002)",
    vr: "SH",
    vm: "1",
    name: "RTImage Label"
  },
  "(3002,0003)": {
    tag: "(3002,0003)",
    vr: "LO",
    vm: "1",
    name: "RTImage Name"
  },
  "(3002,0004)": {
    tag: "(3002,0004)",
    vr: "ST",
    vm: "1",
    name: "RTImage Description"
  },
  "(3002,000A)": {
    tag: "(3002,000A)",
    vr: "CS",
    vm: "1",
    name: "Reported Values Origin"
  },
  "(3002,000C)": {
    tag: "(3002,000C)",
    vr: "CS",
    vm: "1",
    name: "RTImage Plane"
  },
  "(3002,000D)": {
    tag: "(3002,000D)",
    vr: "DS",
    vm: "3",
    name: "XRay Image Receptor Translation"
  },
  "(3002,000E)": {
    tag: "(3002,000E)",
    vr: "DS",
    vm: "1",
    name: "XRay Image Receptor Angle"
  },
  "(3002,0010)": {
    tag: "(3002,0010)",
    vr: "DS",
    vm: "6",
    name: "RTImage Orientation"
  },
  "(3002,0011)": {
    tag: "(3002,0011)",
    vr: "DS",
    vm: "2",
    name: "Image Plane Pixel Spacing"
  },
  "(3002,0012)": {
    tag: "(3002,0012)",
    vr: "DS",
    vm: "2",
    name: "RTImage Position"
  },
  "(3002,0020)": {
    tag: "(3002,0020)",
    vr: "SH",
    vm: "1",
    name: "Radiation Machine Name"
  },
  "(3002,0022)": {
    tag: "(3002,0022)",
    vr: "DS",
    vm: "1",
    name: "Radiation Machine SAD"
  },
  "(3002,0024)": {
    tag: "(3002,0024)",
    vr: "DS",
    vm: "1",
    name: "Radiation Machine SSD"
  },
  "(3002,0026)": { tag: "(3002,0026)", vr: "DS", vm: "1", name: "RTImage SID" },
  "(3002,0028)": {
    tag: "(3002,0028)",
    vr: "DS",
    vm: "1",
    name: "Source To Reference Object Distance"
  },
  "(3002,0029)": {
    tag: "(3002,0029)",
    vr: "IS",
    vm: "1",
    name: "Fraction Number"
  },
  "(3002,0030)": {
    tag: "(3002,0030)",
    vr: "SQ",
    vm: "1",
    name: "Exposure Sequence"
  },
  "(3002,0032)": {
    tag: "(3002,0032)",
    vr: "DS",
    vm: "1",
    name: "Meterset Exposure"
  },
  "(3002,0034)": {
    tag: "(3002,0034)",
    vr: "DS",
    vm: "4",
    name: "Diaphragm Position"
  },
  "(3002,0040)": {
    tag: "(3002,0040)",
    vr: "SQ",
    vm: "1",
    name: "Fluence Map Sequence"
  },
  "(3002,0041)": {
    tag: "(3002,0041)",
    vr: "CS",
    vm: "1",
    name: "Fluence Data Source"
  },
  "(3002,0042)": {
    tag: "(3002,0042)",
    vr: "DS",
    vm: "1",
    name: "Fluence Data Scale"
  },
  "(3002,0050)": {
    tag: "(3002,0050)",
    vr: "SQ",
    vm: "1",
    name: "Primary Fluence Mode Sequence"
  },
  "(3002,0051)": {
    tag: "(3002,0051)",
    vr: "CS",
    vm: "1",
    name: "Fluence Mode"
  },
  "(3002,0052)": {
    tag: "(3002,0052)",
    vr: "SH",
    vm: "1",
    name: "Fluence Mode ID"
  },
  "(3004,0001)": { tag: "(3004,0001)", vr: "CS", vm: "1", name: "DVHType" },
  "(3004,0002)": { tag: "(3004,0002)", vr: "CS", vm: "1", name: "Dose Units" },
  "(3004,0004)": { tag: "(3004,0004)", vr: "CS", vm: "1", name: "Dose Type" },
  "(3004,0006)": {
    tag: "(3004,0006)",
    vr: "LO",
    vm: "1",
    name: "Dose Comment"
  },
  "(3004,0008)": {
    tag: "(3004,0008)",
    vr: "DS",
    vm: "3",
    name: "Normalization Point"
  },
  "(3004,000A)": {
    tag: "(3004,000A)",
    vr: "CS",
    vm: "1",
    name: "Dose Summation Type"
  },
  "(3004,000C)": {
    tag: "(3004,000C)",
    vr: "DS",
    vm: "2",
    name: "Grid Frame Offset Vector"
  },
  "(3004,000E)": {
    tag: "(3004,000E)",
    vr: "DS",
    vm: "1",
    name: "Dose Grid Scaling"
  },
  "(3004,0010)": {
    tag: "(3004,0010)",
    vr: "SQ",
    vm: "1",
    name: "RTDose ROISequence"
  },
  "(3004,0012)": { tag: "(3004,0012)", vr: "DS", vm: "1", name: "Dose Value" },
  "(3004,0014)": {
    tag: "(3004,0014)",
    vr: "CS",
    vm: "1-3",
    name: "Tissue Heterogeneity Correction"
  },
  "(3004,0040)": {
    tag: "(3004,0040)",
    vr: "DS",
    vm: "3",
    name: "DVHNormalization Point"
  },
  "(3004,0042)": {
    tag: "(3004,0042)",
    vr: "DS",
    vm: "1",
    name: "DVHNormalization Dose Value"
  },
  "(3004,0050)": { tag: "(3004,0050)", vr: "SQ", vm: "1", name: "DVHSequence" },
  "(3004,0052)": {
    tag: "(3004,0052)",
    vr: "DS",
    vm: "1",
    name: "DVHDose Scaling"
  },
  "(3004,0054)": {
    tag: "(3004,0054)",
    vr: "CS",
    vm: "1",
    name: "DVHVolume Units"
  },
  "(3004,0056)": {
    tag: "(3004,0056)",
    vr: "IS",
    vm: "1",
    name: "DVHNumber Of Bins"
  },
  "(3004,0058)": { tag: "(3004,0058)", vr: "DS", vm: "2-2n", name: "DVHData" },
  "(3004,0060)": {
    tag: "(3004,0060)",
    vr: "SQ",
    vm: "1",
    name: "DVHReferenced ROISequence"
  },
  "(3004,0062)": {
    tag: "(3004,0062)",
    vr: "CS",
    vm: "1",
    name: "DVHROIContribution Type"
  },
  "(3004,0070)": {
    tag: "(3004,0070)",
    vr: "DS",
    vm: "1",
    name: "DVHMinimum Dose"
  },
  "(3004,0072)": {
    tag: "(3004,0072)",
    vr: "DS",
    vm: "1",
    name: "DVHMaximum Dose"
  },
  "(3004,0074)": {
    tag: "(3004,0074)",
    vr: "DS",
    vm: "1",
    name: "DVHMean Dose"
  },
  "(3006,0002)": {
    tag: "(3006,0002)",
    vr: "SH",
    vm: "1",
    name: "Structure Set Label"
  },
  "(3006,0004)": {
    tag: "(3006,0004)",
    vr: "LO",
    vm: "1",
    name: "Structure Set Name"
  },
  "(3006,0006)": {
    tag: "(3006,0006)",
    vr: "ST",
    vm: "1",
    name: "Structure Set Description"
  },
  "(3006,0008)": {
    tag: "(3006,0008)",
    vr: "DA",
    vm: "1",
    name: "Structure Set Date"
  },
  "(3006,0009)": {
    tag: "(3006,0009)",
    vr: "TM",
    vm: "1",
    name: "Structure Set Time"
  },
  "(3006,0010)": {
    tag: "(3006,0010)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Frame Of Reference Sequence"
  },
  "(3006,0012)": {
    tag: "(3006,0012)",
    vr: "SQ",
    vm: "1",
    name: "RTReferenced Study Sequence"
  },
  "(3006,0014)": {
    tag: "(3006,0014)",
    vr: "SQ",
    vm: "1",
    name: "RTReferenced Series Sequence"
  },
  "(3006,0016)": {
    tag: "(3006,0016)",
    vr: "SQ",
    vm: "1",
    name: "Contour Image Sequence"
  },
  "(3006,0020)": {
    tag: "(3006,0020)",
    vr: "SQ",
    vm: "1",
    name: "Structure Set ROISequence"
  },
  "(3006,0022)": { tag: "(3006,0022)", vr: "IS", vm: "1", name: "ROINumber" },
  "(3006,0024)": {
    tag: "(3006,0024)",
    vr: "UI",
    vm: "1",
    name: "Referenced Frame Of Reference UID"
  },
  "(3006,0026)": { tag: "(3006,0026)", vr: "LO", vm: "1", name: "ROIName" },
  "(3006,0028)": {
    tag: "(3006,0028)",
    vr: "ST",
    vm: "1",
    name: "ROIDescription"
  },
  "(3006,002A)": {
    tag: "(3006,002A)",
    vr: "IS",
    vm: "3",
    name: "ROIDisplay Color"
  },
  "(3006,002C)": { tag: "(3006,002C)", vr: "DS", vm: "1", name: "ROIVolume" },
  "(3006,0030)": {
    tag: "(3006,0030)",
    vr: "SQ",
    vm: "1",
    name: "RTRelated ROISequence"
  },
  "(3006,0033)": {
    tag: "(3006,0033)",
    vr: "CS",
    vm: "1",
    name: "RTROIRelationship"
  },
  "(3006,0036)": {
    tag: "(3006,0036)",
    vr: "CS",
    vm: "1",
    name: "ROIGeneration Algorithm"
  },
  "(3006,0038)": {
    tag: "(3006,0038)",
    vr: "LO",
    vm: "1",
    name: "ROIGeneration Description"
  },
  "(3006,0039)": {
    tag: "(3006,0039)",
    vr: "SQ",
    vm: "1",
    name: "ROIContour Sequence"
  },
  "(3006,0040)": {
    tag: "(3006,0040)",
    vr: "SQ",
    vm: "1",
    name: "Contour Sequence"
  },
  "(3006,0042)": {
    tag: "(3006,0042)",
    vr: "CS",
    vm: "1",
    name: "Contour Geometric Type"
  },
  "(3006,0044)": {
    tag: "(3006,0044)",
    vr: "DS",
    vm: "1",
    name: "Contour Slab Thickness"
  },
  "(3006,0045)": {
    tag: "(3006,0045)",
    vr: "DS",
    vm: "3",
    name: "Contour Offset Vector"
  },
  "(3006,0046)": {
    tag: "(3006,0046)",
    vr: "IS",
    vm: "1",
    name: "Number Of Contour Points"
  },
  "(3006,0048)": {
    tag: "(3006,0048)",
    vr: "IS",
    vm: "1",
    name: "Contour Number"
  },
  "(3006,0049)": {
    tag: "(3006,0049)",
    vr: "IS",
    vm: "1",
    name: "Attached Contours"
  },
  "(3006,0050)": {
    tag: "(3006,0050)",
    vr: "DS",
    vm: "3-3n",
    name: "Contour Data"
  },
  "(3006,0080)": {
    tag: "(3006,0080)",
    vr: "SQ",
    vm: "1",
    name: "RTROIObservations Sequence"
  },
  "(3006,0082)": {
    tag: "(3006,0082)",
    vr: "IS",
    vm: "1",
    name: "Observation Number"
  },
  "(3006,0084)": {
    tag: "(3006,0084)",
    vr: "IS",
    vm: "1",
    name: "Referenced ROINumber"
  },
  "(3006,0085)": {
    tag: "(3006,0085)",
    vr: "SH",
    vm: "1",
    name: "ROIObservation Label"
  },
  "(3006,0086)": {
    tag: "(3006,0086)",
    vr: "SQ",
    vm: "1",
    name: "RTROIIdentification Code Sequence"
  },
  "(3006,0088)": {
    tag: "(3006,0088)",
    vr: "ST",
    vm: "1",
    name: "ROIObservation Description"
  },
  "(3006,00A0)": {
    tag: "(3006,00A0)",
    vr: "SQ",
    vm: "1",
    name: "Related RTROIObservations Sequence"
  },
  "(3006,00A4)": {
    tag: "(3006,00A4)",
    vr: "CS",
    vm: "1",
    name: "RTROIInterpreted Type"
  },
  "(3006,00A6)": {
    tag: "(3006,00A6)",
    vr: "PN",
    vm: "1",
    name: "ROIInterpreter"
  },
  "(3006,00B0)": {
    tag: "(3006,00B0)",
    vr: "SQ",
    vm: "1",
    name: "ROIPhysical Properties Sequence"
  },
  "(3006,00B2)": {
    tag: "(3006,00B2)",
    vr: "CS",
    vm: "1",
    name: "ROIPhysical Property"
  },
  "(3006,00B4)": {
    tag: "(3006,00B4)",
    vr: "DS",
    vm: "1",
    name: "ROIPhysical Property Value"
  },
  "(3006,00B6)": {
    tag: "(3006,00B6)",
    vr: "SQ",
    vm: "1",
    name: "ROIElemental Composition Sequence"
  },
  "(3006,00B7)": {
    tag: "(3006,00B7)",
    vr: "US",
    vm: "1",
    name: "ROIElemental Composition Atomic Number"
  },
  "(3006,00B8)": {
    tag: "(3006,00B8)",
    vr: "FL",
    vm: "1",
    name: "ROIElemental Composition Atomic Mass Fraction"
  },
  "(3006,00C0)": {
    tag: "(3006,00C0)",
    vr: "SQ",
    vm: "1",
    name: "Frame Of Reference Relationship Sequence"
  },
  "(3006,00C2)": {
    tag: "(3006,00C2)",
    vr: "UI",
    vm: "1",
    name: "Related Frame Of Reference UID"
  },
  "(3006,00C4)": {
    tag: "(3006,00C4)",
    vr: "CS",
    vm: "1",
    name: "Frame Of Reference Transformation Type"
  },
  "(3006,00C6)": {
    tag: "(3006,00C6)",
    vr: "DS",
    vm: "16",
    name: "Frame Of Reference Transformation Matrix"
  },
  "(3006,00C8)": {
    tag: "(3006,00C8)",
    vr: "LO",
    vm: "1",
    name: "Frame Of Reference Transformation Comment"
  },
  "(3008,0010)": {
    tag: "(3008,0010)",
    vr: "SQ",
    vm: "1",
    name: "Measured Dose Reference Sequence"
  },
  "(3008,0012)": {
    tag: "(3008,0012)",
    vr: "ST",
    vm: "1",
    name: "Measured Dose Description"
  },
  "(3008,0014)": {
    tag: "(3008,0014)",
    vr: "CS",
    vm: "1",
    name: "Measured Dose Type"
  },
  "(3008,0016)": {
    tag: "(3008,0016)",
    vr: "DS",
    vm: "1",
    name: "Measured Dose Value"
  },
  "(3008,0020)": {
    tag: "(3008,0020)",
    vr: "SQ",
    vm: "1",
    name: "Treatment Session Beam Sequence"
  },
  "(3008,0021)": {
    tag: "(3008,0021)",
    vr: "SQ",
    vm: "1",
    name: "Treatment Session Ion Beam Sequence"
  },
  "(3008,0022)": {
    tag: "(3008,0022)",
    vr: "IS",
    vm: "1",
    name: "Current Fraction Number"
  },
  "(3008,0024)": {
    tag: "(3008,0024)",
    vr: "DA",
    vm: "1",
    name: "Treatment Control Point Date"
  },
  "(3008,0025)": {
    tag: "(3008,0025)",
    vr: "TM",
    vm: "1",
    name: "Treatment Control Point Time"
  },
  "(3008,002A)": {
    tag: "(3008,002A)",
    vr: "CS",
    vm: "1",
    name: "Treatment Termination Status"
  },
  "(3008,002B)": {
    tag: "(3008,002B)",
    vr: "SH",
    vm: "1",
    name: "Treatment Termination Code"
  },
  "(3008,002C)": {
    tag: "(3008,002C)",
    vr: "CS",
    vm: "1",
    name: "Treatment Verification Status"
  },
  "(3008,0030)": {
    tag: "(3008,0030)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Treatment Record Sequence"
  },
  "(3008,0032)": {
    tag: "(3008,0032)",
    vr: "DS",
    vm: "1",
    name: "Specified Primary Meterset"
  },
  "(3008,0033)": {
    tag: "(3008,0033)",
    vr: "DS",
    vm: "1",
    name: "Specified Secondary Meterset"
  },
  "(3008,0036)": {
    tag: "(3008,0036)",
    vr: "DS",
    vm: "1",
    name: "Delivered Primary Meterset"
  },
  "(3008,0037)": {
    tag: "(3008,0037)",
    vr: "DS",
    vm: "1",
    name: "Delivered Secondary Meterset"
  },
  "(3008,003A)": {
    tag: "(3008,003A)",
    vr: "DS",
    vm: "1",
    name: "Specified Treatment Time"
  },
  "(3008,003B)": {
    tag: "(3008,003B)",
    vr: "DS",
    vm: "1",
    name: "Delivered Treatment Time"
  },
  "(3008,0040)": {
    tag: "(3008,0040)",
    vr: "SQ",
    vm: "1",
    name: "Control Point Delivery Sequence"
  },
  "(3008,0041)": {
    tag: "(3008,0041)",
    vr: "SQ",
    vm: "1",
    name: "Ion Control Point Delivery Sequence"
  },
  "(3008,0042)": {
    tag: "(3008,0042)",
    vr: "DS",
    vm: "1",
    name: "Specified Meterset"
  },
  "(3008,0044)": {
    tag: "(3008,0044)",
    vr: "DS",
    vm: "1",
    name: "Delivered Meterset"
  },
  "(3008,0045)": {
    tag: "(3008,0045)",
    vr: "FL",
    vm: "1",
    name: "Meterset Rate Set"
  },
  "(3008,0046)": {
    tag: "(3008,0046)",
    vr: "FL",
    vm: "1",
    name: "Meterset Rate Delivered"
  },
  "(3008,0047)": {
    tag: "(3008,0047)",
    vr: "FL",
    vm: "1",
    name: "Scan Spot Metersets Delivered"
  },
  "(3008,0048)": {
    tag: "(3008,0048)",
    vr: "DS",
    vm: "1",
    name: "Dose Rate Delivered"
  },
  "(3008,0050)": {
    tag: "(3008,0050)",
    vr: "SQ",
    vm: "1",
    name: "Treatment Summary Calculated Dose Reference Sequence"
  },
  "(3008,0052)": {
    tag: "(3008,0052)",
    vr: "DS",
    vm: "1",
    name: "Cumulative Dose To Dose Reference"
  },
  "(3008,0054)": {
    tag: "(3008,0054)",
    vr: "DA",
    vm: "1",
    name: "First Treatment Date"
  },
  "(3008,0056)": {
    tag: "(3008,0056)",
    vr: "DA",
    vm: "1",
    name: "Most Recent Treatment Date"
  },
  "(3008,005A)": {
    tag: "(3008,005A)",
    vr: "IS",
    vm: "1",
    name: "Number Of Fractions Delivered"
  },
  "(3008,0060)": {
    tag: "(3008,0060)",
    vr: "SQ",
    vm: "1",
    name: "Override Sequence"
  },
  "(3008,0061)": {
    tag: "(3008,0061)",
    vr: "AT",
    vm: "1",
    name: "Parameter Sequence Pointer"
  },
  "(3008,0062)": {
    tag: "(3008,0062)",
    vr: "AT",
    vm: "1",
    name: "Override Parameter Pointer"
  },
  "(3008,0063)": {
    tag: "(3008,0063)",
    vr: "IS",
    vm: "1",
    name: "Parameter Item Index"
  },
  "(3008,0064)": {
    tag: "(3008,0064)",
    vr: "IS",
    vm: "1",
    name: "Measured Dose Reference Number"
  },
  "(3008,0065)": {
    tag: "(3008,0065)",
    vr: "AT",
    vm: "1",
    name: "Parameter Pointer"
  },
  "(3008,0066)": {
    tag: "(3008,0066)",
    vr: "ST",
    vm: "1",
    name: "Override Reason"
  },
  "(3008,0068)": {
    tag: "(3008,0068)",
    vr: "SQ",
    vm: "1",
    name: "Corrected Parameter Sequence"
  },
  "(3008,006A)": {
    tag: "(3008,006A)",
    vr: "FL",
    vm: "1",
    name: "Correction Value"
  },
  "(3008,0070)": {
    tag: "(3008,0070)",
    vr: "SQ",
    vm: "1",
    name: "Calculated Dose Reference Sequence"
  },
  "(3008,0072)": {
    tag: "(3008,0072)",
    vr: "IS",
    vm: "1",
    name: "Calculated Dose Reference Number"
  },
  "(3008,0074)": {
    tag: "(3008,0074)",
    vr: "ST",
    vm: "1",
    name: "Calculated Dose Reference Description"
  },
  "(3008,0076)": {
    tag: "(3008,0076)",
    vr: "DS",
    vm: "1",
    name: "Calculated Dose Reference Dose Value"
  },
  "(3008,0078)": {
    tag: "(3008,0078)",
    vr: "DS",
    vm: "1",
    name: "Start Meterset"
  },
  "(3008,007A)": {
    tag: "(3008,007A)",
    vr: "DS",
    vm: "1",
    name: "End Meterset"
  },
  "(3008,0080)": {
    tag: "(3008,0080)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Measured Dose Reference Sequence"
  },
  "(3008,0082)": {
    tag: "(3008,0082)",
    vr: "IS",
    vm: "1",
    name: "Referenced Measured Dose Reference Number"
  },
  "(3008,0090)": {
    tag: "(3008,0090)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Calculated Dose Reference Sequence"
  },
  "(3008,0092)": {
    tag: "(3008,0092)",
    vr: "IS",
    vm: "1",
    name: "Referenced Calculated Dose Reference Number"
  },
  "(3008,00A0)": {
    tag: "(3008,00A0)",
    vr: "SQ",
    vm: "1",
    name: "Beam Limiting Device Leaf Pairs Sequence"
  },
  "(3008,00B0)": {
    tag: "(3008,00B0)",
    vr: "SQ",
    vm: "1",
    name: "Recorded Wedge Sequence"
  },
  "(3008,00C0)": {
    tag: "(3008,00C0)",
    vr: "SQ",
    vm: "1",
    name: "Recorded Compensator Sequence"
  },
  "(3008,00D0)": {
    tag: "(3008,00D0)",
    vr: "SQ",
    vm: "1",
    name: "Recorded Block Sequence"
  },
  "(3008,00E0)": {
    tag: "(3008,00E0)",
    vr: "SQ",
    vm: "1",
    name: "Treatment Summary Measured Dose Reference Sequence"
  },
  "(3008,00F0)": {
    tag: "(3008,00F0)",
    vr: "SQ",
    vm: "1",
    name: "Recorded Snout Sequence"
  },
  "(3008,00F2)": {
    tag: "(3008,00F2)",
    vr: "SQ",
    vm: "1",
    name: "Recorded Range Shifter Sequence"
  },
  "(3008,00F4)": {
    tag: "(3008,00F4)",
    vr: "SQ",
    vm: "1",
    name: "Recorded Lateral Spreading Device Sequence"
  },
  "(3008,00F6)": {
    tag: "(3008,00F6)",
    vr: "SQ",
    vm: "1",
    name: "Recorded Range Modulator Sequence"
  },
  "(3008,0100)": {
    tag: "(3008,0100)",
    vr: "SQ",
    vm: "1",
    name: "Recorded Source Sequence"
  },
  "(3008,0105)": {
    tag: "(3008,0105)",
    vr: "LO",
    vm: "1",
    name: "Source Serial Number"
  },
  "(3008,0110)": {
    tag: "(3008,0110)",
    vr: "SQ",
    vm: "1",
    name: "Treatment Session Application Setup Sequence"
  },
  "(3008,0116)": {
    tag: "(3008,0116)",
    vr: "CS",
    vm: "1",
    name: "Application Setup Check"
  },
  "(3008,0120)": {
    tag: "(3008,0120)",
    vr: "SQ",
    vm: "1",
    name: "Recorded Brachy Accessory Device Sequence"
  },
  "(3008,0122)": {
    tag: "(3008,0122)",
    vr: "IS",
    vm: "1",
    name: "Referenced Brachy Accessory Device Number"
  },
  "(3008,0130)": {
    tag: "(3008,0130)",
    vr: "SQ",
    vm: "1",
    name: "Recorded Channel Sequence"
  },
  "(3008,0132)": {
    tag: "(3008,0132)",
    vr: "DS",
    vm: "1",
    name: "Specified Channel Total Time"
  },
  "(3008,0134)": {
    tag: "(3008,0134)",
    vr: "DS",
    vm: "1",
    name: "Delivered Channel Total Time"
  },
  "(3008,0136)": {
    tag: "(3008,0136)",
    vr: "IS",
    vm: "1",
    name: "Specified Number Of Pulses"
  },
  "(3008,0138)": {
    tag: "(3008,0138)",
    vr: "IS",
    vm: "1",
    name: "Delivered Number Of Pulses"
  },
  "(3008,013A)": {
    tag: "(3008,013A)",
    vr: "DS",
    vm: "1",
    name: "Specified Pulse Repetition Interval"
  },
  "(3008,013C)": {
    tag: "(3008,013C)",
    vr: "DS",
    vm: "1",
    name: "Delivered Pulse Repetition Interval"
  },
  "(3008,0140)": {
    tag: "(3008,0140)",
    vr: "SQ",
    vm: "1",
    name: "Recorded Source Applicator Sequence"
  },
  "(3008,0142)": {
    tag: "(3008,0142)",
    vr: "IS",
    vm: "1",
    name: "Referenced Source Applicator Number"
  },
  "(3008,0150)": {
    tag: "(3008,0150)",
    vr: "SQ",
    vm: "1",
    name: "Recorded Channel Shield Sequence"
  },
  "(3008,0152)": {
    tag: "(3008,0152)",
    vr: "IS",
    vm: "1",
    name: "Referenced Channel Shield Number"
  },
  "(3008,0160)": {
    tag: "(3008,0160)",
    vr: "SQ",
    vm: "1",
    name: "Brachy Control Point Delivered Sequence"
  },
  "(3008,0162)": {
    tag: "(3008,0162)",
    vr: "DA",
    vm: "1",
    name: "Safe Position Exit Date"
  },
  "(3008,0164)": {
    tag: "(3008,0164)",
    vr: "TM",
    vm: "1",
    name: "Safe Position Exit Time"
  },
  "(3008,0166)": {
    tag: "(3008,0166)",
    vr: "DA",
    vm: "1",
    name: "Safe Position Return Date"
  },
  "(3008,0168)": {
    tag: "(3008,0168)",
    vr: "TM",
    vm: "1",
    name: "Safe Position Return Time"
  },
  "(3008,0200)": {
    tag: "(3008,0200)",
    vr: "CS",
    vm: "1",
    name: "Current Treatment Status"
  },
  "(3008,0202)": {
    tag: "(3008,0202)",
    vr: "ST",
    vm: "1",
    name: "Treatment Status Comment"
  },
  "(3008,0220)": {
    tag: "(3008,0220)",
    vr: "SQ",
    vm: "1",
    name: "Fraction Group Summary Sequence"
  },
  "(3008,0223)": {
    tag: "(3008,0223)",
    vr: "IS",
    vm: "1",
    name: "Referenced Fraction Number"
  },
  "(3008,0224)": {
    tag: "(3008,0224)",
    vr: "CS",
    vm: "1",
    name: "Fraction Group Type"
  },
  "(3008,0230)": {
    tag: "(3008,0230)",
    vr: "CS",
    vm: "1",
    name: "Beam Stopper Position"
  },
  "(3008,0240)": {
    tag: "(3008,0240)",
    vr: "SQ",
    vm: "1",
    name: "Fraction Status Summary Sequence"
  },
  "(3008,0250)": {
    tag: "(3008,0250)",
    vr: "DA",
    vm: "1",
    name: "Treatment Date"
  },
  "(3008,0251)": {
    tag: "(3008,0251)",
    vr: "TM",
    vm: "1",
    name: "Treatment Time"
  },
  "(300A,0002)": {
    tag: "(300A,0002)",
    vr: "SH",
    vm: "1",
    name: "RTPlan Label"
  },
  "(300A,0003)": { tag: "(300A,0003)", vr: "LO", vm: "1", name: "RTPlan Name" },
  "(300A,0004)": {
    tag: "(300A,0004)",
    vr: "ST",
    vm: "1",
    name: "RTPlan Description"
  },
  "(300A,0006)": { tag: "(300A,0006)", vr: "DA", vm: "1", name: "RTPlan Date" },
  "(300A,0007)": { tag: "(300A,0007)", vr: "TM", vm: "1", name: "RTPlan Time" },
  "(300A,0009)": {
    tag: "(300A,0009)",
    vr: "LO",
    vm: "1",
    name: "Treatment Protocols"
  },
  "(300A,000A)": { tag: "(300A,000A)", vr: "CS", vm: "1", name: "Plan Intent" },
  "(300A,000B)": {
    tag: "(300A,000B)",
    vr: "LO",
    vm: "1",
    name: "Treatment Sites"
  },
  "(300A,000C)": {
    tag: "(300A,000C)",
    vr: "CS",
    vm: "1",
    name: "RTPlan Geometry"
  },
  "(300A,000E)": {
    tag: "(300A,000E)",
    vr: "ST",
    vm: "1",
    name: "Prescription Description"
  },
  "(300A,0010)": {
    tag: "(300A,0010)",
    vr: "SQ",
    vm: "1",
    name: "Dose Reference Sequence"
  },
  "(300A,0012)": {
    tag: "(300A,0012)",
    vr: "IS",
    vm: "1",
    name: "Dose Reference Number"
  },
  "(300A,0013)": {
    tag: "(300A,0013)",
    vr: "UI",
    vm: "1",
    name: "Dose Reference UID"
  },
  "(300A,0014)": {
    tag: "(300A,0014)",
    vr: "CS",
    vm: "1",
    name: "Dose Reference Structure Type"
  },
  "(300A,0015)": {
    tag: "(300A,0015)",
    vr: "CS",
    vm: "1",
    name: "Nominal Beam Energy Unit"
  },
  "(300A,0016)": {
    tag: "(300A,0016)",
    vr: "LO",
    vm: "1",
    name: "Dose Reference Description"
  },
  "(300A,0018)": {
    tag: "(300A,0018)",
    vr: "DS",
    vm: "3",
    name: "Dose Reference Point Coordinates"
  },
  "(300A,001A)": {
    tag: "(300A,001A)",
    vr: "DS",
    vm: "1",
    name: "Nominal Prior Dose"
  },
  "(300A,0020)": {
    tag: "(300A,0020)",
    vr: "CS",
    vm: "1",
    name: "Dose Reference Type"
  },
  "(300A,0021)": {
    tag: "(300A,0021)",
    vr: "DS",
    vm: "1",
    name: "Constraint Weight"
  },
  "(300A,0022)": {
    tag: "(300A,0022)",
    vr: "DS",
    vm: "1",
    name: "Delivery Warning Dose"
  },
  "(300A,0023)": {
    tag: "(300A,0023)",
    vr: "DS",
    vm: "1",
    name: "Delivery Maximum Dose"
  },
  "(300A,0025)": {
    tag: "(300A,0025)",
    vr: "DS",
    vm: "1",
    name: "Target Minimum Dose"
  },
  "(300A,0026)": {
    tag: "(300A,0026)",
    vr: "DS",
    vm: "1",
    name: "Target Prescription Dose"
  },
  "(300A,0027)": {
    tag: "(300A,0027)",
    vr: "DS",
    vm: "1",
    name: "Target Maximum Dose"
  },
  "(300A,0028)": {
    tag: "(300A,0028)",
    vr: "DS",
    vm: "1",
    name: "Target Underdose Volume Fraction"
  },
  "(300A,002A)": {
    tag: "(300A,002A)",
    vr: "DS",
    vm: "1",
    name: "Organ At Risk Full Volume Dose"
  },
  "(300A,002B)": {
    tag: "(300A,002B)",
    vr: "DS",
    vm: "1",
    name: "Organ At Risk Limit Dose"
  },
  "(300A,002C)": {
    tag: "(300A,002C)",
    vr: "DS",
    vm: "1",
    name: "Organ At Risk Maximum Dose"
  },
  "(300A,002D)": {
    tag: "(300A,002D)",
    vr: "DS",
    vm: "1",
    name: "Organ At Risk Overdose Volume Fraction"
  },
  "(300A,0040)": {
    tag: "(300A,0040)",
    vr: "SQ",
    vm: "1",
    name: "Tolerance Table Sequence"
  },
  "(300A,0042)": {
    tag: "(300A,0042)",
    vr: "IS",
    vm: "1",
    name: "Tolerance Table Number"
  },
  "(300A,0043)": {
    tag: "(300A,0043)",
    vr: "SH",
    vm: "1",
    name: "Tolerance Table Label"
  },
  "(300A,0044)": {
    tag: "(300A,0044)",
    vr: "DS",
    vm: "1",
    name: "Gantry Angle Tolerance"
  },
  "(300A,0046)": {
    tag: "(300A,0046)",
    vr: "DS",
    vm: "1",
    name: "Beam Limiting Device Angle Tolerance"
  },
  "(300A,0048)": {
    tag: "(300A,0048)",
    vr: "SQ",
    vm: "1",
    name: "Beam Limiting Device Tolerance Sequence"
  },
  "(300A,004A)": {
    tag: "(300A,004A)",
    vr: "DS",
    vm: "1",
    name: "Beam Limiting Device Position Tolerance"
  },
  "(300A,004B)": {
    tag: "(300A,004B)",
    vr: "FL",
    vm: "1",
    name: "Snout Position Tolerance"
  },
  "(300A,004C)": {
    tag: "(300A,004C)",
    vr: "DS",
    vm: "1",
    name: "Patient Support Angle Tolerance"
  },
  "(300A,004E)": {
    tag: "(300A,004E)",
    vr: "DS",
    vm: "1",
    name: "Table Top Eccentric Angle Tolerance"
  },
  "(300A,004F)": {
    tag: "(300A,004F)",
    vr: "FL",
    vm: "1",
    name: "Table Top Pitch Angle Tolerance"
  },
  "(300A,0050)": {
    tag: "(300A,0050)",
    vr: "FL",
    vm: "1",
    name: "Table Top Roll Angle Tolerance"
  },
  "(300A,0051)": {
    tag: "(300A,0051)",
    vr: "DS",
    vm: "1",
    name: "Table Top Vertical Position Tolerance"
  },
  "(300A,0052)": {
    tag: "(300A,0052)",
    vr: "DS",
    vm: "1",
    name: "Table Top Longitudinal Position Tolerance"
  },
  "(300A,0053)": {
    tag: "(300A,0053)",
    vr: "DS",
    vm: "1",
    name: "Table Top Lateral Position Tolerance"
  },
  "(300A,0055)": {
    tag: "(300A,0055)",
    vr: "CS",
    vm: "1",
    name: "RTPlan Relationship"
  },
  "(300A,0070)": {
    tag: "(300A,0070)",
    vr: "SQ",
    vm: "1",
    name: "Fraction Group Sequence"
  },
  "(300A,0071)": {
    tag: "(300A,0071)",
    vr: "IS",
    vm: "1",
    name: "Fraction Group Number"
  },
  "(300A,0072)": {
    tag: "(300A,0072)",
    vr: "LO",
    vm: "1",
    name: "Fraction Group Description"
  },
  "(300A,0078)": {
    tag: "(300A,0078)",
    vr: "IS",
    vm: "1",
    name: "Number Of Fractions Planned"
  },
  "(300A,0079)": {
    tag: "(300A,0079)",
    vr: "IS",
    vm: "1",
    name: "Number Of Fraction Pattern Digits Per Day"
  },
  "(300A,007A)": {
    tag: "(300A,007A)",
    vr: "IS",
    vm: "1",
    name: "Repeat Fraction Cycle Length"
  },
  "(300A,007B)": {
    tag: "(300A,007B)",
    vr: "LT",
    vm: "1",
    name: "Fraction Pattern"
  },
  "(300A,0080)": {
    tag: "(300A,0080)",
    vr: "IS",
    vm: "1",
    name: "Number Of Beams"
  },
  "(300A,0082)": {
    tag: "(300A,0082)",
    vr: "DS",
    vm: "3",
    name: "Beam Dose Specification Point"
  },
  "(300A,0084)": { tag: "(300A,0084)", vr: "DS", vm: "1", name: "Beam Dose" },
  "(300A,0086)": {
    tag: "(300A,0086)",
    vr: "DS",
    vm: "1",
    name: "Beam Meterset"
  },
  "(300A,0088)": {
    tag: "(300A,0088)",
    vr: "FL",
    vm: "1",
    name: "Beam Dose Point Depth"
  },
  "(300A,0089)": {
    tag: "(300A,0089)",
    vr: "FL",
    vm: "1",
    name: "Beam Dose Point Equivalent Depth"
  },
  "(300A,008A)": {
    tag: "(300A,008A)",
    vr: "FL",
    vm: "1",
    name: "Beam Dose Point SSD"
  },
  "(300A,00A0)": {
    tag: "(300A,00A0)",
    vr: "IS",
    vm: "1",
    name: "Number Of Brachy Application Setups"
  },
  "(300A,00A2)": {
    tag: "(300A,00A2)",
    vr: "DS",
    vm: "3",
    name: "Brachy Application Setup Dose Specification Point"
  },
  "(300A,00A4)": {
    tag: "(300A,00A4)",
    vr: "DS",
    vm: "1",
    name: "Brachy Application Setup Dose"
  },
  "(300A,00B0)": {
    tag: "(300A,00B0)",
    vr: "SQ",
    vm: "1",
    name: "Beam Sequence"
  },
  "(300A,00B2)": {
    tag: "(300A,00B2)",
    vr: "SH",
    vm: "1",
    name: "Treatment Machine Name"
  },
  "(300A,00B3)": {
    tag: "(300A,00B3)",
    vr: "CS",
    vm: "1",
    name: "Primary Dosimeter Unit"
  },
  "(300A,00B4)": {
    tag: "(300A,00B4)",
    vr: "DS",
    vm: "1",
    name: "Source Axis Distance"
  },
  "(300A,00B6)": {
    tag: "(300A,00B6)",
    vr: "SQ",
    vm: "1",
    name: "Beam Limiting Device Sequence"
  },
  "(300A,00B8)": {
    tag: "(300A,00B8)",
    vr: "CS",
    vm: "1",
    name: "RTBeam Limiting Device Type"
  },
  "(300A,00BA)": {
    tag: "(300A,00BA)",
    vr: "DS",
    vm: "1",
    name: "Source To Beam Limiting Device Distance"
  },
  "(300A,00BB)": {
    tag: "(300A,00BB)",
    vr: "FL",
    vm: "1",
    name: "Isocenter To Beam Limiting Device Distance"
  },
  "(300A,00BC)": {
    tag: "(300A,00BC)",
    vr: "IS",
    vm: "1",
    name: "Number Of Leaf Jaw Pairs"
  },
  "(300A,00BE)": {
    tag: "(300A,00BE)",
    vr: "DS",
    vm: "3",
    name: "Leaf Position Boundaries"
  },
  "(300A,00C0)": { tag: "(300A,00C0)", vr: "IS", vm: "1", name: "Beam Number" },
  "(300A,00C2)": { tag: "(300A,00C2)", vr: "LO", vm: "1", name: "Beam Name" },
  "(300A,00C3)": {
    tag: "(300A,00C3)",
    vr: "ST",
    vm: "1",
    name: "Beam Description"
  },
  "(300A,00C4)": { tag: "(300A,00C4)", vr: "CS", vm: "1", name: "Beam Type" },
  "(300A,00C6)": {
    tag: "(300A,00C6)",
    vr: "CS",
    vm: "1",
    name: "Radiation Type"
  },
  "(300A,00C7)": {
    tag: "(300A,00C7)",
    vr: "CS",
    vm: "1",
    name: "High Dose Technique Type"
  },
  "(300A,00C8)": {
    tag: "(300A,00C8)",
    vr: "IS",
    vm: "1",
    name: "Reference Image Number"
  },
  "(300A,00CA)": {
    tag: "(300A,00CA)",
    vr: "SQ",
    vm: "1",
    name: "Planned Verification Image Sequence"
  },
  "(300A,00CC)": {
    tag: "(300A,00CC)",
    vr: "LO",
    vm: "1",
    name: "Imaging Device Specific Acquisition Parameters"
  },
  "(300A,00CE)": {
    tag: "(300A,00CE)",
    vr: "CS",
    vm: "1",
    name: "Treatment Delivery Type"
  },
  "(300A,00D0)": {
    tag: "(300A,00D0)",
    vr: "IS",
    vm: "1",
    name: "Number Of Wedges"
  },
  "(300A,00D1)": {
    tag: "(300A,00D1)",
    vr: "SQ",
    vm: "1",
    name: "Wedge Sequence"
  },
  "(300A,00D2)": {
    tag: "(300A,00D2)",
    vr: "IS",
    vm: "1",
    name: "Wedge Number"
  },
  "(300A,00D3)": { tag: "(300A,00D3)", vr: "CS", vm: "1", name: "Wedge Type" },
  "(300A,00D4)": { tag: "(300A,00D4)", vr: "SH", vm: "1", name: "Wedge ID" },
  "(300A,00D5)": { tag: "(300A,00D5)", vr: "IS", vm: "1", name: "Wedge Angle" },
  "(300A,00D6)": {
    tag: "(300A,00D6)",
    vr: "DS",
    vm: "1",
    name: "Wedge Factor"
  },
  "(300A,00D7)": {
    tag: "(300A,00D7)",
    vr: "FL",
    vm: "1",
    name: "Total Wedge Tray Water Equivalent Thickness"
  },
  "(300A,00D8)": {
    tag: "(300A,00D8)",
    vr: "DS",
    vm: "1",
    name: "Wedge Orientation"
  },
  "(300A,00D9)": {
    tag: "(300A,00D9)",
    vr: "FL",
    vm: "1",
    name: "Isocenter To Wedge Tray Distance"
  },
  "(300A,00DA)": {
    tag: "(300A,00DA)",
    vr: "DS",
    vm: "1",
    name: "Source To Wedge Tray Distance"
  },
  "(300A,00DB)": {
    tag: "(300A,00DB)",
    vr: "FL",
    vm: "1",
    name: "Wedge Thin Edge Position"
  },
  "(300A,00DC)": { tag: "(300A,00DC)", vr: "SH", vm: "1", name: "Bolus ID" },
  "(300A,00DD)": {
    tag: "(300A,00DD)",
    vr: "ST",
    vm: "1",
    name: "Bolus Description"
  },
  "(300A,00E0)": {
    tag: "(300A,00E0)",
    vr: "IS",
    vm: "1",
    name: "Number Of Compensators"
  },
  "(300A,00E1)": { tag: "(300A,00E1)", vr: "SH", vm: "1", name: "Material ID" },
  "(300A,00E2)": {
    tag: "(300A,00E2)",
    vr: "DS",
    vm: "1",
    name: "Total Compensator Tray Factor"
  },
  "(300A,00E3)": {
    tag: "(300A,00E3)",
    vr: "SQ",
    vm: "1",
    name: "Compensator Sequence"
  },
  "(300A,00E4)": {
    tag: "(300A,00E4)",
    vr: "IS",
    vm: "1",
    name: "Compensator Number"
  },
  "(300A,00E5)": {
    tag: "(300A,00E5)",
    vr: "SH",
    vm: "1",
    name: "Compensator ID"
  },
  "(300A,00E6)": {
    tag: "(300A,00E6)",
    vr: "DS",
    vm: "1",
    name: "Source To Compensator Tray Distance"
  },
  "(300A,00E7)": {
    tag: "(300A,00E7)",
    vr: "IS",
    vm: "1",
    name: "Compensator Rows"
  },
  "(300A,00E8)": {
    tag: "(300A,00E8)",
    vr: "IS",
    vm: "1",
    name: "Compensator Columns"
  },
  "(300A,00E9)": {
    tag: "(300A,00E9)",
    vr: "DS",
    vm: "2",
    name: "Compensator Pixel Spacing"
  },
  "(300A,00EA)": {
    tag: "(300A,00EA)",
    vr: "DS",
    vm: "2",
    name: "Compensator Position"
  },
  "(300A,00EB)": {
    tag: "(300A,00EB)",
    vr: "DS",
    vm: "1",
    name: "Compensator Transmission Data"
  },
  "(300A,00EC)": {
    tag: "(300A,00EC)",
    vr: "DS",
    vm: "1",
    name: "Compensator Thickness Data"
  },
  "(300A,00ED)": {
    tag: "(300A,00ED)",
    vr: "IS",
    vm: "1",
    name: "Number Of Boli"
  },
  "(300A,00EE)": {
    tag: "(300A,00EE)",
    vr: "CS",
    vm: "1",
    name: "Compensator Type"
  },
  "(300A,00F0)": {
    tag: "(300A,00F0)",
    vr: "IS",
    vm: "1",
    name: "Number Of Blocks"
  },
  "(300A,00F2)": {
    tag: "(300A,00F2)",
    vr: "DS",
    vm: "1",
    name: "Total Block Tray Factor"
  },
  "(300A,00F3)": {
    tag: "(300A,00F3)",
    vr: "FL",
    vm: "1",
    name: "Total Block Tray Water Equivalent Thickness"
  },
  "(300A,00F4)": {
    tag: "(300A,00F4)",
    vr: "SQ",
    vm: "1",
    name: "Block Sequence"
  },
  "(300A,00F5)": {
    tag: "(300A,00F5)",
    vr: "SH",
    vm: "1",
    name: "Block Tray ID"
  },
  "(300A,00F6)": {
    tag: "(300A,00F6)",
    vr: "DS",
    vm: "1",
    name: "Source To Block Tray Distance"
  },
  "(300A,00F7)": {
    tag: "(300A,00F7)",
    vr: "FL",
    vm: "1",
    name: "Isocenter To Block Tray Distance"
  },
  "(300A,00F8)": { tag: "(300A,00F8)", vr: "CS", vm: "1", name: "Block Type" },
  "(300A,00F9)": {
    tag: "(300A,00F9)",
    vr: "LO",
    vm: "1",
    name: "Accessory Code"
  },
  "(300A,00FA)": {
    tag: "(300A,00FA)",
    vr: "CS",
    vm: "1",
    name: "Block Divergence"
  },
  "(300A,00FB)": {
    tag: "(300A,00FB)",
    vr: "CS",
    vm: "1",
    name: "Block Mounting Position"
  },
  "(300A,00FC)": {
    tag: "(300A,00FC)",
    vr: "IS",
    vm: "1",
    name: "Block Number"
  },
  "(300A,00FE)": { tag: "(300A,00FE)", vr: "LO", vm: "1", name: "Block Name" },
  "(300A,0100)": {
    tag: "(300A,0100)",
    vr: "DS",
    vm: "1",
    name: "Block Thickness"
  },
  "(300A,0102)": {
    tag: "(300A,0102)",
    vr: "DS",
    vm: "1",
    name: "Block Transmission"
  },
  "(300A,0104)": {
    tag: "(300A,0104)",
    vr: "IS",
    vm: "1",
    name: "Block Number Of Points"
  },
  "(300A,0106)": {
    tag: "(300A,0106)",
    vr: "DS",
    vm: "2-2n",
    name: "Block Data"
  },
  "(300A,0107)": {
    tag: "(300A,0107)",
    vr: "SQ",
    vm: "1",
    name: "Applicator Sequence"
  },
  "(300A,0108)": {
    tag: "(300A,0108)",
    vr: "SH",
    vm: "1",
    name: "Applicator ID"
  },
  "(300A,0109)": {
    tag: "(300A,0109)",
    vr: "CS",
    vm: "1",
    name: "Applicator Type"
  },
  "(300A,010A)": {
    tag: "(300A,010A)",
    vr: "LO",
    vm: "1",
    name: "Applicator Description"
  },
  "(300A,010C)": {
    tag: "(300A,010C)",
    vr: "DS",
    vm: "1",
    name: "Cumulative Dose Reference Coefficient"
  },
  "(300A,010E)": {
    tag: "(300A,010E)",
    vr: "DS",
    vm: "1",
    name: "Final Cumulative Meterset Weight"
  },
  "(300A,0110)": {
    tag: "(300A,0110)",
    vr: "IS",
    vm: "1",
    name: "Number Of Control Points"
  },
  "(300A,0111)": {
    tag: "(300A,0111)",
    vr: "SQ",
    vm: "1",
    name: "Control Point Sequence"
  },
  "(300A,0112)": {
    tag: "(300A,0112)",
    vr: "IS",
    vm: "1",
    name: "Control Point Index"
  },
  "(300A,0114)": {
    tag: "(300A,0114)",
    vr: "DS",
    vm: "1",
    name: "Nominal Beam Energy"
  },
  "(300A,0115)": {
    tag: "(300A,0115)",
    vr: "DS",
    vm: "1",
    name: "Dose Rate Set"
  },
  "(300A,0116)": {
    tag: "(300A,0116)",
    vr: "SQ",
    vm: "1",
    name: "Wedge Position Sequence"
  },
  "(300A,0118)": {
    tag: "(300A,0118)",
    vr: "CS",
    vm: "1",
    name: "Wedge Position"
  },
  "(300A,011A)": {
    tag: "(300A,011A)",
    vr: "SQ",
    vm: "1",
    name: "Beam Limiting Device Position Sequence"
  },
  "(300A,011C)": {
    tag: "(300A,011C)",
    vr: "DS",
    vm: "2-2n",
    name: "Leaf Jaw Positions"
  },
  "(300A,011E)": {
    tag: "(300A,011E)",
    vr: "DS",
    vm: "1",
    name: "Gantry Angle"
  },
  "(300A,011F)": {
    tag: "(300A,011F)",
    vr: "CS",
    vm: "1",
    name: "Gantry Rotation Direction"
  },
  "(300A,0120)": {
    tag: "(300A,0120)",
    vr: "DS",
    vm: "1",
    name: "Beam Limiting Device Angle"
  },
  "(300A,0121)": {
    tag: "(300A,0121)",
    vr: "CS",
    vm: "1",
    name: "Beam Limiting Device Rotation Direction"
  },
  "(300A,0122)": {
    tag: "(300A,0122)",
    vr: "DS",
    vm: "1",
    name: "Patient Support Angle"
  },
  "(300A,0123)": {
    tag: "(300A,0123)",
    vr: "CS",
    vm: "1",
    name: "Patient Support Rotation Direction"
  },
  "(300A,0124)": {
    tag: "(300A,0124)",
    vr: "DS",
    vm: "1",
    name: "Table Top Eccentric Axis Distance"
  },
  "(300A,0125)": {
    tag: "(300A,0125)",
    vr: "DS",
    vm: "1",
    name: "Table Top Eccentric Angle"
  },
  "(300A,0126)": {
    tag: "(300A,0126)",
    vr: "CS",
    vm: "1",
    name: "Table Top Eccentric Rotation Direction"
  },
  "(300A,0128)": {
    tag: "(300A,0128)",
    vr: "DS",
    vm: "1",
    name: "Table Top Vertical Position"
  },
  "(300A,0129)": {
    tag: "(300A,0129)",
    vr: "DS",
    vm: "1",
    name: "Table Top Longitudinal Position"
  },
  "(300A,012A)": {
    tag: "(300A,012A)",
    vr: "DS",
    vm: "1",
    name: "Table Top Lateral Position"
  },
  "(300A,012C)": {
    tag: "(300A,012C)",
    vr: "DS",
    vm: "3",
    name: "Isocenter Position"
  },
  "(300A,012E)": {
    tag: "(300A,012E)",
    vr: "DS",
    vm: "3",
    name: "Surface Entry Point"
  },
  "(300A,0130)": {
    tag: "(300A,0130)",
    vr: "DS",
    vm: "1",
    name: "Source To Surface Distance"
  },
  "(300A,0134)": {
    tag: "(300A,0134)",
    vr: "DS",
    vm: "1",
    name: "Cumulative Meterset Weight"
  },
  "(300A,0140)": {
    tag: "(300A,0140)",
    vr: "FL",
    vm: "1",
    name: "Table Top Pitch Angle"
  },
  "(300A,0142)": {
    tag: "(300A,0142)",
    vr: "CS",
    vm: "1",
    name: "Table Top Pitch Rotation Direction"
  },
  "(300A,0144)": {
    tag: "(300A,0144)",
    vr: "FL",
    vm: "1",
    name: "Table Top Roll Angle"
  },
  "(300A,0146)": {
    tag: "(300A,0146)",
    vr: "CS",
    vm: "1",
    name: "Table Top Roll Rotation Direction"
  },
  "(300A,0148)": {
    tag: "(300A,0148)",
    vr: "FL",
    vm: "1",
    name: "Head Fixation Angle"
  },
  "(300A,014A)": {
    tag: "(300A,014A)",
    vr: "FL",
    vm: "1",
    name: "Gantry Pitch Angle"
  },
  "(300A,014C)": {
    tag: "(300A,014C)",
    vr: "CS",
    vm: "1",
    name: "Gantry Pitch Rotation Direction"
  },
  "(300A,014E)": {
    tag: "(300A,014E)",
    vr: "FL",
    vm: "1",
    name: "Gantry Pitch Angle Tolerance"
  },
  "(300A,0180)": {
    tag: "(300A,0180)",
    vr: "SQ",
    vm: "1",
    name: "Patient Setup Sequence"
  },
  "(300A,0182)": {
    tag: "(300A,0182)",
    vr: "IS",
    vm: "1",
    name: "Patient Setup Number"
  },
  "(300A,0183)": {
    tag: "(300A,0183)",
    vr: "LO",
    vm: "1",
    name: "Patient Setup Label"
  },
  "(300A,0184)": {
    tag: "(300A,0184)",
    vr: "LO",
    vm: "1",
    name: "Patient Additional Position"
  },
  "(300A,0190)": {
    tag: "(300A,0190)",
    vr: "SQ",
    vm: "1",
    name: "Fixation Device Sequence"
  },
  "(300A,0192)": {
    tag: "(300A,0192)",
    vr: "CS",
    vm: "1",
    name: "Fixation Device Type"
  },
  "(300A,0194)": {
    tag: "(300A,0194)",
    vr: "SH",
    vm: "1",
    name: "Fixation Device Label"
  },
  "(300A,0196)": {
    tag: "(300A,0196)",
    vr: "ST",
    vm: "1",
    name: "Fixation Device Description"
  },
  "(300A,0198)": {
    tag: "(300A,0198)",
    vr: "SH",
    vm: "1",
    name: "Fixation Device Position"
  },
  "(300A,0199)": {
    tag: "(300A,0199)",
    vr: "FL",
    vm: "1",
    name: "Fixation Device Pitch Angle"
  },
  "(300A,019A)": {
    tag: "(300A,019A)",
    vr: "FL",
    vm: "1",
    name: "Fixation Device Roll Angle"
  },
  "(300A,01A0)": {
    tag: "(300A,01A0)",
    vr: "SQ",
    vm: "1",
    name: "Shielding Device Sequence"
  },
  "(300A,01A2)": {
    tag: "(300A,01A2)",
    vr: "CS",
    vm: "1",
    name: "Shielding Device Type"
  },
  "(300A,01A4)": {
    tag: "(300A,01A4)",
    vr: "SH",
    vm: "1",
    name: "Shielding Device Label"
  },
  "(300A,01A6)": {
    tag: "(300A,01A6)",
    vr: "ST",
    vm: "1",
    name: "Shielding Device Description"
  },
  "(300A,01A8)": {
    tag: "(300A,01A8)",
    vr: "SH",
    vm: "1",
    name: "Shielding Device Position"
  },
  "(300A,01B0)": {
    tag: "(300A,01B0)",
    vr: "CS",
    vm: "1",
    name: "Setup Technique"
  },
  "(300A,01B2)": {
    tag: "(300A,01B2)",
    vr: "ST",
    vm: "1",
    name: "Setup Technique Description"
  },
  "(300A,01B4)": {
    tag: "(300A,01B4)",
    vr: "SQ",
    vm: "1",
    name: "Setup Device Sequence"
  },
  "(300A,01B6)": {
    tag: "(300A,01B6)",
    vr: "CS",
    vm: "1",
    name: "Setup Device Type"
  },
  "(300A,01B8)": {
    tag: "(300A,01B8)",
    vr: "SH",
    vm: "1",
    name: "Setup Device Label"
  },
  "(300A,01BA)": {
    tag: "(300A,01BA)",
    vr: "ST",
    vm: "1",
    name: "Setup Device Description"
  },
  "(300A,01BC)": {
    tag: "(300A,01BC)",
    vr: "DS",
    vm: "1",
    name: "Setup Device Parameter"
  },
  "(300A,01D0)": {
    tag: "(300A,01D0)",
    vr: "ST",
    vm: "1",
    name: "Setup Reference Description"
  },
  "(300A,01D2)": {
    tag: "(300A,01D2)",
    vr: "DS",
    vm: "1",
    name: "Table Top Vertical Setup Displacement"
  },
  "(300A,01D4)": {
    tag: "(300A,01D4)",
    vr: "DS",
    vm: "1",
    name: "Table Top Longitudinal Setup Displacement"
  },
  "(300A,01D6)": {
    tag: "(300A,01D6)",
    vr: "DS",
    vm: "1",
    name: "Table Top Lateral Setup Displacement"
  },
  "(300A,0200)": {
    tag: "(300A,0200)",
    vr: "CS",
    vm: "1",
    name: "Brachy Treatment Technique"
  },
  "(300A,0202)": {
    tag: "(300A,0202)",
    vr: "CS",
    vm: "1",
    name: "Brachy Treatment Type"
  },
  "(300A,0206)": {
    tag: "(300A,0206)",
    vr: "SQ",
    vm: "1",
    name: "Treatment Machine Sequence"
  },
  "(300A,0210)": {
    tag: "(300A,0210)",
    vr: "SQ",
    vm: "1",
    name: "Source Sequence"
  },
  "(300A,0212)": {
    tag: "(300A,0212)",
    vr: "IS",
    vm: "1",
    name: "Source Number"
  },
  "(300A,0214)": { tag: "(300A,0214)", vr: "CS", vm: "1", name: "Source Type" },
  "(300A,0216)": {
    tag: "(300A,0216)",
    vr: "LO",
    vm: "1",
    name: "Source Manufacturer"
  },
  "(300A,0218)": {
    tag: "(300A,0218)",
    vr: "DS",
    vm: "1",
    name: "Active Source Diameter"
  },
  "(300A,021A)": {
    tag: "(300A,021A)",
    vr: "DS",
    vm: "1",
    name: "Active Source Length"
  },
  "(300A,0222)": {
    tag: "(300A,0222)",
    vr: "DS",
    vm: "1",
    name: "Source Encapsulation Nominal Thickness"
  },
  "(300A,0224)": {
    tag: "(300A,0224)",
    vr: "DS",
    vm: "1",
    name: "Source Encapsulation Nominal Transmission"
  },
  "(300A,0226)": {
    tag: "(300A,0226)",
    vr: "LO",
    vm: "1",
    name: "Source Isotope Name"
  },
  "(300A,0228)": {
    tag: "(300A,0228)",
    vr: "DS",
    vm: "1",
    name: "Source Isotope Half Life"
  },
  "(300A,0229)": {
    tag: "(300A,0229)",
    vr: "CS",
    vm: "1",
    name: "Source Strength Units"
  },
  "(300A,022A)": {
    tag: "(300A,022A)",
    vr: "DS",
    vm: "1",
    name: "Reference Air Kerma Rate"
  },
  "(300A,022B)": {
    tag: "(300A,022B)",
    vr: "DS",
    vm: "1",
    name: "Source Strength"
  },
  "(300A,022C)": {
    tag: "(300A,022C)",
    vr: "DA",
    vm: "1",
    name: "Source Strength Reference Date"
  },
  "(300A,022E)": {
    tag: "(300A,022E)",
    vr: "TM",
    vm: "1",
    name: "Source Strength Reference Time"
  },
  "(300A,0230)": {
    tag: "(300A,0230)",
    vr: "SQ",
    vm: "1",
    name: "Application Setup Sequence"
  },
  "(300A,0232)": {
    tag: "(300A,0232)",
    vr: "CS",
    vm: "1",
    name: "Application Setup Type"
  },
  "(300A,0234)": {
    tag: "(300A,0234)",
    vr: "IS",
    vm: "1",
    name: "Application Setup Number"
  },
  "(300A,0236)": {
    tag: "(300A,0236)",
    vr: "LO",
    vm: "1",
    name: "Application Setup Name"
  },
  "(300A,0238)": {
    tag: "(300A,0238)",
    vr: "LO",
    vm: "1",
    name: "Application Setup Manufacturer"
  },
  "(300A,0240)": {
    tag: "(300A,0240)",
    vr: "IS",
    vm: "1",
    name: "Template Number"
  },
  "(300A,0242)": {
    tag: "(300A,0242)",
    vr: "SH",
    vm: "1",
    name: "Template Type"
  },
  "(300A,0244)": {
    tag: "(300A,0244)",
    vr: "LO",
    vm: "1",
    name: "Template Name"
  },
  "(300A,0250)": {
    tag: "(300A,0250)",
    vr: "DS",
    vm: "1",
    name: "Total Reference Air Kerma"
  },
  "(300A,0260)": {
    tag: "(300A,0260)",
    vr: "SQ",
    vm: "1",
    name: "Brachy Accessory Device Sequence"
  },
  "(300A,0262)": {
    tag: "(300A,0262)",
    vr: "IS",
    vm: "1",
    name: "Brachy Accessory Device Number"
  },
  "(300A,0263)": {
    tag: "(300A,0263)",
    vr: "SH",
    vm: "1",
    name: "Brachy Accessory Device ID"
  },
  "(300A,0264)": {
    tag: "(300A,0264)",
    vr: "CS",
    vm: "1",
    name: "Brachy Accessory Device Type"
  },
  "(300A,0266)": {
    tag: "(300A,0266)",
    vr: "LO",
    vm: "1",
    name: "Brachy Accessory Device Name"
  },
  "(300A,026A)": {
    tag: "(300A,026A)",
    vr: "DS",
    vm: "1",
    name: "Brachy Accessory Device Nominal Thickness"
  },
  "(300A,026C)": {
    tag: "(300A,026C)",
    vr: "DS",
    vm: "1",
    name: "Brachy Accessory Device Nominal Transmission"
  },
  "(300A,0280)": {
    tag: "(300A,0280)",
    vr: "SQ",
    vm: "1",
    name: "Channel Sequence"
  },
  "(300A,0282)": {
    tag: "(300A,0282)",
    vr: "IS",
    vm: "1",
    name: "Channel Number"
  },
  "(300A,0284)": {
    tag: "(300A,0284)",
    vr: "DS",
    vm: "1",
    name: "Channel Length"
  },
  "(300A,0286)": {
    tag: "(300A,0286)",
    vr: "DS",
    vm: "1",
    name: "Channel Total Time"
  },
  "(300A,0288)": {
    tag: "(300A,0288)",
    vr: "CS",
    vm: "1",
    name: "Source Movement Type"
  },
  "(300A,028A)": {
    tag: "(300A,028A)",
    vr: "IS",
    vm: "1",
    name: "Number Of Pulses"
  },
  "(300A,028C)": {
    tag: "(300A,028C)",
    vr: "DS",
    vm: "1",
    name: "Pulse Repetition Interval"
  },
  "(300A,0290)": {
    tag: "(300A,0290)",
    vr: "IS",
    vm: "1",
    name: "Source Applicator Number"
  },
  "(300A,0291)": {
    tag: "(300A,0291)",
    vr: "SH",
    vm: "1",
    name: "Source Applicator ID"
  },
  "(300A,0292)": {
    tag: "(300A,0292)",
    vr: "CS",
    vm: "1",
    name: "Source Applicator Type"
  },
  "(300A,0294)": {
    tag: "(300A,0294)",
    vr: "LO",
    vm: "1",
    name: "Source Applicator Name"
  },
  "(300A,0296)": {
    tag: "(300A,0296)",
    vr: "DS",
    vm: "1",
    name: "Source Applicator Length"
  },
  "(300A,0298)": {
    tag: "(300A,0298)",
    vr: "LO",
    vm: "1",
    name: "Source Applicator Manufacturer"
  },
  "(300A,029C)": {
    tag: "(300A,029C)",
    vr: "DS",
    vm: "1",
    name: "Source Applicator Wall Nominal Thickness"
  },
  "(300A,029E)": {
    tag: "(300A,029E)",
    vr: "DS",
    vm: "1",
    name: "Source Applicator Wall Nominal Transmission"
  },
  "(300A,02A0)": {
    tag: "(300A,02A0)",
    vr: "DS",
    vm: "1",
    name: "Source Applicator Step Size"
  },
  "(300A,02A2)": {
    tag: "(300A,02A2)",
    vr: "IS",
    vm: "1",
    name: "Transfer Tube Number"
  },
  "(300A,02A4)": {
    tag: "(300A,02A4)",
    vr: "DS",
    vm: "1",
    name: "Transfer Tube Length"
  },
  "(300A,02B0)": {
    tag: "(300A,02B0)",
    vr: "SQ",
    vm: "1",
    name: "Channel Shield Sequence"
  },
  "(300A,02B2)": {
    tag: "(300A,02B2)",
    vr: "IS",
    vm: "1",
    name: "Channel Shield Number"
  },
  "(300A,02B3)": {
    tag: "(300A,02B3)",
    vr: "SH",
    vm: "1",
    name: "Channel Shield ID"
  },
  "(300A,02B4)": {
    tag: "(300A,02B4)",
    vr: "LO",
    vm: "1",
    name: "Channel Shield Name"
  },
  "(300A,02B8)": {
    tag: "(300A,02B8)",
    vr: "DS",
    vm: "1",
    name: "Channel Shield Nominal Thickness"
  },
  "(300A,02BA)": {
    tag: "(300A,02BA)",
    vr: "DS",
    vm: "1",
    name: "Channel Shield Nominal Transmission"
  },
  "(300A,02C8)": {
    tag: "(300A,02C8)",
    vr: "DS",
    vm: "1",
    name: "Final Cumulative Time Weight"
  },
  "(300A,02D0)": {
    tag: "(300A,02D0)",
    vr: "SQ",
    vm: "1",
    name: "Brachy Control Point Sequence"
  },
  "(300A,02D2)": {
    tag: "(300A,02D2)",
    vr: "DS",
    vm: "1",
    name: "Control Point Relative Position"
  },
  "(300A,02D4)": {
    tag: "(300A,02D4)",
    vr: "DS",
    vm: "3",
    name: "Control Point3DPosition"
  },
  "(300A,02D6)": {
    tag: "(300A,02D6)",
    vr: "DS",
    vm: "1",
    name: "Cumulative Time Weight"
  },
  "(300A,02E0)": {
    tag: "(300A,02E0)",
    vr: "CS",
    vm: "1",
    name: "Compensator Divergence"
  },
  "(300A,02E1)": {
    tag: "(300A,02E1)",
    vr: "CS",
    vm: "1",
    name: "Compensator Mounting Position"
  },
  "(300A,02E2)": {
    tag: "(300A,02E2)",
    vr: "DS",
    vm: "1",
    name: "Source To Compensator Distance"
  },
  "(300A,02E3)": {
    tag: "(300A,02E3)",
    vr: "FL",
    vm: "1",
    name: "Total Compensator Tray Water Equivalent Thickness"
  },
  "(300A,02E4)": {
    tag: "(300A,02E4)",
    vr: "FL",
    vm: "1",
    name: "Isocenter To Compensator Tray Distance"
  },
  "(300A,02E5)": {
    tag: "(300A,02E5)",
    vr: "FL",
    vm: "1",
    name: "Compensator Column Offset"
  },
  "(300A,02E6)": {
    tag: "(300A,02E6)",
    vr: "FL",
    vm: "1",
    name: "Isocenter To Compensator Distances"
  },
  "(300A,02E7)": {
    tag: "(300A,02E7)",
    vr: "FL",
    vm: "1",
    name: "Compensator Relative Stopping Power Ratio"
  },
  "(300A,02E8)": {
    tag: "(300A,02E8)",
    vr: "FL",
    vm: "1",
    name: "Compensator Milling Tool Diameter"
  },
  "(300A,02EA)": {
    tag: "(300A,02EA)",
    vr: "SQ",
    vm: "1",
    name: "Ion Range Compensator Sequence"
  },
  "(300A,02EB)": {
    tag: "(300A,02EB)",
    vr: "LT",
    vm: "1",
    name: "Compensator Description"
  },
  "(300A,0302)": {
    tag: "(300A,0302)",
    vr: "IS",
    vm: "1",
    name: "Radiation Mass Number"
  },
  "(300A,0304)": {
    tag: "(300A,0304)",
    vr: "IS",
    vm: "1",
    name: "Radiation Atomic Number"
  },
  "(300A,0306)": {
    tag: "(300A,0306)",
    vr: "SS",
    vm: "1",
    name: "Radiation Charge State"
  },
  "(300A,0308)": { tag: "(300A,0308)", vr: "CS", vm: "1", name: "Scan Mode" },
  "(300A,030A)": {
    tag: "(300A,030A)",
    vr: "FL",
    vm: "2",
    name: "Virtual Source Axis Distances"
  },
  "(300A,030C)": {
    tag: "(300A,030C)",
    vr: "SQ",
    vm: "1",
    name: "Snout Sequence"
  },
  "(300A,030D)": {
    tag: "(300A,030D)",
    vr: "FL",
    vm: "1",
    name: "Snout Position"
  },
  "(300A,030F)": { tag: "(300A,030F)", vr: "SH", vm: "1", name: "Snout ID" },
  "(300A,0312)": {
    tag: "(300A,0312)",
    vr: "IS",
    vm: "1",
    name: "Number Of Range Shifters"
  },
  "(300A,0314)": {
    tag: "(300A,0314)",
    vr: "SQ",
    vm: "1",
    name: "Range Shifter Sequence"
  },
  "(300A,0316)": {
    tag: "(300A,0316)",
    vr: "IS",
    vm: "1",
    name: "Range Shifter Number"
  },
  "(300A,0318)": {
    tag: "(300A,0318)",
    vr: "SH",
    vm: "1",
    name: "Range Shifter ID"
  },
  "(300A,0320)": {
    tag: "(300A,0320)",
    vr: "CS",
    vm: "1",
    name: "Range Shifter Type"
  },
  "(300A,0322)": {
    tag: "(300A,0322)",
    vr: "LO",
    vm: "1",
    name: "Range Shifter Description"
  },
  "(300A,0330)": {
    tag: "(300A,0330)",
    vr: "IS",
    vm: "1",
    name: "Number Of Lateral Spreading Devices"
  },
  "(300A,0332)": {
    tag: "(300A,0332)",
    vr: "SQ",
    vm: "1",
    name: "Lateral Spreading Device Sequence"
  },
  "(300A,0334)": {
    tag: "(300A,0334)",
    vr: "IS",
    vm: "1",
    name: "Lateral Spreading Device Number"
  },
  "(300A,0336)": {
    tag: "(300A,0336)",
    vr: "SH",
    vm: "1",
    name: "Lateral Spreading Device ID"
  },
  "(300A,0338)": {
    tag: "(300A,0338)",
    vr: "CS",
    vm: "1",
    name: "Lateral Spreading Device Type"
  },
  "(300A,033A)": {
    tag: "(300A,033A)",
    vr: "LO",
    vm: "1",
    name: "Lateral Spreading Device Description"
  },
  "(300A,033C)": {
    tag: "(300A,033C)",
    vr: "FL",
    vm: "1",
    name: "Lateral Spreading Device Water Equivalent Thickness"
  },
  "(300A,0340)": {
    tag: "(300A,0340)",
    vr: "IS",
    vm: "1",
    name: "Number Of Range Modulators"
  },
  "(300A,0342)": {
    tag: "(300A,0342)",
    vr: "SQ",
    vm: "1",
    name: "Range Modulator Sequence"
  },
  "(300A,0344)": {
    tag: "(300A,0344)",
    vr: "IS",
    vm: "1",
    name: "Range Modulator Number"
  },
  "(300A,0346)": {
    tag: "(300A,0346)",
    vr: "SH",
    vm: "1",
    name: "Range Modulator ID"
  },
  "(300A,0348)": {
    tag: "(300A,0348)",
    vr: "CS",
    vm: "1",
    name: "Range Modulator Type"
  },
  "(300A,034A)": {
    tag: "(300A,034A)",
    vr: "LO",
    vm: "1",
    name: "Range Modulator Description"
  },
  "(300A,034C)": {
    tag: "(300A,034C)",
    vr: "SH",
    vm: "1",
    name: "Beam Current Modulation ID"
  },
  "(300A,0350)": {
    tag: "(300A,0350)",
    vr: "CS",
    vm: "1",
    name: "Patient Support Type"
  },
  "(300A,0352)": {
    tag: "(300A,0352)",
    vr: "SH",
    vm: "1",
    name: "Patient Support ID"
  },
  "(300A,0354)": {
    tag: "(300A,0354)",
    vr: "LO",
    vm: "1",
    name: "Patient Support Accessory Code"
  },
  "(300A,0356)": {
    tag: "(300A,0356)",
    vr: "FL",
    vm: "1",
    name: "Fixation Light Azimuthal Angle"
  },
  "(300A,0358)": {
    tag: "(300A,0358)",
    vr: "FL",
    vm: "1",
    name: "Fixation Light Polar Angle"
  },
  "(300A,035A)": {
    tag: "(300A,035A)",
    vr: "FL",
    vm: "1",
    name: "Meterset Rate"
  },
  "(300A,0360)": {
    tag: "(300A,0360)",
    vr: "SQ",
    vm: "1",
    name: "Range Shifter Settings Sequence"
  },
  "(300A,0362)": {
    tag: "(300A,0362)",
    vr: "LO",
    vm: "1",
    name: "Range Shifter Setting"
  },
  "(300A,0364)": {
    tag: "(300A,0364)",
    vr: "FL",
    vm: "1",
    name: "Isocenter To Range Shifter Distance"
  },
  "(300A,0366)": {
    tag: "(300A,0366)",
    vr: "FL",
    vm: "1",
    name: "Range Shifter Water Equivalent Thickness"
  },
  "(300A,0370)": {
    tag: "(300A,0370)",
    vr: "SQ",
    vm: "1",
    name: "Lateral Spreading Device Settings Sequence"
  },
  "(300A,0372)": {
    tag: "(300A,0372)",
    vr: "LO",
    vm: "1",
    name: "Lateral Spreading Device Setting"
  },
  "(300A,0374)": {
    tag: "(300A,0374)",
    vr: "FL",
    vm: "1",
    name: "Isocenter To Lateral Spreading Device Distance"
  },
  "(300A,0380)": {
    tag: "(300A,0380)",
    vr: "SQ",
    vm: "1",
    name: "Range Modulator Settings Sequence"
  },
  "(300A,0382)": {
    tag: "(300A,0382)",
    vr: "FL",
    vm: "1",
    name: "Range Modulator Gating Start Value"
  },
  "(300A,0384)": {
    tag: "(300A,0384)",
    vr: "FL",
    vm: "1",
    name: "Range Modulator Gating Stop Value"
  },
  "(300A,0386)": {
    tag: "(300A,0386)",
    vr: "FL",
    vm: "1",
    name: "Range Modulator Gating Start Water Equivalent Thickness"
  },
  "(300A,0388)": {
    tag: "(300A,0388)",
    vr: "FL",
    vm: "1",
    name: "Range Modulator Gating Stop Water Equivalent Thickness"
  },
  "(300A,038A)": {
    tag: "(300A,038A)",
    vr: "FL",
    vm: "1",
    name: "Isocenter To Range Modulator Distance"
  },
  "(300A,0390)": {
    tag: "(300A,0390)",
    vr: "SH",
    vm: "1",
    name: "Scan Spot Tune ID"
  },
  "(300A,0392)": {
    tag: "(300A,0392)",
    vr: "IS",
    vm: "1",
    name: "Number Of Scan Spot Positions"
  },
  "(300A,0394)": {
    tag: "(300A,0394)",
    vr: "FL",
    vm: "1",
    name: "Scan Spot Position Map"
  },
  "(300A,0396)": {
    tag: "(300A,0396)",
    vr: "FL",
    vm: "1",
    name: "Scan Spot Meterset Weights"
  },
  "(300A,0398)": {
    tag: "(300A,0398)",
    vr: "FL",
    vm: "2",
    name: "Scanning Spot Size"
  },
  "(300A,039A)": {
    tag: "(300A,039A)",
    vr: "IS",
    vm: "1",
    name: "Number Of Paintings"
  },
  "(300A,03A0)": {
    tag: "(300A,03A0)",
    vr: "SQ",
    vm: "1",
    name: "Ion Tolerance Table Sequence"
  },
  "(300A,03A2)": {
    tag: "(300A,03A2)",
    vr: "SQ",
    vm: "1",
    name: "Ion Beam Sequence"
  },
  "(300A,03A4)": {
    tag: "(300A,03A4)",
    vr: "SQ",
    vm: "1",
    name: "Ion Beam Limiting Device Sequence"
  },
  "(300A,03A6)": {
    tag: "(300A,03A6)",
    vr: "SQ",
    vm: "1",
    name: "Ion Block Sequence"
  },
  "(300A,03A8)": {
    tag: "(300A,03A8)",
    vr: "SQ",
    vm: "1",
    name: "Ion Control Point Sequence"
  },
  "(300A,03AA)": {
    tag: "(300A,03AA)",
    vr: "SQ",
    vm: "1",
    name: "Ion Wedge Sequence"
  },
  "(300A,03AC)": {
    tag: "(300A,03AC)",
    vr: "SQ",
    vm: "1",
    name: "Ion Wedge Position Sequence"
  },
  "(300A,0401)": {
    tag: "(300A,0401)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Setup Image Sequence"
  },
  "(300A,0402)": {
    tag: "(300A,0402)",
    vr: "ST",
    vm: "1",
    name: "Setup Image Comment"
  },
  "(300A,0410)": {
    tag: "(300A,0410)",
    vr: "SQ",
    vm: "1",
    name: "Motion Synchronization Sequence"
  },
  "(300A,0412)": {
    tag: "(300A,0412)",
    vr: "FL",
    vm: "3",
    name: "Control Point Orientation"
  },
  "(300A,0420)": {
    tag: "(300A,0420)",
    vr: "SQ",
    vm: "1",
    name: "General Accessory Sequence"
  },
  "(300A,0421)": {
    tag: "(300A,0421)",
    vr: "SH",
    vm: "1",
    name: "General Accessory ID"
  },
  "(300A,0422)": {
    tag: "(300A,0422)",
    vr: "ST",
    vm: "1",
    name: "General Accessory Description"
  },
  "(300A,0423)": {
    tag: "(300A,0423)",
    vr: "CS",
    vm: "1",
    name: "General Accessory Type"
  },
  "(300A,0424)": {
    tag: "(300A,0424)",
    vr: "IS",
    vm: "1",
    name: "General Accessory Number"
  },
  "(300A,0431)": {
    tag: "(300A,0431)",
    vr: "SQ",
    vm: "1",
    name: "Applicator Geometry Sequence"
  },
  "(300A,0432)": {
    tag: "(300A,0432)",
    vr: "CS",
    vm: "1",
    name: "Applicator Aperture Shape"
  },
  "(300A,0433)": {
    tag: "(300A,0433)",
    vr: "FL",
    vm: "1",
    name: "Applicator Opening"
  },
  "(300A,0434)": {
    tag: "(300A,0434)",
    vr: "FL",
    vm: "1",
    name: "Applicator Opening X"
  },
  "(300A,0435)": {
    tag: "(300A,0435)",
    vr: "FL",
    vm: "1",
    name: "Applicator Opening Y"
  },
  "(300A,0436)": {
    tag: "(300A,0436)",
    vr: "FL",
    vm: "1",
    name: "Source To Applicator Mounting Position Distance"
  },
  "(300C,0002)": {
    tag: "(300C,0002)",
    vr: "SQ",
    vm: "1",
    name: "Referenced RTPlan Sequence"
  },
  "(300C,0004)": {
    tag: "(300C,0004)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Beam Sequence"
  },
  "(300C,0006)": {
    tag: "(300C,0006)",
    vr: "IS",
    vm: "1",
    name: "Referenced Beam Number"
  },
  "(300C,0007)": {
    tag: "(300C,0007)",
    vr: "IS",
    vm: "1",
    name: "Referenced Reference Image Number"
  },
  "(300C,0008)": {
    tag: "(300C,0008)",
    vr: "DS",
    vm: "1",
    name: "Start Cumulative Meterset Weight"
  },
  "(300C,0009)": {
    tag: "(300C,0009)",
    vr: "DS",
    vm: "1",
    name: "End Cumulative Meterset Weight"
  },
  "(300C,000A)": {
    tag: "(300C,000A)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Brachy Application Setup Sequence"
  },
  "(300C,000C)": {
    tag: "(300C,000C)",
    vr: "IS",
    vm: "1",
    name: "Referenced Brachy Application Setup Number"
  },
  "(300C,000E)": {
    tag: "(300C,000E)",
    vr: "IS",
    vm: "1",
    name: "Referenced Source Number"
  },
  "(300C,0020)": {
    tag: "(300C,0020)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Fraction Group Sequence"
  },
  "(300C,0022)": {
    tag: "(300C,0022)",
    vr: "IS",
    vm: "1",
    name: "Referenced Fraction Group Number"
  },
  "(300C,0040)": {
    tag: "(300C,0040)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Verification Image Sequence"
  },
  "(300C,0042)": {
    tag: "(300C,0042)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Reference Image Sequence"
  },
  "(300C,0050)": {
    tag: "(300C,0050)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Dose Reference Sequence"
  },
  "(300C,0051)": {
    tag: "(300C,0051)",
    vr: "IS",
    vm: "1",
    name: "Referenced Dose Reference Number"
  },
  "(300C,0055)": {
    tag: "(300C,0055)",
    vr: "SQ",
    vm: "1",
    name: "Brachy Referenced Dose Reference Sequence"
  },
  "(300C,0060)": {
    tag: "(300C,0060)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Structure Set Sequence"
  },
  "(300C,006A)": {
    tag: "(300C,006A)",
    vr: "IS",
    vm: "1",
    name: "Referenced Patient Setup Number"
  },
  "(300C,0080)": {
    tag: "(300C,0080)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Dose Sequence"
  },
  "(300C,00A0)": {
    tag: "(300C,00A0)",
    vr: "IS",
    vm: "1",
    name: "Referenced Tolerance Table Number"
  },
  "(300C,00B0)": {
    tag: "(300C,00B0)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Bolus Sequence"
  },
  "(300C,00C0)": {
    tag: "(300C,00C0)",
    vr: "IS",
    vm: "1",
    name: "Referenced Wedge Number"
  },
  "(300C,00D0)": {
    tag: "(300C,00D0)",
    vr: "IS",
    vm: "1",
    name: "Referenced Compensator Number"
  },
  "(300C,00E0)": {
    tag: "(300C,00E0)",
    vr: "IS",
    vm: "1",
    name: "Referenced Block Number"
  },
  "(300C,00F0)": {
    tag: "(300C,00F0)",
    vr: "IS",
    vm: "1",
    name: "Referenced Control Point Index"
  },
  "(300C,00F2)": {
    tag: "(300C,00F2)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Control Point Sequence"
  },
  "(300C,00F4)": {
    tag: "(300C,00F4)",
    vr: "IS",
    vm: "1",
    name: "Referenced Start Control Point Index"
  },
  "(300C,00F6)": {
    tag: "(300C,00F6)",
    vr: "IS",
    vm: "1",
    name: "Referenced Stop Control Point Index"
  },
  "(300C,0100)": {
    tag: "(300C,0100)",
    vr: "IS",
    vm: "1",
    name: "Referenced Range Shifter Number"
  },
  "(300C,0102)": {
    tag: "(300C,0102)",
    vr: "IS",
    vm: "1",
    name: "Referenced Lateral Spreading Device Number"
  },
  "(300C,0104)": {
    tag: "(300C,0104)",
    vr: "IS",
    vm: "1",
    name: "Referenced Range Modulator Number"
  },
  "(300E,0002)": {
    tag: "(300E,0002)",
    vr: "CS",
    vm: "1",
    name: "Approval Status"
  },
  "(300E,0004)": { tag: "(300E,0004)", vr: "DA", vm: "1", name: "Review Date" },
  "(300E,0005)": { tag: "(300E,0005)", vr: "TM", vm: "1", name: "Review Time" },
  "(300E,0008)": {
    tag: "(300E,0008)",
    vr: "PN",
    vm: "1",
    name: "Reviewer Name"
  },
  "(4000,0010)": { tag: "(4000,0010)", vr: "LT", vm: "1", name: "Arbitrary" },
  "(4000,4000)": {
    tag: "(4000,4000)",
    vr: "LT",
    vm: "1",
    name: "Text Comments"
  },
  "(4008,0040)": { tag: "(4008,0040)", vr: "SH", vm: "1", name: "Results ID" },
  "(4008,0042)": {
    tag: "(4008,0042)",
    vr: "LO",
    vm: "1",
    name: "Results IDIssuer"
  },
  "(4008,0050)": {
    tag: "(4008,0050)",
    vr: "SQ",
    vm: "1",
    name: "Referenced Interpretation Sequence"
  },
  "(4008,00FF)": {
    tag: "(4008,00FF)",
    vr: "CS",
    vm: "1",
    name: "Report Production Status Trial"
  },
  "(4008,0100)": {
    tag: "(4008,0100)",
    vr: "DA",
    vm: "1",
    name: "Interpretation Recorded Date"
  },
  "(4008,0101)": {
    tag: "(4008,0101)",
    vr: "TM",
    vm: "1",
    name: "Interpretation Recorded Time"
  },
  "(4008,0102)": {
    tag: "(4008,0102)",
    vr: "PN",
    vm: "1",
    name: "Interpretation Recorder"
  },
  "(4008,0103)": {
    tag: "(4008,0103)",
    vr: "LO",
    vm: "1",
    name: "Reference To Recorded Sound"
  },
  "(4008,0108)": {
    tag: "(4008,0108)",
    vr: "DA",
    vm: "1",
    name: "Interpretation Transcription Date"
  },
  "(4008,0109)": {
    tag: "(4008,0109)",
    vr: "TM",
    vm: "1",
    name: "Interpretation Transcription Time"
  },
  "(4008,010A)": {
    tag: "(4008,010A)",
    vr: "PN",
    vm: "1",
    name: "Interpretation Transcriber"
  },
  "(4008,010B)": {
    tag: "(4008,010B)",
    vr: "ST",
    vm: "1",
    name: "Interpretation Text"
  },
  "(4008,010C)": {
    tag: "(4008,010C)",
    vr: "PN",
    vm: "1",
    name: "Interpretation Author"
  },
  "(4008,0111)": {
    tag: "(4008,0111)",
    vr: "SQ",
    vm: "1",
    name: "Interpretation Approver Sequence"
  },
  "(4008,0112)": {
    tag: "(4008,0112)",
    vr: "DA",
    vm: "1",
    name: "Interpretation Approval Date"
  },
  "(4008,0113)": {
    tag: "(4008,0113)",
    vr: "TM",
    vm: "1",
    name: "Interpretation Approval Time"
  },
  "(4008,0114)": {
    tag: "(4008,0114)",
    vr: "PN",
    vm: "1",
    name: "Physician Approving Interpretation"
  },
  "(4008,0115)": {
    tag: "(4008,0115)",
    vr: "LT",
    vm: "1",
    name: "Interpretation Diagnosis Description"
  },
  "(4008,0117)": {
    tag: "(4008,0117)",
    vr: "SQ",
    vm: "1",
    name: "Interpretation Diagnosis Code Sequence"
  },
  "(4008,0118)": {
    tag: "(4008,0118)",
    vr: "SQ",
    vm: "1",
    name: "Results Distribution List Sequence"
  },
  "(4008,0119)": {
    tag: "(4008,0119)",
    vr: "PN",
    vm: "1",
    name: "Distribution Name"
  },
  "(4008,011A)": {
    tag: "(4008,011A)",
    vr: "LO",
    vm: "1",
    name: "Distribution Address"
  },
  "(4008,0200)": {
    tag: "(4008,0200)",
    vr: "SH",
    vm: "1",
    name: "Interpretation ID"
  },
  "(4008,0202)": {
    tag: "(4008,0202)",
    vr: "LO",
    vm: "1",
    name: "Interpretation IDIssuer"
  },
  "(4008,0210)": {
    tag: "(4008,0210)",
    vr: "CS",
    vm: "1",
    name: "Interpretation Type ID"
  },
  "(4008,0212)": {
    tag: "(4008,0212)",
    vr: "CS",
    vm: "1",
    name: "Interpretation Status ID"
  },
  "(4008,0300)": { tag: "(4008,0300)", vr: "ST", vm: "1", name: "Impressions" },
  "(4008,4000)": {
    tag: "(4008,4000)",
    vr: "ST",
    vm: "1 ",
    name: "Results Comments"
  },
  "(4010,0001)": {
    tag: "(4010,0001)",
    vr: "CS",
    vm: "1",
    name: "Low Energy Detectors"
  },
  "(4010,0002)": {
    tag: "(4010,0002)",
    vr: "CS",
    vm: "1",
    name: "High Energy Detectors"
  },
  "(4010,0004)": {
    tag: "(4010,0004)",
    vr: "SQ",
    vm: "1",
    name: "Detector Geometry Sequence"
  },
  "(4010,1001)": {
    tag: "(4010,1001)",
    vr: "SQ",
    vm: "1",
    name: "Threat ROIVoxel Sequence"
  },
  "(4010,1004)": {
    tag: "(4010,1004)",
    vr: "FL",
    vm: "3",
    name: "Threat ROIBase"
  },
  "(4010,1005)": {
    tag: "(4010,1005)",
    vr: "FL",
    vm: "3",
    name: "Threat ROIExtents"
  },
  "(4010,1006)": {
    tag: "(4010,1006)",
    vr: "OB",
    vm: "1",
    name: "Threat ROIBitmap"
  },
  "(4010,1007)": {
    tag: "(4010,1007)",
    vr: "SH",
    vm: "1",
    name: "Route Segment ID"
  },
  "(4010,1008)": { tag: "(4010,1008)", vr: "CS", vm: "1", name: "Gantry Type" },
  "(4010,1009)": {
    tag: "(4010,1009)",
    vr: "CS",
    vm: "1",
    name: "OOIOwner Type"
  },
  "(4010,100A)": {
    tag: "(4010,100A)",
    vr: "SQ",
    vm: "1",
    name: "Route Segment Sequence"
  },
  "(4010,1010)": {
    tag: "(4010,1010)",
    vr: "US",
    vm: "1",
    name: "Potential Threat Object ID"
  },
  "(4010,1011)": {
    tag: "(4010,1011)",
    vr: "SQ",
    vm: "1",
    name: "Threat Sequence"
  },
  "(4010,1012)": {
    tag: "(4010,1012)",
    vr: "CS",
    vm: "1",
    name: "Threat Category"
  },
  "(4010,1013)": {
    tag: "(4010,1013)",
    vr: "LT",
    vm: "1",
    name: "Threat Category Description"
  },
  "(4010,1014)": {
    tag: "(4010,1014)",
    vr: "CS",
    vm: "1",
    name: "ATDAbility Assessment"
  },
  "(4010,1015)": {
    tag: "(4010,1015)",
    vr: "CS",
    vm: "1",
    name: "ATDAssessment Flag"
  },
  "(4010,1016)": {
    tag: "(4010,1016)",
    vr: "FL",
    vm: "1",
    name: "ATDAssessment Probability"
  },
  "(4010,1017)": { tag: "(4010,1017)", vr: "FL", vm: "1", name: "Mass" },
  "(4010,1018)": { tag: "(4010,1018)", vr: "FL", vm: "1", name: "Density" },
  "(4010,1019)": { tag: "(4010,1019)", vr: "FL", vm: "1", name: "ZEffective" },
  "(4010,101A)": {
    tag: "(4010,101A)",
    vr: "SH",
    vm: "1",
    name: "Boarding Pass ID"
  },
  "(4010,101B)": {
    tag: "(4010,101B)",
    vr: "FL",
    vm: "3",
    name: "Center Of Mass"
  },
  "(4010,101C)": {
    tag: "(4010,101C)",
    vr: "FL",
    vm: "3",
    name: "Center Of PTO"
  },
  "(4010,101D)": {
    tag: "(4010,101D)",
    vr: "FL",
    vm: "6",
    name: "Bounding Polygon"
  },
  "(4010,101E)": {
    tag: "(4010,101E)",
    vr: "SH",
    vm: "1",
    name: "Route Segment Start Location ID"
  },
  "(4010,101F)": {
    tag: "(4010,101F)",
    vr: "SH",
    vm: "1",
    name: "Route Segment End Location ID"
  },
  "(4010,1020)": {
    tag: "(4010,1020)",
    vr: "CS",
    vm: "1",
    name: "Route Segment Location IDType"
  },
  "(4010,1021)": {
    tag: "(4010,1021)",
    vr: "CS",
    vm: "1",
    name: "Abort Reason"
  },
  "(4010,1023)": {
    tag: "(4010,1023)",
    vr: "FL",
    vm: "1",
    name: "Volume Of PTO"
  },
  "(4010,1024)": { tag: "(4010,1024)", vr: "CS", vm: "1", name: "Abort Flag" },
  "(4010,1025)": {
    tag: "(4010,1025)",
    vr: "DT",
    vm: "1",
    name: "Route Segment Start Time"
  },
  "(4010,1026)": {
    tag: "(4010,1026)",
    vr: "DT",
    vm: "1",
    name: "Route Segment End Time"
  },
  "(4010,1027)": { tag: "(4010,1027)", vr: "CS", vm: "1", name: "TDRType" },
  "(4010,1028)": {
    tag: "(4010,1028)",
    vr: "CS",
    vm: "1",
    name: "International Route Segment"
  },
  "(4010,1029)": {
    tag: "(4010,1029)",
    vr: "LO",
    vm: "1",
    name: "Threat Detection Algorithmand Version"
  },
  "(4010,102A)": {
    tag: "(4010,102A)",
    vr: "SH",
    vm: "1",
    name: "Assigned Location"
  },
  "(4010,102B)": {
    tag: "(4010,102B)",
    vr: "DT",
    vm: "1",
    name: "Alarm Decision Time"
  },
  "(4010,1031)": {
    tag: "(4010,1031)",
    vr: "CS",
    vm: "1",
    name: "Alarm Decision"
  },
  "(4010,1033)": {
    tag: "(4010,1033)",
    vr: "US",
    vm: "1",
    name: "Number Of Total Objects"
  },
  "(4010,1034)": {
    tag: "(4010,1034)",
    vr: "US",
    vm: "1",
    name: "Number Of Alarm Objects"
  },
  "(4010,1037)": {
    tag: "(4010,1037)",
    vr: "SQ",
    vm: "1",
    name: "PTORepresentation Sequence"
  },
  "(4010,1038)": {
    tag: "(4010,1038)",
    vr: "SQ",
    vm: "1",
    name: "ATDAssessment Sequence"
  },
  "(4010,1039)": { tag: "(4010,1039)", vr: "CS", vm: "1", name: "TIPType" },
  "(4010,103A)": {
    tag: "(4010,103A)",
    vr: "CS",
    vm: "1",
    name: "DICOSVersion"
  },
  "(4010,1041)": {
    tag: "(4010,1041)",
    vr: "DT",
    vm: "1",
    name: "OOIOwner Creation Time"
  },
  "(4010,1042)": { tag: "(4010,1042)", vr: "CS", vm: "1", name: "OOIType" },
  "(4010,1043)": { tag: "(4010,1043)", vr: "FL", vm: "3", name: "OOISize" },
  "(4010,1044)": {
    tag: "(4010,1044)",
    vr: "CS",
    vm: "1",
    name: "Acquisition Status"
  },
  "(4010,1045)": {
    tag: "(4010,1045)",
    vr: "SQ",
    vm: "1",
    name: "Basis Materials Code Sequence"
  },
  "(4010,1046)": {
    tag: "(4010,1046)",
    vr: "CS",
    vm: "1",
    name: "Phantom Type"
  },
  "(4010,1047)": {
    tag: "(4010,1047)",
    vr: "SQ",
    vm: "1",
    name: "OOIOwner Sequence"
  },
  "(4010,1048)": { tag: "(4010,1048)", vr: "CS", vm: "1", name: "Scan Type" },
  "(4010,1051)": {
    tag: "(4010,1051)",
    vr: "LO",
    vm: "1",
    name: "Itinerary ID"
  },
  "(4010,1052)": {
    tag: "(4010,1052)",
    vr: "SH",
    vm: "1",
    name: "Itinerary IDType"
  },
  "(4010,1053)": {
    tag: "(4010,1053)",
    vr: "LO",
    vm: "1",
    name: "Itinerary IDAssigning Authority"
  },
  "(4010,1054)": { tag: "(4010,1054)", vr: "SH", vm: "1", name: "Route ID" },
  "(4010,1055)": {
    tag: "(4010,1055)",
    vr: "SH",
    vm: "1",
    name: "Route IDAssigning Authority"
  },
  "(4010,1056)": {
    tag: "(4010,1056)",
    vr: "CS",
    vm: "1",
    name: "Inbound Arrival Type"
  },
  "(4010,1058)": { tag: "(4010,1058)", vr: "SH", vm: "1", name: "Carrier ID" },
  "(4010,1059)": {
    tag: "(4010,1059)",
    vr: "CS",
    vm: "1",
    name: "Carrier IDAssigning Authority"
  },
  "(4010,1060)": {
    tag: "(4010,1060)",
    vr: "FL",
    vm: "3",
    name: "Source Orientation"
  },
  "(4010,1061)": {
    tag: "(4010,1061)",
    vr: "FL",
    vm: "3",
    name: "Source Position"
  },
  "(4010,1062)": { tag: "(4010,1062)", vr: "FL", vm: "1", name: "Belt Height" },
  "(4010,1064)": {
    tag: "(4010,1064)",
    vr: "SQ",
    vm: "1",
    name: "Algorithm Routing Code Sequence"
  },
  "(4010,1067)": {
    tag: "(4010,1067)",
    vr: "CS",
    vm: "1",
    name: "Transport Classification"
  },
  "(4010,1068)": {
    tag: "(4010,1068)",
    vr: "LT",
    vm: "1",
    name: "OOIType Descriptor"
  },
  "(4010,1069)": {
    tag: "(4010,1069)",
    vr: "FL",
    vm: "1",
    name: "Total Processing Time"
  },
  "(4010,106C)": {
    tag: "(4010,106C)",
    vr: "OB",
    vm: "1",
    name: "Detector Calibration Data"
  },
  "(4FFE,0001)": {
    tag: "(4FFE,0001)",
    vr: "SQ",
    vm: "1",
    name: "MACParameters Sequence"
  },
  "(50xx,0005)": {
    tag: "(50xx,0005)",
    vr: "US",
    vm: "1",
    name: "Curve Dimensions"
  },
  "(50xx,0010)": {
    tag: "(50xx,0010)",
    vr: "US",
    vm: "1",
    name: "Number Of Points"
  },
  "(50xx,0020)": {
    tag: "(50xx,0020)",
    vr: "CS",
    vm: "1",
    name: "Type Of Data"
  },
  "(50xx,0022)": {
    tag: "(50xx,0022)",
    vr: "LO",
    vm: "1",
    name: "Curve Description"
  },
  "(50xx,0030)": {
    tag: "(50xx,0030)",
    vr: "SH",
    vm: "1",
    name: "Axis Units"
  },
  "(50xx,0040)": {
    tag: "(50xx,0040)",
    vr: "SH",
    vm: "1",
    name: "Axis Labels"
  },
  "(50xx,0103)": {
    tag: "(50xx,0103)",
    vr: "US",
    vm: "1",
    name: "Data Value Representation"
  },
  "(50xx,0104)": {
    tag: "(50xx,0104)",
    vr: "US",
    vm: "1",
    name: "Minimum Coordinate Value"
  },
  "(50xx,0105)": {
    tag: "(50xx,0105)",
    vr: "US",
    vm: "1",
    name: "Maximum Coordinate Value"
  },
  "(50xx,0106)": {
    tag: "(50xx,0106)",
    vr: "SH",
    vm: "1",
    name: "Curve Range"
  },
  "(50xx,0110)": {
    tag: "(50xx,0110)",
    vr: "US",
    vm: "1",
    name: "Curve Data Descriptor"
  },
  "(50xx,0112)": {
    tag: "(50xx,0112)",
    vr: "US",
    vm: "1",
    name: "Coordinate Start Value"
  },
  "(50xx,0114)": {
    tag: "(50xx,0114)",
    vr: "US",
    vm: "1",
    name: "Coordinate Step Value"
  },
  "(50xx,1001)": {
    tag: "(50xx,1001)",
    vr: "CS",
    vm: "1",
    name: "Curve Activation Layer"
  },
  "(50xx,2000)": { tag: "(50xx,2000)", vr: "US", vm: "1", name: "Audio Type" },
  "(50xx,2002)": {
    tag: "(50xx,2002)",
    vr: "US",
    vm: "1",
    name: "Audio Sample Format"
  },
  "(50xx,2004)": {
    tag: "(50xx,2004)",
    vr: "US",
    vm: "1",
    name: "Number Of Channels"
  },
  "(50xx,2006)": {
    tag: "(50xx,2006)",
    vr: "UL",
    vm: "1",
    name: "Number Of Samples"
  },
  "(50xx,2008)": { tag: "(50xx,2008)", vr: "UL", vm: "1", name: "Sample Rate" },
  "(50xx,200A)": { tag: "(50xx,200A)", vr: "UL", vm: "1", name: "Total Time" },
  "(50xx,200C)": {
    tag: "(50xx,200C)",
    vr: "OW|OB",
    vm: "1",
    name: "Audio Sample Data"
  },
  "(50xx,200E)": {
    tag: "(50xx,200E)",
    vr: "LT",
    vm: "1 ",
    name: "Audio Comments"
  },
  "(50xx,2500)": { tag: "(50xx,2500)", vr: "LO", vm: "1", name: "Curve Label" },
  "(50xx,2600)": {
    tag: "(50xx,2600)",
    vr: "SQ",
    vm: "1",
    name: "Curve Referenced Overlay Sequence"
  },
  "(50xx,2610)": {
    tag: "(50xx,2610)",
    vr: "US",
    vm: "1",
    name: "Curve Referenced Overlay Group"
  },
  "(50xx,3000)": {
    tag: "(50xx,3000)",
    vr: "OW|OB",
    vm: "1",
    name: "Curve Data"
  },
  "(5200,9229)": {
    tag: "(5200,9229)",
    vr: "SQ",
    vm: "1",
    name: "Shared Functional Groups Sequence"
  },
  "(5200,9230)": {
    tag: "(5200,9230)",
    vr: "SQ",
    vm: "1",
    name: "Per Frame Functional Groups Sequence"
  },
  "(5400,0100)": {
    tag: "(5400,0100)",
    vr: "SQ",
    vm: "1",
    name: "Waveform Sequence"
  },
  "(5400,0110)": {
    tag: "(5400,0110)",
    vr: "OB|OW",
    vm: "1",
    name: "Channel Minimum Value"
  },
  "(5400,0112)": {
    tag: "(5400,0112)",
    vr: "OB|OW",
    vm: "1",
    name: "Channel Maximum Value"
  },
  "(5400,1004)": {
    tag: "(5400,1004)",
    vr: "US",
    vm: "1",
    name: "Waveform Bits Allocated"
  },
  "(5400,1006)": {
    tag: "(5400,1006)",
    vr: "CS",
    vm: "1",
    name: "Waveform Sample Interpretation"
  },
  "(5400,100A)": {
    tag: "(5400,100A)",
    vr: "OB|OW",
    vm: "1",
    name: "Waveform Padding Value"
  },
  "(5400,1010)": {
    tag: "(5400,1010)",
    vr: "OB|OW",
    vm: "1",
    name: "Waveform Data"
  },
  "(5600,0010)": {
    tag: "(5600,0010)",
    vr: "OF",
    vm: "1",
    name: "First Order Phase Correction Angle"
  },
  "(5600,0020)": {
    tag: "(5600,0020)",
    vr: "OF",
    vm: "1",
    name: "Spectroscopy Data"
  },
  "(60xx,0010)": {
    tag: "(60xx,0010)",
    vr: "US",
    vm: "1",
    name: "Overlay Rows"
  },
  "(60xx,0011)": {
    tag: "(60xx,0011)",
    vr: "US",
    vm: "1",
    name: "Overlay Columns"
  },
  "(60xx,0012)": {
    tag: "(60xx,0012)",
    vr: "US",
    vm: "1",
    name: "Overlay Planes"
  },
  "(60xx,0015)": {
    tag: "(60xx,0015)",
    vr: "IS",
    vm: "1",
    name: "Number Of Frames In Overlay"
  },
  "(60xx,0022)": {
    tag: "(60xx,0022)",
    vr: "LO",
    vm: "1",
    name: "Overlay Description"
  },
  "(60xx,0040)": {
    tag: "(60xx,0040)",
    vr: "CS",
    vm: "1",
    name: "Overlay Type"
  },
  "(60xx,0045)": {
    tag: "(60xx,0045)",
    vr: "LO",
    vm: "1",
    name: "Overlay Subtype"
  },
  "(60xx,0050)": {
    tag: "(60xx,0050)",
    vr: "SS",
    vm: "2",
    name: "Overlay Origin"
  },
  "(60xx,0051)": {
    tag: "(60xx,0051)",
    vr: "US",
    vm: "1",
    name: "Image Frame Origin"
  },
  "(60xx,0052)": {
    tag: "(60xx,0052)",
    vr: "US",
    vm: "1",
    name: "Overlay Plane Origin"
  },
  "(60xx,0060)": {
    tag: "(60xx,0060)",
    vr: "CS",
    vm: "1",
    name: "Overlay Compression Code"
  },
  "(60xx,0061)": {
    tag: "(60xx,0061)",
    vr: "SH",
    vm: "1",
    name: "Overlay Compression Originator"
  },
  "(60xx,0062)": {
    tag: "(60xx,0062)",
    vr: "SH",
    vm: "1",
    name: "Overlay Compression Label"
  },
  "(60xx,0063)": {
    tag: "(60xx,0063)",
    vr: "CS",
    vm: "1",
    name: "Overlay Compression Description"
  },
  "(60xx,0066)": {
    tag: "(60xx,0066)",
    vr: "AT",
    vm: "1",
    name: "Overlay Compression Step Pointers"
  },
  "(60xx,0068)": {
    tag: "(60xx,0068)",
    vr: "US",
    vm: "1",
    name: "Overlay Repeat Interval"
  },
  "(60xx,0069)": {
    tag: "(60xx,0069)",
    vr: "US",
    vm: "1",
    name: "Overlay Bits Grouped"
  },
  "(60xx,0100)": {
    tag: "(60xx,0100)",
    vr: "US",
    vm: "1",
    name: "Overlay Bits Allocated"
  },
  "(60xx,0102)": {
    tag: "(60xx,0102)",
    vr: "US",
    vm: "1",
    name: "Overlay Bit Position"
  },
  "(60xx,0110)": {
    tag: "(60xx,0110)",
    vr: "CS",
    vm: "1",
    name: "Overlay Format"
  },
  "(60xx,0200)": {
    tag: "(60xx,0200)",
    vr: "US",
    vm: "1",
    name: "Overlay Location"
  },
  "(60xx,0800)": {
    tag: "(60xx,0800)",
    vr: "CS",
    vm: "1",
    name: "Overlay Code Label"
  },
  "(60xx,0802)": {
    tag: "(60xx,0802)",
    vr: "US",
    vm: "1",
    name: "Overlay Number Of Tables"
  },
  "(60xx,0803)": {
    tag: "(60xx,0803)",
    vr: "AT",
    vm: "1",
    name: "Overlay Code Table Location"
  },
  "(60xx,0804)": {
    tag: "(60xx,0804)",
    vr: "US",
    vm: "1",
    name: "Overlay Bits For Code Word"
  },
  "(60xx,1001)": {
    tag: "(60xx,1001)",
    vr: "CS",
    vm: "1",
    name: "Overlay Activation Layer"
  },
  "(60xx,1100)": {
    tag: "(60xx,1100)",
    vr: "US",
    vm: "1",
    name: "Overlay Descriptor Gray"
  },
  "(60xx,1101)": {
    tag: "(60xx,1101)",
    vr: "US",
    vm: "1",
    name: "Overlay Descriptor Red"
  },
  "(60xx,1102)": {
    tag: "(60xx,1102)",
    vr: "US",
    vm: "1",
    name: "Overlay Descriptor Green"
  },
  "(60xx,1103)": {
    tag: "(60xx,1103)",
    vr: "US",
    vm: "1",
    name: "Overlay Descriptor Blue"
  },
  "(60xx,1200)": {
    tag: "(60xx,1200)",
    vr: "US",
    vm: "1",
    name: "Overlays Gray"
  },
  "(60xx,1201)": {
    tag: "(60xx,1201)",
    vr: "US",
    vm: "1",
    name: "Overlays Red"
  },
  "(60xx,1202)": {
    tag: "(60xx,1202)",
    vr: "US",
    vm: "1",
    name: "Overlays Green"
  },
  "(60xx,1203)": {
    tag: "(60xx,1203)",
    vr: "US",
    vm: "1",
    name: "Overlays Blue"
  },
  "(60xx,1301)": { tag: "(60xx,1301)", vr: "IS", vm: "1", name: "ROIArea" },
  "(60xx,1302)": { tag: "(60xx,1302)", vr: "DS", vm: "1", name: "ROIMean" },
  "(60xx,1303)": {
    tag: "(60xx,1303)",
    vr: "DS",
    vm: "1",
    name: "ROIStandard Deviation"
  },
  "(60xx,1500)": {
    tag: "(60xx,1500)",
    vr: "LO",
    vm: "1",
    name: "Overlay Label"
  },
  "(60xx,3000)": {
    tag: "(60xx,3000)",
    vr: "OB|OW",
    vm: "1",
    name: "Overlay Data"
  },
  "(60xx,4000)": {
    tag: "(60xx,4000)",
    vr: "LT",
    vm: "1",
    name: "Overlay Comments"
  },
  "(7FE0,0010)": {
    tag: "(7FE0,0010)",
    vr: "OW|OB",
    vm: "1",
    name: "Pixel Data"
  },
  "(7FE0,0020)": {
    tag: "(7FE0,0020)",
    vr: "OW",
    vm: "1",
    name: "Coefficients SDVN"
  },
  "(7FE0,0030)": {
    tag: "(7FE0,0030)",
    vr: "OW",
    vm: "1",
    name: "Coefficients SDHN"
  },
  "(7FE0,0040)": {
    tag: "(7FE0,0040)",
    vr: "OW",
    vm: "1",
    name: "Coefficients SDDN"
  },
  "(7Fxx,0010)": {
    tag: "(7Fxx,0010)",
    vr: "OW|OB",
    vm: "1",
    name: "Variable Pixel Data"
  },
  "(7Fxx,0011)": {
    tag: "(7Fxx,0011)",
    vr: "US",
    vm: "1",
    name: "Variable Next Data Group"
  },
  "(7Fxx,0020)": {
    tag: "(7Fxx,0020)",
    vr: "OW",
    vm: "1",
    name: "Variable Coefficients SDVN"
  },
  "(7Fxx,0030)": {
    tag: "(7Fxx,0030)",
    vr: "OW",
    vm: "1",
    name: "Variable Coefficients SDHN"
  },
  "(7Fxx,0040)": {
    tag: "(7Fxx,0040)",
    vr: "OW",
    vm: "1",
    name: "Variable Coefficients SDDN"
  },
  "(FFFA,FFFA)": {
    tag: "(FFFA,FFFA)",
    vr: "SQ",
    vm: "1",
    name: "Digital Signatures Sequence"
  },
  "(FFFC,FFFC)": {
    tag: "(FFFC,FFFC)",
    vr: "OB",
    vm: "1",
    name: "Data Set Trailing Padding"
  },
  "(FFFE,E000)": { tag: "(FFFE,E000)", vr: "", vm: "1", name: "Item" },
  "(FFFE,E00D)": {
    tag: "(FFFE,E00D)",
    vr: "",
    vm: "1",
    name: "Item Delimitation Item"
  },
  "(FFFE,E0DD)": {
    tag: "(FFFE,E0DD)",
    vr: "",
    vm: "1",
    name: "Sequence Delimitation Item"
  }
};

export default TAG_DICT;
